/*!
 * 
 *     Copyright (c) 2022 by Trimble Inc.
 *     Updated: Tue Aug 30 2022 15:30:08 GMT-0400 (Eastern Daylight Time)
 *   
 */
webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _angular = __webpack_require__(3);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularAnimate = __webpack_require__(5);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularCookies = __webpack_require__(9);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularUiBootstrap = __webpack_require__(11);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _uiSelect = __webpack_require__(13);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _angularUiRouter = __webpack_require__(15);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _ngInfiniteScroll = __webpack_require__(16);
	
	var _ngInfiniteScroll2 = _interopRequireDefault(_ngInfiniteScroll);
	
	var _alkFleetlink = __webpack_require__(17);
	
	var _alkFleetlink2 = _interopRequireDefault(_alkFleetlink);
	
	var _alkFleetview = __webpack_require__(104);
	
	var _alkFleetview2 = _interopRequireDefault(_alkFleetview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = __webpack_require__(110);
	
	// 3rd party
	
	
	// alk dependencies
	
	
	(function () {
	  var app = _angular2.default.module("fleetviewApp", [_angularAnimate2.default, _angularSanitize2.default, _angularCookies2.default, _angularUiRouter2.default, _angularUiBootstrap2.default, _uiSelect2.default, "ui.utils", "uiSwitch", _ngInfiniteScroll2.default, "pascalprecht.translate", "tmh.dynamicLocale", _alkFleetlink2.default, _alkFleetview2.default, "alk.authentication", "alk.services", "alk.directives", "alk.constants", "alk.analytics", "alk.filters", "alk.maps", "alk.uirouter", "alk.uirouter", "alk.modal", "alk.cloud", "alk.forms", "alk.translations", "alk.marketing", "alk.companyAdmin", "alk.sso", "alk.email", "tm.navButtonsThreeStack", "visibilityChange"]);
	
	  app.constant("_", __webpack_require__(111)); // todo: don"t need to have constants for third party libraries, can use require("moment") in the files that need it.
	  app.constant("ALKMaps", window.ALKMaps);
	  app.constant("moment", __webpack_require__(113)); // todo: don"t need to have constants for third party libraries, can use require("moment") in the files that need it.
	  app.constant("turf", window.turf);
	  app.constant("LRUCache", __webpack_require__(195)); // todo: don"t need to have constant for lru-cache.  Can put require("lru-cache") in the files that need it.
	  app.constant("STATUSES", {
	    submitted: {
	      "value": 0,
	      "class": "default",
	      "text": "common.Submitted"
	    },
	    review: {
	      "value": 1,
	      "class": "info",
	      "text": "common.InReview"
	    },
	    accepted: {
	      "value": 2,
	      "class": "success",
	      "text": "common.Accepted"
	    },
	    rejected: {
	      "value": 3,
	      "class": "danger",
	      "text": "common.Rejected"
	    },
	    deleted: {
	      "value": 4,
	      "class": "warning",
	      "text": "common.Deleted"
	    }
	  });
	  app.constant("appConstants", {
	    SLIDE_ANIM_SPEED: 300
	  });
	  app.constant("papaparse", __webpack_require__(203));
	  app.constant("filesaver", __webpack_require__(204));
	
	  // configure routes/states
	  app.config(["$stateProvider", "$urlRouterProvider", "$urlMatcherFactoryProvider", "$locationProvider", function ($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $locationProvider) {
	    $locationProvider.html5Mode(true);
	    $urlRouterProvider.otherwise("/");
	    $urlMatcherFactoryProvider.strictMode(false);
	
	    $stateProvider.state("index", {
	      abstract: true,
	      views: {
	        "@": {
	          template: __webpack_require__(207)
	        }
	      },
	      resolve: {
	        authenticated: ["$rootScope", "$q", function ($rootScope, $q) {
	          var authenticatePromise = $q.defer();
	          if ($rootScope.preloginFinished === true) {
	            authenticatePromise.resolve();
	            return authenticatePromise.promise;
	          }
	
	          $rootScope.$watch(function () {
	            return $rootScope.preloginFinished;
	          }, function () {
	            if ($rootScope.preloginFinished === true) {
	              authenticatePromise.resolve();
	            }
	          });
	
	          return authenticatePromise.promise;
	        }]
	      }
	    }).state("main", {
	      parent: "index",
	      url: "/app",
	      data: {
	        requiresLogin: true
	      },
	      reloadOnSearch: false,
	      views: {
	        "": {
	          template: __webpack_require__(208)
	        },
	        "leftpanel": {
	          template: "<div></div>"
	        }
	      },
	      resolve: {
	        messages: ["mapService", function messages(mapService) {
	          "ngInject";
	
	          return mapService.initializeMap();
	        }]
	      }
	    }).state("main.compliance", {
	      url: "/compliance",
	      params: {
	        childState: "main.compliance.group",
	        group: ""
	      },
	      reloadOnSearch: false,
	      data: {
	        requiresLogin: true
	      },
	      views: {
	        "leftpanel@main": {
	          component: "complianceGroups"
	        }
	      },
	      onEnter: ["LayoutService", function onEnter(LayoutService) {
	        LayoutService.openLeftHandPanel("500px");
	      }],
	      onExit: ["LayoutService", function onExit(LayoutService) {
	        LayoutService.closeLeftHandPanel();
	      }]
	    }).state("main.compliance.group", {
	      url: "/:groupType?groupId",
	      params: {
	        parentState: "main.compliance",
	        childState: "main.compliance.group.routes"
	      },
	      data: {
	        requiresLogin: true
	      },
	      reloadOnSearch: false,
	      views: {
	        "leftpanel@main": {
	          component: "complianceGroup"
	        }
	      }
	    }).state("main.compliance.group.routes", {
	      url: "/routes",
	      params: {
	        settings: {},
	        parentState: "main.compliance.group",
	        childState: "main.compliance.group.routes.route",
	        pageNumber: 1
	      },
	      data: {
	        requiresLogin: true
	      },
	      reloadOnSearch: false,
	      views: {
	        "sub@main.compliance.group": {
	          component: "complianceGroupRoutes"
	        }
	      }
	    }).state("main.compliance.group.routes.route", {
	      url: "/routesdetails",
	      params: {
	        settings: {},
	        parentState: "main.compliance.group.routes",
	        pageNumber: 1,
	        pageIndex: 0,
	        totalPagesNum: 1
	      },
	      data: {
	        requiresLogin: true
	      },
	      reloadOnSearch: false,
	      views: {
	        "leftpanel@main": {
	          component: "complianceRouteDetails"
	        }
	      }
	    }).state("main.compliance.querystring", {
	      url: "/:queryUrl",
	      params: {
	        parentState: "main.compliance",
	        childState: "main.compliance.querystring.routes",
	        queryUrl: {}
	      },
	      reloadOnSearch: false,
	      location: false,
	      views: {
	        "leftpanel@main": {
	          component: "complianceQueryString"
	        }
	      }
	    }).state("main.compliance.querystring.routes", {
	      params: {
	        settings: {},
	        parentState: "main.compliance.group",
	        currentState: "querystring",
	        childState: "main.compliance.querystring.routes.details"
	      },
	      data: {
	        requiresLogin: true
	      },
	      reloadOnSearch: false,
	      views: {
	        "query@main.compliance.querystring": {
	          component: "complianceGroupRoutes"
	        }
	      }
	    }).state("main.compliance.querystring.routes.details", {
	      params: {
	        settings: {},
	        pageNumber: 1,
	        pageIndex: 0,
	        totalPagesNum: 1,
	        parentState: "main.compliance.querystring",
	        currentState: "querystring"
	      },
	      data: {
	        requiresLogin: true
	      },
	      reloadOnSearch: false,
	      views: {
	        "leftpanel@main": {
	          component: "complianceRouteDetails"
	        }
	      }
	    })
	    /* start of reports states */
	    .state("reports", {
	      parent: "index",
	      url: "/app/reports",
	      redirectTo: "reports.groups",
	      data: {
	        requiresLogin: true
	      },
	      reloadOnSearch: false,
	      views: {
	        "": {
	          template: __webpack_require__(209)
	        },
	        "leftpanel": {
	          template: "<div></div>"
	        },
	        "reportspanel": {
	          template: "<div></div>"
	        }
	      }
	    }).state("reports.groups", {
	      url: "/groups",
	      reloadOnSearch: false,
	      params: {
	        childState: "reports.groups.group"
	      },
	      data: {
	        requiresLogin: true
	      },
	      views: {
	        "leftpanel@reports": {
	          component: "complianceGroups"
	        }
	      },
	      onEnter: ["LayoutService", function onEnter(LayoutService) {
	        LayoutService.openLeftHandPanel("500px");
	      }],
	      onExit: ["LayoutService", function onExit(LayoutService) {
	        LayoutService.closeLeftHandPanel();
	      }]
	    }).state("reports.groups.group", {
	      url: "/:groupType?groupId",
	      params: {
	        parentState: "reports.groups",
	        childState: "reports.groups.group.data"
	      },
	      data: {
	        requiresLogin: true
	      },
	      reloadOnSearch: false,
	      views: {
	        "leftpanel@reports": {
	          component: "complianceGroup"
	        }
	      }
	    }).state("reports.groups.group.data", {
	      url: "/data",
	      params: {
	        settings: {}
	      },
	      data: {
	        requiresLogin: true
	      },
	      reloadOnSearch: false,
	      views: {
	        "reportspanel@reports": {
	          component: "reportsData"
	        }
	      }
	    })
	    /* end of reports states */
	    .state("dashboard", {
	      url: "/app/dashboard",
	      data: {
	        requiresLogin: true
	      },
	      views: {
	        "": {
	          component: "dashboard"
	        }
	      }
	    })
	    //Uses the common one in common js folder
	    .state("companyadmin", {
	      url: "/app/companyAdmin",
	      data: {
	        requiresLogin: true
	      },
	      controller: "companyAdminController",
	      controllerAs: "vm",
	      views: {
	        "": {
	          template: __webpack_require__(210)
	        }
	      }
	    }).state("reset", {
	      parent: "index",
	      url: "/reset",
	      data: {
	        requiresLogin: false
	      },
	      views: {
	        "": {
	          component: "resetPassword"
	        }
	      }
	    }).state("forgot", {
	      parent: "index",
	      url: "/forgot",
	      data: {
	        requiresLogin: false
	      },
	      views: {
	        "": {
	          component: "forgotPassword"
	        }
	      }
	    }).state("user", {
	      parent: "index",
	      url: "/user",
	      data: {
	        requiresLogin: true
	      },
	      views: {
	        "": {
	          component: "user"
	        }
	      }
	    }).state("login", {
	      parent: "index",
	      url: "/",
	      data: {
	        requiresLogin: false
	      },
	      views: {
	        "": {
	          template: __webpack_require__(211)
	        }
	      }
	    }).state("acceptTerms", {
	      parent: "index",
	      url: "/acceptterms",
	      data: {
	        requiresLogin: true
	      },
	      views: {
	        "": {
	          component: "acceptTerms"
	        }
	      }
	    }).state("terms", {
	      parent: "index",
	      url: "/terms",
	      data: {
	        requiresLogin: false
	      },
	      views: {
	        "": {
	          template: __webpack_require__(212)
	        }
	      }
	    }).state("tidRedirect", {
	      parent: "index",
	      url: "/tid/redirect",
	      reloadOnSearch: false,
	      data: {
	        requiresLogin: false
	      },
	      views: {
	        "": {
	          template: __webpack_require__(211)
	        }
	      }
	    });
	  }]);
	
	  app.config(["$uibTooltipProvider", function ($uibTooltipProvider) {
	    $uibTooltipProvider.options({
	      placement: "bottom",
	      popupDelay: 0,
	      animation: false
	    });
	  }]);
	
	  // Angular Dynamic Locale
	  app.config(["tmhDynamicLocaleProvider", function (tmhDynamicLocaleProvider) {
	    tmhDynamicLocaleProvider.localeLocationPattern("node_modules/angular-i18n/angular-locale_{{locale}}.js");
	  }]);
	
	  // since config is not an angular component now, we know it at compile time, so the mouse-flow directive won"t even be included in builds not for production
	  if (false) {
	    app.config(["$compileProvider", function ($compileProvider) {
	      $compileProvider.debugInfoEnabled(false);
	    }]);
	  }
	
	  app.config(["alkAuthenticationServiceProvider", "alk.authentication.config", function (alkAuthenticationServiceProvider, authConfig) {
	    // set up authentication provider
	    alkAuthenticationServiceProvider.dataAnywhereUrl = config.daUrl;
	    authConfig.applicationUrl = config.fleetViewUrl;
	    authConfig.pcmwsUrl = config.pcmwsUrl;
	    authConfig.alkmapsApiKey = config.alkmapsApiKey;
	    authConfig.linkMappingUrl = config.linkMappingUrl;
	    authConfig.ssoUrl = config.ssoUrl;
	    authConfig.applicationName = config.applicationName;
	    authConfig.clientId = config.tidClientId;
	    authConfig.tidApplicationName = config.tidApplicationName;
	    authConfig.trimbleCloudUrl = config.trimbleCloudUrl;
	
	    //Check that trackJs variable is initialized without throwing an error if it isn't
	    if (typeof trackJs !== "undefined" && config.trackJsEnvironment) {
	      trackJs.configure({
	        application: config.trackJsEnvironment
	      });
	    }
	  }]);
	
	  // configure the fleetportal services
	  app.config(["alk.fleetportal.config", function (fleetPortalConfig) {
	    fleetPortalConfig.apiUrl = config.fleetPortalUrl;
	  }]);
	
	  // configure the fleetview services
	  app.config(["alk.fleetview.config", function (fleetViewConfig) {
	    fleetViewConfig.apiUrl = config.fleetViewUrl;
	  }]);
	
	  app.config(["alk.routereporter.config", function (routeReporterConfig) {
	    routeReporterConfig.apiUrl = config.routeReporterUrl;
	  }]);
	
	  app.config(["MessagesProvider", function (MessagesProvider) {
	    MessagesProvider.setBroadcastType("ui.router");
	  }]);
	
	  // Execute bootstrapping code and any dependencies.
	  /* Leave alkLocaleService here so it gets initialized on initial load of app*/
	  app.run(["$rootScope", "$location", "$timeout", "$window", "UserProvider", "alkLocaleService", "$state", "$stateParams", "$templateCache", "$transitions", "appConstants", "stateService", "$q", "alkAuthenticationService", "savedMapInfo", "mapUtilities", "VisibilityChange", function ($rootScope, $location, $timeout, $window, UserProvider, alkLocaleService, $state, $stateParams, $templateCache, $transitions, appConstants, stateService, $q, alkAuthenticationService, savedMapInfo, mapUtilities, VisibilityChange) {
	    $rootScope.$state = $state;
	    $rootScope.$stateParams = $stateParams;
	    $rootScope.language = "en-US"; // default language, this will be replaced when language is changed in "$translateChangeSuccess"
	
	    // All NG-INCLUDE urls need to go here.  ng-include should be deprecated in favor of using controllers with html templates
	    $templateCache.put("/app/auth/en-US/termsContent.html", __webpack_require__(213));
	    $templateCache.put("/app/help/en-US/startPanelItems.html", __webpack_require__(214));
	    $templateCache.put("/app/help/startPanel.html", __webpack_require__(215));
	
	    // New angular-ui onBefore() will throw a console error if aborting transition with "return false", so need this line to silence error
	    $rootScope.$state.defaultErrorHandler(function (error) {});
	
	    $transitions.onBefore({}, function (trans) {
	
	      var fromState = trans.$from();
	      var toState = trans.$to();
	      var fromParams = trans.params("from");
	      var toParams = trans.params("to");
	
	      if (toState.name === "login") {
	        $rootScope.bodyClass = "marketingPage";
	      } else {
	        $rootScope.bodyClass = "";
	      }
	
	      if (!toState || !toState.data) return false;
	
	      var requireLogin = toState.data.requiresLogin === true;
	
	      if (requireLogin) {
	        var user = UserProvider.getUser();
	        var redirectTo = void 0;
	        if ($location.search().r) {
	
	          redirectTo = decodeURIComponent($location.search().r);
	        } else if ($location.url() === "/") {
	          redirectTo = "/app/dashboard";
	        } else {
	          redirectTo = $location.url();
	        }
	
	        if (user.isLoggedIn !== true) {
	          $timeout(function () {
	            return $location.url("/?r=" + encodeURI(redirectTo));
	          });
	          return false;
	        } else if (user.currentTermsOfUseAccepted < 1 && toState.name !== "acceptTerms") {
	          // only enter this condition if we are not already trying to route to the terms of use.  Otherwise we end up in infinite loop.
	          $timeout(function () {
	            return $location.url("/acceptterms?r=" + encodeURIComponent(redirectTo));
	          });
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    $transitions.onStart({}, function (trans) {
	      //Handle slide can redirect the transition, i.e. going from main.A to main.B, causes slide-out, then slide-in animation
	      return stateService.handleSlide(trans, appConstants.SLIDE_ANIM_SPEED);
	    });
	
	    $transitions.onFinish({}, function (trans) {});
	
	    $rootScope.$on("$translateChangeSuccess", function (event, data) {
	      $rootScope.language = data.language.replace(/_/g, "-");
	    });
	
	    $rootScope.$on("UserLoggedIn", function (event, user) {
	      // if the user is not an alk user, remove the style from local storage in case satellite was already selected.
	      if (!user.isALKUser) {
	        $window.localStorage.removeItem("style");
	      }
	    });
	
	    //  now the app is starting, let's see if we can log in via a cookie
	    $rootScope.preloginFinished = false;
	    var redirectLocation = void 0;
	    var saveInfoClosure = function saveInfoClosure() {};
	    if ($location.search().r) {
	      redirectLocation = decodeURIComponent($location.search().r);
	    } else {
	      var path = $location.path();
	      var urlCenter = mapUtilities.parseCenterParams($location.search());
	
	      if (urlCenter) {
	        var urlMapCenter = mapUtilities.LLtoMerc(urlCenter.center[0], urlCenter.center[1]);
	        $location.search("center", null);
	        saveInfoClosure = function saveInfoClosure() {
	          savedMapInfo.saveCurrentInfo(urlMapCenter, urlCenter.zoom, ALKMaps.STYLE.DEFAULT);
	        };
	      }
	
	      if (_.isEmpty(path) || path === "/") {
	        $location.path("/app/dashboard");
	        redirectLocation = $location.url();
	      } else {
	        var queryParams = $location.search();
	        var queryString = _.map(queryParams, function (v, k) {
	          return k + "=" + v;
	        }).join("&");
	        if (queryString.length > 0) {
	          queryString = "?" + queryString;
	        }
	        redirectLocation = path + queryString;
	      }
	    }
	
	    $rootScope.preloginFinished = false;
	    var skipCookieLogin = _.includes(redirectLocation, "/reset") || _.includes(redirectLocation, "/tid/redirect");
	    if (!skipCookieLogin) {
	      var authenticationPromise = $q.defer();
	      alkAuthenticationService.verify().then(function () {
	        authenticationPromise.resolve();
	      }, function (err) {
	        authenticationPromise.reject();
	      });
	      authenticationPromise.promise.then(function () {
	        $rootScope.preloginFinished = true;
	        saveInfoClosure();
	        $location.url(redirectLocation);
	      }, function () {
	        var finalUrl = "/";
	        if (redirectLocation) {
	          finalUrl += "/?r=" + redirectLocation;
	        }
	        $location.url(finalUrl);
	        $rootScope.preloginFinished = true;
	      });
	    } else {
	      $rootScope.preloginFinished = true;
	    }
	
	    if (!document.getElementsByClassName) {
	      document.getElementsByClassName = function (className) {
	        return this.querySelectorAll("." + className);
	      };
	      Element.prototype.getElementsByClassName = document.getElementsByClassName;
	    }
	
	    // SWCX-556 - Everytime user goes back to the app from other browser tab, check if it still has access to this app
	    VisibilityChange.configure({ broadcast: true });
	
	    $rootScope.$on("pageBecameVisible", function (event) {
	      if ($rootScope.userInfo) {
	        alkAuthenticationService.verifyService().then(function (data) {}, // user is good, do nothing
	        function (err) {
	          // user can not access any more, redirect user to login.
	          UserProvider.clearUser();
	          // pchen: closes an open freshchat window when kicked out
	          //   after logging out in a different tab
	          if (window.fcWidget) {
	            window.fcWidget.destroy();
	          }
	          $location.url("/");
	        });
	      }
	    });
	  }]);
	})();
	
	// require these files so webpack includes them in the dist
	__webpack_require__(216);
	__webpack_require__(217);
	
	// require styles for the application
	__webpack_require__(218);
	//require("./../css/alk-bootstrap-overrides.less");
	__webpack_require__(222);
	__webpack_require__(224);
	
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	
	__webpack_require__(233);
	
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	
	__webpack_require__(246);
	
	__webpack_require__(255);
	__webpack_require__(256);
	
	__webpack_require__(257);
	__webpack_require__(259);
	
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(289);
	
	__webpack_require__(291);
	__webpack_require__(292);
	__webpack_require__(293);
	__webpack_require__(294);
	
	__webpack_require__(295);
	
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(309);
	
	__webpack_require__(312);
	__webpack_require__(313);
	
	__webpack_require__(314);
	
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(334);
	__webpack_require__(336);
	__webpack_require__(338);
	__webpack_require__(339);
	__webpack_require__(340);
	__webpack_require__(342);
	__webpack_require__(344);
	__webpack_require__(346);
	
	__webpack_require__(348);
	
	__webpack_require__(350);
	
	__webpack_require__(352);
	__webpack_require__(353);
	__webpack_require__(354);
	__webpack_require__(354);
	__webpack_require__(355);
	__webpack_require__(356);
	
	__webpack_require__(357);
	__webpack_require__(358);
	__webpack_require__(359);
	
	__webpack_require__(361);
	__webpack_require__(363);
	__webpack_require__(365);
	__webpack_require__(367);
	__webpack_require__(369);
	__webpack_require__(371);
	__webpack_require__(372);
	
	__webpack_require__(373);
	
	console.log(("fleetview") + " running...");
	
	__webpack_require__(374);
	__webpack_require__(375);
	__webpack_require__(376);
	__webpack_require__(377);
	__webpack_require__(378);
	__webpack_require__(380);
	__webpack_require__(382);
	__webpack_require__(384);
	__webpack_require__(386);
	__webpack_require__(392);
	
	// include necessary languages
	__webpack_require__(399);
	__webpack_require__(400);
	__webpack_require__(401);
	__webpack_require__(402);
	__webpack_require__(403);
	__webpack_require__(404);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// alk dependency
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fleetlink = __webpack_require__(18);
	
	var _fleetlink2 = _interopRequireDefault(_fleetlink);
	
	var _fleetlink3 = __webpack_require__(19);
	
	var _fleetlink4 = _interopRequireDefault(_fleetlink3);
	
	var _fleetlink5 = __webpack_require__(96);
	
	var _fleetlink6 = _interopRequireDefault(_fleetlink5);
	
	var _fleetlink7 = __webpack_require__(97);
	
	var _fleetlink8 = _interopRequireDefault(_fleetlink7);
	
	var _fleetlink9 = __webpack_require__(98);
	
	var _fleetlink10 = _interopRequireDefault(_fleetlink9);
	
	var _fleetlink11 = __webpack_require__(99);
	
	var _fleetlink12 = _interopRequireDefault(_fleetlink11);
	
	var _fleetlink13 = __webpack_require__(100);
	
	var _fleetlink14 = _interopRequireDefault(_fleetlink13);
	
	var _fleetlink15 = __webpack_require__(101);
	
	var _fleetlink16 = _interopRequireDefault(_fleetlink15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module("alk.fleetportal", []).constant("alk.fleetportal.config", _fleetlink2.default).service("Vehicles", _fleetlink4.default).service("Drivers", _fleetlink8.default).service("VehicleGroups", _fleetlink6.default).service("DriverGroups", _fleetlink10.default).service("RoutingProfiles", _fleetlink12.default).service("Users", _fleetlink16.default).service("FleetPortalAPI", _fleetlink14.default).name;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  apiUrl: ""
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(20);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vehicles = function () {
	  function Vehicles($q, API) {
	    (0, _classCallCheck3.default)(this, Vehicles);
	
	    this.$q = $q;
	    this.API = API;
	  }
	
	  (0, _createClass3.default)(Vehicles, [{
	    key: "getVehicleList",
	    value: function getVehicleList(groupIds) {
	      var targetAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var baseUrl = "v1/vehiclelist";
	      var param = [];
	      param.push.apply(param, this.API.getArrayQuery("includeGroupIds", groupIds));
	
	      if (targetAccount !== null) {
	        param.push("targetAccount=" + targetAccount);
	      }
	      var query = "";
	      if (param.length > 0) {
	        query += "?" + param.join("&");
	      }
	
	      var url = baseUrl + query;
	      var ctx = this;
	      var promise = new _promise2.default(function (resolve, reject) {
	        ctx.API.get(url).success(function (vehicles) {
	          return resolve(vehicles);
	        }).error(function (err) {
	          return reject(err);
	        });
	      });
	      return promise;
	    }
	
	    // TODO: DEPRECATE due to performance with 20k+ items
	
	  }, {
	    key: "getVehicles",
	    value: function getVehicles(groupIds, searchTerm, paging) {
	      var targetAccount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var deferred = this.$q.defer();
	      var url = "v1/vehicles";
	
	      var param = [];
	      param.push.apply(param, this.API.getPagingQuery(paging));
	      param.push.apply(param, this.API.getArrayQuery("includeGroupId", groupIds));
	      if (searchTerm) param.push("searchTerm=" + searchTerm);
	
	      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (vehicles) {
	        //console.log("vehicles: ", vehicles);
	        deferred.resolve(vehicles);
	      }).error(function (err) {
	        console.log("error: ", err);
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }]);
	  return Vehicles;
	}();
	
	exports.default = Vehicles;
	
	
	Vehicles.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(21), __esModule: true };

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(22);
	__webpack_require__(23);
	__webpack_require__(67);
	__webpack_require__(71);
	__webpack_require__(89);
	__webpack_require__(90);
	module.exports = __webpack_require__(31).Promise;


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(28);
	var global = __webpack_require__(30);
	var ctx = __webpack_require__(32);
	var classof = __webpack_require__(72);
	var $export = __webpack_require__(29);
	var isObject = __webpack_require__(37);
	var aFunction = __webpack_require__(33);
	var anInstance = __webpack_require__(73);
	var forOf = __webpack_require__(74);
	var speciesConstructor = __webpack_require__(78);
	var task = __webpack_require__(79).set;
	var microtask = __webpack_require__(81)();
	var newPromiseCapabilityModule = __webpack_require__(82);
	var perform = __webpack_require__(83);
	var userAgent = __webpack_require__(84);
	var promiseResolve = __webpack_require__(85);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(64)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(86)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(63)($Promise, PROMISE);
	__webpack_require__(87)(PROMISE);
	Wrapper = __webpack_require__(31)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(88)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(54);
	var TAG = __webpack_require__(64)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(32);
	var call = __webpack_require__(75);
	var isArrayIter = __webpack_require__(76);
	var anObject = __webpack_require__(36);
	var toLength = __webpack_require__(56);
	var getIterFn = __webpack_require__(77);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(36);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(46);
	var ITERATOR = __webpack_require__(64)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(72);
	var ITERATOR = __webpack_require__(64)('iterator');
	var Iterators = __webpack_require__(46);
	module.exports = __webpack_require__(31).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(36);
	var aFunction = __webpack_require__(33);
	var SPECIES = __webpack_require__(64)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(32);
	var invoke = __webpack_require__(80);
	var html = __webpack_require__(62);
	var cel = __webpack_require__(41);
	var global = __webpack_require__(30);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(54)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(30);
	var macrotask = __webpack_require__(79).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(54)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(33);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(30);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(36);
	var isObject = __webpack_require__(37);
	var newPromiseCapability = __webpack_require__(82);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(34);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(30);
	var core = __webpack_require__(31);
	var dP = __webpack_require__(35);
	var DESCRIPTORS = __webpack_require__(39);
	var SPECIES = __webpack_require__(64)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(64)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(29);
	var core = __webpack_require__(31);
	var global = __webpack_require__(30);
	var speciesConstructor = __webpack_require__(78);
	var promiseResolve = __webpack_require__(85);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(29);
	var newPromiseCapability = __webpack_require__(82);
	var perform = __webpack_require__(83);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(93);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(94), __esModule: true };

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(95);
	var $Object = __webpack_require__(31).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(29);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(39), 'Object', { defineProperty: __webpack_require__(35).f });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VehicleGroups = function () {
	  function VehicleGroups($q, API) {
	    (0, _classCallCheck3.default)(this, VehicleGroups);
	
	    this.$q = $q;
	    this.API = API;
	  }
	
	  (0, _createClass3.default)(VehicleGroups, [{
	    key: "getVehicleGroups",
	    value: function getVehicleGroups(vehicleIds, groupIds, searchTerm, paging) {
	      var targetAccount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	      var deferred = this.$q.defer();
	      var url = "v1/vehicle-groups";
	
	      var param = [];
	      param.push.apply(param, this.API.getPagingQuery(paging));
	      param.push.apply(param, this.API.getArrayQuery("vehicleId", vehicleIds));
	      param.push.apply(param, this.API.getArrayQuery("groupId", groupIds));
	      if (searchTerm) param.push("searchTerm=" + searchTerm);
	
	      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (vehicles) {
	        //console.log("vehicle groups: ", vehicles);
	        deferred.resolve(vehicles);
	      }).error(function (err) {
	        console.log("error: ", err);
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "getById",
	    value: function getById(groupId) {
	      var targetAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var deferred = this.$q.defer();
	      var url = "v1/vehicle-groups/" + groupId;
	
	      var param = [];
	      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (vehicle) {
	        return deferred.resolve(vehicle);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }]);
	  return VehicleGroups;
	}();
	
	exports.default = VehicleGroups;
	
	
	VehicleGroups.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Drivers = function () {
	  function Drivers($q, API) {
	    (0, _classCallCheck3.default)(this, Drivers);
	
	    this.$q = $q;
	    this.API = API;
	  }
	
	  (0, _createClass3.default)(Drivers, [{
	    key: "getDrivers",
	    value: function getDrivers(groupIds, searchTerm, paging) {
	      var targetAccount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var deferred = this.$q.defer();
	      var url = "v1/drivers";
	
	      var param = [];
	      param.push.apply(param, this.API.getPagingQuery(paging));
	      param.push.apply(param, this.API.getArrayQuery("includeGroupId", groupIds));
	      if (searchTerm) param.push("searchTerm=" + searchTerm);
	
	      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (drivers) {
	        //console.log("drivers: ", drivers);
	        deferred.resolve(drivers);
	      }).error(function (err) {
	        console.log("error: ", err);
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }]);
	  return Drivers;
	}();
	
	exports.default = Drivers;
	
	
	Drivers.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DriverGroups = function () {
	  function DriverGroups($q, API) {
	    (0, _classCallCheck3.default)(this, DriverGroups);
	
	    this.$q = $q;
	    this.API = API;
	  }
	
	  (0, _createClass3.default)(DriverGroups, [{
	    key: "getDriverGroups",
	    value: function getDriverGroups(driverIds, groupIds, searchTerm, paging) {
	      var targetAccount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	      var deferred = this.$q.defer();
	      var url = "v1/driver-groups";
	
	      var param = [];
	      param.push.apply(param, this.API.getPagingQuery(paging));
	      if (searchTerm) param.push("searchTerm=" + searchTerm);
	
	      // todo: group id and driver id arrays are not currently implemented yet on the server side.
	      // todo: leave these here as placeholders for when they do get put in
	      param.push.apply(param, this.API.getArrayQuery("driverId", driverIds));
	      param.push.apply(param, this.API.getArrayQuery("groupId", groupIds));
	
	      if (searchTerm) param.push("searchTerm=" + searchTerm);
	
	      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (drivers) {
	        //console.log("drivers groups: ", drivers);
	        deferred.resolve(drivers);
	      }).error(function (err) {
	        console.log("error: ", err);
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "getById",
	    value: function getById(groupId) {
	      var targetAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var deferred = this.$q.defer();
	      var url = "v1/driver-groups/" + groupId;
	
	      var param = [];
	      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (vehicle) {
	        return deferred.resolve(vehicle);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }]);
	  return DriverGroups;
	}();
	
	exports.default = DriverGroups;
	
	
	DriverGroups.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingProfiles = function () {
	  function RoutingProfiles($q, API) {
	    (0, _classCallCheck3.default)(this, RoutingProfiles);
	
	    this.$q = $q;
	    this.API = API;
	  }
	
	  //Given a vehicle id, get all routing profiles associated with all this vehicle's vehicle groups
	
	
	  (0, _createClass3.default)(RoutingProfiles, [{
	    key: "getVehicleRoutingProfiles",
	    value: function getVehicleRoutingProfiles(vehicleId, options) {
	      var deferred = this.$q.defer();
	      var url = "v1/vehicle-groups?vehicleId=" + vehicleId;
	
	      var that = this;
	
	      this.API.get(url, options).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise.then(function (results) {
	        var vgPromises = _.map(results, function (result) {
	          return that.getRoutingProfiles(result.id, options);
	        });
	        return that.$q.all(vgPromises).then(function (rpArrayOfArrays) {
	          var rpFlatArray = [].concat.apply([], rpArrayOfArrays);
	          rpFlatArray = _.uniq(rpFlatArray, function (rp) {
	            return rp.routingProfileId;
	          });
	          //console.log("VEHICLE ROUTING PROFILES:");
	          //console.log(rpFlatArray);
	          return rpFlatArray;
	        }, function (error) {
	          console.log(error);
	          return null;
	        });
	      }, function (error) {
	        console.log(error);
	        return null;
	      });
	    }
	  }, {
	    key: "getRoutingProfiles",
	    value: function getRoutingProfiles(vehicleGroupId, options) {
	      var deferred = this.$q.defer();
	      var url = "v1/routing-profiles?includeGroupId=" + vehicleGroupId;
	
	      this.API.get(url, options).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "getRoutingProfile",
	    value: function getRoutingProfile(routingProfileId, options) {
	      var deferred = this.$q.defer();
	      var url = "v1/routing-profiles/" + routingProfileId;
	
	      this.API.get(url, options).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "getDefaultRoutingProfile",
	    value: function getDefaultRoutingProfile(options) {
	      var deferred = this.$q.defer();
	      var url = "v1/routing-profiles?isDefault=true";
	
	      this.API.get(url, options).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }]);
	  return RoutingProfiles;
	}();
	
	exports.default = RoutingProfiles;
	
	
	RoutingProfiles.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FleetPortalAPI = function () {
	  function FleetPortalAPI($http, $window, config) {
	    (0, _classCallCheck3.default)(this, FleetPortalAPI);
	
	    this.$http = $http;
	    this.$window = $window;
	    this.config = config;
	  }
	
	  (0, _createClass3.default)(FleetPortalAPI, [{
	    key: "get",
	    value: function get(url, options) {
	      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");
	
	      options = angular.extend({}, options, this.getOptions());
	
	      return this.$http.get("" + this.config.apiUrl + url, options);
	    }
	  }, {
	    key: "post",
	    value: function post(url, data, options) {
	      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");
	
	      options = angular.extend({}, options, this.getOptions());
	
	      return this.$http.post("" + this.config.apiUrl + url, data, options);
	    }
	  }, {
	    key: "put",
	    value: function put(url, data, options) {
	      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");
	
	      options = angular.extend({}, options, this.getOptions());
	
	      return this.$http.put("" + this.config.apiUrl + url, data, options);
	    }
	  }, {
	    key: "delete",
	    value: function _delete(url, options) {
	      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");
	
	      options = angular.extend({}, options, this.getOptions());
	
	      return this.$http.delete("" + this.config.apiUrl + url, options);
	    }
	  }, {
	    key: "getOptions",
	    value: function getOptions() {
	      var userString = this.$window.sessionStorage["userAuthInfo"];
	      var user = JSON.parse(userString);
	
	      var options = {
	        headers: {
	          "ALK-Language": undefined,
	          "Authorization": "Bearer " + user.authToken
	        }
	      };
	
	      return options;
	    }
	  }, {
	    key: "getPagingQuery",
	    value: function getPagingQuery(paging) {
	      if (!paging) return [];
	
	      var p = [];
	      if (paging.pageNumber != null) p.push("pageNumber=" + paging.pageNumber);
	      if (paging.limit != null) p.push("limit=" + paging.limit);
	      if (paging.sortBy != null) p.push("sortBy=" + paging.sortBy);
	      if (paging.sortAscending != null) p.push("sortAscending=" + paging.sortAscending);
	
	      return p;
	    }
	  }, {
	    key: "getArrayQuery",
	    value: function getArrayQuery(key, arr) {
	      if (arr == null) return [];
	
	      var p = [];
	
	      if (this.isArray(arr)) {
	        for (var i = 0; i < arr.length; i++) {
	          p.push(key + "=" + arr[i]);
	        }
	      } else {
	        // if passed in item is not an array, but instead a single item
	        p.push(key + "=" + arr);
	      }
	
	      return p;
	    }
	  }, {
	    key: "isArray",
	    value: function isArray(arg) {
	      return Object.prototype.toString.call(arg) === "[object Array]";
	    }
	  }]);
	  return FleetPortalAPI;
	}();
	
	exports.default = FleetPortalAPI;
	
	
	FleetPortalAPI.$inject = ["$http", "$window", "alk.fleetportal.config"];

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(102);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Users = function () {
	  function Users($q, API) {
	    (0, _classCallCheck3.default)(this, Users);
	
	    this.$q = $q;
	    this.API = API;
	  }
	
	  (0, _createClass3.default)(Users, [{
	    key: "_getOpts",
	    value: function _getOpts(applicationName) {
	      return {
	        params: {
	          applicationName: applicationName
	        }
	      };
	    }
	  }, {
	    key: "getUsers",
	    value: function getUsers(applicationName) {
	      var deferred = this.$q.defer();
	      var url = "v1/users";
	
	      this.API.get(url, this._getOpts(applicationName)).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "getUserWithGroupInfo",
	    value: function getUserWithGroupInfo(userId) {
	      var deferred = this.$q.defer();
	      var url = "v1/usersWithGroupInfo/" + userId;
	
	      this.API.get(url).success(function (results) {
	        deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "createUser",
	    value: function createUser(user, applicationName) {
	
	      var deferred = this.$q.defer();
	      var url = "v1/users";
	
	      var body = (0, _stringify2.default)({
	        EmailAddress: user.emailAddress,
	        FirstName: user.firstName,
	        LastName: user.lastName,
	        Enabled: true,
	        Role: user.role
	      });
	
	      this.API.post(url, body, this._getOpts(applicationName)).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "updateUser",
	    value: function updateUser(user, applicationName) {
	
	      var deferred = this.$q.defer();
	      var url = "v1/users/" + user.userId;
	
	      var body = (0, _stringify2.default)({
	        EmailAddress: user.emailAddress,
	        FirstName: user.firstName,
	        LastName: user.lastName,
	        Role: user.role,
	        Enabled: user.enabled
	      });
	
	      this.API.put(url, body, this._getOpts(applicationName)).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "removeUser",
	    value: function removeUser(userId, applicationName) {
	      var deferred = this.$q.defer();
	      var url = "v1/users/" + userId;
	
	      this.API.delete(url, this._getOpts(applicationName)).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "setUserVehicleGroups",
	    value: function setUserVehicleGroups(userId, applicationName, vehicleGroupIds) {
	      var deferred = this.$q.defer();
	      var url = "v1/users/" + userId + "/vehicle-groups";
	
	      var body = (0, _stringify2.default)(vehicleGroupIds);
	
	      this.API.put(url, body, this._getOpts(applicationName)).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: "setUserDriverGroups",
	    value: function setUserDriverGroups(userId, applicationName, driverGroupIds) {
	      var deferred = this.$q.defer();
	      var url = "v1/users/" + userId + "/driver-groups";
	      var body = (0, _stringify2.default)(driverGroupIds);
	
	      this.API.put(url, body, this._getOpts(applicationName)).success(function (results) {
	        return deferred.resolve(results);
	      }).error(function (err) {
	        return deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }]);
	  return Users;
	}();
	
	exports.default = Users;
	
	
	Users.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(103), __esModule: true };

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(31);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// 3rd party dependency
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(3);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fleetview = __webpack_require__(105);
	
	var _fleetview2 = _interopRequireDefault(_fleetview);
	
	var _fleetview3 = __webpack_require__(106);
	
	var _fleetview4 = _interopRequireDefault(_fleetview3);
	
	var _fleetview5 = __webpack_require__(107);
	
	var _fleetview6 = _interopRequireDefault(_fleetview5);
	
	var _routereporter = __webpack_require__(108);
	
	var _routereporter2 = _interopRequireDefault(_routereporter);
	
	var _routereporter3 = __webpack_require__(109);
	
	var _routereporter4 = _interopRequireDefault(_routereporter3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("alk.fleetview", []).constant("alk.fleetview.config", _fleetview2.default).service("FleetViewDashboard", _fleetview4.default).service("FleetViewAPI", _fleetview6.default).constant("alk.routereporter.config", _routereporter2.default).service("RouteReporterAPI", _routereporter4.default).name;
	
	// alk dependency

/***/ }),
/* 105 */
18,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FleetViewDashboard = function () {
	  function FleetViewDashboard($q, API) {
	    (0, _classCallCheck3.default)(this, FleetViewDashboard);
	
	    this.$q = $q;
	    this.API = API;
	  }
	
	  /**
	   * @name getOutOfRoutePercertange
	   * @desc getOutOfRoutePercertange for Vehcile/Driver.
	   * @param
	   *   @groupIds
	   *   @groupType: Vehicle or Driver
	   */
	
	
	  (0, _createClass3.default)(FleetViewDashboard, [{
	    key: "getOutOfRoutePercertange",
	    value: function getOutOfRoutePercertange(groupIds, groupType) {
	      var deferred = this.$q.defer();
	      var url = "v1/OutOfRoutePercertange";
	
	      var param = [];
	      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
	      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (res) {
	        deferred.resolve(res);
	      }).error(function (err) {
	        console.log("error: ", err);
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	
	    /**
	     * @name getOutOfRouteRatioReport
	     * @desc getOutOfRouteRatioReport for Vehcile/Driver.
	     * @param
	     *   @weeks: number of weeks to retrieve 
	     *   @groupIds
	     *   @groupType: Vehicle or Driver
	     */
	
	  }, {
	    key: "getOutOfRouteRatioReport",
	    value: function getOutOfRouteRatioReport(weeks, groupIds, groupType) {
	      var deferred = this.$q.defer();
	      var url = "v1/OutOfRouteRatioReport";
	
	      var param = [];
	      param.push.apply(param, this.API.getArrayQuery("weeks", weeks));
	      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
	      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (res) {
	        deferred.resolve(res);
	      }).error(function (err) {
	        console.log("error: ", err);
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	
	    /**
	     * @name getOutOfRouteReport
	     * @desc getOutOfRouteReport for Vehcile/Driver.
	     * @param
	     *   @groupIds
	     *   @groupType: Vehicle or Driver
	     */
	
	  }, {
	    key: "getOutOfRouteReport",
	    value: function getOutOfRouteReport(groupIds, groupType) {
	      var deferred = this.$q.defer();
	      var url = "v1/OutOfRouteReport";
	
	      var param = [];
	      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
	      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (res) {
	        deferred.resolve(res);
	      }).error(function (err) {
	        console.log("error: ", err);
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	
	    /**
	     * @name getRoutesByWeek
	     * @desc getRoutesByWeek for Vehcile/Driver.
	     * @param
	     *   @weeks: number of weeks to retrieve 
	     *   @groupIds
	     *   @groupType: Vehicle or Driver
	     */
	
	  }, {
	    key: "getRoutesByWeek",
	    value: function getRoutesByWeek(weeks, groupIds, groupType) {
	      var deferred = this.$q.defer();
	      var url = "v1/RoutesByWeek";
	
	      var param = [];
	      param.push.apply(param, this.API.getArrayQuery("weeks", weeks));
	      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
	      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (res) {
	        deferred.resolve(res);
	      }).error(function (err) {
	        console.log("error: ", err);
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	
	    /**
	     * @name getSummary
	     * @desc get summary for Vehcile/Driver including: unit count, averageOORMiles, averageOORTime, averageOoRString, 
	     *   maxOORMiles, maxOORTime and maxOoRString
	     * @param 
	     *   @groupIds
	     *   @groupType: Vehicle or Driver
	     */
	
	  }, {
	    key: "getSummary",
	    value: function getSummary(groupIds, groupType) {
	      var deferred = this.$q.defer();
	      var url = "v1/Summary";
	
	      var param = [];
	      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
	      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));
	
	      if (param.length > 0) {
	        url += "?" + param.join("&");
	      }
	
	      this.API.get(url).success(function (res) {
	        deferred.resolve(res);
	      }).error(function (err) {
	        console.log("error: ", err);
	        deferred.reject(err);
	      });
	
	      return deferred.promise;
	    }
	  }]);
	  return FleetViewDashboard;
	}();
	
	exports.default = FleetViewDashboard;
	
	
	FleetViewDashboard.$inject = ["$q", "FleetViewAPI"];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FleetViewAPI = function () {
	  function FleetViewAPI($http, $window, config) {
	    (0, _classCallCheck3.default)(this, FleetViewAPI);
	
	    this.$http = $http;
	    this.$window = $window;
	    this.config = config;
	  }
	
	  (0, _createClass3.default)(FleetViewAPI, [{
	    key: "get",
	    value: function get(url, options) {
	      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");
	
	      options = angular.extend({}, options, this.getOptions());
	
	      return this.$http.get("" + this.config.apiUrl + url, options);
	    }
	  }, {
	    key: "post",
	    value: function post(url, data, options) {
	      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");
	
	      options = angular.extend({}, options, this.getOptions());
	
	      return this.$http.post("" + this.config.apiUrl + url, data, options);
	    }
	  }, {
	    key: "getOptions",
	    value: function getOptions() {
	      var userString = this.$window.sessionStorage["userAuthInfo"];
	      var user = JSON.parse(userString);
	
	      var options = {
	        headers: {
	          "ALK-Language": undefined,
	          "Authorization": "Bearer " + user.authToken
	        }
	      };
	
	      return options;
	    }
	  }, {
	    key: "getPagingQuery",
	    value: function getPagingQuery(paging) {
	      if (!paging) return [];
	
	      var p = [];
	      if (paging.pageNumber != null) p.push("pageNumber=" + paging.pageNumber);
	      if (paging.limit != null) p.push("limit=" + paging.limit);
	      if (paging.sortBy != null) p.push("sortBy=" + paging.sortBy);
	      if (paging.sortAscending != null) p.push("sortAscending=" + paging.sortAscending);
	
	      return p;
	    }
	  }, {
	    key: "getArrayQuery",
	    value: function getArrayQuery(key, arr) {
	      if (arr == null) return [];
	
	      var p = [];
	
	      if (this.isArray(arr)) {
	        for (var i = 0; i < arr.length; i++) {
	          p.push(key + "=" + arr[i]);
	        }
	      } else {
	        // if passed in item is not an array, but instead a single item
	        p.push(key + "=" + arr);
	      }
	
	      return p;
	    }
	  }, {
	    key: "isArray",
	    value: function isArray(arg) {
	      return Object.prototype.toString.call(arg) === "[object Array]";
	    }
	  }]);
	  return FleetViewAPI;
	}();
	
	exports.default = FleetViewAPI;
	
	
	FleetViewAPI.$inject = ["$http", "$window", "alk.fleetview.config"];

/***/ }),
/* 108 */
18,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(91);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(92);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RouteReporterAPI = function () {
	  function RouteReporterAPI($http, $window, config) {
	    (0, _classCallCheck3.default)(this, RouteReporterAPI);
	
	    this.$http = $http;
	    this.$window = $window;
	    this.config = config;
	  }
	
	  (0, _createClass3.default)(RouteReporterAPI, [{
	    key: "post",
	    value: function post(url, data, options) {
	      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");
	
	      options = angular.extend({}, options, this.getOptions());
	
	      return this.$http.post("" + this.config.apiUrl + url, data, options);
	    }
	  }, {
	    key: "get",
	    value: function get(url, options) {
	      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");
	
	      options = angular.extend({}, options, this.getOptions());
	
	      return this.$http.get("" + this.config.apiUrl + url, options);
	    }
	  }, {
	    key: "getOptions",
	    value: function getOptions() {
	      var userString = this.$window.sessionStorage["userAuthInfo"];
	      var user = JSON.parse(userString);
	
	      var options = {
	        headers: {
	          "ALK-Language": undefined,
	          "Authorization": "Bearer " + user.authToken
	        }
	      };
	
	      return options;
	    }
	  }, {
	    key: "isArray",
	    value: function isArray(arg) {
	      return Object.prototype.toString.call(arg) === "[object Array]";
	    }
	  }]);
	  return RouteReporterAPI;
	}();
	
	exports.default = RouteReporterAPI;
	
	
	RouteReporterAPI.$inject = ["$http", "$window", "alk.routereporter.config"];

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  environment: "alkqaaws",
	  ssoUrl: "https://authws-qa.alk.com/api/",
	  fleetPortalUrl: "https://api-copilotfleetportal-qa.alk.com/",
	  daUrl: "https://dataanywhere-qa.alk.com/api/",
	  pcmwsUrl: "https://pcmiler-aws-qa.alk.com/APIs/REST/v1.0/service.svc/",
	  alkmapsUrl: "//maps-aws-qa.alk.com/api/1.2/ALKMaps.js",
	  alkiconsUrl: "https://d1azc1qln24ryf.cloudfront.net/104959/ALKIcons/style-cf.css?8hwqaj",
	  alkmapsApiKey: "48667533B12E8942B038B8533A35F4A5",
	  fleetViewUrl: "https://api-copilotroutereporter-qa.alk.com/",
	  routeReporterUrl: "https://routereporter-export-qa.trimblemaps.com/",
	  partnerApplicationName: "CoPilot FleetView",
	  applicationName: "CoPilot FleetView",
	  hubspotPortalId: "4239221",
	  hubspotFormId: "d524628a-c40f-4d1c-bf59-cabcf276fffc",
	  newRRWeb: "https://routereporter-qa.trimblemaps.com/",
	  trimbleApplication: "Route_Reporter--dev-qa",
	  trimbleCloudClientId: "117942a5-d3f3-46bb-943b-5d56969dd86f",
	  tidClientSecret: "79c06d97ac604cc89040a8b8628d406d",
	  trimbleCloudUrl: "https://stage.id.trimblecloud.com/"
	};

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports) {

	module.exports = "<div ui-view></div>";

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <alk-main-nav></alk-main-nav>\r\n  <div ng-controller=\"mapController as vm\">\r\n    <div id=\"center-section\">\r\n      <button class=\"hide-compliance btn btn-md\" ng-style=\"{'left': vm.leftPanelWidth()}\" ng-model=\"vm.isleftPanelHidden\" ng-class=\"{buttonclosed:vm.isleftPanelHidden}\"\r\n        ng-click=\"vm.hidePanel()\" ng-show=\"'main.compliance'| includedByState\">\r\n                <i class=\"ico ico-chevron-left-thick\"  ng-class=\"{closed:vm.isleftPanelHidden}\"></i>\r\n            </button>\r\n      <div id=\"left-panel-wrapper\" class=\"ui-panel left-panel\" ng-style=\"{'width': vm.leftPanelWidth()}\">\r\n        <div id=\"left-panel-main\" ui-view=\"leftpanel\" class=\"left-panel-ui-view\" ng-class=\"leftPanelSlideClass\"></div>\r\n      </div>\r\n      <div class=\"map-warning-container\" ng-class=\"{highlight:!vm.canEdit()}\" ng-style=\"{'left': vm.leftPanelWidth()}\">\r\n        <span id=\"msg-warning\" class=\"label label-info map-warning\" ng-class=\"{'show-warning': vm.mapMessage.showMsg()}\">\r\n                    <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\r\n        <span ng-bind=\"vm.mapMessage.txt\"></span>\r\n        </span>\r\n        <a id=\"edit-warning\" class=\"label label-warning map-warning\" ng-click=\"vm.zoomToEdit()\" ng-class=\"{'show-warning': !vm.canEdit()}\">\r\n          <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\r\n          <span translate=\"views.main.Zoom in to make changes\"></span>\r\n        </a>\r\n        <span id=\"load-warning\" class=\"label label-warning map-warning\" ng-class=\"{'show-warning': vm.showLoading() && vm.canEdit() }\">\r\n                    <span class=\"ico ico-circle-notch ico-spin\"></span>\r\n        <span translate=\"common.Loading\"></span>...\r\n        </span>\r\n      </div>\r\n      <div id=\"map-cursor-tooltip\" ng-class=\"{'showMe':vm.mapTooltip.show}\">\r\n        <span id=\"map-cursor-span\" class=\"label label-{{vm.mapTooltip.labelClass}}\" ng-bind=\"mapTooltip.txt\"></span>\r\n      </div>\r\n      <div alkmap id=\"map\" map-satellite-provider=\"{{userInfo.satelliteProvider}}\" map-region=\"userInfo.region\" map-dataset=\"userInfo.dataVersion\"\r\n        ng-class=\"\" ng-style=\"{'left': vm.leftPanelWidth() }\"></div>\r\n      <!--do not remove addCenterParam SWFV-76-->\r\n      <div alkmaps-navigation map-id=\"map\"></div>\r\n      <!--<div ng-include=\"'/app/help/startPanel.html'\"></div>-->\r\n    </div>\r\n    <map-footer app=\"FleetView\" map-shown=\"true\"></map-footer>\r\n  </div>\r\n</div>\r\n";

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <alk-main-nav></alk-main-nav>\r\n        <div class=\"panel\" >\r\n            <button class=\"hide-compliance btn btn-md\">\r\n                <i class=\"ico ico-chevron-left-thick\"></i>\r\n            </button>\r\n            <div id=\"left-panel-wrapper\" class=\"ui-panel left-panel\" style=\"width: 500px;top:74px\" >\r\n              <div ui-view=\"leftpanel\" class=\"left-panel-ui-view reports-left-panel\" ng-class=\"leftPanelSlideClass\" >\r\n                    <div> go to /reports/groups</div>\r\n              </div>\r\n            </div>\r\n              <div class=\"ui-panel reports-panel\">\r\n              <div ui-view=\"reportspanel\" class=\"reports-panel-ui-view\" >\r\n                <reports-data></reports-data>\r\n              </div>\r\n\r\n            </div>\r\n        </div>\r\n        <map-footer app=\"FleetView\"></map-footer>\r\n</div>\r\n";

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<alk-main-nav></alk-main-nav>\r\n<div class=\"container with-nav company-admin\" ng-controller=\"companyAdminController as vm\">\r\n  <div class=\"panel page-panel\">\r\n    <div class=\"row panel-heading action-panel\">\r\n      <div class=\"col-xs-4\">\r\n      </div>\r\n      <div class=\"col-xs-4\">\r\n        <h4 class=\"panel-name text-center\">\r\n          <span translate=\"views.company.title\"></span>\r\n        </h4>\r\n      </div>\r\n      <div class=\"col-xs-4\">\r\n      </div>\r\n    </div>\r\n    <div class=\"row tab-panel\" ng-if=\"vm.hasCompanyAdminAccess\">\r\n      <ul class=\"nav nav-tabs\">\r\n        <li class=\"nav-item\" ng-class=\"{'active':vm.activeTab==='users'}\" ng-click=\"vm.activeTab='users'\">\r\n          <a class=\"nav-link\"><span translate=\"views.company.users\"></span></a>\r\n        </li>\r\n      </ul>\r\n      <div class=\"tab-content\">\r\n        <div ng-if=\"vm.activeTab==='users'\">\r\n          <common-account-users></common-account-users>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"row tab-panel\" ng-hide=\"vm.hasCompanyAdminAccess\">\r\n  <div class=\"panel page-panel\">\r\n  <h4>You do not have access to this page</h4>\r\n    </div>\r\n</div>\r\n  </div>\r\n</div>\r\n<map-footer></map-footer>";

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"marketing-page login-page login-routereporter\" ng-controller=\"tidLoginController as vm\">\r\n  <div class=\"top-section routereporter-top-section\">\r\n    <div class=\"row tid-banner-padding\">\r\n      <div id=\"tmxtid-banner-component\" class=\"tmxtid-init\"></div>\r\n    </div>\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"new-rr-web-container-login\">\r\n          <a href=\"https://routereporter.trimblemaps.com/\" class=\"new-rr-web\">We've redesigned RouteReporter, click here to check out the new version.</a>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-10\"><img src=\"/img/RouteReporter_Logo-reversed.svg\" alt=\"RouteReporter\" class=\"page-logo\"></div>\r\n        <div class=\"col-sm-2 text-right form-group\">\r\n          <div alk-language-select></div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-6\" style=\"padding-top: 30px;\">\r\n          <div class=\"row\">\r\n            <h1 class=\"with-icon\">\r\n              <span class=\"landing-app-icon\">\r\n                <img src=\"/img/cloud-menu-fleetview.svg\" alt=\"RouteReporter\">\r\n              </span>\r\n              View planned vs. actual routes and analyze post-trip data.\r\n            </h1>\r\n          </div>\r\n          <p class=\"subhead bullet\"><span class=\"ico ico-check-circle-o\"></span>Back office alerting of out-of-route and out-of-corridor events</p>\r\n          <p class=\"subhead bullet\"><span class=\"ico ico-check-circle-o\"></span>Compare planned vs. actual distances and drive times</p>\r\n          <p class=\"subhead bullet\"><span class=\"ico ico-check-circle-o\"></span>Gain insight fleet-wide, or drill down to each route</p>\r\n          <p class=\"availability text-center\">Ideal for fleets of 50 trucks or more</p>\r\n        </div>\r\n        <div class=\"col-sm-5 col-sm-offset-1\">\r\n          \r\n          <div id=\"tmxtid-components\">\r\n            <div class=\"center-countdown\">\r\n            <div id=\"tmxtid-countdown-component\" class=\"tmxtid-init\"></div>\r\n            </div>\r\n            <div class=\"login-form\" ng-show=\"vm.formTab === 'login'\">\r\n              <p class=\"login-title\">{{'common.landing.loginTitle' | translate}}</p>\r\n              <div id=\"tmxtid-sign-in-component\" class=\"tmxtid-init\">\r\n            </div>\r\n            <div class=\"has-error\">\r\n              <p class=\"help-block\" ng-show=\"showAccountDisabled\">{{\"views.login.User or account is disabled\" | translate}}</p>\r\n              <p id=\"login-error\" class=\"help-block\" ng-show=\"showPasswordIncorrect\">{{\"views.login.Username or password is incorrect\" | translate}}</p>\r\n              <p id=\"server-error\" class=\"help-block\" ng-show=\"showGenericError\">{{\"views.login.GenericServerError\" | translate}}</p>\r\n              <p class=\"help-block\" ng-show=\"showNoAccountForApplication\">{{\"views.login.NoAccess\" | translate}}</p>\r\n              <p id=\"login-error\" class=\"help-block\" ng-show=\"failedToLoginAccountExpired\">{{\"views.login.FailedToLoginAccountExpired\" | translate}}</p>\r\n              <p id=\"login-error\" class=\"help-block\" ng-show=\"failedToValidateTidToken\">{{\"views.login.FailedToValidateTidToken\" | translate}}</p>\r\n              <p id=\"login-error\" class=\"help-block\" ng-show=\"views.login.FailedToFindUserInAccount\">{{\"views.login.Username or password is incorrect\" | translate}}</p>\r\n              <p id=\"login-error\" class=\"help-block\" ng-show=\"userDoesNotExist\">This username does not exist. Please try a different email or <a href=\"https://maps.trimble.com/support/\">contact support</a> for help.</p>\r\n              <p id=\"login-error\" class=\"help-block\" ng-show=\"noAccess\">Failed to login. The user doesn't belong to an account licensed for this product. Contact your account admin for access.</p>\r\n          </div>\r\n            </div>\r\n          </div>\r\n\r\n\r\n          <div id=\"originallogin\" class=\"login-box\">\r\n         \r\n          <div class=\"login-box\" id=\"login-box\">\r\n            <!-- Log In -->\r\n            <!-- <div class=\"login-form\" ng-show=\"vm.formTab === 'login'\">\r\n              <p class=\"login-title\">{{'common.landing.loginTitle' | translate}}</p>\r\n              <p class=\"login-subhead visible-xs-block\" translate=\"{{'common.landing.mobileLoginMsg'}}\" translate-values='{productName: \"CoPilot RouteReporter\"}'></p>\r\n              <login-form class=\"hidden-xs\"></login-form> -->\r\n            </div>\r\n            <!-- Sign Up-->\r\n            <div class=\"login-form\" ng-show=\"vm.formTab === 'signup'\">\r\n              <p class=\"login-title\" style=\"margin-bottom: 15px;\">{{'common.landing.signupTitle' | translate}}</p>\r\n              <hubspot-form></hubspot-form>\r\n            </div>\r\n            <!-- Forgot Password -->\r\n            <!-- <div class=\"login-form\" ng-show=\"vm.formTab === 'forgot'\">\r\n              <p class=\"login-title\">{{\"views.forgotPassword.Forgot Password\" | translate}}</p>\r\n              <p class=\"login-subhead\">{{\"views.forgotPassword.Helptext\" | translate}}</p>\r\n              <forgot-password></forgot-password>\r\n            </div> -->\r\n            <!-- Login Tabs -->\r\n            <div class=\"login-tabs\">\r\n              <div class=\"col-xs-6 login-tab\" ng-class=\"{'active' : vm.formTab === 'login'}\" ng-click=\"vm.formTab = 'login'\">\r\n                SIGN IN\r\n              </div>\r\n              <div class=\"col-xs-6 login-tab\" ng-class=\"{'active' : vm.formTab === 'signup'}\" ng-click=\"vm.formTab = 'signup'\">\r\n                GET ACCESS\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <p class=\"availability text-center\" style=\"font-size: 11pt; margin-bottom: 0px;\">\r\n            RouteReporter is available to select CoPilot Truck customers. Contact us to request access.\r\n            <p class=\"availability text-center\" style=\"font-size: 11pt; margin-bottom: 0px;\">\r\n              Supported on Microsoft Edge, Firefox, and Google Chrome\r\n            </p>\r\n            <p class=\"availability text-center\" style=\"font-size: 11pt; font-weight: 200; margin-top: 0px;\">\r\n              No longer supported on Internet Explorer\r\n            </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"landing-support-section\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-8 col-sm-offset-2 text-center\">\r\n          <p class=\"subhead\">\r\n            <img src=\"/img/landing-support-center.svg\" class=\"landing-support-icon\" /><br/>\r\n            <strong>We're Here to Help</strong><br/>\r\n            We have various ways to help our customers get quick, easy answers to common questions and technical support needs<br/>\r\n            <a class=\"btn btn-primary support-button\" href=\"https://support.copilotpro.com/en/support/solutions/19000100110\">Support Center</a>\r\n          </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <marketing-footer></marketing-footer>\r\n</div>\r\n";

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports = "<alk-main-nav></alk-main-nav>\r\n<div class=\"container with-nav terms-page\">\r\n    <div class=\"panel col-md-10 col-md-offset-1\">\r\n        <div class=\"page-content\">\r\n            <div class=\"terms-content\" ng-include=\"'/app/auth/' + language + '/termsContent.html'\"></div>\r\n        </div>\r\n    </div>\r\n</div>";

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	module.exports = "\r\n<div class=\"terms-content\">\r\n\r\n<h2>Terms of Service</h2>\r\n\r\n<p>By using this Application (referred to below as the \"Service\") and any data or information accessed from the Service, you agree to be bound the terms and conditions set forth below. The Service is made available to you for your personal, non-commercial use in accordance with the Terms of Service. Also, you may not use the Service in a manner which gives you or any other person access to mass downloads or bulk feeds of numerical latitude and longitude coordinates.</p>\r\n\r\n<h3>Service</h3>\r\n\r\n<p>The Service allows you to add and edit map data on high resolution geographic imagery provided by Trimble MAPS, Inc. ( “</span><span style=\"font-weight: 700; font-size: 10.5pt;\">Trimble MAPS</span><span style=\"font-size: 10.5pt;\">”)  The drawing and annotation tools in the Service enable you to draw roads and features that are visible in the imagery, and label these items based on your personal knowledge of a region, city, or town. Additionally, you may use the Service to create points of interest, such as a school, business, or community feature, and to locate and describe that point of interest. The Service is intended to reflect the local knowledge of users, and is not intended as a place for users to upload information obtained from third parties, such as directories, compilations, printed or online maps, or similar sources of information, including copyrighted content. Because the Service focuses on documenting factual information rather than creative expression, there are certain types of information that are not suitable for submission, and will not be accepted in the Service, as described below.</p>\r\n\r\n<h3>Photographic Imagery</h3>\r\n<p>The photographic imagery made available for display through the Service is provided under a nonexclusive, non-transferable license for use only by you. You may not use the imagery for any purpose other than as reference to add information as provided through the Service. You may not copy, modify or make derivative works of the imagery, in whole or in part. You also may not rent, disclose, publish, sell, assign, lease, sublicense, market, or transfer the imagery or any part thereof or use it in any manner not expressly authorized by the Terms of Service. By using the Service, you do not receive any, and Trimble MAPS and/or its licensors (if any) retain all ownership rights in the imagery. The imagery is copyrighted and may not be copied, even if modified or merged with other data or software.</p>\r\n\r\n<h3>User Submissions</h3>\r\n<p>When you sign into the Service, you may submit content in the manner permitted by the Service (referred to below as the \"User Submissions\"). You are solely responsible for your own User Submissions and the consequences of posting or publishing them.</p>\r\n<p>By submitting User Submissions to the Service, you give Trimble MAPS a perpetual, irrevocable, worldwide, royalty-free, and non-exclusive license to reproduce, adapt, modify, translate, publish, publicly perform, publicly display, distribute, and create derivative works of the User Submission. You confirm and warrant to Trimble MAPS that you own or have all of the necessary rights or permissions to grant this license. You also grant to end users of Trimble MAPS services the right to access and use, including the right to edit, the User Submissions as permitted under the applicable Trimble MAPS’ terms of service.</p>\r\n<p>Trimble MAPS does not endorse any User Submission or any content expressed therein, and Trimble MAPS expressly disclaims any and all liability in connection with User Submissions. Trimble MAPS does not permit copyright infringing activities and infringement of intellectual property rights through the Trimble MAPS services, and Trimble MAPS will remove all content and User Submissions if properly notified under the United States Digital Millennium Copyright Act or other applicable law that such content or User Submissions infringe a party's intellectual property rights. Trimble MAPS reserves the right to remove content and User Submissions without prior notice.</p>\r\n\r\n<h3>Appropriate Conduct and Prohibited Actions</h3>\r\n<p>You agree that you are responsible for your own conduct and content while using the Service, and are responsible for any consequences thereof. You agree to use the Service only for purposes that are legal, proper and in accordance with the Terms of Service. By way of example, and not as a limitation, you agree that when using the Service, you will not:</p>\r\n<ul>\r\n    <li>defame, abuse, harass, stalk, threaten or otherwise violate the legal rights (such as rights of privacy and publicity) of others;</li>\r\n    <li>upload, post, email, transmit or otherwise make available the name, address, phone number or email address of any individual, where that information was not made publicly available by that individual;</li>\r\n    <li>upload, post, email, transmit or otherwise make available any inappropriate, defamatory, infringing, obscene, or unlawful content;</li>\r\n    <li>upload, post, email, transmit or otherwise make available any content that is protected by any copyright, trademark, trade secret, patent or other proprietary right of any other party, unless you are the owner of the rights or have the legal permission of the owner to post such content;</li>\r\n    <li>create any submission such as a road, business, park, or similar point of interest that does not correspond to the imagery available in the Service;</li>\r\n    <li>create or label any submission such as a road, business, park or similar point of interest in a manner that you know, or should reasonably know, is inaccurate;</li>\r\n    <li>edit or modify any other user's submission in a manner that you know, or should reasonably know, is inaccurate;</li>\r\n    <li>upload, post, email or transmit or otherwise make available \"spam\", including messages that promote pyramid schemes, chain letters or disruptive commercial messages or advertisements, or anything else prohibited by law, these Terms of Service or any applicable policies or guidelines;</li>\r\n    <li>download any file posted by another that you know, or reasonably should know, that cannot be legally distributed in such manner; impersonate another person or entity, or falsify or delete any author attributions, legal or other proper notices or proprietary designations or labels of the origin or source of software or other material;</li>\r\n    <li>restrict or inhibit any other user from using and enjoying the Service;</li>\r\n    <li>use the Service for any illegal or unauthorized purpose; remove any copyright, trademark or other proprietary rights notices contained in or on the Service;</li>\r\n    <li>interfere with or disrupt Trimble MAPS services or servers or networks connected to Trimble MAPS services, or disobey any requirements, procedures, policies or regulations of networks connected to Trimble MAPS services, including the Service;</li>\r\n    <li>use any robot, spider, site search/retrieval application, or other device to retrieve or index any portion of Trimble MAPS services, including the Service, or collect information about users for any unauthorized purpose;</li>\r\n    <li>submit content that falsely expresses or implies that such content is sponsored or endorsed by Trimble MAPS;</li>\r\n    <li>promote or provide instructional information about illegal activities or promote physical harm or injury against any group or individual; or</li>\r\n    <li>transmit any viruses, worms, defects, Trojan horses, or any items of a destructive nature.</li>\r\n</ul>\r\n\r\n<p>International users agree to comply with their own local laws regarding online conduct and acceptable content, including laws regulating the export of data to the United States or your country of residence. While Trimble MAPS prohibits the conduct and content described above, you understand and agree that Trimble MAPS may or may not pre-screen User Submissions and other content and shall have the right (but not the obligation) in its sole discretion to pre-screen, refuse or remove any User Submissions or other content in connection with the Service.</p>\r\n\r\n\r\n<h3>Disclaimer</h3>\r\n<p>You acknowledge and agree that any content (including other User Submissions) made available or accessible through the Service is provided \"as is,\" and you agree to use it at your own risk. Trimble MAPS makes no guarantee, representation or warranty of any kind, express or implied, arising by law or otherwise, including but not limited to, content, quality, accuracy, completeness, reliability, fitness for a particular purpose, usefulness, or that the Service will be uninterrupted or error-free.</p>\r\n\r\n<h3>Indemnity</h3>\r\n<p>You agree to defend, indemnify and hold harmless Trimble MAPS and its subsidiaries, affiliates, officers, agents, employees, advertisers, syndication partners, API partners, strategic partners and users, from and against any third party claim or liability arising from or in any way related to (a) your use of Trimble MAPS services, including your upload of User Submissions to the Service; (b) your violation of these Terms of Service; or (c) any other action by you connected with the Trimble MAPS services; including in all cases above any liability or expense arising from all claims, losses, damages (actual and consequential), suits, judgments, litigation costs and attorneys' fees, of every kind and nature. Trimble MAPS will provide you with written notice of any claim or liability for which Trimble MAPS seeks indemnity.</p>\r\n<p></p>\r\n<p>Terms are effective as of September 2nd,  2019.</p>\r\n\r\n</div>";

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"list-group-item\" ng-model=\"vm.fixRoad\">\r\n    <div class=\"item-title cursor-pointer\" ng-click=\"vm.fixRoad = !vm.fixRoad\">\r\n        <!-- Start Translate -->\r\n        Fix an Existing Road\r\n        <!-- End Translate -->\r\n        <div class=\"expand-container pull-right\">\r\n            <div class=\"expand-button\" ng-class=\"{'open':vm.fixRoad}\"></div>\r\n        </div>\r\n    </div>\r\n    <div ng-show=\"vm.fixRoad\">\r\n        <ol>\r\n            <li>\r\n                <a href=\"#\" ng-click=\"vm.goToLocation()\">\r\n                    <!-- Start Translate -->\r\n                    Zoom to your current location,\r\n                    <!-- End Translate -->\r\n                </a>\r\n                <!-- Start Translate -->\r\n                or move the map and zoom in, or find a location by using\r\n                <!-- End Translate -->\r\n                <code class=\"cursor-pointer\" ng-click=\"vm.showSearch()\">\r\n                    <i class=\"ico ico-inline ico-search\"></i>\r\n                    <!-- Start Translate -->\r\n                    Search\r\n                    <!-- End Translate -->\r\n                </code>\r\n            </li>\r\n            <li>\r\n                <!-- Start Translate -->\r\n                Click on a road segment to select it and make changes\r\n                <!-- End Translate -->\r\n            </li>\r\n        </ol>\r\n    </div>\r\n</div>\r\n<div class=\"list-group-item\" ng-model=\"vm.addRoad\" ng-if=\"!userInfo.isEnterprise\">\r\n    <div class=\"item-title cursor-pointer\" ng-click=\"vm.addRoad = !vm.addRoad\">\r\n        <!-- Start Translate -->\r\n        Add a Missing Road\r\n        <!-- End Translate -->\r\n        <div class=\"expand-container pull-right\">\r\n            <div class=\"expand-button\" ng-class=\"{'open':vm.addRoad}\"></div>\r\n        </div>\r\n    </div>\r\n    <div ng-show=\"vm.addRoad\">\r\n        <ol>\r\n            <li>\r\n                <a href=\"#\" ng-click=\"vm.goToLocation()\">Zoom to your current location</a>, or move the map and zoom in, or find a location by using\r\n                <code class=\"cursor-pointer\" ng-click=\"vm.showSearch()\"><i class=\"ico ico-inline ico-search\"></i> Search</code>\r\n            </li>\r\n            <li>\r\n                <!-- Start Translate -->\r\n                Click on\r\n                <!-- End Translate -->\r\n\r\n                <code class=\"cursor-pointer\" ng-click=\"vm.drawLink()\" >\r\n                Add New Road\r\n                </code>\r\n\r\n                <!-- Start Translate -->\r\n                in the tool bar\r\n               <!-- End Translate -->\r\n            </li>\r\n            <li>\r\n                Click anywhere to begin and then draw the new road you wish to add\r\n            </li>\r\n            <li>Press <code>ESC</code> to cancel, <code>DEL</code> to undo, <code>double-click</code> or <code>ENTER</code> to finish</li>\r\n        </ol>\r\n    </div>\r\n</div>\r\n<div class=\"list-group-item\" ng-model=\"vm.fixAddress\" ng-if=\"false\">\r\n    <div class=\"item-title cursor-pointer\" ng-click=\"vm.fixAddress = !vm.fixAddress\">\r\n        Fix or Add an Address\r\n        <div class=\"expand-container pull-right\">\r\n            <div class=\"expand-button\" ng-class=\"{'open':vm.fixAddress}\"></div>\r\n        </div>\r\n    </div>\r\n    <div ng-show=\"vm.fixAddress\">\r\n        <ol>\r\n            <li>\r\n                Find an address using <code class=\"cursor-pointer\" ng-click=\"vm.showSearch()\"><i class=\"ico ico-inline ico-search\"></i> Search</code>, or <a href=\"#\" ng-click=\"vm.goToLocation()\">Zoom to your current location</a>, or move the map and zoom in\r\n            </li>\r\n            <li>\r\n                Select a search result or click on the map to edit an address\r\n            </li>\r\n        </ol>\r\n    </div>\r\n</div>\r\n<a class=\"list-group-item item-title cursor-pointer\" ng-click=\"vm.showEdits()\" ng-if=\"!userInfo.isEnterprise\">\r\n    View My Previous Edits\r\n</a>\r\n<a class=\"list-group-item item-title cursor-pointer\" ng-click=\"vm.showOverrides()\" ng-if=\"userInfo.isEnterprise\">\r\n    View Overrides List\r\n</a>";

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports = "<div ng-controller=\"startController as vm\">\r\n    <div class=\"panel panel-default panel-floating start-panel ng-cloak\" ng-cloak ng-hide=\"!vm.showStartPanel\">\r\n        <div class=\"panel-heading\">\r\n                <h4 class=\"panel-name\">\r\n                    <span translate=\"templates.start.title\"></span>\r\n                </h4>\r\n            <button class=\"btn btn-sm btn-default\" ng-click=\"vm.closeStartPanel()\" translate=\"common.Close\"></button>\r\n        </div>\r\n        <div class=\"panel-body\">\r\n            <!--<button id=\"start-search-btn\" class=\"btn btn-sm btn-default form-control search-btn\" ng-click=\"vm.showSearch()\">\r\n                <i class=\"ico ico-search\" ng-click=\"vm.showSearch()\"></i>\r\n                <span translate=\"common.Search\" ng-click=\"vm.showSearch()\">Search</span>\r\n                <span class=\"ico ico-chevron-right-thick pull-right\"></span>\r\n            </button>-->\r\n            <div class=\"list-group\">\r\n                <div ng-include=\"'/app/help/' + language + '/startPanelItems.html'\"></div>\r\n                <div class=\"checkbox\" style=\"margin: 5px 0 0 5px\">\r\n                    <label><input type=\"checkbox\" ng-model=\"vm.showOnStartup\" ng-change=\"vm.toggleStartup()\"><span translate=\"templates.start.startup\"></span></label>\r\n                </div>\r\n            </div>\r\n            \r\n        </div>\r\n    </div>\r\n</div>";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "web.config";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "favicon.ico";

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	"use strict";

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
554,
/* 223 */,
/* 224 */
554,
/* 225 */,
/* 226 */
/***/ (function(module, exports) {

	'use strict';
	
	ALKMaps.Control.CustomPlace = ALKMaps.Class(ALKMaps.Control, {
	  initialize: function initialize(options) {
	    this.handlerOptions = {
	      'single': true,
	      'double': false,
	      'pixelTolerance': 0,
	      'stopSingle': false,
	      'stopDouble': false
	    };
	    ALKMaps.Control.prototype.initialize.apply(this, arguments);
	    this.handler = new ALKMaps.Handler.Click(this, { 'click': this.trigger }, this.handlerOptions);
	  },
	  trigger: function trigger(e) {
	    this.addCustomPlace({ 'xy': e.xy, "callback": this.addCustomPlaceCB });
	  },
	  addCustomPlace: function addCustomPlace(param) {},
	  addCustomPlaceCB: function addCustomPlaceCB(param) {},
	  CLASS_NAME: "ALKMaps.Control.CustomPlace"
	});

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	"use strict";
	
	ALKMaps.Popup.AddressPopup = ALKMaps.Class(ALKMaps.Popup.SimplePopup, {
	  initialize: function initialize(id, lonlat, contentSize, contentHTML, offset, closeBox, closeCallback, cancelCallback, saveCallback) {
	    // this.id = ALKMaps.Util.createUniqueID(id + "_");
	    if (cancelCallback) {
	      this.cancelCallback = cancelCallback;
	    }
	    if (saveCallback) {
	      this.saveCallback = saveCallback;
	    }
	
	    ALKMaps.Popup.SimplePopup.prototype.initialize.apply(this, arguments);
	    var clickPopup = function clickPopup(e) {
	      if (e.target.id === "btnPopupCancel") {
	        // Hacking code. Need hard coded value.
	        this.cancelCallback(this);
	        ALKMaps.Event.stop(e);
	      } else if (e.target.id === "btnPopupSave") {
	        this.saveCallback(this);
	        ALKMaps.Event.stop(e);
	      }
	    };
	    ALKMaps.Event.observe(this.contentDiv, "touchend", ALKMaps.Function.bindAsEventListener(clickPopup, this));
	    ALKMaps.Event.observe(this.contentDiv, "click", ALKMaps.Function.bindAsEventListener(clickPopup, this));
	  },
	
	  cancelCallback: function cancelCallback(e) {
	    // console.log(e);
	  },
	
	  saveCallback: function saveCallback(e) {
	    // alert('save');
	  },
	
	  destroy: function destroy() {
	    ALKMaps.Event.stopObservingElement(this.contentDiv);
	    ALKMaps.Popup.SimplePopup.prototype.destroy.apply(this, arguments);
	  },
	
	  CLASS_NAME: "ALKMaps.Popup.AddressPopup"
	});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	"use strict";
	
	ALKMaps.Control.CustomPlaceDragFeature = ALKMaps.Class(ALKMaps.Control.DragFeature, {
	  initialize: function initialize(layer, options) {
	    ALKMaps.Control.DragFeature.prototype.initialize.apply(this, arguments);
	  },
	
	  onStart: function onStart(feature, pixel) {
	    var llPix = feature.layer.map.getViewPortPxFromLonLat(feature.lonlat);
	    var deltaX = llPix.x - pixel.x;
	    var deltaY = llPix.y - pixel.y;
	    feature.deltaXY = { x: deltaX, y: deltaY };
	  },
	
	  onDrag: function onDrag(feature, pixel) {
	    if (feature.popup) {
	      feature.popup.div.style.display = 'none';
	    }
	  },
	
	  CLASS_NAME: "ALKMaps.Control.CustomPlaceDragFeature"
	});

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	"use strict";
	
	ALKMaps.Control.NetworkSnapping = ALKMaps.Class(ALKMaps.Control.Snapping, {
	  considerSnapping: function considerSnapping(point, loc) {
	    var best = {
	      rank: Number.POSITIVE_INFINITY,
	      dist: Number.POSITIVE_INFINITY,
	      x: null, y: null,
	      _nodeAorB: null,
	      _origAttributes: null,
	      _tempAttributes: null
	    };
	    var snapped = false;
	    var result, target;
	    for (var i = 0, len = this.targets.length; i < len; ++i) {
	      target = this.targets[i];
	      result = this.testTarget(target, loc);
	      if (result) {
	        if (this.greedy) {
	          best = result;
	          best.target = target;
	          best._nodeAorB = result._nodeAorB;
	          best._origAttributes = result._origAttributes;
	          best._tempAttributes = result._tempAttributes;
	          snapped = true;
	          break;
	        } else {
	          if (result.rank < best.rank || result.rank === best.rank && result.dist < best.dist) {
	            best = result;
	            best.target = target;
	            best._nodeAorB = result._nodeAorB;
	            best._origAttributes = result._origAttributes;
	            best._tempAttributes = result._tempAttributes;
	            snapped = true;
	          }
	        }
	      }
	    }
	    if (snapped) {
	      var proceed = this.events.triggerEvent("beforesnap", {
	        point: point, x: best.x, y: best.y, distance: best.dist,
	        layer: best.target.layer, snapType: this.precedence[best.rank]
	      });
	      if (proceed !== false) {
	        point.x = best.x;
	        point.y = best.y;
	        this.point = point;
	        this.point._nodeAorB = best._nodeAorB;
	        this.point._origAttributes = best._origAttributes;
	        this.point._tempAttributes = best._tempAttributes;
	        this.events.triggerEvent("snap", {
	          point: point,
	          snapType: this.precedence[best.rank],
	          layer: best.target.layer,
	          distance: best.dist
	        });
	      } else {
	        snapped = false;
	      }
	    }
	    if (this.point && !snapped) {
	      point.x = loc.x;
	      point.y = loc.y;
	      this.point = null;
	      this.events.triggerEvent("unsnap", { point: point });
	    }
	  },
	
	  testTarget: function testTarget(target, loc) {
	    var resolution = this.layer.map.getResolution();
	    if ("minResolution" in target) {
	      if (resolution < target.minResolution) {
	        return null;
	      }
	    }
	    if ("maxResolution" in target) {
	      if (resolution >= target.maxResolution) {
	        return null;
	      }
	    }
	    var tolerance = {
	      node: this.getGeoTolerance(target.nodeTolerance, resolution),
	      vertex: this.getGeoTolerance(target.vertexTolerance, resolution),
	      edge: this.getGeoTolerance(target.edgeTolerance, resolution)
	    };
	    // this could be cached if we don't support setting tolerance values directly
	    var maxTolerance = Math.max(tolerance.node, tolerance.vertex, tolerance.edge);
	    var result = {
	      rank: Number.POSITIVE_INFINITY, dist: Number.POSITIVE_INFINITY
	    };
	    var eligible = false;
	    var features = target.layer.features;
	    var feature, type, vertices, vertex, closest, dist, found;
	    var numTypes = this.precedence.length;
	    var ll = new ALKMaps.LonLat(loc.x, loc.y);
	    for (var i = 0, len = features.length; i < len; ++i) {
	      feature = features[i];
	      if (feature !== this.feature && !feature._sketch && feature.state !== ALKMaps.State.DELETE && (!target.filter || target.filter.evaluate(feature))) {
	        if (feature.atPoint(ll, maxTolerance, maxTolerance)) {
	          for (var j = 0, stop = Math.min(result.rank + 1, numTypes); j < stop; ++j) {
	            type = this.precedence[j];
	            if (target[type]) {
	              if (type === "edge") {
	                closest = feature.geometry.distanceTo(loc, { details: true });
	                dist = closest.distance;
	                if (dist <= tolerance[type] && dist < result.dist) {
	                  result = {
	                    rank: j, dist: dist,
	                    x: closest.x0, y: closest.y0, // closest coords on feature
	                    _nodeAorB: null,
	                    _origAttributes: feature._origAttributes,
	                    _tempAttributes: feature._tempAttributes
	                  };
	                  // console.log(feature);
	                  eligible = true;
	                  // don't look for lower precedence types for this feature
	                  break;
	                }
	              } else {
	                // look for nodes or vertices
	                vertices = feature.geometry.getVertices(type === "node");
	                found = false;
	                for (var k = 0, klen = vertices.length; k < klen; ++k) {
	                  vertex = vertices[k];
	                  dist = vertex.distanceTo(loc);
	                  if (dist <= tolerance[type] && (j < result.rank || j === result.rank && dist < result.dist)) {
	                    result = {
	                      rank: j, dist: dist,
	                      x: vertex.x, y: vertex.y,
	                      _nodeAorB: k,
	                      _origAttributes: feature._origAttributes,
	                      _tempAttributes: feature._tempAttributes
	                    };
	                    eligible = true;
	                    found = true;
	                  }
	                }
	                if (found) {
	                  // don't look for lower precedence types for this feature
	                  break;
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	    return eligible ? result : null;
	  },
	
	  CLASS_NAME: "ALKMaps.Control.NetworkSnapping"
	});

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	"use strict";
	
	ALKMaps.Control.YardSnapping = ALKMaps.Class(ALKMaps.Control.Snapping, {
	
	  CLASS_NAME: "ALKMaps.Control.YardSnapping"
	});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	"use strict";
	
	ALKMaps.Control.YardGateDragFeature = ALKMaps.Class(ALKMaps.Control.DragFeature, {
	  initialize: function initialize(layer, options) {
	    ALKMaps.Control.DragFeature.prototype.initialize.apply(this, arguments);
	    this.handlers.feature.featureAttributesFilter = this.featureAttributesFilter;
	  },
	
	  CLASS_NAME: "ALKMaps.Control.YardGateDragFeature"
	});

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	"use strict";
	
	/*
	    * This class inherits DrawFeature control. It adds a keyboard handler to manage ESCAPE
	    * and DELETE key press.
	    */
	ALKMaps.Control.DrawFeatureOpt = ALKMaps.Class(ALKMaps.Control.DrawFeature, {
	  handlers: null,
	  initialize: function initialize(layer, handler, options) {
	    ALKMaps.Control.DrawFeature.prototype.initialize.apply(this, [layer, handler, options]);
	    // configure the keyboard handler
	    var keyboardOptions = {
	      keydown: this.handleKeypress
	    };
	    this.handlers = {
	      keyboard: new ALKMaps.Handler.Keyboard(this, keyboardOptions)
	    };
	  },
	  handleKeypress: function handleKeypress(param) {},
	  activate: function activate(param) {},
	  deactivate: function deactivate(param) {},
	
	  CLASS_NAME: "ALKMaps.Control.DrawFeatureOpt"
	});

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	"use strict";
	
	// this is in its own file (and removed from app.js) so our unit test configuration can exclude it
	angular.module("fleetviewApp").config(["$translateProvider", "alkTranslationLoaderProvider", function ($translateProvider, alkTranslationLoaderProvider) {
	  alkTranslationLoaderProvider.$get().load($translateProvider);
	}]);

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("alk.services", []);
	
	  angular.module("alk.services").provider("Messages", function () {
	    var broadcastType = "ngRoute";
	
	    this.setBroadcastType = function (broadcast) {
	      //  only supports ui.router or ngRoute for the moment
	      broadcastType = broadcast;
	
	      //  fall back to ngRoute if something weird is specified
	      if (broadcastType !== "ngRoute" && broadcastType !== "ui.router") broadcastType = "ngRoute";
	    };
	
	    this.$get = ["$rootScope", "$timeout", "_", "$injector", function ($rootScope, $timeout, _, $injector) {
	      var allMessages = [];
	      var messagesToDisplay = [];
	      var currentMessageId = 0;
	
	      function handleRouteChange() {
	        messagesToDisplay = [];
	
	        for (var i = 0; i < allMessages.length; i++) {
	          if (allMessages[i].showOnNextPage === true) {
	            messagesToDisplay.push(allMessages[i]);
	          }
	        }
	
	        // remove all the items from all messages that we are going to display on this page.
	        allMessages = _.filter(allMessages, function (message) {
	          return message.showOnNextPage !== true;
	        });
	      }
	
	      if (broadcastType === "ui.router") {
	        $injector.get("$transitions").onSuccess({}, handleRouteChange);
	      } else if (broadcastType === "ngRoute") {
	        $rootScope.$on("$routeChangeSuccess", handleRouteChange);
	      }
	
	      return {
	        add: function add(type, message, options) {
	          options = options || {};
	
	          var onlyDisplayOne = options.onlyDisplayOne == null || options.onlyDisplayOne === true; // can use == with null because it means null or undefined
	          var showOnNextPage = options.showOnNextPage == null || options.showOnNextPage === true;
	          var deleteAfterTimeout = options.deleteAfterTimeout || false;
	          var messageObj;
	
	          if (showOnNextPage === true) {
	            messageObj = _.find(allMessages, {
	              message: message
	            });
	          } else {
	            messageObj = _.find(messagesToDisplay, {
	              message: message
	            });
	          }
	
	          if (messageObj && onlyDisplayOne === true) {
	            messageObj.number++;
	          } else {
	            messageObj = {
	              type: type,
	              message: message,
	              number: 1,
	              showOnNextPage: showOnNextPage,
	              deleteAfterTimeout: deleteAfterTimeout,
	              id: currentMessageId
	            };
	
	            if (_.isNumber(messageObj.deleteAfterTimeout)) {
	              setTimeout(function () {
	                if (messageObj.showOnNextPage === true) {
	                  allMessages = _.reject(allMessages, function (m) {
	                    return m.id === messageObj.currentMessageId;
	                  });
	                } else {
	                  messagesToDisplay = _.reject(messagesToDisplay, function (m) {
	                    return m.id === messageObj.currentMessageId;
	                  });
	                }
	              }, messageObj.deleteAfterTimeout);
	            }
	
	            currentMessageId++;
	
	            if (messageObj.showOnNextPage === true) {
	              allMessages.push(messageObj);
	            } else {
	              messagesToDisplay.push(messageObj);
	            }
	          }
	        },
	        getMessages: function getMessages() {
	          return messagesToDisplay;
	        },
	        clear: function clear() {
	          messagesToDisplay = [];
	        }
	      };
	    }];
	  });
	})(window.angular);

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	    "use strict";
	
	    angular.module("alk.services").service("GeoParser", [function () {
	
	        function convertCompassToLatLon(degree1, compass1, degree2, compass2) {
	            // normalize degrees to use - when referring to West or South compass directions
	            if (compass1 === "W" || compass1 === "S") {
	                degree1 = "-" + degree1;
	            }
	
	            if (compass2 === "W" || compass2 === "S") {
	                degree2 = "-" + degree2;
	            }
	
	            if ((compass1 === "W" || compass1 === "E") && (compass2 === "N" || compass2 === "S")) {
	                return { lat: Number(degree2), lon: Number(degree1) };
	            } else if ((compass1 === "N" || compass1 === "S") && (compass2 === "W" || compass2 === "E")) {
	                return { lat: Number(degree1), lon: Number(degree2) };
	            } else {
	                return {};
	            }
	        }
	
	        function getLatLon(input) {
	            // cleanup input by removing explicit + sign
	            input = input.replace("+", "");
	            var latlon;
	            var searchll;
	            var matches;
	
	            // matches positive decimal followed by compass direction, with comma or spaces following by the same thing
	            var regexCompassPost = /^(\d+.{0,1}\d+)\s*([NSEW])[\s,]+(\d+.{0,1}\d+)\s*([NSEW])$/;
	
	            // matches compass direction followed by decimal, with comma or spaces, followed by the same thing
	            var regexCompassPre = /^([NSEW])\s*(\d+.{0,1}\d+)[\s,]+([NSEW])\s*(\d+.{0,1}\d+)$/;
	
	            if (matches = input.match(regexCompassPost)) {
	                latlon = convertCompassToLatLon(matches[1], matches[2], matches[3], matches[4]);
	            } else if (matches = input.match(regexCompassPre)) {
	                latlon = convertCompassToLatLon(matches[2], matches[1], matches[4], matches[3]);
	            } else if ((searchll = input.split(/[\s,]+/)).length === 2) {
	                //todo: if they can both be parsed as floats return them as lat/lon, otherwise null.
	                latlon = { lat: Number(searchll[0]), lon: Number(searchll[1]) };
	            } else {
	                return null;
	            }
	
	            if (Math.abs(latlon.lat) < 90 && Math.abs(latlon.lon) < 180) {
	                return latlon;
	            }
	
	            return null;
	        }
	
	        var parseCity = function parseCity(strAddr) {
	            var pTxt = strAddr.trim();
	            var pObj = {
	                city: "",
	                state: "",
	                zip: "",
	                error: 0,
	                errorTxt: ""
	            };
	            if (pTxt !== null) {
	                pTxt = pTxt.replace(/,/g, " ");
	                pTxt = pTxt.replace(/\s{2,}/g, " ");
	                var pVals = pTxt.split(" ");
	                //console.log(pVals);
	
	                var stateMarker = pVals.length;
	
	                //test last 'word' or two for zip or postcode
	                if (pVals[pVals.length - 1].match(/^\d{1,5}$|^\d{5}-\d{1,4}$|^[A-Za-z]\d[A-Za-z][-]?\d[A-Za-z]\d$/) !== null) {
	                    if (pVals[pVals.length - 1].match(/^[A-Za-z]\d[A-Za-z][-]\d[A-Za-z]\d$/) !== null) {
	                        //strip hypen from postcode if necessary
	                        pObj.zip = pVals[pVals.length - 1].replace("-", "");
	                    } else {
	                        pObj.zip = pVals[pVals.length - 1];
	                        stateMarker = pVals.length - 1;
	                    }
	                } else if (pVals.length > 1 && pVals[pVals.length - 2].match(/^[A-Za-z]\d[A-Za-z]$/) !== null && pVals[pVals.length - 1].match(/^\d[A-Za-z]\d$/) !== null) {
	                    pObj.zip = pVals[pVals.length - 2] + pVals[pVals.length - 1];
	                    stateMarker = pVals.length - 2;
	                }
	
	                //walk the 'words' backwards and test for US or Canada State/province.  Need to add MX and EU codes
	                for (var p = pVals.length - 1; p >= 0; p--) {
	                    if (_.find(STATES, { abbreviation: pVals[p].toUpperCase() }) !== undefined) {
	                        //if (typeof (states[pVals[p].toUpperCase()]) != "undefined") {
	                        pObj.state = pVals[p];
	                        stateMarker = p;
	                        break;
	                    }
	                }
	
	                if (!(pObj.zip !== "" && pVals.length === 1)) {
	                    for (var z = 0; z < stateMarker; z++) {
	                        if (typeof pVals[z] !== "undefined") {
	                            pObj.city += pVals[z] + " ";
	                        }
	                    }
	                    pObj.city = pObj.city.trim();
	                }
	            }
	            if (pObj.zip === "" && pObj.city === "") {
	                pObj.error = 1;
	                pObj.errorTxt = $translate.instant("controllers.searchController.NoZipOrCity");
	            }
	            return pObj;
	        };
	
	        return {
	            getLatLon: getLatLon,
	            parseCity: parseCity
	        };
	    }]);
	})(window.angular);

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("alk.directives", ["alk.services", "alk.filters"]);
	
	  angular.module("alk.directives").directive("onlyDigits", function () {
	
	    return {
	      restrict: "A",
	      require: "ngModel",
	      link: function link(scope, element, attrs, ctrl) {
	        function inputValue(val) {
	          if (val) {
	            var digits = val.replace(/[^0-9]/g, '');
	
	            if (digits !== val) {
	              ctrl.$setViewValue(digits);
	              ctrl.$render();
	            }
	            return parseInt(digits, 10);
	          }
	          return undefined;
	        }
	        ctrl.$parsers.push(inputValue);
	      }
	    };
	  });
	
	  angular.module("alk.directives").directive("alkInteger", function () {
	    return {
	      require: "ngModel",
	      link: function link(scope, elm, attrs, ctrl) {
	        var INTEGER_REGEXP = /^\d+$/;
	
	        function integerValidation(val) {
	          if (!val || INTEGER_REGEXP.test(val)) {
	            ctrl.$setValidity("pcmInteger", true);
	            return val;
	          } else {
	            ctrl.$setValidity("pcmInteger", false);
	            return undefined;
	          }
	        }
	
	        ctrl.$parsers.unshift(integerValidation);
	        ctrl.$formatters.unshift(integerValidation);
	      }
	    };
	  });
	
	  angular.module("alk.directives").directive("copyrightText", copyrightText);
	
	  copyrightText.$inject = ["$compile"];
	  function copyrightText($compile) {
	    return {
	      scope: {
	        type: "@"
	      },
	      restrict: "AE",
	      replace: true,
	      link: function link(scope, elem, attrs) {
	        // jshint ignore:line
	        var templates = {
	          Default: "<span class=\"copyright-text\">Copyright &copy; <a target=\"_blank\" href=\"https://maps.trimble.com\">Trimble, Inc.</a> 1986-{{year}}</span>",
	          WebUI: "<span class=\"copyright-text\">Copyright &copy; 2010-{{year}} Trimble, Inc. All Rights Reserved.</span>"
	        };
	        scope.year = new Date().getFullYear();
	        var html = "";
	        if (scope.type === "WebUI") {
	          html = templates.WebUI;
	        } else {
	          html = templates.Default;
	        }
	        elem.replaceWith($compile(html)(scope));
	      }
	    };
	  };
	
	  angular.module("alk.directives").directive("alkEmail", function () {
	    var REGEX_EMAIL = /^([\w!#$%&"*+\/=?^_`{|}~.-]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,3})(\]?)$/;
	
	    return {
	      restrict: "A",
	      require: "ngModel",
	      link: function link(scope, element, attrs, ngModel) {
	        ngModel.$validators.alkEmail = function (modelValue) {
	          if (modelValue === null || modelValue === "") {
	            return true;
	          }
	          return REGEX_EMAIL.test(modelValue);
	        };
	      }
	    };
	  });
	
	  angular.module("alk.directives").directive("alkCompare", function () {
	    var d = {
	      restrict: "A",
	      require: "ngModel",
	      scope: {},
	      link: function link(scope, element, attr, control) {
	        scope.$watch("alkCompare", function () {
	          control.$validate();
	        });
	
	        control.$validators.alkCompare = function (modelValue, viewValue) {
	          var value = modelValue || viewValue;
	          var other = scope.alkCompare;
	          return value === other;
	        };
	      }
	    };
	
	    d.scope.alkCompare = "=";
	
	    return d;
	  });
	
	  angular.module("alk.directives").directive("alkSubmit", ["$parse", "$timeout", function ($parse, $timeout) {
	    return {
	      restrict: "A",
	      require: ["form"],
	      link: function link(scope, element, attrs, controllers) {
	        var formController = controllers[0];
	        var fn = $parse(attrs.alkSubmit);
	        var submitIfFn;
	
	        if (attrs.alkSubmitIf) {
	          submitIfFn = $parse(attrs.alkSubmitIf);
	        }
	
	        formController.shouldSubmit = function (event) {
	          if (typeof submitIfFn === "function" && submitIfFn(scope, {
	            $event: event
	          }) === false) {
	            return false;
	          }
	
	          return true;
	        };
	
	        formController.needsAttention = function (field) {
	          return field.$invalid && formController.submitted;
	        };
	
	        formController.setSubmitted = function (val) {
	          formController.submitted = val;
	          if (!scope.$$phase) scope.$apply();
	        };
	
	        element.bind("submit", function (event) {
	          if (formController.shouldSubmit(event) === false) {
	            return;
	          }
	
	          formController.setSubmitted(true);
	
	          if (!scope.$$phase) scope.$apply();
	
	          if (!formController.$valid) return false;
	
	          $timeout(function () {
	            formController.setSubmitted(false);
	            fn(scope, {
	              $event: event
	            });
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module("alk.directives").directive("alkMessages", ["Messages", "_", function (Messages, _) {
	
	    var templateString = "<div id=\"messages\">" + "<div class=\"alert alert-{{ message.type }}\" ng-repeat=\"message in messages\">" + "<a class=\"close\" ng-click=\"closeMessage(message)\" data-dismiss=\"alert\">&times;</a>" + "<span ng-bind-html=\"message.message | unsafe\"></span>" + "</div>" + "</div>";
	
	    return {
	      restrict: "E",
	      template: templateString,
	      scope: {},
	      controller: ["$scope", function ($scope) {
	        var messages = Messages.getMessages();
	
	        for (var i = 0; i < messages.length; i++) {
	          messages[i].read = true;
	        }
	        $scope.messages = messages;
	
	        $scope.closeMessage = function (message) {
	          message.closed = true;
	          var index = $scope.messages.indexOf(message);
	          $scope.messages.splice(index, 1);
	        };
	
	        $scope.$watchCollection(function () {
	          return Messages.getMessages();
	        }, function (messages) {
	          for (var j = 0; j < messages.length; j++) {
	            messages[j].read = true;
	          }
	          $scope.messages = messages;
	        });
	      }],
	      link: function link(scope, element, attrs) {}
	    };
	  }]);
	
	  angular.module("alk.directives").directive("alkAutofocus", ["$timeout", "$parse", function ($timeout, $parse) {
	    return {
	      restrict: "A",
	      link: function link($scope, $element, attrs) {
	        if (attrs.alkAutofocus === "" || $parse(attrs.alkAutofocus)($scope)) {
	          $timeout(function () {
	            $element[0].focus();
	          });
	        }
	      }
	    };
	  }]);
	
	  angular.module("alk.directives").directive("alkDisabled", [function () {
	    return {
	      restrict: "A",
	      scope: {
	        alkDisabled: "="
	      },
	      controller: ["$scope", function ($scope) {
	        this.getDisabled = function () {
	          return $scope.alkDisabled;
	        };
	      }]
	    };
	  }]);
	
	  var disabledInputDirective = [function () {
	    return {
	      restrict: "E",
	      require: "?^alkDisabled",
	      link: function link($scope, $element, attrs, alkDisableController) {
	        if (!alkDisableController) return;
	
	        $scope.$watch(function () {
	          return alkDisableController.getDisabled();
	        }, function (newValue, oldValue) {
	          if (newValue === true) {
	            $element.attr("disabled", "disabled");
	          } else {
	            $element.removeAttr("disabled");
	          }
	        }, true);
	      }
	    };
	  }];
	
	  angular.module("alk.directives").directive("button", disabledInputDirective).directive("select", disabledInputDirective).directive("input", disabledInputDirective);
	
	  var mapsInputDirective = ["$rootScope", function ($rootScope) {
	    return {
	      restrict: "E",
	      require: "?^alkmap",
	      link: function link($scope, $element, attrs, alkMapController) {
	        if (!alkMapController) {
	          $element.on("focus", function () /* event */{
	            $rootScope.$broadcast("MapInputFocus", $element);
	          });
	
	          $element.on("blur", function () {
	            $rootScope.$broadcast("MapInputBlur", $element);
	          });
	        }
	      }
	    };
	  }];
	
	  angular.module("alk.directives").directive("input", mapsInputDirective).directive("textarea", mapsInputDirective);
	
	  angular.module("alk.directives").directive("alkmapsInput", ["$rootScope", function alkmapsInput($rootScope) {
	    function link(scope, element /*, attrs */) {
	      element.on("focus", function () /* event */{
	        $rootScope.$broadcast("MapInputFocus", element);
	      });
	
	      element.on("blur", function () {
	        $rootScope.$broadcast("MapInputBlur", element);
	      });
	    }
	
	    var directive = {
	      link: link,
	      restrict: "A",
	      scope: {}
	    };
	
	    return directive;
	  }]);
	
	  angular.module("alk.directives").directive("includeReplace", function () {
	    return {
	      require: "ngInclude",
	      restrict: "A",
	      link: function link(scope, el, attrs) {
	        el.replaceWith(el.children());
	      }
	    };
	  });
	})();

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(238);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	  "use strict";
	
	  angular.module("alk.filters", []);
	
	  angular.module("alk.filters").filter("fullAddressFilter", [function () {
	    //return an HTML string from an ALK Address result
	    // eslint-disable-next-line complexity
	    return function (address, returnHtml, linebreaks) {
	      returnHtml = returnHtml || false;
	      linebreaks = linebreaks || false;
	      var addrStr = "";
	      var br = void 0;
	      if (!linebreaks) {
	        br = ", ";
	      } else if (returnHtml) {
	        br = "<br>";
	      } else {
	        br = "\n";
	      }
	
	      if (address.City !== "" && address.City !== null && address.City !== undefined) {
	        addrStr += address.City;
	      }
	      if (address.State !== "" && address.State !== null && address.State !== undefined) {
	        addrStr += ", " + address.State;
	      }
	      if (address.Zip !== "" && address.Zip !== null && address.Zip !== undefined) {
	        addrStr += ", " + address.Zip;
	      }
	      if (address.Country !== "" && address.Country !== null && address.Country !== undefined && address.Country !== "United States") {
	        addrStr += ", " + address.Country;
	      }
	
	      if (returnHtml) {
	        if (address.StreetAddress !== "" && address.StreetAddress !== null && address.StreetAddress !== undefined) {
	          addrStr = "<strong>" + address.StreetAddress + "</strong>" + (br + addrStr);
	        }
	        if (address.SPLC !== "" && address.SPLC !== null && address.SPLC !== undefined) {
	          addrStr = "<strong>" + address.SPLC + "</strong>" + (br + addrStr);
	        }
	      } else {
	        if (address.StreetAddress !== "" && address.StreetAddress !== null && address.StreetAddress !== undefined) {
	          addrStr = address.StreetAddress + br + addrStr;
	        }
	        if (address.SPLC !== "" && address.SPLC !== null && address.SPLC !== undefined) {
	          addrStr = address.SPLC + br + addrStr;
	        }
	      }
	
	      return addrStr;
	    };
	  }]);
	
	  // format output from Links service
	  angular.module("alk.filters").filter("getRouteName", function () {
	    return function (props, index) {
	      var routeName = "";
	      var routenums;
	      if (!index) index = 0;
	      if (props.routenums) {
	        routenums = props.routenums;
	      } else {
	        routenums = props;
	      }
	      if (typeof routenums === "string") JSON.parse(routenums);
	      if (routenums !== "") {
	        if (routenums[index].category) routeName += " " + routenums[index].category;
	        if (routenums[index].rtnum) routeName += " " + routenums[index].rtnum;
	        if (routenums[index].modifier) routeName += " " + routenums[index].modifier;
	        if (routenums[index].alpha) routeName += " " + routenums[index].alpha;
	        if (routenums[index].compass) routeName += " " + routenums[index].compass;
	      }
	      return routeName;
	    };
	  });
	
	  angular.module("alk.filters").filter("concatName", function () {
	    return function (names, index) {
	      var fullName = "";
	      if (typeof names === "string") JSON.parse(names);
	      if (names !== "" && names.length > 0) {
	        if (names[index].prefix) fullName += " " + names[index].prefix.abbreviation;
	        fullName += " " + names[index].name;
	        if (names[index].type) fullName += " " + names[index].type.description;
	        if (names[index].suffix) fullName += " " + names[index].suffix.abbreviation;
	      }
	      return fullName;
	    };
	  });
	
	  angular.module("alk.filters").filter("getFullName", getFullName);
	
	  getFullName.$inject = ["concatNameFilter", "getRouteNameFilter"];
	  function getFullName(concatNameFilter, getRouteNameFilter) {
	    return function (props, index) {
	      if (_.isUndefined(props) || _.isNull(props)) {
	        return "";
	      } else {
	        if (!index) index = 0;
	        var fullName = "";
	        if (props.names != null && props.names.length > 0) {
	          // jshint ignore:line
	          var names = props.names;
	          fullName = concatNameFilter(names, index);
	        } else if (props.routenums != null && props.routenums.length > 0) {
	          // jshint ignore:line
	          fullName = getRouteNameFilter(props, index);
	        } else {
	          var names = props;
	          fullName = concatNameFilter(names, index);
	        }
	        if (fullName === "") fullName = "Unnamed";
	        return fullName;
	      }
	    };
	  };
	
	  angular.module("alk.filters").filter("coordsToCardinal", function () {
	    return function (coords, index) {
	      var outputStr = "";
	      var xCardinal, yCardinal;
	      if (typeof coords !== "undefined") {
	        xCardinal = parseFloat(coords.Lon) > 0 ? " E" : " W";
	        yCardinal = parseFloat(coords.Lat) > 0 ? " N" : " S";
	        outputStr = coords.Lat + yCardinal + ", " + coords.Lon + xCardinal;
	      }
	      return outputStr;
	    };
	  });
	
	  angular.module("alk.filters").filter("hexToRGBa", function () {
	    return function (hex, alpha) {
	      var r = parseInt(hex.slice(1, 3), 16),
	          g = parseInt(hex.slice(3, 5), 16),
	          b = parseInt(hex.slice(5, 7), 16);
	
	      if (alpha) {
	        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
	      } else {
	        return "rgb(" + r + ", " + g + ", " + b + ")";
	      }
	    };
	  });
	
	  angular.module("alk.filters").filter("propsFilter", function () {
	    return function (items, props) {
	      var out = [];
	
	      if (angular.isArray(items)) {
	        items.forEach(function (item) {
	          var itemMatches = false;
	
	          var keys = (0, _keys2.default)(props);
	          for (var i = 0; i < keys.length; i++) {
	            var prop = keys[i];
	            var text = props[prop].toLowerCase();
	            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
	              itemMatches = true;
	              break;
	            }
	          }
	
	          if (itemMatches) {
	            out.push(item);
	          }
	        });
	      } else {
	        // Let the output be the input untouched
	        out = items;
	      }
	
	      return out;
	    };
	  });
	
	  angular.module("alk.filters").filter("unsafe", ["$sce", function ($sce) {
	    return $sce.trustAsHtml;
	  }]);
	
	  angular.module("alk.filters").filter("minmax", function () {
	    return function (arr, min, max, incr) {
	      min = parseInt(min);
	      max = parseInt(max);
	      incr = parseInt(incr) || 1;
	      for (var i = min; i <= max; i += incr) {
	        arr.push(i);
	      }
	      return arr;
	    };
	  });
	})();

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(239), __esModule: true };

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240);
	module.exports = __webpack_require__(31).Object.keys;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(66);
	var $keys = __webpack_require__(50);
	
	__webpack_require__(241)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(29);
	var core = __webpack_require__(31);
	var fails = __webpack_require__(40);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.translations", ["pascalprecht.translate", "tmh.dynamicLocale", "ngCookies"]);
	})(window.angular);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(238);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module("alk.translations").constant("LOCALES", {
	  "locales": {
	    "en_US": "English"
	    // "es_ES": "Espanol",
	    // "de_DE": "Deutsch"
	  }
	});
	
	angular.module("alk.translations").service("alkLocaleService", ["$translate", "LOCALES", "$rootScope", "tmhDynamicLocale", "$http", "$templateCache", function ($translate, LOCALES, $rootScope, tmhDynamicLocale, $http, $templateCache) {
	  "use strict";
	  // VARS
	
	  var localesObj = LOCALES.locales;
	
	  // locales and locales display names
	  var _LOCALES = (0, _keys2.default)(localesObj);
	  if (!_LOCALES || _LOCALES.length === 0) {
	    console.error("There are no _LOCALES provided");
	  }
	  var _LOCALES_DISPLAY_NAMES = [];
	  _LOCALES.forEach(function (locale) {
	    _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
	  });
	
	  var currentLocale = $translate.proposedLanguage() || $translate.use();
	
	  // on initial load of the app, make sure to set the custom alk-language header as well as update the html attribute to be correct as per the language currently showing.
	  $http.defaults.headers.common["ALK-Language"] = currentLocale;
	  document.documentElement.setAttribute("lang", currentLocale);
	
	  // METHODS
	  var checkLocaleIsValid = function checkLocaleIsValid(locale) {
	    return _LOCALES.indexOf(locale) !== -1;
	  };
	
	  var setLocale = function setLocale(locale) {
	    if (!checkLocaleIsValid(locale)) {
	      console.error("Locale name '" + locale + "' is invalid");
	      return;
	    }
	    startLoadingAnimation();
	    currentLocale = locale;
	    $translate.use(locale);
	  };
	
	  /**
	   * Stop application loading animation when translations are loaded
	   */
	  var $html = angular.element("html");
	  var LOADING_CLASS = "app-loading";
	
	  function startLoadingAnimation() {
	    $html.addClass(LOADING_CLASS);
	  }
	
	  function stopLoadingAnimation() {
	    $html.removeClass(LOADING_CLASS);
	  }
	
	  // EVENTS
	  $rootScope.$on("$translateChangeSuccess", function (event, data) {
	    document.documentElement.setAttribute("lang", data.language); // sets "lang" attribute to html
	    $http.defaults.headers.common["ALK-Language"] = data.language;
	
	    // this ensures that any pages that were using language specific view are no longer cached. example of this is the terms of use template
	    // TODO: come up with more robust way to remove all [[language]] templates
	    $templateCache.remove("templates/[[language]]/terms.html");
	
	    tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, "-")); // load Angular locale
	  });
	
	  $rootScope.$on("$localeChangeSuccess", function (e, locale) {
	    stopLoadingAnimation();
	  });
	
	  return {
	    getLocaleDisplayName: function getLocaleDisplayName() {
	      return localesObj[currentLocale];
	    },
	    setLocaleByDisplayName: function setLocaleByDisplayName(localeDisplayName) {
	      setLocale(_LOCALES[_LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName) // get locale index
	      ]);
	    },
	    getLocalesDisplayNames: function getLocalesDisplayNames() {
	      return _LOCALES_DISPLAY_NAMES;
	    }
	  };
	}]);

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	"use strict";
	
	var app = angular.module("alk.translations");
	
	app.factory("alkTranslationLoader", [function () {
	
	  function load($translateProvider) {
	    //Turn this on during debugging to get console warnings when translations are missing
	    $translateProvider.useMissingTranslationHandlerLog();
	
	    $translateProvider.useStaticFilesLoader({
	      //Put common first so that app-specific overrides for same translation string
	      files: [{
	        prefix: "/resources/common/",
	        suffix: ".json"
	      }, {
	        prefix: "/resources/",
	        suffix: ".json"
	      }]
	    }).registerAvailableLanguageKeys(["en_US", "es_ES", "de_DE"], {
	      "en-US": "en_US",
	      "es-ES": "es_ES",
	      "de-DE": "de_DE",
	      "en": "en_US",
	      "es": "es_ES",
	      "de": "de_DE"
	    }).determinePreferredLanguage(function () {
	      // if a language is not explicitely set by the user, it uses the language returned from the html "lang" attribute.  This is set on the serverside based on the Accept-Language request header.
	      var lang = document.getElementsByTagName("html")[0].lang;
	      return lang;
	    }).fallbackLanguage("en_US");
	
	    $translateProvider.useSanitizeValueStrategy("escapeParameters");
	
	    $translateProvider.useLocalStorage();
	  }
	
	  return {
	    load: load
	  };
	}]);

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("alk.translations").directive("alkLanguageSelect", ["alkLocaleService", function (alkLocaleService) {
	    return {
	      replace: true,
	      restrict: "A",
	      template: "" + "<div class=\"language-select\" ng-if=\"visible\">" + "<select class=\"form-control\" ng-model=\"currentLocaleDisplayName\"" + "ng-options=\"localesDisplayName for localesDisplayName in localesDisplayNames\"" + "ng-change=\"changeLanguage(currentLocaleDisplayName)\">" + "</select>" + "</div>" + "",
	      controller: ["$scope", function ($scope) {
	        $scope.currentLocaleDisplayName = alkLocaleService.getLocaleDisplayName();
	        $scope.localesDisplayNames = alkLocaleService.getLocalesDisplayNames();
	
	        //  don't show if there's one or less languages available for select
	        $scope.visible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;
	
	        $scope.changeLanguage = function (locale) {
	          alkLocaleService.setLocaleByDisplayName(locale);
	        };
	      }]
	    };
	  }]);
	})(window.angular);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.authentication", []);
	})(window.angular);
	
	__webpack_require__(247);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(102);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperties = __webpack_require__(248);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @typedef {Object} alkAuthenticationService
	 * @property {Function} logout
	 * @property {Function} validate
	 * @property {Function} forgotPassword
	 * @property {Function} resetPassword
	 * @property {Function} changePassword
	 * @property {Function} acceptTerms
	 */
	
	(function () {
	  "use strict";
	
	  angular.module("alk.authentication")
	  /** @name alk.authentication.config
	   * @ngdoc constant
	   * @description Provides configuration settings for the [alkAuthenticationService](alk.authentication.alkAuthenticationService.html) service.
	   * @example
	   * app.config(["alkAuthenticationServiceProvider", "alk.authentication.config", function (authProvider, authConfig) {
	   *   // set up authentication provider
	   *   authProvider.dataAnywhereUrl = config.daUrl;
	   *   authConfig.applicationUrl = config.mapsureUrl;
	   *   authConfig.mapsureUrl = config.mapsureUrl;
	   *   authConfig.pcmwsUrl = config.pcmwsUrl;
	   *   authConfig.alkmapsApiKey = config.alkmapsApiKey;
	   *   authConfig.linkMappingUrl = config.linkMappingUrl;
	   * }]);
	   * @memberof alk.authentication
	   */
	  .constant("alk.authentication.config", {
	    httpInterceptor: true,
	
	    //  should be the url to the API for the web app
	    applicationUrl: "/",
	
	    loginRoute: "login",
	
	    //  url for SSO
	    ssoUrl: "",
	
	    //  for validating that a username/password combination is correct.
	    validateUrl: "v1/validate",
	
	    //  for resetting a user's password via use of a reset token
	    resetPasswordUrl: "v1/password/reset",
	
	    //  for generating a reset password token
	    forgotPasswordUrl: "v1/password/forgot",
	
	    //  for changing a user's password
	    changePasswordUrl: "v1/password/change",
	
	    //  for accepting the terms of use
	    termsOfUseUrl: "v1/user/accept-terms",
	
	    //  for getting user info by auth token
	    userInfoUrl: "v1/user",
	
	    //  the name of the current application
	    applicationName: "",
	
	    shouldLogoutOnForbidden: function shouldLogoutOnForbidden(rejection) {
	      if (rejection.config.url.indexOf(this.loginUrl) === 0) {
	        return false;
	      }
	
	      return true;
	    },
	    extraUserProperties: {}
	  }).provider("alkAuthenticationService", ["alk.authentication.config",
	  /** @name alkAuthenticationService
	   * @ngdoc service
	   * @param {constant} alk.authentication.config - an [alk.authentication.config](alk.authentication.alk.authentication.config.html) object
	   * @description Provides functionality for interfacing with ALK's authentication API.
	   * @returns alkAuthenticationService
	   * @memberof alk.authentication
	   */
	  function (config) {
	    (0, _defineProperties2.default)(this, {
	      httpInterceptor: {
	        get: function get() {
	          return config.httpInterceptor;
	        },
	        set: function set(value) {
	          config.httpInterceptor = value;
	        }
	      },
	      applicationUrl: {
	        get: function get() {
	          return config.applicationUrl;
	        },
	        set: function set(value) {
	          config.applicationUrl = value;
	        }
	      },
	      loginRoute: {
	        get: function get() {
	          return config.loginRoute;
	        },
	        set: function set(value) {
	          config.loginRoute = value;
	        }
	      },
	      validateUrl: {
	        set: function set(value) {
	          config.validateUrl = value;
	        },
	        get: function get() {
	          return config.validateUrl;
	        }
	      },
	      resetPasswordUrl: {
	        get: function get() {
	          return config.resetPasswordUrl;
	        },
	        set: function set(value) {
	          config.resetPasswordUrl = value;
	        }
	      },
	      forgotPasswordUrl: {
	        get: function get() {
	          return config.forgotPasswordUrl;
	        },
	        set: function set(value) {
	          config.forgotPasswordUrl = value;
	        }
	      },
	      pcmilerUrl: {
	        get: function get() {
	          return config.pcmilerUrl;
	        },
	        set: function set(value) {
	          config.pcmilerUrl = value;
	        }
	      },
	      dataAnywhereUrl: {
	        get: function get() {
	          return config.dataAnywhereUrl;
	        },
	        set: function set(value) {
	          config.dataAnywhereUrl = value;
	        }
	      },
	      shouldLogoutOnForbidden: {
	        get: function get() {
	          return config.shouldLogoutOnForbidden;
	        },
	        set: function set(value) {
	          config.shouldLogoutOnForbidden = value;
	        }
	      },
	      extraUserProperties: {
	        get: function get() {
	          return config.extraUserProperties;
	        },
	        set: function set(value) {
	          config.extraUserProperties = value;
	        }
	      },
	      ssoUrl: {
	        get: function get() {
	          return config.ssoUrl;
	        },
	        set: function set(value) {
	          config.ssoUrl = value;
	        }
	      },
	      applicationName: {
	        get: function get() {
	          return config.applicationName;
	        },
	        set: function set(value) {
	          config.applicationName = value;
	        }
	      }
	    });
	
	    this.$get = ["$http", "$q", "$window", "$location", "UserProvider", function ($http, $q, $window, $location, UserProvider) {
	
	      function _getTrueUrl(url) {
	        return config.applicationUrl + url;
	      }
	
	      function getUserInfo(authToken, userName, account) {
	        var forcePasswordReset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        var basicAuthHeader = userName + ":" + account + ":" + authToken;
	        var encodedHeader = "Basic " + window.btoa(basicAuthHeader);
	
	        var userInfoRequest = {
	          url: _getTrueUrl(config.userInfoUrl),
	          method: "GET",
	          headers: {
	            Authorization: encodedHeader
	          }
	        };
	
	        var deferred = $q.defer();
	        $http(userInfoRequest).then(function (resp) {
	          var data = resp.data;
	
	          data.forcePasswordReset = forcePasswordReset;
	          deferred.resolve(data);
	        }, function (err) {
	          deferred.reject(err.data);
	        });
	
	        return deferred.promise;
	      }
	
	      /** validate - logs the user in but does not set any roles
	       * Some controller actions need to be accessed while logged in during the signup process (e.g. - getting list of accounts for the user).
	       * This authenticates the SSO user so they can use those actions but they currently don"t have an account.
	       * @param {ALKLogin} login - An [ALKLogin](alk.authentication.ALKLogin.html) object.
	       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves
	       * to the response from the service. If the response from the server is not valid, or if the user is null,
	       * it rejects to the response from the service, also.
	       * Otherwise, it rejects to the error, if there is one.
	       * @memberof alkAuthenticationService
	       */
	      function validate(login) {
	        var deferred = $q.defer();
	
	        $http.post(_getTrueUrl(config.validateUrl), {
	          username: login.username,
	          password: login.password
	        }).then(function (raw) {
	          var response = raw.data;
	          if (response.isValid === true && response.user !== null) {
	            // when validating the user, we are not validating for a specific account or application, not setting account here
	            UserProvider.loadUser(response.user);
	            deferred.resolve(response);
	          } else {
	            logout();
	            deferred.reject(response);
	          }
	        }, function (err) {
	          logout();
	          deferred.reject(err.data);
	        });
	
	        return deferred.promise;
	      }
	
	      /** resetPassword - Reset a user's password using a reset token.
	       * @param {ALKResetPassword} resetPassword - An [ALKResetPassword](alk.authentication.ALKResetPassword.html) object.
	       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise.
	       * @memberof alkAuthenticationService
	       */
	      function resetPassword(resetPassword) {
	        return $http.post(_getTrueUrl(config.resetPasswordUrl), {
	          email: resetPassword.email,
	          newPassword: resetPassword.newPassword,
	          token: resetPassword.token
	        });
	      }
	
	      /** forgotPassword - Send an email with a reset tken to a user that has forgotten their password.
	       * @param {ALKForgotPassword} forgotPassword - An [ALKForgotPassword](alk.authentication.ALKForgotPassword.html) object.
	       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise.
	       * @memberof alkAuthenticationService
	       */
	      function forgotPassword(forgotPassword) {
	        return $http.post(_getTrueUrl(config.forgotPasswordUrl), {
	          email: forgotPassword.email
	        });
	      }
	
	      /** changePassword - Changes a user's password.
	       * @param {ALKChangePassword} changePassword - An [ALKChangePassword](alk.authentication.ALKChangePassword.html) object.
	       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise.
	       * @memberof alkAuthenticationService
	       */
	      function changePassword(changePassword) {
	        return $http.post(_getTrueUrl(config.changePasswordUrl), {
	          existingPassword: changePassword.oldPassword,
	          newPassword: changePassword.newPassword
	        });
	      }
	
	      function login(login) {
	        var deferred = $q.defer();
	
	        var loginRequest = {
	          method: "POST",
	          url: config.ssoUrl + "v2/security/authenticate",
	          data: {
	            email: login.username,
	            password: login.password,
	            account: login.account,
	            product: config.applicationName
	          },
	          withCredentials: true
	        };
	
	        $http(loginRequest).then(function (res) {
	          var data = res.data;
	
	          if (data.userId && data.authToken) {
	            if (config.applicationUrl) {
	              var authToken = data.authToken,
	                  username = data.username,
	                  accountName = data.accountName,
	                  forcePasswordReset = data.forcePasswordReset;
	
	              getUserInfo(authToken, username, accountName, forcePasswordReset).then(function (userInfo) {
	                UserProvider.loadUser(userInfo.user);
	                deferred.resolve(userInfo);
	              }, function (err) {
	                console.log("rejected user info", err);
	                deferred.reject(err);
	              });
	            } else {
	              UserProvider.loadUser(data);
	              deferred.resolve(data);
	            }
	          } else {
	            deferred.reject(data);
	          }
	        }, function (err) {
	          deferred.reject(err.data);
	        });
	
	        return deferred.promise;
	      }
	
	      function verifyService() {
	        var deferred = $q.defer();
	
	        var verifyRequest = {
	          method: "POST",
	          url: config.ssoUrl + "v2/security/verify",
	          data: {
	            product: config.applicationName
	          },
	          withCredentials: true
	        };
	
	        $http(verifyRequest).then(function (response) {
	          deferred.resolve(response.data);
	        }, function (err) {
	          deferred.reject(err.data);
	        });
	
	        return deferred.promise;
	      }
	
	      function verify() {
	        var deferred = $q.defer();
	
	        verifyService().then(function (response) {
	          if (response.userId && response.authToken) {
	            if (config.applicationUrl) {
	              getUserInfo(response.authToken, response.username, response.accountName).then(function (userInfo) {
	                UserProvider.loadUser(userInfo.user);
	                deferred.resolve();
	              }, function (err) {
	                console.log("rejected user info", err);
	                deferred.reject(err);
	              });
	            } else {
	              UserProvider.loadUser(response);
	              deferred.resolve(response);
	            }
	          } else {
	            deferred.reject(response);
	          }
	        }, function (err) {
	          console.log("verify error", err);
	          deferred.reject(err);
	        });
	
	        return deferred.promise;
	      }
	
	      /** logout - Logout a user by clearing them from the UserProvider, and globally expiring them across other apps.
	       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise.
	       * @memberof alkAuthenticationService
	       */
	      function logout() {
	        var serverInput = {
	          authToken: UserProvider.getUser().authToken
	        };
	
	        // clear local user
	        UserProvider.clearUser();
	
	        $window.sessionStorage["logoutInProgress"] = true;
	
	        // log the user out of the server
	        return $http.post(config.ssoUrl + "v2/security/logout", serverInput);
	      }
	
	      /** acceptTerms - accepts the current terms of use
	       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves
	       * to nothing or rejects to the error from the service.
	       * @memberof alkAuthenticationService
	       */
	      function acceptTerms() {
	        var deferred = $q.defer();
	
	        $http.post(_getTrueUrl(config.termsOfUseUrl), {}).then(function (response) {
	          deferred.resolve();
	        }, function (err) {
	          deferred.reject(err);
	        });
	
	        return deferred.promise;
	      }
	
	      /** getLicensedApps - gets the applications the currently logged in user can access
	       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves
	       * to nothing or rejects to the error from the service.
	       * @memberof alkAuthenticationService
	       */
	      function getLicensedApps() {
	        var deferred = $q.defer();
	
	        var url = _getTrueUrl("v1/user/licensed-apps");
	
	        $http.get(url).then(function (raw) {
	          var data = raw.data;
	          var alkCloudProducts = {
	            expired: [],
	            unlicensed: [],
	            licensed: []
	          };
	          for (var i = 0; i < data.length; i++) {
	            var product = {
	              productId: i,
	              // temporarily remove ALK and CoPilot app name prefixes in front-end
	              // TODO pchen: do this in ALKSSO.TALK_Applications instead
	              productTitle: data[i].name.replace(/^ALK /, "").replace(/^CoPilot /, ""),
	              productText: data[i].description,
	              productLicensed: data[i].licensed,
	              productAppUrl: data[i].homeUrl,
	              productInfoUrl: data[i].homeUrl,
	              productImgSrc: "/img/" + data[i].imageSource,
	              productExpired: data[i].expired,
	              showUnlicensedMessage: false
	            };
	
	            if (product.productExpired) {
	              alkCloudProducts.expired.push(product);
	            } else if (!product.productLicensed) {
	              alkCloudProducts.unlicensed.push(product);
	            } else if (product.productLicensed) {
	              alkCloudProducts.licensed.push(product);
	            }
	          }
	
	          deferred.resolve(alkCloudProducts);
	        }, function (err) {
	          console.log(err);
	          deferred.reject(err.data);
	        });
	
	        return deferred.promise;
	      }
	
	      var service = {
	        logout: logout,
	        validate: validate,
	        forgotPassword: forgotPassword,
	        resetPassword: resetPassword,
	        changePassword: changePassword,
	        acceptTerms: acceptTerms,
	        getLicensedApps: getLicensedApps,
	        getUserInfo: getUserInfo,
	        login: login,
	        verifyService: verifyService,
	        verify: verify
	      };
	
	      return service;
	    }];
	  }]).factory("UserProvider", ["$rootScope", "$window", "alk.authentication.config", function ($rootScope, $window, config) {
	
	    function loadUser(user) {
	      $rootScope.userInfo = angular.extend({
	        isLoggedIn: true
	      }, user, config.extraUserProperties);
	      $window.sessionStorage["userAuthInfo"] = (0, _stringify2.default)($rootScope.userInfo); // jshint ignore:line
	
	      $rootScope.$broadcast("UserLoggedIn", $rootScope.userInfo);
	    }
	
	    function init() {
	      if ($window.sessionStorage["userAuthInfo"]) {
	        // jshint ignore:line
	        loadUser(JSON.parse($window.sessionStorage["userAuthInfo"])); // jshint ignore:line
	      }
	
	      // always watch for changes to the user info object and if any are made, than update the session storage correctly.
	      $rootScope.$watch("userInfo", function (newValue, oldValue, scope) {
	        // jshint ignore:line
	        if (newValue === null) {
	          delete $window.sessionStorage["userAuthInfo"]; // jshint ignore:line
	          delete $window.sessionStorage["groupSelectedForSession"];
	        } else if (angular.equals(newValue, oldValue) === false) {
	          $window.sessionStorage["userAuthInfo"] = (0, _stringify2.default)(newValue); // jshint ignore:line
	        }
	      }, true);
	    }
	
	    function getUser() {
	      if ($rootScope.userInfo) {
	        return $rootScope.userInfo;
	      }
	
	      var defaultUser = {
	        isLoggedIn: false,
	        userName: "",
	        userId: -1,
	        authToken: "",
	        account: "",
	        roles: []
	      };
	
	      // return default - not logged in user
	      return angular.extend(defaultUser, config.extraUserProperties);
	    }
	
	    function clearUser() {
	      // delete the user from session first so if the init function is called, it does not get the stale user from session.
	      delete $window.sessionStorage["userAuthInfo"]; // jshint ignore:line
	      delete $window.sessionStorage["groupSelectedForSession"];
	      $rootScope.userInfo = null;
	
	      $rootScope.$broadcast("UserLoggedOut");
	    }
	
	    init();
	
	    return {
	      loadUser: loadUser,
	      getUser: getUser,
	      clearUser: clearUser
	    };
	  }]).factory("alk.authentication.interceptor", ["$window", "$location", "$q", "UserProvider", "Messages", "alk.authentication.config", function ($window, $location, $q, UserProvider, Messages, alkConfig) {
	    return {
	      request: function request(config) {
	
	        if (alkConfig.httpInterceptor === false) {
	          return config;
	        }
	
	        var user = UserProvider.getUser();
	        if (!user.isLoggedIn && !window.localStorage.getItem("jwtToken")) {
	          return config;
	        }
	
	        if (!config.headers) {
	          config.headers = {};
	        }
	
	        if (config.url.indexOf(alkConfig.dataAnywhereUrl) === 0) {
	          // we need to check to see if we are currently in a support account.
	          // if we are in a support account, we have an encrypted owner id.
	          // we do not want to send encrypted owner IDs as our authentication
	          // mechanism for the owner ID route. send our auth token.
	          if (user.supportOwnerId && config.url.indexOf("/api/owner/") === -1) {
	            // attach authorization with the encrypted owner id
	            config.headers.Authorization = "pcmws=" + user.supportOwnerId;
	          } else if (window.localStorage.getItem("jwtToken") && $location.url().startsWith("/place-editor")) {
	            // We must use token when on place-editor
	            config.headers.Authorization = "bearer " + window.localStorage.getItem("jwtToken");
	          } else {
	            // attach authorization header to all requests made to data anywhere
	            config.headers.Authorization = "token=" + user.authToken;
	          }
	        } else if (config.url.indexOf("/") === 0 || config.url.indexOf(alkConfig.applicationUrl) === 0) {
	          // attach authorization header to all requests made to the this website.
	          var basicAuthHeader = user.userName + ":" + user.account + ":" + user.authToken;
	
	          if (user.supportOwnerId) basicAuthHeader += ":" + user.supportOwnerId;
	
	          if (config.headers.Authorization === undefined) config.headers.Authorization = "Basic " + window.btoa(basicAuthHeader);
	        } else if (config.url.indexOf(alkConfig.pcmwsUrl) === 0) {
	          // if Web UI, use region-specific reportApiKey; if Mapsure, use WW alkmapsApiKey
	          var apiKey = void 0;
	          if (alkConfig.reportApiKey) {
	            apiKey = alkConfig.reportApiKey[UserProvider.getUser().region || "NA"];
	          } else {
	            apiKey = alkConfig.alkmapsApiKey;
	          }
	          // attach authorization header in the style of FleetPortal: API Key | authToken | date
	          config.headers.Authorization = apiKey + "|" + user.authToken + "|" + new Date().toISOString();
	
	          if (user.supportOwnerId) {
	            config.headers.Authorization += "|" + user.supportOwnerId;
	          }
	        }
	
	        return config;
	      },
	      responseError: function responseError(rejection) {
	        if (alkConfig.httpInterceptor === false || alkConfig.shouldLogoutOnForbidden(rejection) === false) {
	          return $q.reject(rejection);
	        }
	
	        var clearUser = false;
	
	        // The expected use of this is to capture the case of when a user was authenticatd but it has expired, to send them to the login screen to re-login.
	        // If the "unauthorized" error is coming from trying to login originally, don"t redirect them
	        if (rejection.status === 401 && rejection.config.url.indexOf("/") === 0) {
	          // if the request is unauthorized (status code 401), log the user out and bring them to the login screen.  This would happen if the token ever expires after the user is logged in.
	          Messages.add("danger", "Please login again.", {
	            showOnNextPage: true
	          });
	          clearUser = true;
	        } else if ((rejection.status === 0 || rejection.status === 403) && rejection.config.url.indexOf(alkConfig.dataAnywhereUrl) === 0) {
	          // Previous logic is an issue. Status of 0 can mean several things, including a timeout and/or a response without CORS headers.
	          // Temporary fix is skipping the log out logic if status is 0 and url is for edits list, where previous logic was causing issues
	          // seen in ALKWE-1273.
	          if (!(rejection.config.url.includes("mapsure/abridged-edits-with-count") && rejection.status === 0)) {
	            Messages.add("danger", "Please login again.", {
	              showOnNextPage: true
	            });
	            clearUser = true;
	          }
	        } else if (rejection.status === 403 && rejection.config.url.indexOf(alkConfig.pcmilerUrl) === 0) {
	          Messages.add("danger", "Please login again.", {
	            showOnNextPage: true
	          });
	          clearUser = true;
	        }
	
	        if (clearUser === true) {
	          UserProvider.clearUser();
	          $location.path(alkConfig.loginRoute);
	        }
	
	        return $q.reject(rejection);
	      }
	    };
	  }]).config(["$httpProvider", function ($httpProvider) {
	    $httpProvider.interceptors.push("alk.authentication.interceptor");
	  }]);
	})();

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(249), __esModule: true };

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(250);
	var $Object = __webpack_require__(31).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(29);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(39), 'Object', { defineProperties: __webpack_require__(49) });


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	"use strict";
	
	/** @typedef {Object} ALKChangePassword
	 * @property {String} oldPassword
	 * @property {String} newPassword
	 */
	
	(function () {
	  "use strict";
	
	  angular.module("alk.authentication").factory("ALKChangePassword", ALKChangePassword);
	
	  /** @name ALKChangePassword
	   * @ngdoc factory
	   * @description A factory for an object that encapsulates change password requests.
	   * @param {String} oldPassword - existing password for the user
	   * @param {String} newPassword - new password for the user
	   * @example
	   * var change = new ALKChangePassword(oldPassword, newPassword);
	   * @returns ALKChangePassword
	   * @memberof alk.authentication
	   */
	  function ALKChangePassword() {
	    return function (oldPassword, newPassword) {
	      this.oldPassword = oldPassword;
	      this.newPassword = newPassword;
	    };
	  }
	})();

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	"use strict";
	
	/** @typedef {Object} ALKForgotPassword
	 * @property {String} email
	 */
	
	(function () {
	  "use strict";
	
	  angular.module("alk.authentication").factory("ALKForgotPassword", ALKForgotPassword);
	
	  /** @name ALKForgotPassword
	   * @ngdoc factory
	   * @description A factory for an object that encapsulates forgot password requests.
	   * @param {String} email - email of the user to which a "forgot password" email will be sent
	   * @example
	   * var forgot = new ALKForgotPassword(email);
	   * @returns ALKForgotPassword
	   * @memberof alk.authentication
	   */
	  function ALKForgotPassword() {
	    return function (email) {
	      this.email = email;
	    };
	  }
	})();

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	"use strict";
	
	/** @typedef {Object} ALKLogin
	 * @property {String} login
	 * @property {String} logout
	 * @property {String} validate
	 * @property {String} forgotPassword
	 */
	
	(function () {
	  "use strict";
	
	  angular.module("alk.authentication").factory("ALKLogin", ALKLogin);
	
	  /** @name ALKLogin
	   * @ngdoc factory
	   * @description A factory for an object that encapsulates login requests. 
	   * @param {String} username - username for the request
	   * @param {String} password - password for the request
	   * @param {String} account - optional account name for the request.
	   * @param {String} application - optional application name for the request.
	   * @example
	   * var login = new ALKLogin(username, password, acct);
	   * @returns ALKLogin
	   * @memberof alk.authentication
	   */
	  function ALKLogin() {
	    return function (username, password) {
	      var _this = this;
	
	      var account = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	      var application = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
	
	      this.username = username;
	      this.password = password;
	      this.account = account;
	      this.application = application;
	
	      this.isBaseValid = _.bind(function () {
	        return _this.username && _this.username.length > 0 && _this.password && _this.password.length > 0;
	      }, this);
	      this.isAccountValid = _.bind(function () {
	        return _this.account.length > 0;
	      }, this);
	      this.isApplicationValid = _.bind(function () {
	        return _this.application.length > 0;
	      }, this);
	    };
	  }
	})();

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	"use strict";
	
	/** @typedef {Object} ALKResetPassword
	 * @property {String} email
	 * @property {String} newPassword
	 * @property {String} token
	 */
	
	(function () {
	  "use strict";
	
	  angular.module("alk.authentication").factory("ALKResetPassword", ALKResetPassword);
	
	  /** @name ALKResetPassword
	   * @ngdoc factory
	   * @description A factory for an object that encapsulates reset password requests.
	   * @param {String} email - email of the user resetting their password
	   * @param {String} newPassword - the new password that will be set for the user
	   * @param {String} token - the reset token for the user
	   * @example
	   * var reset = new ALKResetPassword(email, newPassword, token);
	   * @returns ALKResetPassword
	   * @memberof alk.authentication
	   */
	  function ALKResetPassword() {
	    return function (email, newPassword, token) {
	      this.email = email;
	      this.newPassword = newPassword;
	      this.token = token;
	    };
	  }
	})();

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	    "use strict";
	
	    angular.module("alk.services").factory("mapTextPath", ["_", function (_) {
	
	        var svgNS = "http://www.w3.org/2000/svg";
	
	        function getCoordArray(feature, toLL) {
	            var theseCoords = angular.copy(feature.geometry.components);
	            toLL = toLL || false;
	            var coords = _.map(theseCoords, function (c) {
	                if (toLL && (c.x > 180 || c.x < -180)) {
	                    var tempLL = new ALKMaps.LonLat(c.x, c.y).transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));
	                    c.x = tempLL.lon;
	                    c.y = tempLL.lat;
	                }
	                return [c.x, c.y];
	            });
	            return coords;
	        }
	
	        function convertPolyToPath(polyline, id) {
	            var thisNS = polyline.ownerSVGElement.namespaceURI;
	            var path = document.createElementNS(thisNS, "path");
	            var points = polyline.getAttribute("points").split(/\s+|,/);
	            var x0 = points.shift(),
	                y0 = points.shift();
	            var pathdata = "M" + x0 + "," + y0 + "L" + points.join(" ");
	            if (polyline.tagName === "polygon") pathdata += "z";
	            path.setAttribute("d", pathdata);
	            path.setAttribute("id", id);
	            path.setAttribute("fill", "none");
	            //polyline.parentNode.appendChild(path);
	            return path;
	        }
	
	        function setText(feature, text, options, redraw) {
	            if (!feature._textElements) feature._textElements = [];
	            if (document.getElementById(feature.geometry.id) !== null) {
	                var defaults = {
	                    repeat: false,
	                    fillColor: "black",
	                    attributes: {},
	                    below: false,
	                    position: "middle",
	                    autoRotate: true
	                };
	                options = _.assign(defaults, options);
	
	                feature._pathid = feature.geometry.id + "_path";
	                var _path = document.getElementById(feature._pathid);
	
	                if (_path === null) {
	                    _path = convertPolyToPath(document.getElementById(feature.geometry.id), feature._pathid);
	                }
	                var svg = document.getElementById(feature.geometry.id).parentNode;
	                svg.appendChild(_path);
	                /* Put it along the path using textPath */
	                var textNode = document.createElementNS(svgNS, "text"),
	                    textPath = document.createElementNS(svgNS, "textPath");
	
	                textNode.setAttribute("class", "textpath textpath-" + feature.geometry.id);
	
	                //textPath.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", window.location.href + "#" + feature._pathid);
	                textPath.setAttribute("href", window.location.href + "#" + feature._pathid);
	
	                var dx = options.attributes.dx || "0";
	                var dy = options.attributes.dy || _path.getAttribute("stroke-width");
	
	                textNode.setAttribute("dx", dx);
	                textNode.setAttribute("dy", dy);
	
	                for (var attr in options.attributes) {
	                    textNode.setAttribute(attr, options.attributes[attr]);
	                }textPath.appendChild(document.createTextNode(text));
	                textNode.appendChild(textPath);
	
	                if (options.below) {
	                    svg.insertBefore(textNode, svg.firstChild);
	                } else {
	                    svg.appendChild(textNode);
	                }
	
	                /* Center text according to the path"s bounding box */
	                if (options.center) {
	                    var textWidth = textNode.getBBox().width;
	                    var pathWidth = _path.getBoundingClientRect().width;
	                    /* Set the position for the left side of the textNode */
	                    textNode.setAttribute("dx", pathWidth / 2 - textWidth / 2);
	                }
	
	                if (options.position === "middle") {
	                    textNode.setAttribute("text-anchor", "middle");
	                    textPath.setAttribute("startOffset", "50%");
	                }
	
	                if (options.position === "right") {
	                    textNode.setAttribute("text-anchor", "end");
	                    textPath.setAttribute("startOffset", "100%");
	                }
	
	                if (options.autoRotate) {
	                    var pathPoints = getCoordArray(feature);
	                    var x1 = pathPoints[0][0],
	                        x2 = pathPoints[pathPoints.length - 1][0];
	                    if (x1 < 0) x1 += 360;
	                    if (x2 < 0) x2 += 360;
	                    if (x1 - x2 > 0) {
	                        var textBBox = textNode.getBBox();
	                        var textNodeCenter = {
	                            x: textBBox.x + textBBox.width / 2,
	                            y: textBBox.y + textBBox.height / 2
	                        };
	                        textNode.setAttribute("transform", "rotate(180 " + textNodeCenter.x + "," + textNodeCenter.y + ")");
	                    }
	                }
	
	                if (!redraw) {
	                    feature._textElements.push({
	                        text: text,
	                        options: options
	                    });
	                }
	            }
	        }
	
	        function removeText(feature, temp) {
	            temp = temp || false;
	
	            if (feature && feature.layer == null) {
	                console.log("feature.layer is null when attempting to remove text");
	            }
	
	            if (feature && feature.layer) {
	                feature.layer.redraw();
	                var pathEl = document.getElementById(feature._pathid);
	                if (pathEl !== null) {
	                    var nodeClass = "textpath textpath-" + feature.geometry.id;
	                    var parent = document.getElementById(feature._pathid).parentNode;
	                    var textElems = document.getElementsByClassName(nodeClass);
	                    for (var el = textElems.length - 1; el > -1; el--) {
	                        parent.removeChild(textElems[el]);
	                    }
	                    var pathElem = document.getElementById(feature._pathid);
	                    parent.removeChild(pathElem);
	                    if (!temp) {
	                        feature._textElements = null;
	                    }
	                }
	            }
	        }
	
	        return {
	            add: setText,
	            remove: removeText
	        };
	    }]);
	})(window.angular);

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("alk.directives").directive("mapsLocation", [function () {
	    return {
	      restrict: "A",
	      replace: false,
	      template: "{{vm.location}}",
	      scope: {
	        mapRegion: "=",
	        mapDataset: "=",
	        mapObj: "="
	      },
	      controllerAs: "vm",
	      controller: ["$scope", "$timeout", "_", "alkGeocodeService", "STATES", function ($scope, $timeout, _, alkGeocodeService, STATES) {
	        var vm = this;
	        var map = $scope.mapObj;
	
	        function displayLocation(region, zoom, r) {
	
	          var address = r[0].Address;
	
	          var strCity = address.City + " > ";
	          var strCounty = "";
	
	          if (region === "NA") {
	            strCounty = address.County ? address.County + " County > " : "";
	          } else {
	            strCounty = address.County ? address.County + " > " : "";
	          }
	
	          var strState = "";
	          var strCountry = "";
	
	          if (region === "NA") {
	            // North american states will be in the STATES array so we can get the country, state from their
	            var stObj = _.find(STATES, {
	              abbreviation: address.State
	            });
	
	            if (stObj) {
	              strState = stObj.name + " > ";
	              strCountry = stObj.country;
	            }
	          } else {
	            // Other regions just use the country. todo: make logic more clear and document logic for what should be displayed for different regions
	            strCountry = address.Country;
	          }
	
	          switch (true) {
	            case zoom >= 13:
	              vm.location = strCity + strCounty + strState + strCountry;
	              break;
	            case zoom >= 10:
	              vm.location = strCounty + strState + strCountry;
	              break;
	            case zoom >= 7:
	              vm.location = strState + strCountry;
	              break;
	            case zoom < 7:
	              vm.location = strCountry;
	          }
	        }
	
	        function displayError(err) {
	          vm.location = "Location unknown";
	        }
	
	        function getUpdatedLocation() {
	          if (map) {
	            var zoom = map.getZoom();
	
	            var center = map.getCenter().transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));
	
	            alkGeocodeService.reverseGeocode(center, {
	              region: $scope.mapRegion,
	              dataset: $scope.mapDataset
	            }).then(function (r) {
	              return displayLocation($scope.mapRegion, zoom, r);
	            }, displayError);
	          } else {
	            displayError();
	          }
	        }
	
	        function onMoveEnd() {
	          $timeout(function () {
	            getUpdatedLocation();
	          });
	        }
	
	        map.events.register("moveend", {}, onMoveEnd);
	
	        // get the intial location of the map
	        getUpdatedLocation();
	      }]
	    };
	  }]);
	
	  angular.module("alk.directives").directive("mapsMousePosition", [function () {
	
	    return {
	      restrict: "A",
	      replace: true,
	      template: "<div id=\"mouse-position\"></div",
	      scope: {
	        mapObj: "="
	      },
	      controller: ["$scope", "ALKMaps", function ($scope, ALKMaps) {
	        var vm = this;
	        var map = $scope.mapObj;
	
	        var mousePos = new ALKMaps.Control.MousePosition({
	          prefix: "Lon: ", //Optional setting for the text displayed before the longitude value.
	          separator: " Lat: ", //Optional setting for text displayed before the latitude value.
	          numDigits: 6, //Optional setting for the number of digits to be displayed after the decimal point.
	          div: ALKMaps.Util.getElement("mouse-position")
	        });
	
	        map.addControl(mousePos);
	      }]
	    };
	  }]);
	})(window.angular);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.geocode", []);
	})(window.angular);
	
	__webpack_require__(258);

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	"use strict";
	
	/** @typedef {Object} alkGeocodeService
	 *  @property {Function} geocode
	 *  @property {Function} reverseGeocode
	 */
	
	(function () {
	  "use strict";
	
	  angular.module("alk.geocode").service("alkGeocodeService", alkGeocodeService);
	
	  /** @name alkGeocodeService
	   * @ngdoc service
	   * @param {service} ALKMaps [ALKMaps](https://maps.alk.com/Developer/1.2/api_docs)
	   * @param {service} $q angularJS [promises/deferred objects service](https://docs.angularjs.org/api/ng/service/$q)
	   * @param {service} timeout angularJS [window.setTimeout wrapper](https://docs.angularjs.org/api/ng/service/$timeout#!)
	   * @description Provides geocoding and reverse geocoding functions as a light wrapper around [ALKMaps](https://maps.alk.com/Developer/1.2/api_docs)
	   * @returns alkGeocodeService
	   * @memberof alk.geocode
	   */
	
	  alkGeocodeService.$inject = ["ALKMaps", "$q", "$timeout"];
	  function alkGeocodeService(ALKMaps, $q, $timeout) {
	    return {
	      geocode: geocode,
	      reverseGeocode: reverseGeocode
	    };
	
	    ////////////////
	
	    /** geocode - Turn an address object into an array of Addresses. By default, we return one address unless
	     * options.listSize > 1.
	     * @param {Object} address - The input address to geocode. Should look like `{addr: string, city: string, state: string, zip: string, region: string}`
	     * @param {Object} options - Options for geocoding. Supports `{listSize: int, region: string, dataset: string}`.
	     * Valid values for region are NA, EU, OC, and SA. Valid values for dataset are PCM_EU, PCM_OC, PCM_SA, or Current.
	     * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves to an array of address objects or
	     * rejects to an object `{searchError: boolean, messages: [String]}`.
	     * @memberof alkGeocodeService
	     */
	    function geocode(address, options) {
	      var deferred = $q.defer();
	
	      options = options || {};
	
	      address.region = options.region || "NA";
	      address.dataset = options.dataset || "PCM_NA";
	
	      ALKMaps.Geocoder.geocode({
	        address: address,
	        listSize: options.listSize || 1, //Optional. The number of results returned if the geocoding service finds multiple matches.
	        success: function success(resp) {
	          $timeout(function () {
	            var chk = checkResponseError(resp);
	            if (chk.hasError === true) {
	              deferred.reject({
	                searchError: true,
	                messages: chk.messages
	              });
	            } else {
	              deferred.resolve(resp);
	            }
	          });
	        },
	        failure: function failure() {
	          $timeout(function () {
	            deferred.reject({
	              searchError: true
	            });
	          });
	        }
	      });
	
	      return deferred.promise;
	    }
	
	    /** reverseGeocode - Turn a longitude and a latitude into an address.
	     * @param {Object} lonLat - An [ALKMaps.LonLat](https://maps.alk.com/api/1.2/docs/files/BaseTypes/LonLat-js.html) or an object with lon and lat properties.
	     * @param {Object} optsObj - Options for reverse geocoding. Supports region: string, dataset: string.
	     * Valid values for region are NA, EU, OC, and SA. Valid values for dataset are PCM_EU, PCM_OC, PCM_SA, or Current.
	     * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves to an array of address objects or
	     * rejects to an object `{searchError: boolean, messages: [String]}`.
	     * @memberof alkGeocodeService
	     */
	    function reverseGeocode(lonLat, optsObj) {
	      var deferred = $q.defer();
	
	      optsObj = optsObj || {};
	
	      ALKMaps.Geocoder.reverseGeocode({
	        lonLat: lonLat,
	        region: optsObj.region || "NA",
	        dataset: optsObj.dataset || "PCM_NA",
	        success: function success(resp) {
	          $timeout(function () {
	            var chk = checkResponseError(resp);
	
	            if (chk.hasError === true) {
	              deferred.reject({
	                searchError: true,
	                messages: chk.messages
	              });
	            } else {
	              deferred.resolve(resp);
	            }
	          });
	        },
	        failure: function failure() {
	          $timeout(function () {
	            deferred.reject({
	              searchError: true
	            });
	          });
	        }
	      });
	
	      return deferred.promise;
	    }
	
	    function checkResponseError(resp) {
	      var hasError = false;
	      var messages = [];
	      if (resp !== null && resp.length > 0) {
	        var errors = resp[0].Errors; // Errors in first item
	        if (errors !== null && errors.length > 0) {
	          for (var i = 0; i < errors.length; i++) {
	            if (errors[i].Type === 1) {
	              hasError = true;
	              messages.push(errors[i].Description);
	            }
	          }
	        }
	      }
	      return {
	        hasError: hasError,
	        messages: messages
	      };
	    }
	  }
	})();

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.maps", ["alk.geocode", "alk.constants"]);
	})(window.angular);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function () {
	  "use strict";
	
	  angular.module("alk.maps").factory("mapService", mapService);
	  mapService.$inject = ["$rootScope", "ALKMaps"];
	
	  function mapService($rootScope, ALKMaps) {
	    var mapElem = {};
	    var mapObj = null;
	    var editZoom = 16;
	
	    var service = {
	      addControl: addControl,
	      removeControl: removeControl,
	      addLayer: addLayer,
	      canEditMap: canEditMap,
	      deregisterEvent: deregisterEvent,
	      getMap: getMap,
	      getStyle: getStyle,
	      getZoom: getZoom,
	      initializeMap: initializeMap,
	      destroyMap: destroyMap,
	      registerEvent: registerEvent,
	      releaseMap: releaseMap,
	      removeLayer: removeLayer,
	      resizeMap: resizeMap,
	      safePanTo: safePanTo,
	      setCenter: setCenter,
	      setStyle: setStyle,
	      zoomIn: zoomIn,
	      zoomOut: zoomOut,
	      zoomTo: zoomTo,
	      zoomToEdit: zoomToEdit,
	      getEditZoomLevel: getEditZoomLevel
	    };
	
	    return service;
	
	    function addControl(name, mapControlObj, activate) {
	      mapObj.addControls([mapControlObj]);
	      if (activate) {
	        mapControlObj.activate();
	      }
	    }
	
	    function removeControl(mapControlObj) {
	      mapObj.removeControl(mapControlObj);
	    }
	
	    function addLayer(name, mapLayerObj) {
	      mapObj.addLayers([mapLayerObj]);
	    }
	
	    function deregisterEvent(evtName, callback) {
	      mapObj.events.unregister(evtName, mapObj.map, callback);
	    }
	
	    function registerEvent(evtName, callback) {
	      mapObj.events.register(evtName, mapObj.map, callback);
	    }
	
	    function initializeMap(map) {
	      if (mapObj == null) {
	        mapObj = new ALKMaps.Map();
	        mapObj.displayProjection = new ALKMaps.Projection("EPSG:4326");
	        mapObj.routeElements = [];
	      }
	    }
	
	    function releaseMap() {
	      $rootScope.$broadcast("releaseMap", {
	        center: mapObj.getCenter(),
	        zoom: mapObj.getZoom(),
	        style: getStyle()
	      });
	
	      mapObj.mapStyle = "default";
	    }
	
	    function destroyMap() {
	      if (mapObj != null) {
	        mapObj.destroy();
	        mapObj = null;
	      }
	    }
	
	    function getMap() {
	      return mapObj;
	    }
	
	    function getZoom() {
	      return mapObj.getZoom();
	    }
	
	    function resizeMap() {
	      if (mapObj != null) mapObj.updateSize();
	    }
	
	    //A normal, smooth transition pan can cause issues flicking back to the panned spot if trying to manually pan after
	    function safePanTo(lonlat, zoom) {
	      mapObj.zoomTo(4);
	      mapObj.panTo(lonlat);
	      mapObj.zoomTo(zoom);
	    }
	
	    function zoomTo(zoom) {
	      mapObj.zoomTo(zoom);
	    }
	
	    function setCenter(center) {
	      var zoomLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	
	      mapObj.setCenter(center, zoomLevel);
	    }
	
	    function setStyle(style) {
	      if (mapObj.baseLayer) {
	        if (style === "satellite_only") {
	          mapObj.baseLayer.satelliteOnly = true;
	          mapObj.baseLayer.changeStyle("satellite");
	        } else {
	          if (mapObj.baseLayer.satelliteOnly) delete mapObj.baseLayer.satelliteOnly;
	          mapObj.baseLayer.changeStyle(style);
	        }
	      }
	    }
	
	    function getStyle() {
	      if (mapObj.baseLayer.satelliteOnly && mapObj.baseLayer.params.STYLE === "satellite") {
	        return "satellite_only";
	      } else {
	        return mapObj.baseLayer.params.STYLE;
	      }
	    }
	
	    function removeLayer(layerObj) {
	      mapObj.removeLayer(layerObj);
	    }
	
	    function zoomIn() {
	      mapObj.zoomIn();
	    }
	
	    function zoomOut() {
	      mapObj.zoomOut();
	    }
	
	    function canEditMap() {
	      if (!getMap()) return false;
	      return getMap().getZoom() >= editZoom;
	    }
	
	    function getEditZoomLevel() {
	      return editZoom;
	    }
	
	    function zoomToEdit() {
	      zoomTo(editZoom);
	    }
	  }
	})();

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(262);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	  "use strict";
	
	  angular.module("alk.maps").factory("mapUtilities", ["ALKMaps", "mapService", "PCMRegion", function mapUtilities(ALKMaps, mapService, PCMRegion) {
	    //colors to use on the map with 50% opacity
	    var mapColors = ["#123EC4", "#B84A00", "#7318A1", "#1E6CA8", "#B50E59", "#450DBD", "#009DC4", "#E63D00"];
	    //colors to use in the UI at full opacity that match the mapColors above at 50% opacity
	    var uiColors = ["#889EE1", "#DBA47F", "#B98BD0", "#8EB5D3", "#DA86AC", "#A286DE", "#7FCEE1", "#F29E7F"];
	
	    var mapBaseLayerDefs = {
	      "WW": {
	        index: 0,
	        name: "WWMap",
	        region: "EU",
	        dataset: "current"
	      },
	      "NA": {
	        index: 1,
	        name: "NAMap",
	        region: "NA",
	        dataset: "Current"
	      },
	      "EU": {
	        index: 2,
	        name: "EUMap",
	        region: "EU",
	        dataset: "PCM_EU"
	      },
	      "SA": {
	        index: 3,
	        name: "SAMap",
	        region: "SA",
	        dataset: "PCM_SA"
	      },
	      "OC": {
	        index: 4,
	        name: "OCMap",
	        region: "OC",
	        dataset: "PCM_OC"
	      },
	      "ME": {
	        index: 5,
	        name: "MEMap",
	        region: "ME",
	        dataset: "PCM_ME"
	      },
	      "AS": {
	        index: 6,
	        name: "ASMap",
	        region: "AS",
	        dataset: "PCM_AS"
	      },
	      "AF": {
	        index: 7,
	        name: "AFMap",
	        region: "AF",
	        dataset: "PCM_AF"
	      },
	      "GT": {
	        index: 8,
	        name: "GTMap",
	        region: "GT",
	        dataset: "PCM_GT"
	      }
	    };
	
	    var service = {
	      getMapColor: getMapColor,
	      getUIColor: getUIColor,
	      parseCenterParams: parseCenterParams,
	      LLtoMerc: LLtoMerc,
	      MercToLL: MercToLL,
	      zoomToCurrentLocation: zoomToCurrentLocation,
	      attachScopeToMapEvents: attachScopeToMapEvents,
	      deactivateKeyboardControl: deactivateKeyboardControl,
	      activateKeyboardControl: activateKeyboardControl,
	      getMapBaseLayerDefs: getMapBaseLayerDefs,
	      getRegionFromLonLat: getRegionFromLonLat,
	      getCenterLonLatFromRegion: getCenterLonLatFromRegion,
	      isPolygonSelfIntersecting: isPolygonSelfIntersecting,
	      getDistanceFromCoords: getDistanceFromCoords
	    };
	
	    return service;
	
	    ///////////////////////
	    function getMapColor(index) {
	      if (typeof index !== "undefined" && isNumeric(index)) {
	        return mapColors[index % mapColors.length];
	      } else {
	        return mapColors;
	      }
	    }
	
	    function getUIColor(index) {
	      if (typeof index !== "undefined" && isNumeric(index)) {
	        return mapColors[index % mapColors.length];
	      } else {
	        return mapColors;
	      }
	    }
	
	    function isNumeric(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	    function parseCenterParams(params) {
	      if (params && params.center) {
	        var args = params.center.split(",");
	        if (args.length === 3) {
	          var zoom = parseInt(args[0], 10),
	              lat = parseFloat(args[1]),
	              lon = parseFloat(args[2]);
	          if (isNaN(zoom) || isNaN(lat) || isNaN(lon)) {
	            return false;
	          } else {
	            return {
	              center: [lon, lat],
	              zoom: zoom
	            };
	          }
	        } else {
	          return false;
	        }
	      }
	    }
	
	    function zoomToCurrentLocation() {
	      if (navigator.geolocation) {
	        navigator.geolocation.getCurrentPosition(function (position) {
	          mapService.setCenter(LLtoMerc(position.coords.longitude, position.coords.latitude), 16);
	        }, function (error) {
	          console.log(error);
	        }, {
	          timeout: 10000
	        });
	      }
	    }
	
	    function LLtoMerc(lon, lat) {
	      if ((typeof lon === "undefined" ? "undefined" : (0, _typeof3.default)(lon)) === "object") {
	        lat = lon.lat;
	        lon = lon.lon;
	      }
	      return new ALKMaps.LonLat(lon, lat).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	    }
	
	    function MercToLL(lon, lat) {
	      if ((typeof lon === "undefined" ? "undefined" : (0, _typeof3.default)(lon)) === "object") {
	        lat = lon.lat;
	        lon = lon.lon;
	      }
	      return new ALKMaps.LonLat(lon, lat).transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));
	    }
	
	    function attachScopeToMapEvents(scopeToAttach) {
	      scopeToAttach.$on("MapInputFocus", function (event, message) {
	        // jshint ignore:line
	        deactivateKeyboardControl();
	      });
	
	      scopeToAttach.$on("MapInputBlur", function () /*event, message */{
	        activateKeyboardControl();
	      });
	    }
	
	    function deactivateKeyboardControl() {
	      var map = mapService.getMap();
	      if (map == null) {
	        return;
	      }
	
	      for (var i = 0; i < map.controls.length; i++) {
	        if (map.controls[i].displayClass === "olControlKeyboardDefaults") {
	          map.controls[i].deactivate();
	        }
	      }
	    }
	
	    function activateKeyboardControl() {
	      var map = mapService.getMap();
	      if (map == null) {
	        return;
	      }
	
	      for (var i = 0; i < map.controls.length; i++) {
	        if (map.controls[i].displayClass === "olControlKeyboardDefaults") {
	          map.controls[i].activate();
	        }
	      }
	    }
	
	    function getMapBaseLayerDefs() {
	      return mapBaseLayerDefs;
	    }
	
	    function getRegionFromLonLat(centerlon, centerlat) {
	      var region = "NA";
	
	      if (centerlat > -36 && centerlat < 11.5 && centerlon > -27 && centerlon < 64 || centerlat > 11.501 && centerlat < 34 && centerlon > -27 && centerlon < 34) {
	        region = "AF";
	      } else if (centerlat > -10.8 && centerlat < 10.38 && centerlon > 70 && centerlon < 146 || centerlat > 8 && centerlat < 27.2 && centerlon > 71.2 && centerlon < 92.15 || centerlat > 0 && centerlat < 25.6 && centerlon > 120 && centerlon < 130) {
	        region = "AS";
	      } else if (centerlat > 37.6 && centerlat < 71.5 && centerlon > -15 && centerlon < 39.5 || centerlat > 55.8 && centerlat < 78 && centerlon > 0 && centerlon < 179.9 || centerlat > 27.63 && centerlat < 33.20 && centerlon > -18.25 && centerlon < -13.40) {
	        region = "EU";
	      } else if (centerlat > 25 && centerlat < 75 && centerlon > -168 && centerlon < -30 || centerlat > 14.6 && centerlat < 25 && centerlon > -162 && centerlon < -93 || centerlat > 17.5 && centerlat < 19 && centerlon > -67.5 && centerlon < -63.5) {
	        region = "NA";
	      } else if (centerlat > -44.65 && centerlat < -12.2 && centerlon > 112.3 && centerlon < 153.4 || centerlat > -47.5 && centerlat < -33 && centerlon > 165 && centerlon < 179) {
	        region = "OC";
	      } else if (centerlat > 22.75 && centerlat < 27.1 && centerlon > -79.4 && centerlon < -73 || centerlat > 32.2 && centerlat < 32.5 && centerlon > -65 && centerlon < -64.5 || centerlat > 17.5 && centerlat < 23 && centerlon > -74.1 && centerlon < -67.8) {
	        region = "SA";
	      } else if (centerlat > -60 && centerlat < 24 && centerlon > -86 && centerlon < -32) {
	        region = "SA";
	      } else if (centerlat > 17.5 && centerlat < 20.1 && centerlon > -74.5 && centerlon < -68.3) {
	        region = "WW";
	      } else {
	        var lonlat = new ALKMaps.LonLat(centerlon, centerlat);
	        var results = ALKMaps.Geocoder.reverseGeocode({
	          lonLat: lonlat,
	          async: false,
	          region: "EU",
	          dataset: "current"
	        });
	
	        if (results[0].Address != null && results[0].Region != null) {
	          var regionFromGeocoder = results[0].Region;
	          var currentState = results[0].Address.State;
	          if (regionFromGeocoder === PCMRegion.AF) {
	            region = "AF";
	          } else if (regionFromGeocoder === PCMRegion.AS) {
	            if (currentState === "PK") {
	              region = "WW";
	            } else {
	              region = "AS";
	            }
	          } else if (regionFromGeocoder === PCMRegion.EU) {
	            region = "EU";
	          } else if (regionFromGeocoder === PCMRegion.NA) {
	            region = "NA";
	          } else if (regionFromGeocoder === PCMRegion.OC) {
	            region = "OC";
	          } else if (regionFromGeocoder === PCMRegion.SA) {
	            region = "SA";
	          } else if (regionFromGeocoder === PCMRegion.ME) {
	            region = "ME";
	          }
	        }
	      }
	
	      return region;
	    }
	
	    function getCenterLonLatFromRegion(region) {
	      if (!region) region = "NA";
	
	      var zoom = 5;
	      var lat = 38.5;
	      var lon = -95;
	
	      if (region === "WW") {
	        zoom = 3, lat = 31.5;
	        lon = -44;
	      } else if (region === "EU") {
	        zoom = 5;
	        lat = 47.8;
	        lon = 8.4;
	      } else if (region === "OC") {
	        zoom = 5;
	        lat = -27.387;
	        lon = 133.164;
	      } else if (region === "SA") {
	        zoom = 4;
	        lat = -19.24;
	        lon = -57.43;
	      } else if (region === "AF") {
	        zoom = 4;
	        lat = 8.95;
	        lon = 17.46;
	      } else if (region === "AS") {
	        zoom = 5;
	        lat = 19.87;
	        lon = 84.21;
	      } else if (region === "ME") {
	        zoom = 5;
	        lat = 30.24;
	        lon = 62.85;
	      }
	
	      return {
	        zoom: zoom,
	        lat: lat,
	        lon: lon
	      };
	    }
	
	    function isPolygonSelfIntersecting(polygon) {
	      var outer = [];
	      if (polygon.CLASS_NAME === "ALKMaps.Geometry.LinearRing") {
	        outer = polygon.components;
	      } else if (polygon.CLASS_NAME === "ALKMaps.Geometry.Polygon") {
	        outer = polygon.components[0].components;
	      }
	      var segments = outer.slice(1).map(function (right, i) {
	        var left = outer[i];
	        return new ALKMaps.Geometry.LineString([left.clone(), right.clone()]);
	      });
	      return segments.some(function (segment) {
	        return segmentIntersects(segment, segments);
	      });
	    }
	
	    function segmentIntersects(segment1, segments) {
	      return segments.some(function (segment2) {
	        return !startOrStopEquals(segment1, segment2) && segment1.intersects(segment2);
	      });
	    }
	
	    function startOrStopEquals(segment1, segment2) {
	      if (segment1.components[0].equals(segment2.components[0])) {
	        return true;
	      }
	      if (segment1.components[0].equals(segment2.components[1])) {
	        return true;
	      }
	      if (segment1.components[1].equals(segment2.components[0])) {
	        return true;
	      }
	      if (segment1.components[1].equals(segment2.components[1])) {
	        return true;
	      }
	      return false;
	    }
	
	    /*
	      calculate the real distance between 2 point.
	      If coords are in degree, pass in projection "EPSG:4326"
	      If coords are in meters, pass in projection "EPSG:900913"
	    */
	    function getDistanceFromCoords(lonlat1, lonlat2, projection) {
	      var line = new ALKMaps.Geometry.LineString([lonlat1, lonlat2]);
	      return line.getGeodesicLength(new ALKMaps.Projection(projection));
	    }
	  }]);
	})();

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("alk.maps").factory("savedMapInfo", savedMapInfo);
	  savedMapInfo.$inject = ["$rootScope", "$location", "ALKMaps", "UserProvider", "mapUtilities"];
	
	  function savedMapInfo($rootScope, $location, ALKMaps, UserProvider, mapUtilities) {
	    var mapElem = {};
	
	    var service = {
	      getSavedInfo: getSavedInfo,
	      saveCurrentInfo: saveCurrentInfo,
	      getSavedInfoAsUrl: getSavedInfoAsUrl
	    };
	
	    $rootScope.$on("UserLoggedIn", function () {
	      mapElem.savedInfo = null;
	    });
	
	    $rootScope.$on("releaseMap", function (event, data) {
	      mapElem = mapElem || {};
	      mapElem.savedInfo = mapElem.savedInfo || {};
	      mapElem.savedInfo.mapCenter = data.center;
	      mapElem.savedInfo.mapZoom = data.zoom;
	      mapElem.savedInfo.mapStyle = data.style;
	    });
	
	    return service;
	
	    function getSavedInfoAsUrl() {
	      var savedInfo = getSavedInfo();
	      var precision = Math.max(0, Math.ceil(Math.log(savedInfo.mapZoom) / Math.LN2));
	      var center = angular.copy(savedInfo.mapCenter).transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));
	      var urlCenterParam = [savedInfo.mapZoom, center.lat.toFixed(precision), center.lon.toFixed(precision)].join(",");
	      return urlCenterParam;
	    }
	
	    function saveCurrentInfo(center, zoom, style) {
	      mapElem = mapElem || {};
	      mapElem.savedInfo = mapElem.savedInfo || {};
	      mapElem.savedInfo.mapCenter = center;
	      mapElem.savedInfo.mapZoom = zoom;
	      mapElem.savedInfo.mapStyle = style;
	    }
	
	    function getSavedInfo() {
	      if (mapElem.savedInfo) return mapElem.savedInfo;
	
	      var zoom;
	      var center;
	      var urlCenter = mapUtilities.parseCenterParams($location.search());
	      var couldTryGeolocating = false;
	      if (urlCenter) {
	        center = mapUtilities.LLtoMerc(urlCenter.center[0], urlCenter.center[1]);
	        zoom = urlCenter.zoom;
	      } else {
	        // initial location of map is based on the region the user is setup for currently. in the future if the user has access to world wide, use the location of the browser possibly?
	        var centerLonLat = mapUtilities.getCenterLonLatFromRegion(UserProvider.getUser().region);
	        center = mapUtilities.LLtoMerc(centerLonLat.lon, centerLonLat.lat);
	        zoom = centerLonLat.zoom;
	
	        //  if there is no saved info, and we had to fallback to just a default lat/lon for a region,
	        //  then it is up to the app to choose if they want to geolocate instead.
	        couldTryGeolocating = true;
	      }
	
	      return {
	        mapCenter: center,
	        mapStyle: ALKMaps.STYLE.DEFAULT,
	        mapZoom: zoom,
	        couldTryGeolocating: couldTryGeolocating
	      };
	    }
	  }
	})();

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("alk.maps").directive("mapStyles", mapStyles);
	
	  function mapStyles() {
	
	    var directive = {
	      bindToController: true,
	      controller: mapSylesController,
	      controllerAs: "vm",
	      template: __webpack_require__(282),
	      restrict: "E",
	      scope: {}
	    };
	    return directive;
	  }
	
	  mapSylesController.$inject = ["$scope", "$element", "$attrs", "$translate", "mapService", "UserProvider"];
	
	  function mapSylesController($scope, $element, $attrs, $translate, mapService, UserProvider) {
	
	    var vm = this;
	
	    var mapStyles = [{
	      name: "Road Map",
	      style: "transportation",
	      img: __webpack_require__(283)
	    }, {
	      name: "Satellite Map",
	      style: "satellite",
	      img: __webpack_require__(284)
	    }, {
	      name: "Satellite Only",
	      style: "satellite_only",
	      img: __webpack_require__(285)
	    }, {
	      name: "Terrain Map",
	      style: "terrain",
	      img: __webpack_require__(286)
	    }, {
	      name: "Light Data Map",
	      style: "datalight",
	      img: __webpack_require__(287)
	    }, {
	      name: "Dark Data Map",
	      style: "datadark",
	      img: __webpack_require__(288)
	      // {
	      //   name: "Trimble Map",
	      //   style: "classic",
	      //   img: require("../../../Common Style Files/img/mapstyle-default.svg")
	      // },
	    }];
	
	    // remove this if PCM_GT gets the other styles
	    var dataVersion = UserProvider.getUser().dataVersion;
	    if (dataVersion === "PCM_GT") {
	      mapStyles = mapStyles.filter(function (style) {
	        return ['satellite_only', 'transportation'].includes(style.style);
	      });
	    }
	
	    function filterStyles() {
	      if ($attrs && $attrs.exclude) {
	        var exList = $attrs.exclude.split(",");
	        var exStyles = _.filter(mapStyles, function (s) {
	          var isExcluded = exList.indexOf(s.style) === -1;
	          return isExcluded;
	        });
	        return exStyles;
	      } else {
	        return mapStyles;
	      }
	    }
	
	    vm.includedMapStyles = filterStyles();
	
	    vm.changeMapStyle = mapService.setStyle;
	
	    vm.isStyle = function (style) {
	      return style === mapService.getStyle();
	    };
	
	    vm.currentMapStyle = function () {
	      var currentStyle = mapService.getStyle();
	      return _.find(mapStyles, function (s) {
	        return s.style === currentStyle;
	      });
	    };
	  }
	})();

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<ul>\r\n    <li class=\"large-btn btn-group dropdown\" uib-dropdown>\r\n      <button class=\"dropdown-toggle\" uib-dropdown-toggle id=\"map-style-btn\">\r\n        <img class=\"square\" ng-src=\"{{vm.currentMapStyle().img}}\" />\r\n        <span translate=\"common.nav.MapStyle\"></span>\r\n      <br />\r\n      <span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" role=\"menu\">\r\n        <li role=\"menuitem\" ng-repeat=\"style in vm.includedMapStyles\" ng-click=\"vm.changeMapStyle(style.style)\" ng-class=\"{'active': vm.isStyle(style.style)}\">\r\n          <a href=\"#\"><img class=\"square small-inline\" ng-src=\"{{style.img}}\" /> {{style.name}}</a></li>\r\n      </ul>\r\n    </li>\r\n  </ul>\r\n";

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "data:image/svg+xml;base64,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";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__.p + "183b514699c789b3a98dd27006d0d7cc.svg";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__.p + "29229af6feac8618c655f15286b83880.svg";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__.p + "b869d752f7324753aedd4b9f7153eaa1.svg";

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNjQgNjQiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO30uY2xzLTJ7bWFzazp1cmwoI21hc2spO30uY2xzLTN7ZmlsbDojZWJlYmViO30uY2xzLTR7ZmlsbDojYzdkM2Q5O30uY2xzLTV7ZmlsbDojZTFlNWRhO3N0cm9rZTojZDdkYmQwO30uY2xzLTEwLC5jbHMtMTEsLmNscy0xMiwuY2xzLTEzLC5jbHMtMTQsLmNscy01LC5jbHMtNiwuY2xzLTcsLmNscy04LC5jbHMtOXtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9LmNscy0xMCwuY2xzLTExLC5jbHMtMTIsLmNscy0xMywuY2xzLTE0LC5jbHMtNiwuY2xzLTcsLmNscy04LC5jbHMtOXtmaWxsOm5vbmU7fS5jbHMtNiwuY2xzLTh7c3Ryb2tlOiNkNmQ2ZDY7fS5jbHMtMTIsLmNscy0xNCwuY2xzLTYsLmNscy05e3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMTEsLmNscy03e3N0cm9rZTojZmZmO30uY2xzLTcsLmNscy04e3N0cm9rZS13aWR0aDoycHg7fS5jbHMtOXtzdHJva2U6I2NmY2ZjZjt9LmNscy0xMHtzdHJva2U6I2UzY2NiMTtzdHJva2Utd2lkdGg6NHB4O30uY2xzLTEye3N0cm9rZTojZmZmZWY3O30uY2xzLTEze3N0cm9rZTojZWJjYWE5O3N0cm9rZS13aWR0aDo1cHg7fS5jbHMtMTR7c3Ryb2tlOiNmYWVkZTE7fTwvc3R5bGU+PG1hc2sgaWQ9Im1hc2siIHg9Ii0yNS41OSIgeT0iLTMzLjcxIiB3aWR0aD0iMTEzLjUxIiBoZWlnaHQ9IjExNy41NCIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiLz48L21hc2s+PC9kZWZzPjx0aXRsZT5tYXBzdHlsZS1tb25vY2hyb21lPC90aXRsZT48ZyBpZD0idGh1bWJuYWlsIj48ZyBjbGFzcz0iY2xzLTIiPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iLTE4IiB5PSItMjMiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIi8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNLTE0LDc4Yy0yLjY2LTIuODMtMi44OS02LjU4LTMtOC40LS4xMi0yLS4zNC01LjU1LDEuOC04LjRzNC4yOS0xLjgzLDEwLjQtNS40YzQuMzEtMi41Miw0LTMuNSw2LjgtNC40LDMuNC0xLjExLDQuODEuMDYsMTEsLjYsNy45LjY5LDcuODYtMSwxNS0uMiw1Ljg0LjY3LDguMzgsMi4xMSw5LjguNiwxLjgxLTEuOTItMS4xNy01LjQzLjgtOC42LDEtMS41OCwzLjI3LTIuMjEsNy44LTMuNCw1Ljc2LTEuNTEsMTAuMTItMi42MSwxMS44LS42LDEuMDYsMS4yNy4yMiwyLjc4LDEuNCwzLjYsMS40NSwxLDMuMjMtLjkxLDYtLjgsMy4zNy4xNCwzLjY5LDMuMDksNy40LDQuNiw1LjMxLDIuMTYsOS0yLjE0LDEyLC4yLDIuMzcsMS44NCwzLjA3LDYuODEuOCw4LjYtMSwuODEtMi4zOC0uNjEtNS40LDBhOC43LDguNywwLDAsMC0zLDEuMmMtLjIuMTMtMy44MiwyLjUyLTMuMiw0LjhhMi40NiwyLjQ2LDAsMCwwLDIuMiwxLjhjLjMxLDAsLjc5LS4xNSwyLjQtMi4yLDEuNC0xLjc5LDEuMzEtMiwxLjgtMi40LDIuMTUtMS42Miw3LjI5LjY1LDcuMiwyLS4wNS43OS0xLjg0Ljc5LTUuNiwzLTIuOTEsMS43MS0zLDIuMzktMywyLjYsMCwxLjQ1LDIuNzMsMS42Nyw0LjIsNC40LDEuMDUsMiwuOTEsNC4yMi40LDQuNHMtMS4xMi0yLjEyLTMuMi0yLjhjLTEuNTctLjUxLTIuMzcuNDQtMy40LS4yLTEuMjktLjgtLjQ3LTIuNTctMS42LTQtMS40MS0xLjc3LTQuOTItMS44OS03LjQtMS0zLjQsMS4yMi00LDQtNi40LDMuOGE0LDQsMCwwLDEtMy0yYy0uOTMtMS42OC4yNS0zLC4yLTYuMmExMS4xNiwxMS4xNiwwLDAsMC0xLTQuOGMtMS4zNC0yLjczLTQuNTgtNS40MS03LjgtNS4yLTIuODguMTktMy4xOCwyLjUyLTYuOCwzLTIuNi4zNC0yLjkzLS43OS01LjQtLjYtMy43OC4zLTQuMywzLjA2LTguOCw1YTE4LjUxLDE4LjUxLDAsMCwxLTkuNiwxLjJjLTQuOTItLjY2LTUuNi0yLjkyLTkuNC0yLjYtMi4zOS4yLTIuMSwxLjA5LTcuMiwzcy03Ljc2LDEuOTUtOCwzLjRjLS4xNS44OS43NSwxLjc3LDIsMywxLjgyLDEuNzksMi44NiwxLjc2LDMuOCwyLjgsMS43NywxLjk1LDEuNzIsNiwwLDguMkMtMi4wOSw4My4yNS0xMC4xMyw4Mi4xMi0xNCw3OFoiLz48cGF0aCBjbGFzcz0iY2xzLTUiIGQ9Ik01NS40LDQyLjhjMS40MiwxLjM3LDEuMyw0LjU5LS4yLDYtMS4yMiwxLjE0LTIuNTEuMjktNS42LjgtNC44Ni44LTYuNSwzLjcxLTgsMi44cy0xLjQ2LTQuMTgsMC02LjJjLjQ1LS42MiwxLjE4LTEuMyw1LTIuNEM1MS42NSw0Mi4zNCw1NC4xNyw0MS42MSw1NS40LDQyLjhaTTYzLDQ5LjRhNy43OSw3Ljc5LDAsMCwwLTQuOCwxLjJjLS42LjQyLTEuODYsMS4zMi0xLjgsMi40LjEsMS43MywzLjQzLDEuNSw0LjgsNC4yLjU3LDEuMTIuNjUsMi40OC44LDUuMi4xMSwxLjksMCwyLjQ4LjQsMi44LjY2LjQ5LDEuODgtLjE4LDYtMi44LDUuMDgtMy4yMiw1LjU4LTMuNjksNi00LjZhNi42Nyw2LjY3LDAsMCwwLS40LTYuNEM3Mi42MSw0OS40Nyw2OS40LDQ5LjQ1LDYzLDQ5LjRaIi8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtNiIgcG9pbnRzPSIzOCAtMSA0NSAwIDg2IDIiLz48cG9seWxpbmUgY2xhc3M9ImNscy02IiBwb2ludHM9Ijc1LjggLTIzIDU3IDUgNTggMjAgNjYgMjMiLz48bGluZSBjbGFzcz0iY2xzLTYiIHgxPSIyMiIgeTE9IjUiIHgyPSIzOSIgeTI9Ii0yNyIvPjxsaW5lIGNsYXNzPSJjbHMtNiIgeDE9IjExIiB5MT0iMSIgeDI9IjI5IiB5Mj0iLTMzIi8+PGxpbmUgY2xhc3M9ImNscy02IiB4MT0iLTEiIHkxPSItNSIgeDI9Ii0yMiIgeTI9IjI4Ii8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtNiIgcG9pbnRzPSIyNCA3IDEwIDI4IC00IDI5IC0xOCAyMi4yIi8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtNiIgcG9pbnRzPSIxNCAyMiAtMTEgMTEgLTI1IDUiLz48bGluZSBjbGFzcz0iY2xzLTYiIHgxPSItMTUiIHkxPSIxNyIgeDI9IjEwIiB5Mj0iMjciLz48bGluZSBjbGFzcz0iY2xzLTYiIHgxPSIzMyIgeTE9IjYzIiB4Mj0iOCIgeTI9IjY5Ii8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtNiIgcG9pbnRzPSItMjIgLTE0IDIxIDUgMzUgMTAgODYgMTIiLz48cG9seWxpbmUgY2xhc3M9ImNscy03IiBwb2ludHM9Ii0yMiAtMTQgMjEgNSAzNSAxMCA4NiAxMiIvPjxwYXRoIGNsYXNzPSJjbHMtOCIgZD0iTTM0LjIsMjEuNmE5LjUyLDkuNTIsMCwwLDEsNS4yLTYuMiw3Ljg5LDcuODksMCwwLDEsNi40LDAsNi40MSw2LjQxLDAsMCwxLDMuNiw0LjIsNi4yMiw2LjIyLDAsMCwxLTEsNC44QTYuNSw2LjUsMCwwLDEsNDMuNiwyNyIvPjxsaW5lIGNsYXNzPSJjbHMtOSIgeDE9IjMzIiB5MT0iMTAiIHgyPSI1MyIgeTI9Ii0yNyIvPjxwYXRoIGNsYXNzPSJjbHMtMTAiIGQ9Ik0yNSw2YTExLjQsMTEuNCwwLDAsMSw1LjQsMy40QTExLjg3LDExLjg3LDAsMCwxLDMzLDE1LjhjMS4xMSw4LjI1LS4xOCwxNS4zNC0uMiwyMy42LDAsNC4wOS40Niw4LjI2LDEuNCwxNi42LjYxLDUuNDMsMSw5LDIsMTMuOGExMTMuMSwxMTMuMSwwLDAsMCwzLjYsMTMuNCIvPjxwYXRoIGNsYXNzPSJjbHMtOCIgZD0iTTQwLjQsMjguOGMzLjMzLS4yLDUuODgsMi4wNyw2LDQuNFM0My45MiwzNy41LDQxLjgsMzhBNi44OCw2Ljg4LDAsMCwxLDM2LDM2LjRhNy4xMiw3LjEyLDAsMCwxLTIuMi0zLjgiLz48cGF0aCBjbGFzcz0iY2xzLTgiIGQ9Ik0tNCwzNGM2LjYsMi44LDkuNzIsNi4yNSwxMS42LDYuOCwzLjcsMS4wOSw1Ljg0LjQyLDEwLjQsMS4yYTI0LjU4LDI0LjU4LDAsMCwxLDcuOCwyLjRjNS41MiwzLjA5LDcuNiw5LjUsOC40LDEzIi8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtNyIgcG9pbnRzPSIzOCAtMSA0NSAwIDg2IDIiLz48cG9seWxpbmUgY2xhc3M9ImNscy03IiBwb2ludHM9Ijc1LjggLTIzIDU3IDUgNTggMjAgNjYgMjMiLz48bGluZSBjbGFzcz0iY2xzLTciIHgxPSIyMiIgeTE9IjUiIHgyPSIzOSIgeTI9Ii0yNyIvPjxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjExIiB5MT0iMSIgeDI9IjI5IiB5Mj0iLTMzIi8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtNyIgcG9pbnRzPSIyNCA3IDEwIDI4IC00IDI5IC0xOCAyMi4yIi8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtNyIgcG9pbnRzPSIxNCAyMiAtMTEgMTEgLTI1IDUiLz48bGluZSBjbGFzcz0iY2xzLTciIHgxPSItMTUiIHkxPSIxNyIgeDI9IjEwIiB5Mj0iMjciLz48bGluZSBjbGFzcz0iY2xzLTciIHgxPSIzMyIgeTE9IjYzIiB4Mj0iOCIgeTI9IjY5Ii8+PHBhdGggY2xhc3M9ImNscy0xMSIgZD0iTTM0LjIsMjEuNmE5LjUyLDkuNTIsMCwwLDEsNS4yLTYuMiw3Ljg5LDcuODksMCwwLDEsNi40LDAsNi40MSw2LjQxLDAsMCwxLDMuNiw0LjIsNi4yMiw2LjIyLDAsMCwxLTEsNC44QTYuNSw2LjUsMCwwLDEsNDMuNiwyNyIvPjxwYXRoIGNsYXNzPSJjbHMtMTIiIGQ9Ik0yNSw2YTExLjQsMTEuNCwwLDAsMSw1LjQsMy40QTExLjg3LDExLjg3LDAsMCwxLDMzLDE1LjhjMS4xMSw4LjI1LS4xOCwxNS4zNC0uMiwyMy42LDAsNC4wOS40Niw4LjI2LDEuNCwxNi42LjYxLDUuNDMsMSw5LDIsMTMuOGExMTMuMSwxMTMuMSwwLDAsMCwzLjYsMTMuNCIvPjxsaW5lIGNsYXNzPSJjbHMtNyIgeDE9IjMzIiB5MT0iMTAiIHgyPSI1MyIgeTI9Ii0yNyIvPjxwYXRoIGNsYXNzPSJjbHMtMTEiIGQ9Ik00MC40LDI4LjhjMy4zMy0uMiw1Ljg4LDIuMDcsNiw0LjRTNDMuOTIsMzcuNSw0MS44LDM4QTYuODgsNi44OCwwLDAsMSwzNiwzNi40YTcuMTIsNy4xMiwwLDAsMS0yLjItMy44Ii8+PHBhdGggY2xhc3M9ImNscy0xMSIgZD0iTS00LDM0YzYuNiwyLjgsOS43Miw2LjI1LDExLjYsNi44LDMuNywxLjA5LDUuODQuNDIsMTAuNCwxLjJhMjQuNTgsMjQuNTgsMCwwLDEsNy44LDIuNGM1LjUyLDMuMDksNy42LDkuNSw4LjQsMTMiLz48cGF0aCBjbGFzcz0iY2xzLTEzIiBkPSJNLTIzLDM1YzIwLjE0LS4yNywzNC4xNy0xLjIyLDQ0LjgtMy44LDItLjUsMTEuMzMtMy4zNCwyMS44Mi0zLjUzQzQ5LjIzLDI3LjU2LDU0LDI4LDU0LDI4YzIuOTQuMjcsNC4wNS41MiwxMC41LDEuMzYsMi4xNC4yOCw0LjgyLjYxLDguNSwxLDYuMi43MiwxMS4zNCwxLDE0LjgsMS4yIi8+PHBhdGggY2xhc3M9ImNscy0xNCIgZD0iTS0yMywzNWMyMC4xNC0uMjcsMzQuMTctMS4yMiw0NC44LTMuOCwyLS41LDExLjMzLTMuMzQsMjEuODItMy41M0M0OS4yMywyNy41Niw1NCwyOCw1NCwyOGMyLjk0LjI3LDQuMDUuNTIsMTAuNSwxLjM2LDIuMTQuMjgsNC44Mi42MSw4LjUsMSw2LjIuNzIsMTEuMzQsMSwxNC44LDEuMiIvPjwvZz48L2c+PC9zdmc+";

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "data:image/svg+xml;base64,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";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * A common footer that is used by Angular 1.x apps with a map (for logged-in pages).
	 * Currently used by Mapsure, MapExact, Content Tools, FleetView, and PCM Web UI.
	 */
	
	(function () {
	  "use strict";
	
	  angular.module("alk.maps").directive("mapFooter", mapFooter);
	
	  mapFooter.$inject = [];
	
	  function mapFooter() {
	
	    var directive = {
	      template: __webpack_require__(290),
	      controllerAs: "vm",
	      controller: ["$scope", "$injector", "$rootScope", function ($scope, $injector, $rootScope) {
	        var vm = this;
	        vm.app = $scope.app;
	        var UserProvider = $injector.get("UserProvider");
	        vm.userInfo = UserProvider.getUser();
	
	        vm.isProd = ("alkqaaws") === "production";
	        if (vm.userInfo.roles) {
	          vm.isAdminOrSupport = vm.userInfo.roles.indexOf("ALK Administrator") !== -1 || vm.userInfo.roles.indexOf("ALK Support") !== -1;
	        }
	        vm.userRoles = _.uniq(vm.userInfo.roles).toString();
	        //If not showing the map, only need the copyright and TOS links
	        if ($scope.mapShown !== "true") {
	          return;
	        }
	
	        var mapService = $injector.get("mapService");
	
	        //A bit hacky since the map services differ across apps, should refactor all apps to use same mapService eventually.
	        if (vm.app === "PCMWebUI") {
	          vm.mapObj = mapService.getMapFromId("pcmMap").map;
	        } else {
	          vm.mapObj = mapService.getMap();
	        }
	
	        $rootScope.$on("RegionUpdated", function () {
	          vm.userInfo = UserProvider.getUser();
	        });
	      }],
	      scope: {
	        app: "@",
	        mapShown: "@"
	      }
	    };
	
	    return directive;
	  }
	})();

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<div id=\"footer\">\r\n  <div class=\"pull-left\">\r\n    <div class=\"legal-text\">\r\n      <span ng-if=\"vm.app !== 'PCMWebUI'\">\r\n        <copyright-text></copyright-text> | <a href=\"/terms\" translate=\"views.nav.TOS\"></a> |\r\n        <a href=\"https://www.alk.com/support\" target=\"_blank\"translate=\"views.nav.ContactSupport\"></a>\r\n      </span>\r\n      <span ng-if=\"vm.app === 'PCMWebUI'\">\r\n        <copyright-text type=\"WebUI\"></copyright-text> |\r\n        <a href=\"/terms\" translate=\"views.nav.TOS\"></a> |\r\n        <a href=\"http://support.pcmiler.com\" target=\"_blank\"translate=\"views.nav.ContactSupport\"></a>\r\n        </span>\r\n      </span>\r\n    </div>\r\n  </div>\r\n  <div >\r\n    <div ng-if=\"vm.mapObj && vm.userInfo.gridDataVersion\" id=\"grid-data-version\" class=\"pull-right\">{{vm.userInfo.gridDataVersion}}</div>\r\n    <div id=\"locator-panel\" class=\"pull-right\" ng-if=\"vm.mapObj\">\r\n      <p>\r\n        <span id=\"locator-output\" class=\"ng-cloak\" ng-cloak maps-location map-obj=\"vm.mapObj\" map-dataset=\"(vm.userInfo.accountType === 'PCMWeb')? vm.userInfo.dataset : vm.userInfo.dataVersion\"\r\n          map-region=\"vm.userInfo.region\"></span>\r\n      </p>\r\n    </div>\r\n    <div maps-mouse-position map-obj=\"vm.mapObj\" class=\"pull-right\" ng-if=\"vm.mapObj\"></div>\r\n    <div id=\"user-info\" class=\"pull-right\" ng-if=\"vm.userInfo.userName\">{{vm.userInfo.userName}} ({{ vm.userRoles }}), {{vm.userInfo.account ? vm.userInfo.account : \"\"}}\r\n    </div>\r\n  </ng-if>\r\n</div>\r\n";

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("alk.constants", []);

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("alk.constants")
	/** @name STATES
	 * @ngdoc constant
	 * @description Provides a list of states that are supported by ALK applications.
	 * The constant is an array of objects that look like
	 * `{abbreviation: string, name: string, country: string}`
	 * @memberof alk.constants
	 */
	.constant("STATES", [{
	  "abbreviation": "AL",
	  "name": "Alabama",
	  "country": "United States"
	}, {
	  "abbreviation": "AK",
	  "name": "Alaska",
	  "country": "United States"
	}, {
	  "abbreviation": "AZ",
	  "name": "Arizona",
	  "country": "United States"
	}, {
	  "abbreviation": "AR",
	  "name": "Arkansas",
	  "country": "United States"
	}, {
	  "abbreviation": "CA",
	  "name": "California",
	  "country": "United States"
	}, {
	  "abbreviation": "CO",
	  "name": "Colorado",
	  "country": "United States"
	}, {
	  "abbreviation": "CT",
	  "name": "Connecticut",
	  "country": "United States"
	}, {
	  "abbreviation": "DE",
	  "name": "Delaware",
	  "country": "United States"
	}, {
	  "abbreviation": "DC",
	  "name": "District of Columbia",
	  "country": "United States"
	}, {
	  "abbreviation": "FL",
	  "name": "Florida",
	  "country": "United States"
	}, {
	  "abbreviation": "GA",
	  "name": "Georgia",
	  "country": "United States"
	}, {
	  "abbreviation": "HI",
	  "name": "Hawaii",
	  "country": "United States"
	}, {
	  "abbreviation": "ID",
	  "name": "Idaho",
	  "country": "United States"
	}, {
	  "abbreviation": "IL",
	  "name": "Illinois",
	  "country": "United States"
	}, {
	  "abbreviation": "IN",
	  "name": "Indiana",
	  "country": "United States"
	}, {
	  "abbreviation": "IA",
	  "name": "Iowa",
	  "country": "United States"
	}, {
	  "abbreviation": "KS",
	  "name": "Kansas",
	  "country": "United States"
	}, {
	  "abbreviation": "KY",
	  "name": "Kentucky",
	  "country": "United States"
	}, {
	  "abbreviation": "LA",
	  "name": "Louisiana",
	  "country": "United States"
	}, {
	  "abbreviation": "ME",
	  "name": "Maine",
	  "country": "United States"
	}, {
	  "abbreviation": "MD",
	  "name": "Maryland",
	  "country": "United States"
	}, {
	  "abbreviation": "MA",
	  "name": "Massachusetts",
	  "country": "United States"
	}, {
	  "abbreviation": "MI",
	  "name": "Michigan",
	  "country": "United States"
	}, {
	  "abbreviation": "MN",
	  "name": "Minnesota",
	  "country": "United States"
	}, {
	  "abbreviation": "MS",
	  "name": "Mississippi",
	  "country": "United States"
	}, {
	  "abbreviation": "MO",
	  "name": "Missouri",
	  "country": "United States"
	}, {
	  "abbreviation": "MT",
	  "name": "Montana",
	  "country": "United States"
	}, {
	  "abbreviation": "NE",
	  "name": "Nebraska",
	  "country": "United States"
	}, {
	  "abbreviation": "NV",
	  "name": "Nevada",
	  "country": "United States"
	}, {
	  "abbreviation": "NH",
	  "name": "New Hampshire",
	  "country": "United States"
	}, {
	  "abbreviation": "NJ",
	  "name": "New Jersey",
	  "country": "United States"
	}, {
	  "abbreviation": "NM",
	  "name": "New Mexico",
	  "country": "United States"
	}, {
	  "abbreviation": "NY",
	  "name": "New York",
	  "country": "United States"
	}, {
	  "abbreviation": "NC",
	  "name": "North Carolina",
	  "country": "United States"
	}, {
	  "abbreviation": "ND",
	  "name": "North Dakota",
	  "country": "United States"
	}, {
	  "abbreviation": "OH",
	  "name": "Ohio",
	  "country": "United States"
	}, {
	  "abbreviation": "OK",
	  "name": "Oklahoma",
	  "country": "United States"
	}, {
	  "abbreviation": "OR",
	  "name": "Oregon",
	  "country": "United States"
	}, {
	  "abbreviation": "PA",
	  "name": "Pennsylvania",
	  "country": "United States"
	}, {
	  "abbreviation": "RI",
	  "name": "Rhode Island",
	  "country": "United States"
	}, {
	  "abbreviation": "SC",
	  "name": "South Carolina",
	  "country": "United States"
	}, {
	  "abbreviation": "SD",
	  "name": "South Dakota",
	  "country": "United States"
	}, {
	  "abbreviation": "TN",
	  "name": "Tennessee",
	  "country": "United States"
	}, {
	  "abbreviation": "TX",
	  "name": "Texas",
	  "country": "United States"
	}, {
	  "abbreviation": "UT",
	  "name": "Utah",
	  "country": "United States"
	}, {
	  "abbreviation": "VT",
	  "name": "Vermont",
	  "country": "United States"
	}, {
	  "abbreviation": "VA",
	  "name": "Virginia",
	  "country": "United States"
	}, {
	  "abbreviation": "WA",
	  "name": "Washington",
	  "country": "United States"
	}, {
	  "abbreviation": "WV",
	  "name": "West Virginia",
	  "country": "United States"
	}, {
	  "abbreviation": "WI",
	  "name": "Wisconsin",
	  "country": "United States"
	}, {
	  "abbreviation": "WY",
	  "name": "Wyoming",
	  "country": "United States"
	}, {
	  "abbreviation": "AB",
	  "name": "Alberta",
	  "country": "Canada"
	}, {
	  "abbreviation": "BC",
	  "name": "British Columbia",
	  "country": "Canada"
	}, {
	  "abbreviation": "MB",
	  "name": "Manitoba",
	  "country": "Canada"
	}, {
	  "abbreviation": "NB",
	  "name": "New Brunswick",
	  "country": "Canada"
	}, {
	  "abbreviation": "NF",
	  "name": "Newfoundland",
	  "country": "Canada"
	}, {
	  "abbreviation": "NT",
	  "name": "Northwest Territory",
	  "country": "Canada"
	}, {
	  "abbreviation": "NS",
	  "name": "Nova Scotia",
	  "country": "Canada"
	}, {
	  "abbreviation": "NU",
	  "name": "Nunavut",
	  "country": "Canada"
	}, {
	  "abbreviation": "ON",
	  "name": "Ontario",
	  "country": "Canada"
	}, {
	  "abbreviation": "PE",
	  "name": "Prince Edward Island",
	  "country": "Canada"
	}, {
	  "abbreviation": "QC",
	  "name": "Quebec",
	  "country": "Canada"
	}, {
	  "abbreviation": "SK",
	  "name": "Saskatchewan",
	  "country": "Canada"
	}, {
	  "abbreviation": "YT",
	  "name": "Yukon Territory",
	  "country": "Canada"
	}, {
	  "abbreviation": "AG",
	  "name": "Aguascalientes",
	  "country": "Mexico"
	}, {
	  "abbreviation": "BJ",
	  "name": "Baja California",
	  "country": "Mexico"
	}, {
	  "abbreviation": "BS",
	  "name": "Baja California Sur",
	  "country": "Mexico"
	}, {
	  "abbreviation": "CP",
	  "name": "Campeche",
	  "country": "Mexico"
	}, {
	  "abbreviation": "CH",
	  "name": "Chiapas",
	  "country": "Mexico"
	}, {
	  "abbreviation": "CI",
	  "name": "Chihuahua",
	  "country": "Mexico"
	}, {
	  "abbreviation": "CU",
	  "name": "Coahuila",
	  "country": "Mexico"
	}, {
	  "abbreviation": "CL",
	  "name": "Colima",
	  "country": "Mexico"
	}, {
	  "abbreviation": "DF",
	  "name": "Distrito Federal",
	  "country": "Mexico"
	}, {
	  "abbreviation": "DG",
	  "name": "Durango",
	  "country": "Mexico"
	}, {
	  "abbreviation": "GJ",
	  "name": "Guanajuato",
	  "country": "Mexico"
	}, {
	  "abbreviation": "GR",
	  "name": "Guerrero",
	  "country": "Mexico"
	}, {
	  "abbreviation": "HG",
	  "name": "Hidalgo",
	  "country": "Mexico"
	}, {
	  "abbreviation": "JA",
	  "name": "Jalisco",
	  "country": "Mexico"
	}, {
	  "abbreviation": "EM",
	  "name": "Mexico",
	  "country": "Mexico"
	}, {
	  "abbreviation": "MH",
	  "name": "Michoacan",
	  "country": "Mexico"
	}, {
	  "abbreviation": "MR",
	  "name": "Morelos",
	  "country": "Mexico"
	}, {
	  "abbreviation": "NA",
	  "name": "Nayarit",
	  "country": "Mexico"
	}, {
	  "abbreviation": "NL",
	  "name": "Nuevo Leon",
	  "country": "Mexico"
	}, {
	  "abbreviation": "OA",
	  "name": "Oaxaca",
	  "country": "Mexico"
	}, {
	  "abbreviation": "PU",
	  "name": "Puebla",
	  "country": "Mexico"
	}, {
	  "abbreviation": "QA",
	  "name": "Queretaro",
	  "country": "Mexico"
	}, {
	  "abbreviation": "QR",
	  "name": "Quintana Roo",
	  "country": "Mexico"
	}, {
	  "abbreviation": "SL",
	  "name": "San Luis Potosi",
	  "country": "Mexico"
	}, {
	  "abbreviation": "SI",
	  "name": "Sinaloa",
	  "country": "Mexico"
	}, {
	  "abbreviation": "SO",
	  "name": "Sonora",
	  "country": "Mexico"
	}, {
	  "abbreviation": "TA",
	  "name": "Tabasco",
	  "country": "Mexico"
	}, {
	  "abbreviation": "TM",
	  "name": "Tamaulipas",
	  "country": "Mexico"
	}, {
	  "abbreviation": "TL",
	  "name": "Tlaxcala",
	  "country": "Mexico"
	}, {
	  "abbreviation": "VZ",
	  "name": "Veracruz",
	  "country": "Mexico"
	}, {
	  "abbreviation": "YC",
	  "name": "Yucatan",
	  "country": "Mexico"
	}, {
	  "abbreviation": "ZT",
	  "name": "Zacatecas",
	  "country": "Mexico"
	}]);

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("alk.constants")
	/** @name PCMRegion
	 * @ngdoc constant
	 * @description Provides a list of the supported PCMiler regions recognized by PCMiler Web Services.
	 * The constant is the following object:
	 * 
	 * `{
	 * "Unknown": 0,
	 * "AF": 1,
	 * "AS": 2,
	 * "EU": 3,
	 * "NA": 4,
	 * "OC": 5,
	 * "SA": 6,
	 * "ME": 7
	 * }`
	 * @memberof alk.constants
	 */
	.constant("PCMRegion", {
	  "Unknown": 0,
	  "AF": 1,
	  "AS": 2,
	  "EU": 3,
	  "NA": 4,
	  "OC": 5,
	  "SA": 6,
	  "ME": 7
	});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("alk.constants")
	/** @name COUNTRIES
	 * @ngdoc constant
	 * @description Provides the countries supported by ALK applications. The constant is
	 * an object keyed by [PCMRegion](alk.constants.PCMRegion.html) strings that map to an array of
	 * objects of the form
	 * `{ name: string, id: number, abbreviation: string}`
	 * @memberof alk.constants
	 */
	.constant("COUNTRIES", {
	  "AF": [{
	    "name": "Algeria",
	    "id": 3,
	    "abbreviation": "DZ"
	  }, {
	    "name": "Angola",
	    "id": 6,
	    "abbreviation": "AO"
	  }, {
	    "name": "Benin",
	    "id": 22,
	    "abbreviation": "BJ"
	  }, {
	    "name": "Botswana",
	    "id": 27,
	    "abbreviation": "BW"
	  }, {
	    "name": "Burkina Faso",
	    "id": 32,
	    "abbreviation": "BF"
	  }, {
	    "name": "Burundi",
	    "id": 34,
	    "abbreviation": "BI"
	  }, {
	    "name": "Cameroon",
	    "id": 36,
	    "abbreviation": "CM"
	  }, {
	    "name": "Cape Verde",
	    "id": 38,
	    "abbreviation": "CV"
	  }, {
	    "name": "Central African Republic",
	    "id": 40,
	    "abbreviation": "CF"
	  }, {
	    "name": "Chad",
	    "id": 41,
	    "abbreviation": "TD"
	  }, {
	    "name": "Comoros",
	    "id": 46,
	    "abbreviation": "KM"
	  }, {
	    "name": "Congo, Democratic Republic (Kinshasa)",
	    "id": 176,
	    "abbreviation": "CG"
	  }, {
	    "name": "Congo, Replublic of the (Brazzaville)",
	    "id": 47,
	    "abbreviation": "CD"
	  }, {
	    "name": "Djibouti",
	    "id": 56,
	    "abbreviation": "DJ"
	  }, {
	    "name": "Egypt",
	    "id": 61,
	    "abbreviation": "EG"
	  }, {
	    "name": "Equatorial Guinea",
	    "id": 63,
	    "abbreviation": "GQ"
	  }, {
	    "name": "Eritrea",
	    "id": 64,
	    "abbreviation": "ER"
	  }, {
	    "name": "Ethiopia",
	    "id": 66,
	    "abbreviation": "ET"
	  }, {
	    "name": "Gabon",
	    "id": 75,
	    "abbreviation": "GA"
	  }, {
	    "name": "Gambia",
	    "id": 76,
	    "abbreviation": "GM"
	  }, {
	    "name": "Ghana",
	    "id": 79,
	    "abbreviation": "GH"
	  }, {
	    "name": "Guinea",
	    "id": 87,
	    "abbreviation": "GN"
	  }, {
	    "name": "Guinea-Bissau",
	    "id": 88,
	    "abbreviation": "GW"
	  }, {
	    "name": "Ivory Coast (Cote d'Ivoire)",
	    "id": 103,
	    "abbreviation": "CI"
	  }, {
	    "name": "Kenya",
	    "id": 108,
	    "abbreviation": "KE"
	  }, {
	    "name": "Lesotho",
	    "id": 118,
	    "abbreviation": "LS"
	  }, {
	    "name": "Liberia",
	    "id": 119,
	    "abbreviation": "LR"
	  }, {
	    "name": "Libya",
	    "id": 120,
	    "abbreviation": "LY"
	  }, {
	    "name": "Madagascar",
	    "id": 126,
	    "abbreviation": "MG"
	  }, {
	    "name": "Malawi",
	    "id": 127,
	    "abbreviation": "MW"
	  }, {
	    "name": "Mali",
	    "id": 130,
	    "abbreviation": "ML"
	  }, {
	    "name": "Mauritania",
	    "id": 134,
	    "abbreviation": "MR"
	  }, {
	    "name": "Mauritius",
	    "id": 135,
	    "abbreviation": "MU"
	  }, {
	    "name": "Mayotte",
	    "id": 136,
	    "abbreviation": "YT"
	  }, {
	    "name": "Morocco",
	    "id": 145,
	    "abbreviation": "MA"
	  }, {
	    "name": "Mozambique",
	    "id": 146,
	    "abbreviation": "MZ"
	  }, {
	    "name": "Namibia",
	    "id": 148,
	    "abbreviation": "NA"
	  }, {
	    "name": "Niger",
	    "id": 156,
	    "abbreviation": "NE"
	  }, {
	    "name": "Nigeria",
	    "id": 157,
	    "abbreviation": "NG"
	  }, {
	    "name": "Rwanda",
	    "id": 180,
	    "abbreviation": "RW"
	  }, {
	    "name": "Saint Helena",
	    "id": 181,
	    "abbreviation": "SH"
	  }, {
	    "name": "Sao Tome and Principe",
	    "id": 187,
	    "abbreviation": "ST"
	  }, {
	    "name": "Senegal",
	    "id": 189,
	    "abbreviation": "SN"
	  }, {
	    "name": "Seychelles",
	    "id": 190,
	    "abbreviation": "SC"
	  }, {
	    "name": "Sierra Leone",
	    "id": 191,
	    "abbreviation": "SL"
	  }, {
	    "name": "Somalia",
	    "id": 196,
	    "abbreviation": "SO"
	  }, {
	    "name": "South Africa",
	    "id": 197,
	    "abbreviation": "ZA"
	  }, {
	    "name": "South Sudan",
	    "id": 246,
	    "abbreviation": "SS"
	  }, {
	    "name": "Sudan",
	    "id": 200,
	    "abbreviation": "SD"
	  }, {
	    "name": "Swaziland",
	    "id": 203,
	    "abbreviation": "SZ"
	  }, {
	    "name": "Tanzania",
	    "id": 209,
	    "abbreviation": "TZ"
	  }, {
	    "name": "Togo",
	    "id": 211,
	    "abbreviation": "TG"
	  }, {
	    "name": "Tunisia",
	    "id": 215,
	    "abbreviation": "TN"
	  }, {
	    "name": "Uganda",
	    "id": 220,
	    "abbreviation": "UG"
	  }, {
	    "name": "Western Sahara",
	    "id": 234,
	    "abbreviation": "EH"
	  }, {
	    "name": "Zambia",
	    "id": 238,
	    "abbreviation": "ZM"
	  }, {
	    "name": "Zimbabwe",
	    "id": 239,
	    "abbreviation": "ZW"
	  }],
	  "AS": [{
	    "name": "Bangladesh",
	    "id": 17,
	    "abbreviation": "BD"
	  }, {
	    "name": "Bhutan",
	    "id": 24,
	    "abbreviation": "BT"
	  }, {
	    "name": "British Indian Ocean Territory",
	    "id": 252,
	    "abbreviation": "IO"
	  }, {
	    "name": "Brunei",
	    "id": 30,
	    "abbreviation": "BN"
	  }, {
	    "name": "Burma (Myanmar)",
	    "id": 33,
	    "abbreviation": "MM"
	  }, {
	    "name": "Cambodia",
	    "id": 35,
	    "abbreviation": "KH"
	  }, {
	    "name": "China",
	    "id": 44,
	    "abbreviation": "CN"
	  }, {
	    "name": "Guam",
	    "id": 85,
	    "abbreviation": "GU"
	  }, {
	    "name": "Hong Kong",
	    "id": 92,
	    "abbreviation": "HK"
	  }, {
	    "name": "India",
	    "id": 95,
	    "abbreviation": "IN"
	  }, {
	    "name": "Indonesia",
	    "id": 96,
	    "abbreviation": "ID"
	  }, {
	    "name": "Japan",
	    "id": 105,
	    "abbreviation": "JP"
	  }, {
	    "name": "Korea, North",
	    "id": 111,
	    "abbreviation": "KP"
	  }, {
	    "name": "Korea, South",
	    "id": 112,
	    "abbreviation": "KR"
	  }, {
	    "name": "Laos",
	    "id": 115,
	    "abbreviation": "LA"
	  }, {
	    "name": "Macau (Macao)",
	    "id": 124,
	    "abbreviation": "MO"
	  }, {
	    "name": "Malaysia",
	    "id": 128,
	    "abbreviation": "MY"
	  }, {
	    "name": "Maldives",
	    "id": 129,
	    "abbreviation": "MV"
	  }, {
	    "name": "Mongolia",
	    "id": 142,
	    "abbreviation": "MN"
	  }, {
	    "name": "Nepal",
	    "id": 150,
	    "abbreviation": "NP"
	  }, {
	    "name": "Northern Mariana Islands",
	    "id": 160,
	    "abbreviation": "MP"
	  }, {
	    "name": "Pakistan",
	    "id": 163,
	    "abbreviation": "PK"
	  }, {
	    "name": "Palau",
	    "id": 164,
	    "abbreviation": "PW"
	  }, {
	    "name": "Papua New Guinea",
	    "id": 167,
	    "abbreviation": "PG"
	  }, {
	    "name": "Philippines",
	    "id": 170,
	    "abbreviation": "PH"
	  }, {
	    "name": "Singapore",
	    "id": 192,
	    "abbreviation": "SG"
	  }, {
	    "name": "Solomon Islands",
	    "id": 195,
	    "abbreviation": "SB"
	  }, {
	    "name": "Sri Lanka",
	    "id": 199,
	    "abbreviation": "LK"
	  }, {
	    "name": "Taiwan",
	    "id": 207,
	    "abbreviation": "TW"
	  }, {
	    "name": "Thailand",
	    "id": 210,
	    "abbreviation": "TH"
	  }, {
	    "name": "Timor-Leste",
	    "id": 59,
	    "abbreviation": "TL"
	  }, {
	    "name": "Vietnam",
	    "id": 231,
	    "abbreviation": "VN"
	  }],
	  "EU": [{
	    "name": "Akrotiri",
	    "id": 249,
	    "abbreviation": "(blank)"
	  }, {
	    "name": "Albania",
	    "id": 2,
	    "abbreviation": "AL"
	  }, {
	    "name": "Andorra",
	    "id": 5,
	    "abbreviation": "AD"
	  }, {
	    "name": "Armenia",
	    "id": 10,
	    "abbreviation": "AM"
	  }, {
	    "name": "Austria",
	    "id": 13,
	    "abbreviation": "AT"
	  }, {
	    "name": "Azerbaijan",
	    "id": 14,
	    "abbreviation": "AZ"
	  }, {
	    "name": "Belarus",
	    "id": 21,
	    "abbreviation": "BY"
	  }, {
	    "name": "Belgium",
	    "id": 19,
	    "abbreviation": "BE"
	  }, {
	    "name": "Bosnia and Herzegovina",
	    "id": 26,
	    "abbreviation": "BA"
	  }, {
	    "name": "Bulgaria",
	    "id": 31,
	    "abbreviation": "BG"
	  }, {
	    "name": "Channel Islands",
	    "id": 42,
	    "abbreviation": "(blank)"
	  }, {
	    "name": "Croatia",
	    "id": 51,
	    "abbreviation": "HR"
	  }, {
	    "name": "Cyprus",
	    "id": 53,
	    "abbreviation": "CY"
	  }, {
	    "name": "Czech Republic",
	    "id": 54,
	    "abbreviation": "CZ"
	  }, {
	    "name": "Denmark",
	    "id": 55,
	    "abbreviation": "DK"
	  }, {
	    "name": "Dhekelia",
	    "id": 251,
	    "abbreviation": "(blank)"
	  }, {
	    "name": "Estonia",
	    "id": 65,
	    "abbreviation": "EE"
	  }, {
	    "name": "Faroe Islands",
	    "id": 67,
	    "abbreviation": "FO"
	  }, {
	    "name": "Finland",
	    "id": 70,
	    "abbreviation": "FI"
	  }, {
	    "name": "France",
	    "id": 71,
	    "abbreviation": "FR"
	  }, {
	    "name": "Georgia",
	    "id": 77,
	    "abbreviation": "GE"
	  }, {
	    "name": "Germany",
	    "id": 78,
	    "abbreviation": "DE"
	  }, {
	    "name": "Gibraltar",
	    "id": 80,
	    "abbreviation": "GI"
	  }, {
	    "name": "Greece",
	    "id": 81,
	    "abbreviation": "GR"
	  }, {
	    "name": "Guernsey",
	    "id": 243,
	    "abbreviation": "GG"
	  }, {
	    "name": "Hungary",
	    "id": 93,
	    "abbreviation": "HU"
	  }, {
	    "name": "Iceland",
	    "id": 94,
	    "abbreviation": "IS"
	  }, {
	    "name": "Ireland",
	    "id": 99,
	    "abbreviation": "IE"
	  }, {
	    "name": "Isle of Man",
	    "id": 100,
	    "abbreviation": "IM"
	  }, {
	    "name": "Italy",
	    "id": 102,
	    "abbreviation": "IT"
	  }, {
	    "name": "Jersey",
	    "id": 244,
	    "abbreviation": "JE"
	  }, {
	    "name": "Kazakhstan",
	    "id": 107,
	    "abbreviation": "KZ"
	  }, {
	    "name": "Kosovo",
	    "id": 240,
	    "abbreviation": "XK"
	  }, {
	    "name": "Kyrgyzstan",
	    "id": 114,
	    "abbreviation": "KG"
	  }, {
	    "name": "Latvia",
	    "id": 116,
	    "abbreviation": "LV"
	  }, {
	    "name": "Liechtenstein",
	    "id": 121,
	    "abbreviation": "LI"
	  }, {
	    "name": "Lithuania",
	    "id": 122,
	    "abbreviation": "LT"
	  }, {
	    "name": "Luxembourg",
	    "id": 123,
	    "abbreviation": "LU"
	  }, {
	    "name": "Macedonia",
	    "id": 125,
	    "abbreviation": "MK"
	  }, {
	    "name": "Malta",
	    "id": 131,
	    "abbreviation": "MT"
	  }, {
	    "name": "Moldova",
	    "id": 140,
	    "abbreviation": "MD"
	  }, {
	    "name": "Monaco",
	    "id": 141,
	    "abbreviation": "MC"
	  }, {
	    "name": "Montenegro",
	    "id": 143,
	    "abbreviation": "ME"
	  }, {
	    "name": "Netherlands",
	    "id": 151,
	    "abbreviation": "NL"
	  }, {
	    "name": "Norway",
	    "id": 161,
	    "abbreviation": "NO"
	  }, {
	    "name": "Poland",
	    "id": 172,
	    "abbreviation": "PL"
	  }, {
	    "name": "Portugal",
	    "id": 173,
	    "abbreviation": "PT"
	  }, {
	    "name": "Romania",
	    "id": 178,
	    "abbreviation": "RO"
	  }, {
	    "name": "Russia",
	    "id": 179,
	    "abbreviation": "RU"
	  }, {
	    "name": "San Marino",
	    "id": 186,
	    "abbreviation": "SM"
	  }, {
	    "name": "Serbia",
	    "id": 237,
	    "abbreviation": "RS"
	  }, {
	    "name": "Slovakia",
	    "id": 193,
	    "abbreviation": "SK"
	  }, {
	    "name": "Slovenia",
	    "id": 194,
	    "abbreviation": "SI"
	  }, {
	    "name": "Spain",
	    "id": 198,
	    "abbreviation": "ES"
	  }, {
	    "name": "Svalbard Islands",
	    "id": 202,
	    "abbreviation": "SJ"
	  }, {
	    "name": "Sweden",
	    "id": 204,
	    "abbreviation": "SE"
	  }, {
	    "name": "Switzerland",
	    "id": 205,
	    "abbreviation": "CH"
	  }, {
	    "name": "Tajikistan",
	    "id": 208,
	    "abbreviation": "TJ"
	  }, {
	    "name": "Turkey",
	    "id": 216,
	    "abbreviation": "TR"
	  }, {
	    "name": "Turkmenistan",
	    "id": 217,
	    "abbreviation": "TM"
	  }, {
	    "name": "Ukraine",
	    "id": 221,
	    "abbreviation": "UA"
	  }, {
	    "name": "United Kingdom",
	    "id": 223,
	    "abbreviation": "GB"
	  }, {
	    "name": "Uzbekistan",
	    "id": 227,
	    "abbreviation": "UZ"
	  }, {
	    "name": "Vatican City",
	    "id": 229,
	    "abbreviation": "VA"
	  }],
	  "ME": [{
	    "name": "Afghanistan",
	    "id": 1,
	    "abbreviation": "AF"
	  }, {
	    "name": "Bahrain",
	    "id": 16,
	    "abbreviation": "BH"
	  }, {
	    "name": "Gaza Strip",
	    "id": 248,
	    "abbreviation": "XG"
	  }, {
	    "name": "Iran",
	    "id": 97,
	    "abbreviation": "IR"
	  }, {
	    "name": "Iraq",
	    "id": 98,
	    "abbreviation": "IQ"
	  }, {
	    "name": "Israel",
	    "id": 101,
	    "abbreviation": "IL"
	  }, {
	    "name": "Jordan",
	    "id": 106,
	    "abbreviation": "JO"
	  }, {
	    "name": "Kuwait",
	    "id": 113,
	    "abbreviation": "KW"
	  }, {
	    "name": "Lebanon",
	    "id": 117,
	    "abbreviation": "LB"
	  }, {
	    "name": "Oman",
	    "id": 162,
	    "abbreviation": "OM"
	  }, {
	    "name": "Palestinian Territory",
	    "id": 165,
	    "abbreviation": "PS"
	  }, {
	    "name": "Qatar",
	    "id": 175,
	    "abbreviation": "QA"
	  }, {
	    "name": "Saudi Arabia",
	    "id": 188,
	    "abbreviation": "SA"
	  }, {
	    "name": "Syria",
	    "id": 206,
	    "abbreviation": "SY"
	  }, {
	    "name": "United Arab Emirates",
	    "id": 222,
	    "abbreviation": "AE"
	  }, {
	    "name": "West Bank",
	    "id": 250,
	    "abbreviation": "XW"
	  }, {
	    "name": "Yemen",
	    "id": 236,
	    "abbreviation": "YE"
	  }],
	  "NA": [{
	    "name": "Canada",
	    "id": 37,
	    "abbreviation": "CA"
	  }, {
	    "name": "Greenland",
	    "id": 82,
	    "abbreviation": "GL"
	  }, {
	    "name": "Mexico",
	    "id": 137,
	    "abbreviation": "MX"
	  }, {
	    "name": "Puerto Rico",
	    "id": 174,
	    "abbreviation": "PR"
	  }, {
	    "name": "Saint Pierre and Miquelon",
	    "id": 184,
	    "abbreviation": "PM"
	  }, {
	    "name": "United States",
	    "id": 224,
	    "abbreviation": "US"
	  }, {
	    "name": "Virgin Islands, U.S.",
	    "id": 225,
	    "abbreviation": "VI"
	  }],
	  "OC": [{
	    "name": "American Samoa",
	    "id": 4,
	    "abbreviation": "AS"
	  }, {
	    "name": "Australia",
	    "id": 12,
	    "abbreviation": "AU"
	  }, {
	    "name": "Cook Islands",
	    "id": 48,
	    "abbreviation": "CK"
	  }, {
	    "name": "Fiji",
	    "id": 69,
	    "abbreviation": "FJ"
	  }, {
	    "name": "French Polynesia",
	    "id": 73,
	    "abbreviation": "PF"
	  }, {
	    "name": "French Southern and Antarctic Lands",
	    "id": 74,
	    "abbreviation": "TF"
	  }, {
	    "name": "Kiribati",
	    "id": 110,
	    "abbreviation": "KI"
	  }, {
	    "name": "Marshall Islands",
	    "id": 132,
	    "abbreviation": "MH"
	  }, {
	    "name": "Micronesia, Federated States of",
	    "id": 138,
	    "abbreviation": "FM"
	  }, {
	    "name": "Midway Island",
	    "id": 139,
	    "abbreviation": "UM"
	  }, {
	    "name": "Nauru",
	    "id": 149,
	    "abbreviation": "NR"
	  }, {
	    "name": "New Caledonia",
	    "id": 153,
	    "abbreviation": "NC"
	  }, {
	    "name": "New Zealand",
	    "id": 154,
	    "abbreviation": "NZ"
	  }, {
	    "name": "Niue",
	    "id": 158,
	    "abbreviation": "NU"
	  }, {
	    "name": "Norfolk Island",
	    "id": 159,
	    "abbreviation": "NF"
	  }, {
	    "name": "Pitcairn Islands",
	    "id": 171,
	    "abbreviation": "PN"
	  }, {
	    "name": "Samoa (Western Samoa)",
	    "id": 235,
	    "abbreviation": "WS"
	  }, {
	    "name": "Tokelau",
	    "id": 212,
	    "abbreviation": "TK"
	  }, {
	    "name": "Tonga",
	    "id": 213,
	    "abbreviation": "TO"
	  }, {
	    "name": "Tuvalu",
	    "id": 219,
	    "abbreviation": "TV"
	  }, {
	    "name": "Vanuatu",
	    "id": 228,
	    "abbreviation": "VU"
	  }, {
	    "name": "Wake Island",
	    "id": 232,
	    "abbreviation": "WQ"
	  }, {
	    "name": "Wallis and Futuna",
	    "id": 233,
	    "abbreviation": "WF"
	  }],
	  "SA": [{
	    "name": "Anguilla",
	    "id": 7,
	    "abbreviation": "AI"
	  }, {
	    "name": "Antigua and Barbuda",
	    "id": 8,
	    "abbreviation": "AG"
	  }, {
	    "name": "Argentina",
	    "id": 9,
	    "abbreviation": "AR"
	  }, {
	    "name": "Aruba",
	    "id": 11,
	    "abbreviation": "AW"
	  }, {
	    "name": "Bahamas",
	    "id": 15,
	    "abbreviation": "BS"
	  }, {
	    "name": "Barbados",
	    "id": 18,
	    "abbreviation": "BB"
	  }, {
	    "name": "Belize",
	    "id": 20,
	    "abbreviation": "BZ"
	  }, {
	    "name": "Bermuda",
	    "id": 23,
	    "abbreviation": "BM"
	  }, {
	    "name": "Bolivia",
	    "id": 25,
	    "abbreviation": "BO"
	  }, {
	    "name": "Brazil",
	    "id": 28,
	    "abbreviation": "BR"
	  }, {
	    "name": "Caribbean Netherlands",
	    "id": 152,
	    "abbreviation": "BQ"
	  }, {
	    "name": "Cayman Islands",
	    "id": 39,
	    "abbreviation": "KY"
	  }, {
	    "name": "Chile",
	    "id": 43,
	    "abbreviation": "CL"
	  }, {
	    "name": "Colombia",
	    "id": 45,
	    "abbreviation": "CO"
	  }, {
	    "name": "Costa Rica",
	    "id": 49,
	    "abbreviation": "CR"
	  }, {
	    "name": "Cuba",
	    "id": 52,
	    "abbreviation": "CU"
	  }, {
	    "name": "Curacao",
	    "id": 50,
	    "abbreviation": "CW"
	  }, {
	    "name": "Dominica",
	    "id": 57,
	    "abbreviation": "DM"
	  }, {
	    "name": "Dominican Republic",
	    "id": 58,
	    "abbreviation": "DO"
	  }, {
	    "name": "Ecuador",
	    "id": 60,
	    "abbreviation": "EC"
	  }, {
	    "name": "El Salvador",
	    "id": 62,
	    "abbreviation": "SV"
	  }, {
	    "name": "Falkland Islands (Islas Malvinas)",
	    "id": 68,
	    "abbreviation": "FK"
	  }, {
	    "name": "French Guiana",
	    "id": 72,
	    "abbreviation": "GF"
	  }, {
	    "name": "Grenada",
	    "id": 83,
	    "abbreviation": "GD"
	  }, {
	    "name": "Guadeloupe",
	    "id": 84,
	    "abbreviation": "GP"
	  }, {
	    "name": "Guantanamo Bay",
	    "id": 241,
	    "abbreviation": "(blank)"
	  }, {
	    "name": "Guatemala",
	    "id": 86,
	    "abbreviation": "GT"
	  }, {
	    "name": "Guyana",
	    "id": 89,
	    "abbreviation": "GY"
	  }, {
	    "name": "Haiti",
	    "id": 90,
	    "abbreviation": "HT"
	  }, {
	    "name": "Honduras",
	    "id": 91,
	    "abbreviation": "HN"
	  }, {
	    "name": "Jamaica",
	    "id": 104,
	    "abbreviation": "JM"
	  }, {
	    "name": "Martinique",
	    "id": 133,
	    "abbreviation": "MQ"
	  }, {
	    "name": "Montserrat",
	    "id": 144,
	    "abbreviation": "MS"
	  }, {
	    "name": "Nicaragua",
	    "id": 155,
	    "abbreviation": "NI"
	  }, {
	    "name": "Panama",
	    "id": 166,
	    "abbreviation": "PA"
	  }, {
	    "name": "Paraguay",
	    "id": 168,
	    "abbreviation": "PY"
	  }, {
	    "name": "Peru",
	    "id": 169,
	    "abbreviation": "PE"
	  }, {
	    "name": "Saint Barthelemy",
	    "id": 242,
	    "abbreviation": "BL"
	  }, {
	    "name": "Saint Kitts and Nevis",
	    "id": 182,
	    "abbreviation": "KN"
	  }, {
	    "name": "Saint Lucia",
	    "id": 183,
	    "abbreviation": "LC"
	  }, {
	    "name": "Saint Martin",
	    "id": 245,
	    "abbreviation": "MF"
	  }, {
	    "name": "Saint Vincent and the Grenadines",
	    "id": 185,
	    "abbreviation": "VC"
	  }, {
	    "name": "Sint Maarten",
	    "id": 247,
	    "abbreviation": "SX"
	  }, {
	    "name": "Suriname",
	    "id": 201,
	    "abbreviation": "SR"
	  }, {
	    "name": "Trinidad and Tobago",
	    "id": 214,
	    "abbreviation": "TT"
	  }, {
	    "name": "Turks and Caicos Islands",
	    "id": 218,
	    "abbreviation": "TC"
	  }, {
	    "name": "Uruguay",
	    "id": 226,
	    "abbreviation": "UY"
	  }, {
	    "name": "Venezuela",
	    "id": 230,
	    "abbreviation": "VE"
	  }, {
	    "name": "Virgin Islands, British",
	    "id": 29,
	    "abbreviation": "VG"
	  }]
	});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.forms", ["alk.authentication", "alk.services"]);
	})(window.angular);
	
	__webpack_require__(296);
	__webpack_require__(298);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(303);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("alk.forms").directive("alkLogin", alkLogin);
	
	  alkLogin.$inject = [];
	
	  function alkLogin() {
	
	    var directive = {
	      template: __webpack_require__(297),
	      restrict: "E",
	      scope: {
	        controllerName: "@",
	        marketingLink: "@"
	      },
	      //Use the passed-in controller-name attribute to create its controller
	      controller: ["$controller", "$scope", function ($controller, $scope) {
	        var c = $controller($scope.controllerName, { $scope: $scope });
	        return c;
	      }]
	    };
	
	    return directive;
	  }
	})();

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<form alk-disabled=\"isProcessing\" class=\"hidden-xs\" name=\"loginForm\" novalidate role=\"form\" ng-show=\"!isltIE9\">\r\n\r\n  <div class=\"row\">\r\n    <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : loginForm.username.$invalid && loginForm.submitted }\">\r\n      <input id=\"username\" name=\"username\" placeholder=\"{{'common.login.Username' | translate}}\" class=\"form-control input-line\"\r\n        type=\"text\" alk-email ng-model=\"userInfo.username\" ng-disabled=\"accounts.length>0\" required />\r\n      <p ng-show=\"loginForm.username.$error.alkEmail && loginForm.submitted\" class=\"help-block pull-left\">{{\"validation.email\" | translate}}</p>\r\n      <p ng-show=\"loginForm.username.$error.required && loginForm.submitted && !loginForm.username.$error.alkEmail\" class=\"help-block pull-left\">{{\"validation.required\" | translate}}</p>\r\n    </div>\r\n    <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : loginForm.password.$invalid && loginForm.submitted }\">\r\n      <input id=\"password\" name=\"password\" placeholder=\"{{'common.login.Password' | translate}}\" class=\"form-control input-line\"\r\n        type=\"password\" ng-model=\"userInfo.password\" ng-disabled=\"accounts.length > 0\" required />\r\n      <p ng-show=\"loginForm.password.$error.required && loginForm.submitted\" class=\"help-block pull-left\">{{\"validation.required\" | translate}}</p>\r\n      <span class=\"pull-right\"><a ng-click=\"$parent.vm.formTab = 'forgot'\" class=\"btn btn-link btn-sm\">{{\"common.login.Forgot Password?\" | translate}}</a></span>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"form-group col-sm-12\" ng-if=\"accounts.length>0\" ng-class=\"{ 'has-error' : loginForm.account.$invalid && loginForm.submitted }\">\r\n      <select id=\"account\" name=\"account\" class=\"form-control input-sm input-line\" ng-model=\"userInfo.account\" required>\r\n        <option value=\"\">{{\"common.login.Select Account\" | translate}}</option>\r\n        <option ng-repeat=\"account in accounts\" value=\"{{account.accountName}}\">{{account.accountName}}</option>\r\n      </select>\r\n      <p ng-show=\"loginForm.account.$error.required && loginForm.submitted\" class=\"help-block\">{{\"validation.required\" | translate}}</p>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-6\">\r\n      <p class=\"text-small\"><a href=\"{{marketingLink}}\" target=\"_blank\">{{\"common.landing.DoIHaveID\" | translate}}</a></p>\r\n    </div>\r\n    <div class=\"col-sm-6 text-right form-group\">\r\n      <button id=\"login-submit\" ng-click=\"loginForm.submitted = true; login(userInfo, loginForm); $event.preventDefault(); $event.stopPropagation();\"\r\n        type=\"submit\" class=\"btn btn-lg btn-success\" ng-disabled=\"isltIE9 || isIE9\">\r\n        <i ng-show=\"isProcessing\" class=\"ico ico-circle-notch ico-spin ng-cloak\" ng-cloak></i> <span translate>{{(isProcessing)? 'common.login.Logging in...': 'common.Go'}}</span>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <div class=\"has-error\">\r\n        <p class=\"help-block\" ng-show=\"showAccountDisabled\">{{\"views.login.User or account is disabled\" | translate}}</p>\r\n        <p id=\"login-error\" class=\"help-block\" ng-show=\"showPasswordIncorrect\">{{\"views.login.Username or password is incorrect\" | translate}}</p>\r\n        <p id=\"server-error\" class=\"help-block\" ng-show=\"showGenericError || showUserDisabled\">{{\"views.login.GenericServerError\" | translate}}</p>\r\n        <p class=\"help-block\" ng-show=\"showNoAccountForApplication\">{{\"views.login.NoAccess\" | translate}}</p>\r\n      </div>\r\n      <div class=\"ie-old-warn alert alert-danger\" ng-if=\"isltIE9 || isIE9\">\r\n        <strong>{{\"common.OldIE\" | translate}}</strong>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("alk.forms").directive("alkForgotPassword", alkForgotPassword);
	
	  alkForgotPassword.$inject = [];
	
	  function alkForgotPassword() {
	
	    var directive = {
	      template: __webpack_require__(299),
	      restrict: "E",
	      scope: {
	        controllerName: "@"
	      },
	      //Use the passed-in controller-name attribute to create its controller
	      controller: ["$controller", "$scope", function ($controller, $scope) {
	        var c = $controller($scope.controllerName, { $scope: $scope });
	        return c;
	      }]
	    };
	
	    return directive;
	  }
	})();

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<form name=\"forgotPasswordForm\" alk-disabled=\"isProcessing\" alk-submit=\"submitForgotPassword()\" novalidate role=\"form\">\r\n  <div class=\"row\">\r\n    <alk-messages></alk-messages>\r\n    <div class=\"form-group col-sm-12\" ng-class=\"{ 'has-error' : forgotPasswordForm.email.$invalid && forgotPasswordForm.submitted }\">\r\n      <input id=\"email\" name=\"email\" class=\"form-control input-sm\" type=\"text\" ng-model=\"email\" alk-autofocus alk-email placeholder=\"{{ 'views.forgotPassword.Email' | translate }}\"\r\n        required />\r\n      <div ng-show=\"forgotPasswordForm.submitted\">\r\n        <p ng-show=\"forgotPasswordForm.email.$error.alkEmail && !forgotPasswordForm.email.$error.required\" class=\"help-block\">{{\"validation.email\" | translate}}</p>\r\n        <p ng-show=\"forgotPasswordForm.email.$error.required\" class=\"help-block\">{{\"validation.required\" | translate}}</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12 text-right\">\r\n      <span><a ng-click=\"$parent.vm.formTab = 'login'\" class=\"btn btn-link btn-sm\">{{\"common.BackToLogin\" | translate}}</a></span>\r\n      <button type=\"submit\" class=\"btn btn-success btn-lg\"><i ng-show=\"isProcessing\" class=\"ico ico-circle-notch ico-spin ng-cloak\" ng-cloak></i> <span translate>{{(isProcessing)? 'common.Submitting': 'common.Go'}}</span> </button>\r\n    </div>\r\n  </div>\r\n</form>\r\n";

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("alk.forms").controller("ChangePasswordController", ChangePasswordController);
	
	  ChangePasswordController.$inject = ["alkAuthenticationService", "Messages", "ALKChangePassword", "$translate", "$uibModalInstance"];
	
	  function ChangePasswordController(alkAuthenticationService, Messages, ALKChangePassword, $translate, $uibModalInstance) {
	    var vm = this;
	
	    vm.isProcessing = false;
	    vm.updateLogin = updateLogin;
	    vm.messageToShow = "";
	    vm.loginInfo = {};
	    vm.cancel = cancel;
	
	    ////////////////
	
	    function cancel() {
	      $uibModalInstance.close();
	      Messages.clear();
	    }
	
	    function updateLogin() {
	      vm.loginInformationForm.$setSubmitted(true);
	
	      if (!vm.loginInformationForm.$valid) {
	        return;
	      }
	
	      vm.loginInformationForm.$setPristine(false);
	
	      vm.isProcessing = true;
	      Messages.clear();
	
	      var changePassword = new ALKChangePassword(vm.loginInfo.existingPassword, vm.loginInfo.newPassword);
	      alkAuthenticationService.changePassword(changePassword).then(function () {
	        vm.loginInfo = {};
	
	        Messages.add("success", $translate.instant("common.password.changeSuccess"), {
	          showOnNextPage: false
	        });
	      }, function (err) {
	        var errData = err.data;
	        var message = $translate.instant("common.password.changeUnknownError");
	        if (errData.reason === 1) {
	          message = $translate.instant("common.password.changeFailedToLogin");
	        }
	
	        Messages.add("danger", message, {
	          showOnNextPage: false
	        });
	      }).finally(function () {
	        vm.messageToShow = "password";
	        vm.isProcessing = false;
	      });
	    }
	  }
	})();

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function () {
	  "use strict";
	
	  angular.module("alk.forms").directive("partnerAccountSelect", partnerAccountSelect);
	
	  partnerAccountSelect.$inject = ["UserProvider"];
	
	  function partnerAccountSelect(UserProvider) {
	
	    function isRole(role) {
	      var roles = UserProvider.getUser().roles;
	      roles = _.map(roles, function (role) {
	        return role.toLowerCase();
	      });
	      roles = _.uniq(roles);
	      return roles.indexOf(role) !== -1;
	    }
	
	    function isSupportRole() {
	      return isRole("support");
	    }
	
	    function isALKSupportRole() {
	      return isRole("alk support");
	    }
	
	    var partnerAccountController = ["$http", "$window", "$scope", "$state", function ($http, $window, $scope, $state) {
	
	      var vm = this;
	      vm.partnerAccountChange = partnerAccountChange;
	
	      init();
	
	      function init() {
	        var url = "";
	        if (isALKSupportRole()) {
	          url = config.ssoUrl + "v1/accounts/application?applicationName=" + ("CoPilot FleetView");
	        } else if (isSupportRole()) {
	          url = config.fleetPortalUrl + "v1/account/partneraccounts?applicationName=" + ("CoPilot FleetView");
	        } else {
	          return;
	        }
	
	        var request = {
	          method: "GET",
	          url: url,
	          headers: {
	            Authorization: "Bearer " + UserProvider.getUser().authToken,
	            "ALK-Language": undefined
	          }
	        };
	
	        $http(request).then(function (response) {
	          vm.partnerAccounts = _.chain(response.data).map(function (acct) {
	            // accounts that come from SSO have different attributes
	            // than the accounts that come from fleetportal's partner account
	            // api.
	            if (acct.accountId === undefined) acct.accountId = acct.id;
	            if (acct.accountName === undefined) acct.accountName = acct.name;
	            return acct;
	          }).sortBy("accountName").value();
	          var user = UserProvider.getUser();
	          var accountId = user.accountId;
	          if (user.supportAccount) {
	            accountId = user.supportAccount.accountId;
	          }
	
	          if (accountId) {
	            vm.selectedPartnerAccount = _.find(vm.partnerAccounts, {
	              "accountId": Number(accountId)
	            });
	          }
	        });
	      }
	
	      function partnerAccountChange() {
	        var request = {
	          method: "POST",
	          url: config.daUrl + ("owner/" + vm.selectedPartnerAccount.accountId + "?application=") + ("CoPilot FleetView")
	        };
	
	        $http(request).then(function (resp) {
	          var currentUser = UserProvider.getUser();
	
	          //  if we switch to the account we originally logged in as, just
	          //  clear out any support account information.
	          if (currentUser.accountId === vm.selectedPartnerAccount.accountId) {
	            delete currentUser.supportOwnerId;
	            delete currentUser.supportAccount;
	          } else {
	            currentUser.supportOwnerId = resp.data;
	            currentUser.supportAccount = vm.selectedPartnerAccount;
	          }
	          $state.reload();
	        });
	      }
	    }];
	
	    var directive = {
	      template: __webpack_require__(302),
	      restrict: "A",
	      scope: {
	        //Should be the product name stored in the database.
	        //i.e. "CloudXChange", "CoPilot FleetView"
	        partnerAccountSelect: "@"
	      },
	      controller: partnerAccountController,
	      controllerAs: "vm",
	      link: function link(scope, element) {
	        //Don't show this directive if not a support role. We must delete the whole element because the navbar will display a
	        //divider line to the right otherwise.
	        if (!isSupportRole() && !isALKSupportRole()) {
	          element.remove();
	        }
	      }
	    };
	
	    return directive;
	  }
	})();

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<span tabindex=\"-1\" class=\"partner-account-select-label\">{{ \"views.partnerAccountSelect.label\" | translate }} </span>\r\n<ui-select class=\"partner-account-select no-trans\" ng-model=\"vm.selectedPartnerAccount\" ng-change=\"vm.partnerAccountChange()\">\r\n  <ui-select-match>{{ $select.selected.accountName }}</ui-select-match>\r\n  <ui-select-choices repeat=\"partnerAccount in vm.partnerAccounts | filter: $select.search\">\r\n    <span ng-bind-html=\"partnerAccount.accountName | highlight: $select.search\"></span>\r\n  </ui-select-choices>\r\n</ui-select>\r\n";

/***/ }),
/* 303 */
218,
/* 304 */,
/* 305 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("alk.analytics", []);
	
	  angular.module("alk.analytics").directive("alkGoogleAnalytics", [function () {
	    return {
	      retrict: "A",
	      scope: {
	        alkGoogleAnalytics: "@"
	      },
	      controllerAs: "vm",
	      bindToController: true,
	      controller: ["$rootScope", "$scope", "$location", "$window", "$attrs", function ($rootScope, $scope, $location, $window, $attrs) {
	        var vm = this;
	        //fix for JIRA task SWFV-334
	        (function (i, s, o, g, r, a, m) {
	          i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
	            (i[r].q = i[r].q || []).push(arguments);
	          }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName('head')[0];a.async = 1;a.src = g;m.insertBefore(a, m.firstChild);
	        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
	
	        $window.ga('create', vm.alkGoogleAnalytics || $attrs.alkGoogleAnalytics, 'auto');
	
	        var first = true;
	
	        var track = function track() {
	          if (first) {
	            // avoid duplicate call to tracking page view on initial page load
	            first = false;
	            return;
	          }
	
	          $window.ga("send", "pageview", { "page": $location.path() });
	        };
	
	        //fire on each route change
	        var cleanupViewContentLoaded = $rootScope.$on("$viewContentLoaded", track);
	
	        vm.getGoogleAnalytics = function () {
	          return $window.ga;
	        };
	
	        $scope.$on("$destroy", function () {
	          cleanupViewContentLoaded();
	        });
	      }]
	    };
	  }]);
	
	  angular.module("alk.analytics").directive("alkAnalytics", [function () {
	    return {
	      require: ["^alkGoogleAnalytics"],
	      restrict: "A",
	      link: function link(scope, element, attrs, alkGoogleAnalytics) {
	        var myGa = alkGoogleAnalytics[0].getGoogleAnalytics();
	
	        var bindEvent = attrs.analyticsOn || "click";
	        var commands;
	
	        if (attrs.alkAnalytics) {
	          commands = scope.$eval(attrs.alkAnalytics);
	        } else {
	          commands = [element[0].tagName];
	          if (element.attr("id")) commands.push(element.attr("id"));
	        }
	
	        var gaCommands = ["send", "event"].concat(commands);
	
	        element.bind(bindEvent, function () {
	          myGa.apply(this, gaCommands);
	        });
	      }
	    };
	  }]);
	})(window.angular);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("alk.cloud", ["alk.maps"]);
	
	  angular.module("alk.cloud").directive("alkCloudMenu", alkCloudMenu);
	
	  function alkCloudMenu() {
	
	    var directive = {
	      bindToController: true,
	      controller: cloudMenuController,
	      controllerAs: "vm",
	      template: __webpack_require__(307),
	      link: link,
	      restrict: "E",
	      scope: {
	        onAppChange: "&",
	        onLogOut: "&"
	      }
	    };
	    return directive;
	
	    function link(scope, element, attrs) {}
	  }
	
	  cloudMenuController.$inject = ["$translate", "$http", "$window", "alkAuthenticationService", "alkModalService", "savedMapInfo", "UserProvider"];
	
	  function cloudMenuController($translate, $http, $window, alkAuthenticationService, alkModalService, savedMapInfo, UserProvider) {
	
	    var vm = this;
	    vm.webToolsImgSrc = "/img/webtools-icon.svg";
	
	    // get licensed products from server
	    alkAuthenticationService.getLicensedApps().then(function (data) {
	      // "[Temporarily] remove RouteReporter and MapExact products for EU accounts in ALK Cloud menu" SWMI-1173
	      if (UserProvider.getUser().region === "EU") {
	        data.unlicensed = data.unlicensed.filter(function (app) {
	          return app.productTitle !== "RouteReporter" && app.productTitle !== "MapExact";
	        });
	      }
	      vm.alkCloudProducts = data;
	    });
	
	    vm.toggleUnlicensedProductInfo = toggleUnlicensedProductInfo;
	    vm.goToInfoPage = goToInfoPage;
	    vm.goToAppPage = goToAppPage;
	    vm.logout = logout;
	    vm.showChangePassword = showChangePassword;
	    vm.isOpen = false;
	
	    function toggleUnlicensedProductInfo(product) {
	      product.showUnlicensedMessage = !product.showUnlicensedMessage;
	    }
	
	    function goToAppPage(product) {
	      if (("CoPilot RouteReporter") === product.productTitle) return;
	
	      vm.onAppChange({ product: product });
	
	      var url = product.productAppUrl;
	      var centerParams = savedMapInfo.getSavedInfoAsUrl();
	      var urlWithCenter = url + "?center=" + centerParams;
	      vm.isOpen = false;
	      $window.open(urlWithCenter, "_blank");
	    }
	
	    function goToInfoPage(product) {
	      vm.isOpen = false;
	      $window.open(product.productInfoUrl, "_blank");
	    }
	
	    function logout() {
	      vm.onLogOut();
	      alkAuthenticationService.logout().then(function () {
	        $window.location.href = "";
	      });
	    }
	
	    function showChangePassword() {
	      vm.isOpen = false;
	      alkModalService.show({
	        size: "md",
	        template: __webpack_require__(308),
	        controller: "ChangePasswordController",
	        controllerAs: "vm",
	        backdrop: true
	      });
	    }
	  }
	})();

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<ul>\r\n  <li class=\"large-btn cloud-button dropbown\" uib-dropdown auto-close=\"outsideClick\" is-open=\"vm.isOpen\">\r\n    <button id=\"locations-btn\" class=\"nav-button dropdown-toggle\" uib-dropdown-toggle alk-analytics=\"['ALK Apps']\">\r\n          <img ng-src=\"{{vm.webToolsImgSrc}}\" /> \r\n          <span translate=\"common.nav.webTools\"></span> <span class=\"caret\"></span>\r\n      </button>\r\n    <div class=\"dropdown-menu dropdown-menu-right popover cloud-panel\" uib-dropdown-menu role=\"menu\">\r\n      <h5 class=\"legend\">\r\n        <span translate=\"common.nav.LicensedApps\"></span>\r\n        <span ng-click=\"vm.isOpen = false\" class=\"cursor-pointer ico ico-times-circle pull-right\" style=\"top: -1px;font-size: 16px;\"></span>\r\n      </h5>\r\n      <ul class=\"list-group cloud-menu\">\r\n        <li class=\"cursor-pointer list-group-item cloud-menu-item\" ng-repeat=\"product in vm.alkCloudProducts.licensed\">\r\n          <a ng-click=\"vm.goToAppPage(product)\" target=\"_blank\">\r\n            <img ng-src=\"{{product.productImgSrc}}\" alt=\"{{product.productTitle}}\" class=\"pull-left\">\r\n            <div class=\"cloud-menu-title\">{{product.productTitle}}</div>\r\n            <div class=\"cloud-menu-text\">{{product.productText}}</div>\r\n          </a>\r\n        </li>\r\n      </ul>\r\n      <h5 ng-if=\"vm.alkCloudProducts.unlicensed.length > 0\" class=\"legend\" translate=\"common.nav.UnlicensedApps\"></h5>\r\n      <ul ng-if=\"vm.alkCloudProducts.unlicensed.length > 0\" class=\"list-group cloud-menu\">\r\n        <li class=\"cursor-pointer list-group-item cloud-menu-item cursor-pointer\" ng-repeat=\"product in vm.alkCloudProducts.unlicensed\"\r\n          ng-click=\"vm.toggleUnlicensedProductInfo(product); $event.preventDefault(); $event.stopPropagation();\">\r\n          <div>\r\n            <img ng-src=\"{{product.productImgSrc}}\" alt=\"{{product.productTitle}}\" class=\"pull-left\">\r\n            <div class=\"cloud-menu-title\">{{product.productTitle}}</div>\r\n            <div class=\"cloud-menu-text\">{{product.productText}}</div>\r\n          </div>\r\n          <div class=\"container-fluid\" ng-if=\"product.showUnlicensedMessage\">\r\n            <div class=\"row cloud-menu-unlicensed-alert\">\r\n              <span class=\"cloud-menu-unlicensed-label\" translate=\"common.nav.NotLicensed\"></span>\r\n              <a ng-click=\"vm.goToInfoPage(product)\" class=\"btn btn-default btn-xs pull-right cloud-menu-unlicensed-btn\" translate=\"common.nav.LearnMore\"></a>\r\n            </div>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n      <h5 ng-if=\"vm.alkCloudProducts.expired.length > 0\" class=\"legend\" translate=\"common.nav.ExpiredApps\"></h5>\r\n      <ul ng-if=\"vm.alkCloudProducts.expired.length > 0\" class=\"list-group cloud-menu\">\r\n        <li class=\"cursor-pointer list-group-item cloud-menu-item cursor-pointer\" ng-repeat=\"product in vm.alkCloudProducts.expired\"\r\n          ng-click=\"vm.toggleUnlicensedProductInfo(product); $event.preventDefault(); $event.stopPropagation();\">\r\n          <div>\r\n            <img ng-src=\"{{product.productImgSrc}}\" alt=\"{{product.productTitle}}\" class=\"pull-left\">\r\n            <div class=\"cloud-menu-title\">{{product.productTitle}}</div>\r\n            <div class=\"cloud-menu-text\">{{product.productText}}</div>\r\n          </div>\r\n          <div class=\"container-fluid\" ng-if=\"product.showUnlicensedMessage\">\r\n            <div class=\"row cloud-menu-unlicensed-alert\">\r\n              <span class=\"cloud-menu-unlicensed-label\" translate=\"common.nav.NotLicensed\"></span>\r\n              <a ng-click=\"vm.goToInfoPage(product)\" class=\"btn btn-default btn-xs pull-right cloud-menu-unlicensed-btn\" translate=\"common.nav.LearnMore\"></a>\r\n            </div>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n      <a id=\"logoutButton\" class=\"btn btn-xs btn-default pull-right cloud-menu-btn cloud-menu-btn-last\" alk-analytics=\"['Logout']\" ng-click=\"vm.logout(); $event.preventDefault(); $event.stopPropagation();\"\r\n        translate=\"common.nav.Logout\"></a>\r\n      <a id=\"changePasswordButton\" class=\"btn btn-xs btn-default pull-right cloud-menu-btn\" ng-click=\"vm.showChangePassword()\" translate=\"common.password.change\"></a>\r\n    </div>\r\n  </li>\r\n</ul>\r\n";

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title\" translate=\"common.password.change\"></h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <alk-messages></alk-messages>\r\n  <form name=\"vm.loginInformationForm\" novalidate>\r\n    <div alk-disabled=\"vm.isProcessing\">\r\n      <div class=\"form-group sm row\">\r\n        <div class=\"col-md-6\" ng-class=\"{ 'has-error' : vm.loginInformationForm.currentPassword.$invalid && vm.loginInformationForm.$submitted}\">\r\n          <input id=\"currentPassword\" name=\"currentPassword\" class=\"form-control input-sm input-line\" required type=\"password\" ng-model=\"vm.loginInfo.existingPassword\"\r\n          />\r\n          <label for=\"currentPassword\" class=\"control-label label-sm label-line\" translate=\"views.user.Current Password\"></label>\r\n          <p ng-show=\"vm.loginInformationForm.currentPassword.$error.required && vm.loginInformationForm.$submitted\" class=\"help-block\"\r\n            translate=\"validation.required\"></p>\r\n        </div>\r\n        <div class=\"col-md-6\" ng-class=\"{ 'has-error' : vm.loginInformationForm.password.$invalid && vm.loginInformationForm.$submitted}\">\r\n          <input id=\"password\" name=\"password\" class=\"form-control input-sm input-line\" type=\"password\" ng-model=\"vm.loginInfo.newPassword\"\r\n            required ng-minlength=\"8\" ng-maxlength=\"20\" />\r\n          <label for=\"password\" class=\"control-label label-sm label-line\" translate=\"views.user.New Password\"></label>\r\n          <p ng-show=\"vm.loginInformationForm.password.$error.required && vm.loginInformationForm.$submitted\" class=\"help-block\" translate=\"validation.required\"></p>\r\n          <p ng-show=\"vm.loginInformationForm.password.$error.maxlength && vm.loginInformationForm.$submitted\" class=\"help-block\" translate=\"validation.passwordMaximum\"></p>\r\n          <p ng-show=\"vm.loginInformationForm.password.$error.minlength && vm.loginInformationForm.$submitted\" class=\"help-block\" translate=\"validation.passwordMinimum\"></p>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group sm row\">\r\n        <div class=\"col-md-6 col-md-push-6\" ng-class=\"{ 'has-error' : vm.loginInformationForm.confirmPassword.$invalid && vm.loginInformationForm.$submitted}\">\r\n          <input id=\"confirmPassword\" name=\"confirmPassword\" class=\"form-control input-sm input-line\" type=\"password\" ng-model=\"vm.loginInfo.confirmPassword\"\r\n            alk-compare=\"vm.loginInfo.newPassword\" />\r\n          <label for=\"confirmPassword\" class=\"control-label label-sm label-line\" translate=\"views.user.Confirm Password\"></label>\r\n          <p ng-show=\"vm.loginInformationForm.confirmPassword.$error.alkCompare && vm.loginInformationForm.$submitted\" class=\"help-block\"\r\n            translate=\"validation.doesnt match\"></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-default btn-sm\" ng-click=\"vm.cancel()\" translate=\"common.Cancel\"></button>\r\n  <button class=\"btn btn-success btn-sm\" ng-click=\"vm.updateLogin()\" translate=\"common.password.update\"></button>\r\n</div>\r\n";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.modal", []);
	})(window.angular);
	
	__webpack_require__(310);

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/** @typedef {Object} alkModalService
	 * @property {Function} show
	 * @property {Function} initiateModalWizard
	 * @property {Function} openNextModal
	 * @property {Function} openPrevModal
	 * @property {Function} getCurrentWizardData
	 * @property {Function} setCurrentWizardData
	 * @property {Function} clearWizardData
	 * @property {Function} setWizardCleanupFunction
	 */
	
	(function (angular) {
	
	  angular.module("alk.modal").factory("alkModalService", ["$uibModal", "$translate",
	  /** @name alkModalService
	   * @ngdoc service
	   * @param {service} $uibModal angularJS twitter bootstrap [modal service](https://angular-ui.github.io/bootstrap/#!#modal)
	   * @param {service} $translate angularJS [translation service](https://angular-translate.github.io/)
	   * @description Provides services for displaying  and configuring custom modal flows.
	   * @returns alkModalService
	   * @memberof alk.modal
	   */
	  function ($uibModal, $translate) {
	
	    var defaultController = ["modalOptions", "$uibModalInstance", function defaultModalController(modalOptions, $uibModalInstance) {
	      var vm = this;
	      vm.modalOptions = modalOptions;
	
	      vm.close = function () {
	        $uibModalInstance.close(modalOptions);
	      };
	
	      vm.dismiss = function () {
	        $uibModalInstance.dismiss("cancel");
	      };
	    }];
	
	    var modalWizardArray = [];
	    var modalWizardIndex = 0;
	    var currentWizardData = null;
	    var wizardCleanupFunction = null;
	
	    var modalDefaults = {
	      backdrop: true,
	      keyboard: true,
	      modalFade: true,
	      template: __webpack_require__(311)
	    };
	
	    function getModalOptions() {
	      return {
	        closeButtonText: $translate.instant("views.common.Cancel"),
	        actionButtonText: $translate.instant("views.common.OK"),
	        okOnly: false,
	        headerText: "",
	        bodyText: null,
	        bodyTemplate: null,
	        data: {}
	      };
	    }
	
	    return {
	      show: show,
	      initiateModalWizard: initiateModalWizard,
	      openNextModal: openNextModal,
	      openPrevModal: openPrevModal,
	      getCurrentWizardData: getCurrentWizardData,
	      setCurrentWizardData: setCurrentWizardData,
	      clearWizardData: clearWizardData,
	      setWizardCleanupFunction: setWizardCleanupFunction
	    };
	
	    /** show - Display a modal. The default is to display a "static" modal according to ui-bootstrap.
	     * @param {Object} customModalDefaults - Custom defaults for the modal. The same options for a [uibootstrap-modal](https://angular-ui.github.io/bootstrap/#!#modal)
	     * are allowed here.
	     * @param {Object} customModalOptions - Custom options for the modal. The custom options object can look like
	     * `{bodyTemplate: string, bodyText: string, headerText: string, okOnly: boolean, closeButtonText: string, actionButtonText: string, onRender: function}`.
	     * Reasonable defaults for an actionable modal are to supply just `bodyText` and `headerText`.
	     *
	     * `bodyTemplate` is a url to template to include in the modal's body.
	     *
	     * `bodyText` is a string of text that will be displayed in the modal's body.
	     *
	     * `headerText` is a string of text that will be displayed in the modal's header.
	     *
	     * `okOnly` is a boolean to indicate that the modal should only have an action button.
	     *
	     * `closeButtonText` text to be displayed in the close button for the modal. Default is "Cancel"
	     *
	     * `actionButtonText` text to be displayed in the action button for the modal. Default is "OK".
	     *
	     * @returns {Promise}  Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves when the modal is closed
	     * or is rejected when the modal is dismissed.
	     * @memberof alkModalService
	     */
	    function show(customModalDefaults, customModalOptions) {
	      if (!customModalDefaults) {
	        customModalDefaults = {};
	      }
	
	      customModalDefaults.backdrop = customModalDefaults.backdrop || "static";
	
	      //Create temp objects to work with since we"re in a singleton service
	      var tempModalDefaults = {};
	      var tempModalOptions = {};
	
	      //Map angular-ui modal custom defaults to modal defaults defined in service
	      angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);
	
	      //Map modal.html $scope custom properties to defaults defined in service
	      angular.extend(tempModalOptions, getModalOptions(), customModalOptions);
	
	      // prioritize template url over template
	      if (tempModalDefaults.template && tempModalDefaults.templateUrl) {
	        delete tempModalDefaults.template;
	      }
	
	      if (!tempModalDefaults.controller) {
	        //tempModalDefaults.controller = controllerId; //TODO: what is this used for? if anything? controllerId is not defined.
	        tempModalDefaults.resolve = {
	          modalOptions: function modalOptions() {
	            return tempModalOptions;
	          }
	        };
	        tempModalDefaults.controller = defaultController;
	        tempModalDefaults.controllerAs = "$ctrl";
	      }
	
	      return $uibModal.open(tempModalDefaults).result;
	    }
	
	    //See places.controller.js for an example of this function being used
	
	    /** initiateModalWizard - Initiates a modal wizard given an array of custom modal objects. Will launch the modals in the order they are provided in the array.
	     * @param {Object[]} modalArray - modalArray. Each member of the array is an object with the following format:
	     * `{onModalSuccess: function, modalOptions: object}`. The `modalOptions` object should be an object with standard [uib-modal](https://angular-ui.github.io/bootstrap/#!#modal) options.
	     * `onModalSuccess` is a function that runs when the modal has been submitted. This can call [`openPrevModal`](alk.modal.alkModalService.html#openPrevModal) (go to prev modal in wizard)
	     * or [`openNextModal`](alk.modal.alkModalService.html#openNextModal) (go to next modal in wizard).
	     * @param {Object} wizardData - Object that contains fields that should persist for the duration of the modal wizard.
	     * @memberof alkModalService
	     */
	    function initiateModalWizard(modalArray, wizardData) {
	      currentWizardData = wizardData;
	      modalWizardArray = modalArray;
	      modalWizardIndex = 0;
	      _openModal(modalWizardArray[0]);
	    }
	
	    /** openNextModal - Opens the next modal in the wizard. This should be called from within the
	     * `onModalSuccess` callback function.
	     * @memberof alkModalService
	     * @param {Number} skip - optional arg to increment index
	     */
	    function openNextModal() {
	      var skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      var nextModalWizardIndex = modalWizardIndex + skip + 1;
	      if (nextModalWizardIndex >= modalWizardArray.length) {
	        return;
	      }
	      var nextModal = modalWizardArray[nextModalWizardIndex];
	      modalWizardIndex = nextModalWizardIndex;
	      _openModal(nextModal);
	    }
	
	    /** openPrevModal - Opens the previous modal in the wizard. This should be called from within the modal
	     * object's `onModalCancel` callback.
	     * @memberof alkModalService
	     * @param {Number} skip - optional arg to decrement index
	     */
	    function openPrevModal() {
	      var skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      var prevModalWizardIndex = modalWizardIndex - skip - 1;
	      if (prevModalWizardIndex < 0) {
	        return;
	      }
	      modalWizardIndex = prevModalWizardIndex;
	      _openModal(modalWizardArray[prevModalWizardIndex]);
	    }
	
	    /** getCurrentWizardData - Returns the current wizard data for the modal service.
	     * @returns {Object} Object that contains fields that should persist for the duration of the modal wizard.
	     * @memberof alkModalService
	     */
	    function getCurrentWizardData() {
	      return currentWizardData;
	    }
	
	    /** setCurrentWizardData - Sets the current wizard data for the modal service.
	     * @param {Object} data - Object that contains fields that should persist for the duration of the modal wizard.
	     * @memberof alkModalService
	     */
	    function setCurrentWizardData(data) {
	      currentWizardData = data;
	    }
	
	    //Clear the wizard data, which can also call a custom cleanup function that can be set via setWizardCleanupFunction().
	    //To be called by consuming code when the modal completes successfully. (It gets called automatically called if the modal was cancelled.)
	    function clearWizardData() {
	      currentWizardData = null;
	      modalWizardArray = [];
	      modalWizardIndex = 0;
	      if (wizardCleanupFunction) {
	        wizardCleanupFunction();
	        wizardCleanupFunction = null;
	      }
	    }
	
	    function setWizardCleanupFunction(func) {
	      wizardCleanupFunction = func;
	    }
	
	    //Used internally by modal wizard system
	    function _openModal(customModalObj) {
	      var modal = $uibModal.open(customModalObj.modalOptions);
	      modal.result.then(function (result) {
	        customModalObj.onModalSuccess(result);
	      }, function (cancel) {
	        clearWizardData();
	      });
	    }
	  }]);
	})(window.angular);

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title\">{{$ctrl.modalOptions.headerText}}</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <p ng-if=\"$ctrl.modalOptions.bodyText\">{{$ctrl.modalOptions.bodyText}}</p>\r\n  <div ng-if=\"$ctrl.modalOptions.bodyTemplate\" ng-include=\"$ctrl.modalOptions.bodyTemplate\"></div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-sm btn-default\" ng-if=\"!$ctrl.modalOptions.okOnly\" ng-click=\"$ctrl.dismiss()\">{{$ctrl.modalOptions.closeButtonText}}</button>\r\n  <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.close($ctrl.modalOptions)\">{{$ctrl.modalOptions.actionButtonText}}</button>\r\n</div>\r\n";

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.uirouter", []);
	})(window.angular);

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	"use strict";
	
	//Contains custom code that extends/wraps/uses the angular ui-router module.
	
	(function (angular) {
	  "use strict";
	
	  angular.module("alk.uirouter").service("stateService", ["$rootScope", "$state", "$timeout", function ($rootScope, $state, $timeout) {
	
	    //Wrapper for ui-router's $state.go that will fire an event that lets controllers abort the $state.go call by calling event.preventDefault()
	    //If using this module for checking unsaved changes before state change, then all $state.go calls should be replaced with this except for cases
	    //where you want to go without the check, in which cases you should just use goWithoutChecks (or $state.go, if this service hasn't been loaded yet, as in app.js)
	    function go(to, toParams, options) {
	      var e = $rootScope.$broadcast("attemptStateChange", to, toParams, options);
	      if (e.defaultPrevented) {
	        return null;
	      }
	      return $state.go(to, toParams, options);
	    }
	
	    //Same as above, but sometimes you want to run code BEFORE the state change, but AFTER the handler responds, i.e. as cleanup before the state transitions
	    //If so, put the function as the first variable to this call. The function won't be run if the handler prevents the event
	    function goWithCallback(funcToRunBeforeStateChange, to, toParams, options) {
	      var e = $rootScope.$broadcast("attemptStateChange", to, toParams, options);
	      if (e.defaultPrevented) {
	        return null;
	      }
	      funcToRunBeforeStateChange();
	      return $state.go(to, toParams, options);
	    }
	
	    //A simple wrapper to $state.go. This exists for purpose clarity and readability only. (May be updated in the future to contain more logic)
	    function goWithoutChecks(to, toParams, options) {
	      return $state.go(to, toParams, options);
	    }
	
	    //Panel transition slide code.
	    function handleSlide(trans, slideSpeedInMs) {
	
	      var fromState = trans.$from();
	      var toState = trans.$to();
	      var fromParams = trans.params("from");
	      var toParams = trans.params("to");
	
	      if (!fromState) {
	        return true;
	      }
	
	      //Handle the panel slide animation when it's closed or changed
	      //Remove persisting slide classes first by default from the previous transition
	      if ($rootScope.leftPanelSlideClass) {
	        angular.element(".left-panel-ui-view").removeClass("panelSlideLeft");
	        angular.element(".left-panel-ui-view").removeClass("panelSlideRight");
	        $rootScope.leftPanelSlideClass = "";
	      }
	
	      //Don't slide for panel in/out, since it slides already
	      if (toState.name === "main" || fromState.name === "main") {
	        return true;
	      }
	
	      var subpanel = fromState.name.startsWith("main.") && toState.name.startsWith("main.") || fromState.name.startsWith("reports.") && toState.name.startsWith("reports.");
	
	      //These transitions only apply to subpanels, not whole pages, so "main." transitions
	      if (subpanel && fromState.name !== toState.name) {
	        //If transitioning from a parent state to a child state (i.e. main.places ==> main.places.set), slide left (forward)
	        if (toState.name.startsWith(fromState.name)) {
	          angular.element(".left-panel-ui-view").removeClass("panelSlideRight"); //Set the current panel's scroll direction
	          angular.element(".left-panel-ui-view").addClass("panelSlideLeft");
	          $rootScope.leftPanelSlideClass = "panelSlideLeft"; //The new panel doesn't exist yet for DOM manipulation, so need to set a prospective variable
	        }
	        //If transitioning from a child state to a parent state (i.e. main.places.set ==> main.places), slide right (backward)
	        else if (fromState.name.startsWith(toState.name)) {
	            angular.element(".left-panel-ui-view").removeClass("panelSlideLeft");
	            angular.element(".left-panel-ui-view").addClass("panelSlideRight");
	            $rootScope.leftPanelSlideClass = "panelSlideRight";
	          }
	          //If transitioning between siblings (i.e. main.places ==> main.search): close the current panel, then open new one
	          else {
	              $state.go("main").then(function () {
	                $timeout(function () {
	                  $state.go(toState.name, toParams);
	                }, slideSpeedInMs);
	              });
	              return false;
	            }
	      }
	      return true;
	    }
	
	    return {
	      go: go,
	      goWithCallback: goWithCallback,
	      goWithoutChecks: goWithoutChecks,
	      handleSlide: handleSlide
	    };
	  }]);
	})(window.angular);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _values = __webpack_require__(315);
	
	var _values2 = _interopRequireDefault(_values);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	  "use strict";
	
	  angular.module("alk.directives").directive("tidPassword", function () {
	    return {
	      restrict: "A",
	      require: "ngModel",
	      scope: {},
	      link: function link(scope, element, attrs, ngModel) {
	
	        ngModel.$validators.tidPassword = function (password) {
	          if (!password) {
	            return true;
	          }
	          var validationObj = {};
	          validationObj.length = password.length >= 8 && password.length <= 20;
	          validationObj.lowercase = /[a-z]/.test(password);
	          validationObj.uppercase = /[A-Z]/.test(password);
	          validationObj.number = /\d/.test(password);
	          validationObj.specialCharacter = /[!@#$%&*^_\-+]/.test(password);
	          validationObj.overall = (0, _values2.default)(validationObj).every(function (isTrue) {
	            return isTrue;
	          });
	          return validationObj.overall;
	        };
	        ngModel.$validators.hasLength = function (password) {
	          if (!password) {
	            return true;
	          }
	          var length = password.length >= 8 && password.length <= 20;
	          return length;
	        };
	        ngModel.$validators.hasLowercase = function (password) {
	          if (!password) {
	            return true;
	          }
	          var lowercase = /[a-z]/.test(password);
	          return lowercase;
	        };
	        ngModel.$validators.hasUppercase = function (password) {
	          if (!password) {
	            return true;
	          }
	          var uppercase = /[A-Z]/.test(password);
	          return uppercase;
	        };
	        ngModel.$validators.hasNumber = function (password) {
	          if (!password) {
	            return true;
	          }
	          var number = /\d/.test(password);
	          return number;
	        };
	        ngModel.$validators.hasCharacter = function (password) {
	          if (!password) {
	            return true;
	          }
	          var specialCharacter = /[!@#$%&*^_\-+]/.test(password);
	          return specialCharacter;
	        };
	      }
	    };
	  });
	})();

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(316), __esModule: true };

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317);
	module.exports = __webpack_require__(31).Object.values;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(29);
	var $values = __webpack_require__(318)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(39);
	var getKeys = __webpack_require__(50);
	var toIObject = __webpack_require__(52);
	var isEnum = __webpack_require__(273).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* globals _ */
	var config = __webpack_require__(110);
	
	(function () {
	  "use strict";
	
	  complianceMapService.$inject = ["ALKMaps", "mapService", "mapUtilities", "$rootScope"];
	  angular.module("fleetviewApp").factory("complianceMapService", complianceMapService);
	
	  function complianceMapService(ALKMaps, mapService, mapUtilities, $rootScope) {
	    "ngInject";
	
	    //ALKMaps.Renderer.symbol.flagshape = [-4, 0, -4, -5, 0, -5, 0, -2, -4, -2, -4, 0];
	
	    ALKMaps.Renderer.symbol.check = [0, 0, 1, -1, 2, 0, 5, -3, 6, -2, 2, 2, 0, 0];
	    ALKMaps.Renderer.symbol.ex = [0, 0, 2, -2, 0, -4, 1, -5, 3, -3, 5, -5, 6, -4, 4, -2, 6, 0, 5, 1, 3, -1, 1, 1, 0, 0];
	
	    var complianceLayers = [];
	    var eventSelect = void 0;
	
	    var service = {
	      initMap: initMap,
	      clearMap: clearMap,
	      drawRoute: drawRoute,
	      redrawRoute: redrawRoute,
	      selectRoute: selectRoute,
	      setRouteVisibility: setRouteVisibility,
	      setRoutePingsVisibility: setRoutePingsVisibility,
	      frameRoute: frameRoute,
	      frameAllRoutes: frameAllRoutes,
	      zoomtoStop: zoomtoStop
	    };
	    return service;
	
	    //Percent can be from -1 (shade to pure black) to 1 (shade to pure white). Negative number darkens, positive lightens
	    function shadeColor(color, percent) {
	      var f = parseInt(color.slice(1), 16),
	          t = percent < 0 ? 0 : 255,
	          p = percent < 0 ? percent * -1 : percent,
	          R = f >> 16,
	          G = f >> 8 & 0x00FF,
	          B = f & 0x0000FF;
	      return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
	    }
	
	    function initMap() {
	      var mapObj = mapService.getMap();
	
	      eventSelect = new ALKMaps.Control.FeatureEvent([], {
	        featureAttributesFilter: [{
	          property: "isMarker", //add route line as well
	          value: true
	        }]
	      });
	
	      mapObj.addControls([eventSelect]);
	      eventSelect.activate();
	    }
	
	    function clearMap() {
	      var mapObj = mapService.getMap();
	      _.forEach(complianceLayers, function (complianceObj) {
	        mapObj.removeLayer(complianceObj.plannedLayer);
	        mapObj.removeLayer(complianceObj.actualLayer);
	        complianceObj.oorLayer.removeAllFeatures();
	        mapObj.removeLayer(complianceObj.oorLayer);
	        complianceObj.stopLayer.removeAllFeatures();
	        mapObj.removeLayer(complianceObj.stopLayer);
	      });
	
	      complianceLayers = [];
	    }
	
	    function redrawRoute(route) {
	      var _getConnectorLines = getConnectorLines(route),
	          origin = _getConnectorLines.origin,
	          destination = _getConnectorLines.destination;
	
	      route.complianceObj.plannedLayer.destroyFeatures(route.complianceObj.plannedRouteFeature);
	      route.complianceObj.plannedRouteFeature = getPlannedRouteFeature(route);
	      // NOTE(boyler): adds the higher res planned line with the origin & destination connectors
	      route.complianceObj.plannedLayer.addFeatures([origin, route.complianceObj.plannedRouteFeature, destination]);
	
	      route.complianceObj.actualLayer.destroyFeatures(route.complianceObj.actualRouteFeatures);
	      route.complianceObj.actualRouteFeatures = getActualRouteFeatures(route);
	      route.complianceObj.actualLayer.addFeatures(route.complianceObj.actualRouteFeatures);
	
	      route.complianceObj.plannedLayer.redraw();
	      route.complianceObj.actualLayer.redraw();
	    }
	
	    function getPlannedRouteFeature(route) {
	      return new ALKMaps.Feature.Vector(new ALKMaps.Geometry.LineString(route.plannedRoutePoints), {
	        routeColor: route.routeColor
	      });
	    }
	
	    //Return multiple features in case we want to draw a line with an outline (AKA 2 lines), and also to draw the GPS pings
	    function getActualRouteFeatures(route) {
	      var features = [
	      //The filled-in line that represents the actual route taken
	      new ALKMaps.Feature.Vector(new ALKMaps.Geometry.LineString(route.actualRoutePoints), null, {
	        //strokeWidth: 20,
	        strokeColor: shadeColor(route.routeColor, -0.4), //Do not make this the regular routeColor - it needs to be visible when on top of the planned route and made distinct
	        arrows: "line",
	        arrowSize: "900%",
	        arrowSpacing: 50,
	        arrowStrokeColor: shadeColor(route.routeColor, -0.4),
	        arrowFillColor: "#fff",
	        arrowFillOpacity: 0.7,
	        strokeOpacity: 0.8
	      })];
	      //GPS Pings of actual route taken
	      _.forEach(route.gpsPositions, function (p) {
	        var ll = mapUtilities.LLtoMerc(p.Ln, p.Lt);
	        var point = new ALKMaps.Geometry.Point(ll.lon, ll.lat);
	        var pointFeature = new ALKMaps.Feature.Vector(point, null, {
	          pointRadius: 2,
	          fillColor: shadeColor(route.routeColor, -0.4),
	          strokeWidth: 1,
	          strokeColor: shadeColor(route.routeColor, -0.4)
	        });
	        features.push(pointFeature);
	      });
	      return features;
	    }
	
	    function getConnectorLines(route) {
	
	      var origin = new ALKMaps.Feature.Vector(new ALKMaps.Geometry.LineString(route.plannedConnectorPoints.origin), {
	        routeColor: route.routeColor
	      });
	
	      var destination = new ALKMaps.Feature.Vector(new ALKMaps.Geometry.LineString(route.plannedConnectorPoints.destination), {
	        routeColor: route.routeColor
	      });
	
	      return {
	        origin: origin,
	        destination: destination
	      };
	    }
	
	    //TODO Function too big. Refactor to simplify and make smaller.
	    function drawRoute(route) {
	      var mapObj = mapService.getMap();
	
	      var complianceObj = {};
	      route.complianceObj = complianceObj;
	      complianceObj.tripId = route.tripId;
	
	      /* styles for prescribed route*/
	      var routeStyle = new ALKMaps.Style({
	        strokeColor: "${strokeColor}",
	        strokeWidth: "${strokeWidth}",
	        strokeOpacity: 0.7,
	        strokeDashstyle: "line",
	        graphicZIndex: 2
	      }, {
	        context: {
	          strokeColor: function strokeColor(feature) {
	            return feature.attributes.routeColor;
	          },
	          strokeWidth: function strokeWidth(feature) {
	            if (feature.layer.map.zoom >= 18) {
	              return 35;
	            } else if (feature.layer.map.zoom >= 16) {
	              return 20;
	            } else if (feature.layer.map.zoom >= 9) {
	              return 10;
	            } else {
	              return 5;
	            }
	          }
	        }
	      });
	      /*styles for origin and destination markers*/
	
	      var markerStyle = new ALKMaps.Style({
	        strokeColor: "${strokeColor}",
	        strokeWidth: "${strokeWidth}",
	        externalGraphic: "",
	        fontWeight: "700",
	        pointRadius: "${pointRadius}",
	        fillColor: "#FFFFFF",
	        fontColor: route.routeColor + "",
	        fontSize: "${fontSize}",
	        graphicZIndex: 100,
	        label: "${label}"
	      }, {
	        context: {
	          strokeColor: function strokeColor(feature) {
	            return feature.attributes.markerColor || feature.attributes.routeColor;
	          },
	          strokeWidth: function strokeWidth(feature) {
	            if (feature.layer.map.zoom >= 17) {
	              if (feature.attributes.label) {
	                return 6;
	              }
	              return 10.5;
	            } else {
	              return feature.attributes.strokeWidth || 5.5;
	            }
	          },
	          pointRadius: function pointRadius(feature) {
	            if (feature.layer.map.zoom >= 17) {
	              return 12.5;
	            } else {
	              return feature.attributes.pointRadius;
	            }
	          },
	          fontSize: function fontSize(feature) {
	            if (feature.layer.map.zoom >= 17 && feature.attributes.label) {
	              return 13;
	            } else {
	              return 10;
	            }
	          },
	          label: function label(feature) {
	            return feature.attributes.label;
	          }
	        }
	      });
	
	      /* GPS points map styling */
	      var pointsStyle = new ALKMaps.Style({
	        externalGraphic: "${graphic}",
	        graphicHeight: "${size}",
	        graphicWidth: "${size}",
	        graphicZIndex: 1000,
	        rotation: "${rotation}"
	      }, {
	        context: {
	          graphic: function graphic(feature) {
	            if (feature.attributes.heading) {
	              return "/img/icons/gps_ping.svg";
	            } else {
	              return "/img/icons/gps_ping_nohd.svg";
	            }
	          },
	          size: function size(feature) {
	            if (feature.layer.map.zoom >= 17) {
	
	              return 26;
	            } else if (feature.layer.map.zoom >= 13) {
	              return 24;
	            } else if (feature.layer.map.zoom >= 11) {
	              return 18;
	            } else {
	              return 10;
	            }
	          },
	          rotation: function rotation(feature) {
	            var heading = parseInt(feature.attributes.heading);
	            return heading;
	          }
	        }
	      });
	
	      var routeStyleMap = new ALKMaps.StyleMap({
	        default: routeStyle,
	        select: routeStyle
	      });
	
	      var markerStyleMap = new ALKMaps.StyleMap({
	        default: markerStyle,
	        select: markerStyle
	      });
	      var pointsStyleMap = new ALKMaps.StyleMap({
	        default: pointsStyle,
	        select: pointsStyle
	      });
	
	      complianceObj.plannedLayer = new ALKMaps.Layer.VectorMarkers("Planned Layer " + route.tripId, {
	        styleMap: routeStyleMap
	      });
	      complianceObj.actualLayer = new ALKMaps.Layer.Vector("Actual Layer " + route.tripId);
	      complianceObj.oorLayer = new ALKMaps.Layer.VectorMarkers("OOR Layer " + route.tripId, {
	        styleMap: pointsStyleMap
	      });
	
	      complianceObj.stopLayer = new ALKMaps.Layer.VectorMarkers("Stop Layer " + route.tripId, {
	        styleMap: markerStyleMap
	      });
	
	      mapObj.addLayers([complianceObj.plannedLayer, complianceObj.actualLayer, complianceObj.oorLayer, complianceObj.stopLayer]);
	
	      complianceObj.plannedRouteFeature = getPlannedRouteFeature(route);
	      complianceObj.plannedLayer.addFeatures(complianceObj.plannedRouteFeature);
	      complianceObj.actualRouteFeatures = getActualRouteFeatures(route);
	
	      complianceObj.actualLayer.addFeatures(complianceObj.actualRouteFeatures);
	
	      _.forEach(route.gpsPositions, function (p, i) {
	        var lonlat, dir, heading;
	        var pingContent = "<div class='oor-popup'>";
	
	        if (p.Lt) {
	          lonlat = new ALKMaps.LonLat(p.Ln, p.Lt).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	          dir = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];
	          heading = dir[Math.floor(p.H / 22.5 + .5) % 16];
	          pingContent += "<strong> GPS Ping: " + i + " </strong> <br/>";
	          pingContent += "<strong>Coordinates: </strong>" + p.Lt + ", " + p.Ln;
	          pingContent += p.timeStamp && p.timeStamp !== "--" && p.timeStamp.length !== 0 ? "<br/> <strong>Time:</strong> " + p.timeStamp : "<br/> <strong>Time:</strong> Date Unavailable";
	          pingContent += p.S ? " <br/> <strong>Speed:</strong> " + p.S + " mph " : "";
	          pingContent += p.H ? " <br/> <strong>Direction:</strong> " + heading + " (" + p.H + "\xB0)" : "";
	          pingContent += p.Al ? "  <br/><strong>Altitude:</strong> " + p.Al + " m" : "";
	        } else {
	          lonlat = new ALKMaps.LonLat(p[0], p[1]).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	          pingContent += "<strong> GPS Ping: </strong> <br/>";
	          pingContent += "<strong>Coordinates: </strong>" + p[0] + ", " + p[1] + "</br>";
	        }
	
	        pingContent += "</div>";
	        var pingMarker = complianceObj.oorLayer.createMarker(lonlat.clone(), {
	          popupSize: new ALKMaps.Size(225, 60),
	          popupContentHTML: pingContent,
	          anchor: {
	            size: new ALKMaps.Size(1, 1)
	            //offset: new ALKMaps.Pixel(-3, -25)
	          },
	          overflow: "auto",
	          markerType: "custom",
	          routeColor: route.routeColor + "",
	          speed: p.S,
	          heading: p.H
	        });
	        pingMarker.createPopup(true); //close button argument
	      });
	
	      _.forEach(route.outOfRouteEvents, function (e) {
	
	        var dir = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];
	        var heading = dir[Math.floor(e.oorHeading / 22.5 + .5) % 16];
	        var popupContent = "<div class='oor-popup'>";
	
	        popupContent += "<strong> " + e.type + " </strong><br>\n        <strong> Coordinates: </strong> " + e.oorLat + ", " + e.oorLon + "<br>\n        <strong> Time: </strong> " + e.timeStamp + " ";
	        popupContent += e.type === "Left Route" ? "" : " <br><strong>OOR:</strong> " + e.distanceOOR + " mi";
	        popupContent += e.oorSpeed ? "  <br/><strong>Speed:</strong> " + e.oorSpeed + " mph " : "";
	        popupContent += e.oorHeading ? " <br/><strong> Direction: </strong> " + heading + " (" + e.oorHeading + "\xB0)" : "";
	        popupContent += e.oorAltitude ? " <br/> <strong> Altitude: </strong> " + e.oorAltitude + " m " : "";
	        popupContent += "</div>";
	
	        var graphic = "";
	        if (e.type === "Left Route") {
	          graphic = e.oorHeading ? "/img/icons/gps_ping_exit.svg" : "/img/icons/gps_ping_exit_nohd.svg";
	        } else {
	          graphic = e.oorHeading ? "/img/icons/gps_ping_return.svg" : "/img/icons/gps_ping_return_nohd.svg";
	        }
	
	        var oorPing = complianceObj.oorLayer.createMarker(e.lonlat.clone(), {
	          popupSize: new ALKMaps.Size(225, 60),
	          popupContentHTML: popupContent,
	          anchor: {
	            size: new ALKMaps.Size(1, 1)
	            //offset: new ALKMaps.Pixel(-3, -25)
	          },
	          overflow: "auto"
	        }, {
	          externalGraphic: graphic,
	          pointRadius: "12",
	          rotation: e.oorHeading
	        });
	        oorPing.createPopup(true); //close button argument
	      });
	
	      var stopContent = {};
	      var stopMarker = {};
	      for (var i = 1; i <= route.stopCount; i++) {
	        stopContent[i] = "<div class='oor-popup'>";
	        stopContent[i] += "<strong> Stop: </strong>  (" + route.stops[i].stopNumber + ") <br/>";
	        if (route.stops[i].stopName) {
	          stopContent[i] += "<br/> <strong> " + route.stops[i].stopName + " </strong>";
	        }
	        stopContent[i] += "<strong> Address: </strong>";
	        stopContent[i] += " " + route.stops[i].stopStreet + ",";
	        stopContent[i] += route.stops[i].stopCity + ", " + route.stops[i].stopState + " " + route.stops[i].stopZip + "<br/>";
	        stopContent[i] += "<strong>Coordinates: </strong> " + route.stops[i].stopCoords + " <br/>";
	
	        stopContent[i] += "</div>";
	        stopMarker[i] = complianceObj.stopLayer.createMarker(route.stops[i].stoplonLat.clone(), {
	          popupSize: new ALKMaps.Size(225, 60),
	          popupContentHTML: stopContent[i],
	          anchor: {
	            size: new ALKMaps.Size(1, 1)
	          },
	          overflow: "auto",
	          markerType: "custom",
	          label: route.stops[i].stopNumber,
	          routeColor: route.routeColor + "",
	          pointRadius: "8",
	          strokeWidth: 2
	        });
	        stopMarker[i].createPopup(true); //close button argument
	      }
	
	      if (route.originLonLat) {
	        var originContent = "<div class='oor-popup'>";
	        originContent += " <strong> Origin:</strong>";
	        if (route.originStopName) {
	          originContent += "<strong> " + route.originStopName + "</strong> <br/>";
	        }
	        originContent += "<strong> Address: </strong>";
	        originContent += route.originStreet + ",";
	        originContent += route.originCity + ", " + route.originState + " " + route.originZip + "<br/>";
	        originContent += "<strong>Coordinates: </strong> " + route.originCoords + " <br/>";
	        originContent += "<strong>Time: </strong> " + route.originTime;
	        originContent += "</div>";
	
	        var originMarker = complianceObj.stopLayer.createMarker(route.originLonLat.clone(), {
	          popupSize: new ALKMaps.Size(225, 60),
	          popupContentHTML: originContent,
	          anchor: {
	            size: new ALKMaps.Size(1, 1)
	          },
	          overflow: "auto",
	          markerType: "custom",
	          markerColor: "#279E00",
	          pointRadius: "6.5",
	          label: ""
	        });
	
	        originMarker.createPopup(true); //close button argument
	      }
	
	      if (route.destinationLonLat) {
	        var destinationContent = "<div class='oor-popup'>";
	        destinationContent += "<strong>Destination: </strong>";
	        if (route.destinationStopName) {
	          destinationContent += " <strong> " + route.destinationStopName + " </strong>";
	        }
	        destinationContent += " <br/><strong> Address: </strong>";
	        destinationContent += route.destinationStreet + ",";
	        destinationContent += route.destinationCity + ", " + route.destinationState + " " + route.destinationZip + "<br/>";
	        destinationContent += "<strong>Coordinates: </strong> " + route.destinationCoords + " <br/>";
	        destinationContent += "<strong>Time: </strong> " + route.destinationTime;
	
	        destinationContent += "</div>";
	
	        var destinationMarker = complianceObj.stopLayer.createMarker(route.destinationLonLat.clone(), {
	          popupSize: new ALKMaps.Size(225, 60),
	          popupContentHTML: destinationContent,
	          anchor: {
	            size: new ALKMaps.Size(1, 1)
	            //offset: new ALKMaps.Pixel(-3, -25)
	          },
	          overflow: "auto",
	          markerType: "custom",
	          markerColor: "#be2525",
	          pointRadius: "6.5",
	          label: ""
	        });
	
	        destinationMarker.createPopup(true);
	      }
	      complianceObj.actualLayer.setVisibility(false);
	      complianceObj.oorLayer.setVisibility(false);
	
	      complianceObj.oorLayer.events.register("featureclicked", this, clickHandler);
	      complianceObj.oorLayer.events.register("featureclickedout", this, outHandler);
	
	      complianceObj.stopLayer.events.register("featureclicked", this, clickHandler);
	      complianceObj.stopLayer.events.register("featureclickedout", this, outHandler);
	
	      complianceLayers.push(complianceObj);
	
	      eventSelect.setLayer(_.flatten(_.map(complianceLayers, function (co) {
	        return [co.oorLayer, co.stopLayer];
	      })));
	    }
	
	    function clickHandler(event) {
	      var mapObj = mapService.getMap();
	      mapObj.addPopup(event.feature.popup, true);
	      event.feature.popup.show();
	    }
	
	    function outHandler(event) {
	      //Removing the popup (as opposed to just hiding it) stops the popup from sometimes blinking in and out repeatedly
	      var mapObj = mapService.getMap();
	      mapObj.removePopup(event.feature.popup);
	    }
	
	    function selectRoute(tripId, isVisible) {
	      var mapObj = mapService.getMap();
	      _.forEach(complianceLayers, function (complianceObj) {
	        eventSelect.deactivate();
	
	        complianceObj.plannedLayer.setOpacity(0.4);
	        complianceObj.actualLayer.setVisibility(false);
	        complianceObj.oorLayer.setVisibility(false);
	        setStopLayerOpacity(complianceObj.stopLayer, 0.4);
	        complianceObj.stopLayer.setZIndex(100);
	        complianceObj.stopLayer.refresh();
	        complianceObj.plannedLayer.refresh();
	        eventSelect.activate();
	        if (mapObj.popups.length) {
	          mapObj.removePopup(mapObj.popups[0]);
	        }
	      });
	      var selectedRoute = _.find(complianceLayers, {
	        tripId: tripId
	      });
	      selectedRoute.select = true;
	
	      if (selectedRoute && isVisible) {
	        selectedRoute.plannedLayer.setOpacity(0.8);
	        selectedRoute.actualLayer.setVisibility(true);
	        setStopLayerOpacity(selectedRoute.stopLayer, 1);
	        selectedRoute.stopLayer.refresh();
	        selectedRoute.plannedLayer.setZIndex(500);
	        selectedRoute.actualLayer.setZIndex(500);
	        selectedRoute.stopLayer.setZIndex(610);
	      }
	    }
	
	    function setRouteVisibility(tripId, isVisible) {
	      var mapObj = mapService.getMap();
	      var theRoute = _.find(complianceLayers, {
	        tripId: tripId
	      });
	      if (theRoute) {
	        theRoute.plannedLayer.setVisibility(isVisible);
	        theRoute.stopLayer.setVisibility(isVisible);
	
	        if (!isVisible) {
	          theRoute.actualLayer.setVisibility(false);
	          theRoute.oorLayer.setVisibility(false);
	        }
	        if (isVisible) {
	          selectRoute(tripId, isVisible);
	        }
	      }
	      if (mapObj.popups.length) {
	        mapObj.removePopup(mapObj.popups[0]);
	      }
	    }
	
	    function setRoutePingsVisibility(tripId, isVisible) {
	      var mapObj = mapService.getMap();
	      var theRoute = _.find(complianceLayers, {
	        tripId: tripId
	      });
	
	      if (theRoute && isVisible) {
	        theRoute.oorLayer.setVisibility(true);
	        theRoute.oorLayer.setZIndex(600);
	      }
	
	      if (theRoute && !isVisible) {
	        theRoute.oorLayer.setVisibility(false);
	        theRoute.oorLayer.setZIndex(0);
	      }
	      if (mapObj.popups.length) {
	        mapObj.removePopup(mapObj.popups[0]);
	      }
	    }
	
	    function frameRoute(tripId) {
	      var mapObj = mapService.getMap();
	
	      mapObj.updateSize();
	
	      var route = _.find(complianceLayers, {
	        tripId: tripId
	      });
	
	      if (route) {
	        var dataExtent = route.plannedLayer.getDataExtent();
	        var actualLayer = route.actualLayer.getDataExtent();
	        dataExtent.extend(actualLayer);
	        if (!_.isEmpty(dataExtent)) {
	          mapObj.zoomToExtent(dataExtent, false);
	        }
	      }
	    }
	
	    function zoomtoStop(latlong) {
	      var mapObj = mapService.getMap();
	      mapObj.setCenter(latlong);
	      mapObj.zoomTo(16);
	    }
	
	    function frameAllRoutes() {
	      var mapObj = mapService.getMap();
	
	      mapObj.updateSize();
	
	      var e = new ALKMaps.Bounds();
	
	      _.forEach(complianceLayers, function (complianceObj) {
	        e.extend(complianceObj.plannedLayer.getDataExtent());
	        complianceObj.plannedLayer.setOpacity(1);
	        setStopLayerOpacity(complianceObj.stopLayer, 0.8);
	      });
	
	      if (e.left !== null) {
	        mapObj.zoomToExtent(e, false);
	      }
	      if (mapObj.popups.length) {
	        mapObj.removePopup(mapObj.popups[0]);
	      }
	    }
	
	    //When setting the opacity of a layer with select control we must disable that control before setting opacity and re-activate after
	    function setStopLayerOpacity(stopLayer, opacity) {
	      eventSelect.deactivate();
	      stopLayer.setOpacity(opacity);
	      eventSelect.activate();
	    }
	  }
	})();

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _promise = __webpack_require__(20);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _toConsumableArray2 = __webpack_require__(321);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _angular = __webpack_require__(3);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _deriveRoute = __webpack_require__(326);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global _, ALKMaps */
	var config = __webpack_require__(110);
	var debug = __webpack_require__(331)("compliance:service");
	
	var routeColors = ["#123EC4", "#B84A00", "#7318A1", "#1E6CA8", "#B50E59", "#450DBD", "#009DC4", "#E63D00"]; //route color properties
	
	_angular2.default.module("fleetviewApp").service("complianceService", ComplianceService);
	
	ComplianceService.$inject = ["$http", "moment", "RoutingProfiles", "mapUtilities", "cacheService", "ComplianceRoutingProfileService", "UserProvider", "$q", "complianceMapService", "$location", "timeService", "$timeout", "RouteReporterAPI"];
	
	function ComplianceService($http, moment, RoutingProfiles, mapUtilities, cacheService, ComplianceRoutingProfileService, UserProvider, $q, complianceMapService, $location, timeService, $timeout, RouteReporterAPI) {
	  var currentColor = 0;
	  var vehicleGroupRoutingProfiles = [];
	  var $ctrl = {};
	  // array containing the route id's and visibility properties for that route
	  // each array item (a route) is of the form { tripId (number), isVisible (boolean) }
	  var routeVisibilityList = [];
	
	  var service = {
	    getComplianceData: getComplianceData,
	    mapRoute: mapRoute,
	    changeProfile: changeProfile,
	    noRoutingProfiles: noRoutingProfiles,
	    getRoutePage: getRoutePage,
	    getRouteVisibilityList: getRouteVisibilityList,
	    setRouteVisibility: setRouteVisibility,
	    initRoutes: initRoutes
	  };
	
	  return service;
	
	  /**
	     * @example
	     *  {
	          "accountId": 1,
	          "groupId": 24535,
	          "ids": 1061,
	          "type": "vehicle",
	          "startDate": "8/1/2014",
	          "endDate": "9/1/2014",
	          "page": 1,
	          "pageSize": 10,
	          "noCoords": false,
	          "oorCost": 0.77,
	          "sort": "VehicleName",
	          "order": "asc",
	          "noQuestionableRoutes": true,
	          "includeRoutesWithNoOorMiles": true
	        }
	    * @param {any} params post data
	    * @returns A list of compliance data
	    *
	    * @memberOf ComplianceService
	    * @returns {object} compliance data
	    */
	  function getComplianceData(params) {
	    return RouteReporterAPI.post("api/Report", params, null).then(function (response) {
	      return response.data;
	    });
	  }
	
	  /**
	     * Gets the array filled with route visibility data, where each item is in the format of 
	     * {
	     *  tripId: number,
	     *  isVisible: boolean
	     * }
	     * @returns {Array} route visibility array
	     */
	  function getRouteVisibilityList() {
	    return routeVisibilityList;
	  }
	
	  /**
	     * Sets the visibility of the route.
	     * @param {number} idx index in the route visibility array
	     * @param {boolean} isVisible whether the route should be visible on the map
	     */
	  function setRouteVisibility(idx, isVisible) {
	    routeVisibilityList[idx].isVisible = isVisible;
	  }
	
	  /**
	     * Converts a route returned from the compliance data to a format usable for this component.
	     * @param {any} route
	     * @returns promise
	     */
	  //  TODO: clean this up
	  function mapRoute(route, shouldDraw) {
	    // eslint-disable-line complexity
	    var routeFound = routeVisibilityList.some(function (el) {
	      return el.tripId === route.tripId;
	    });
	    if (!routeFound) {
	      var _r = {};
	      _r.tripId = route.tripId;
	      _r.isVisible = true;
	      routeVisibilityList.push(_r);
	    }
	
	    var r = {};
	    var stops = {};
	    r.pointsFormatted = false;
	    r.tripId = route.tripId;
	    r.isVisible = true;
	    r.routeColor = routeColors[currentColor];
	    r.routeColorClass = "routeColor" + currentColor;
	    r.isCancelled = route.effectedRoute.canceled;
	    r.questionable = route.effectedRoute.questionable;
	    r.oorCost = route.oorCost;
	    r.routingProfileId = route.prescribedRoute.routingProfileId;
	
	    r.routeSource = route.prescribedRoute.routeSource.toUpperCase();
	    if (r.routeSource !== "MANUAL" && r.routeSource !== "INTEGRATION" && r.routeSource !== "ROUTESYNC" && r.routeSource !== "DISPATCH") {
	      r.routeSource = "UNKNOWN";
	    }
	    currentColor++;
	    if (currentColor >= 8) {
	      currentColor = 0;
	    }
	    r.driverName = route.driverName;
	    r.driverId = route.prescribedRoute.driverId;
	    r.vehicleName = route.vehicleName; // NOTE: used to display Vehicle Name (aka ScreenName)
	    r.vehicleId = route.deviceId; // NOTE: used to display deviceId as Vehicle ID
	    r.unitId = route.unitId; // NOTE: this is internal [TVehicle.VehicleId] used for getVehicleRoutingProfiles() in fleetlink.routing-profiles.js
	    r.showStops = false;
	
	    var originStop = null;
	    var destinationStop = null;
	    if (route.prescribedRoute.tripStops.length > 0) {
	      originStop = route.prescribedRoute.tripStops[0];
	      destinationStop = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1];
	      r.originStopName = originStop.stopName;
	      r.originStreet = originStop.street;
	      r.originCity = originStop.city;
	      r.originState = originStop.state;
	      r.originZip = originStop.zip;
	      r.originOffset = route.effectedRoute.routeStartUtcOffset;
	      r.originTime = timeService.getFormattedTime2(route.effectedRoute.routeStart, route.effectedRoute.routeStartUtcOffset);
	      if (route.effectedRoute.routeStartUtcOffset) {
	        r.originTimeStamp = route.effectedRoute.routeStart;
	      }
	      r.originLonLat = new ALKMaps.LonLat(originStop.longitude, originStop.latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	      r.originCoords = originStop.latitude + ", " + originStop.longitude;
	      r.destinationStopName = destinationStop.stopName;
	      r.destinationStreet = destinationStop.street;
	      r.destinationCity = destinationStop.city;
	      r.destinationState = destinationStop.state;
	      r.destinationZip = destinationStop.zip;
	      r.destinationOffset = route.effectedRoute.routeEndUtcOffset;
	      r.destinationTime = timeService.getFormattedTime2(route.effectedRoute.routeEnd, route.effectedRoute.routeEndUtcOffset);
	      if (route.effectedRoute.routeEndUtcOffset) {
	        r.destinationTimeStamp = route.effectedRoute.routeEnd;
	      }
	      r.destinationLonLat = new ALKMaps.LonLat(destinationStop.longitude, destinationStop.latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	      r.destinationCoords = destinationStop.latitude + ", " + destinationStop.longitude;
	      if (route.prescribedRoute.tripStops.length > 2) {
	        for (var i = 1; i < route.prescribedRoute.tripStops.length - 1; i++) {
	          stops[i] = {};
	          stops[i].stopNumber = i;
	          stops[i].stopName = route.prescribedRoute.tripStops[i].stopName;
	          stops[i].stopStreet = route.prescribedRoute.tripStops[i].street;
	          stops[i].stopCity = route.prescribedRoute.tripStops[i].city;
	          stops[i].stopState = route.prescribedRoute.tripStops[i].state;
	          stops[i].stopZip = route.prescribedRoute.tripStops[i].zip;
	          stops[i].stoplonLat = new ALKMaps.LonLat(route.prescribedRoute.tripStops[i].longitude, route.prescribedRoute.tripStops[i].latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	          stops[i].stopCoords = route.prescribedRoute.tripStops[i].latitude + " , " + route.prescribedRoute.tripStops[i].longitude;
	        }
	
	        r.stops = stops;
	        r.stopCount = route.prescribedRoute.tripStops.length - 2;
	      }
	    } else {
	      console.log("no trips stops! todo: log error. ", route);
	    }
	    r.distancePlanned = route.prescribedRoute.distance;
	    r.distanceActual = route.effectedRoute.distance;
	    r.distanceDifference = route.distanceDelta;
	    r.status = "";
	    if (r.isCancelled) {
	      r.status = "Cancelled";
	    } else if (r.distanceActual > 0) {
	      r.status = "Ended";
	    } else {
	      r.status = "Incomplete";
	    }
	    r.timePlanned = moment.duration(route.prescribedRoute.time / 1000, "hours").format("h:mm", {
	      trim: false
	    });
	    r.timeActual = moment.duration(route.effectedRoute.time / 1000, "hours").format("h:mm", {
	      trim: false
	    });
	    r.timeDifference = moment.duration(route.timeDelta / 1000, "hours").format("h:mm", {
	      trim: false
	    });
	    r.timeDifference = r.timeDifference === "-0:00" ? "0:00" : r.timeDifference;
	    r.isDelayed = r.timePlanned < r.timeActual ? true : false;
	    r.oorDistance = route.oorDistance;
	    r.isOor = route.outOfRouteEvents.events.length > 0 ? route.outOfRouteEvents.events.length + " found" : "None";
	    r.origStopList = route.prescribedRoute.tripStops;
	    r.stopList = _.map(route.prescribedRoute.tripStops, function (stop) {
	      return new ALKMaps.LonLat(stop.longitude, stop.latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	    });
	    r.outOfRouteEvents = [];
	    if (route.outOfRouteEvents.events.length > 0) {
	      r.outOfRouteEvents = _.map(route.outOfRouteEvents.events, function (e) {
	        return {
	          type: e.type,
	          oorLon: e.lon,
	          oorLat: e.lat,
	          lonlat: new ALKMaps.LonLat(e.lon, e.lat).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913")),
	          point: new ALKMaps.Geometry.Point(e.lon, e.lat).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913")),
	          latlong: new ALKMaps.LonLat(e.lat, e.lon).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913")),
	          distanceOOR: e.distanceOOR,
	          timeStamp: timeService.getFormattedTime2(e.timeStamp, e.timeStampUtcOffset),
	          timeStampUtcOffset: e.timeStampUtcOffset,
	          oorStreetAddr: e.streetAddress,
	          oorCity: e.city,
	          oorState: e.state,
	          oorZip: e.zip,
	          oorHeading: e.heading,
	          oorAltitude: e.altitude,
	          oorSpeed: e.speed
	        };
	      });
	    }
	    r.outOfRouteEvents = r.outOfRouteEvents.reverse();
	    var routingProfilePromise = void 0;
	
	    r.externalTripId = route.prescribedRoute.externalTripId;
	    var _route$prescribedRout = route.prescribedRoute,
	        routingProfileId = _route$prescribedRout.routingProfileId,
	        prescribedRouteId = _route$prescribedRout.prescribedRouteId;
	    var routingProfileFromPrescribedRoute = route.routingProfileFromPrescribedRoute;
	    //First try routing profile of the trip itself
	
	    if (routingProfileId) {
	      var currentUser = UserProvider.getUser();
	      var options = { cache: true };
	
	      if (currentUser.supportAccount) {
	        options.params = {};
	        options.params.targetAccount = currentUser.supportAccount.accountId;
	      }
	      routingProfilePromise = RoutingProfiles.getRoutingProfile(routingProfileId, options);
	    } else {
	      routingProfilePromise = getBackupRPPromise(r);
	    }
	    //change format of time & lat lon for positions
	    if (!route.pointsFormatted && route.effectedRoute.positions) {
	      route.effectedRoute.positions.forEach(function (point) {
	        point.Ln = Number(point.Ln) / 1e6;
	        point.Lt = Number(point.Lt) / 1e6;
	        point.timeStamp = timeService.getEpochFormattedTime(point.DTS, point.O);
	      });
	
	      route.pointsFormatted = true; // format points only once
	    }
	
	    // gets flagged as "DriverProfile" & added to r.routingProfile[] for the drop-down
	    // beware of side-effects by moving this elsewhere
	    if (routingProfileFromPrescribedRoute && !routingProfileFromPrescribedRoute.routingProfileId) {
	      routingProfileFromPrescribedRoute.source = "DriverProfile";
	      debug("routingProfileFromPrescribedRoute:", routingProfileFromPrescribedRoute);
	      r.routingProfileFromPrescribedRoute = routingProfileFromPrescribedRoute;
	    }
	
	    //Add start and end destination points to beginning and end of derived and prescribed route points if they exist
	    // TODO: extract into own function
	    if (route.prescribedRoute && route.prescribedRoute.coords && route.prescribedRoute.coords.length) {
	      if (originStop) {
	        var originPoint = [originStop.longitude, originStop.latitude];
	        var hasOrigin = _.some(route.prescribedRoute.coords, originPoint);
	        if (!hasOrigin) {
	          route.prescribedRoute.coords = [originPoint].concat((0, _toConsumableArray3.default)(route.prescribedRoute.coords));
	        }
	
	        if (route.effectedRoute && route.effectedRoute.positions) {
	          route.effectedRoute.positions.unshift(originPoint);
	        }
	      }
	      if (destinationStop) {
	        var destinationPoint = [destinationStop.longitude, destinationStop.latitude];
	        var hasDest = _.some(route.prescribedRoute.coords, destinationPoint);
	        if (!hasDest) {
	          route.prescribedRoute.coords = [].concat((0, _toConsumableArray3.default)(route.prescribedRoute.coords), [destinationPoint]);
	        }
	
	        if (route.effectedRoute && route.effectedRoute.positions && route.effectedRoute.positions.length >= 1) {
	          var lastPing = route.effectedRoute.positions[route.effectedRoute.positions.length - 1];
	          var destGeom = new ALKMaps.Geometry.Point(destinationStop.longitude, destinationStop.latitude);
	          var lastPingGeom = new ALKMaps.Geometry.Point(lastPing.Ln, lastPing.Lt);
	          var line = new ALKMaps.Geometry.LineString([destGeom, lastPingGeom]);
	          var distance = line.getGeodesicLength(new ALKMaps.Projection("EPSG:4326"));
	          distance *= 0.001; //meters to km
	          //0.321869 km = 0.2 mi
	          if (distance < 0.321869) {
	            route.effectedRoute.positions.push(destinationPoint);
	          }
	        }
	      }
	    }
	
	    r.origPlannedRoutePoints = route.prescribedRoute.coords.slice(1, -1); // remove 1st & last point
	    r.origPlannedConnectorPoints = {
	      origin: _.take(route.prescribedRoute.coords, 2), // first 2 points
	      destination: _.takeRight(route.prescribedRoute.coords, 2) // last 2 points
	    };
	    r.origActualRoutePoints = []; //used to derive route
	    if (route.effectedRoute.positions) {
	      route.effectedRoute.positions.forEach(function (point) {
	        if (point.Ln) {
	          r.origActualRoutePoints.push([point.Ln, point.Lt]);
	        } else {
	          r.origActualRoutePoints.push(point);
	        }
	      });
	    }
	    r.gpsPositions = route.effectedRoute.positions || route.effectedRoute.coords; //used in map service
	
	    var onRPGetSuccess = function onRPGetSuccess(response) {
	      var results = response;
	      //routing profile object returned
	      if (_.isObject(results) && !Array.isArray(results)) {
	        // ensure its an Object and not Array
	        r.routingProfiles = [results];
	        if (r.routingProfileId) {
	          r.routingProfiles[0].source = "CompanyProfile";
	          // r.selectedRoutingProfile = r.routingProfiles[0]; // TODO: clean up
	        }
	      }
	      //Array of routing profiles returned; either VG or Account profiles
	      else if (Array.isArray(results) && _.some(results)) {
	          r.routingProfiles = _angular2.default.copy(results);
	        } else {
	          r.routingProfiles = [];
	        }
	      // if RP from prescribedRoute exists, set as 'selected'
	      if (!r.selectedRoutingProfile && r.routingProfileFromPrescribedRoute) {
	        r.selectedRoutingProfile = r.routingProfileFromPrescribedRoute;
	      }
	
	      debug("onRPGetSuccess()", r.selectedRoutingProfile, r);
	      return results;
	    };
	
	    //Getting the routing profile associated with the trip may sometimes fail if it's outdated, so use the backup rps from the vehicle group
	    return routingProfilePromise.then(onRPGetSuccess, function (error) {
	      if (error) {
	        console.error("routingProfilePromise()", error); // eslint-disable-line no-console
	      }
	      return getBackupRPPromise(r).then(onRPGetSuccess, function (errorBackup) {
	        return null;
	      });
	    }).then(function () {
	      setRoughRoutePoints(r); //When the page first loads, set rough line strings to avoid waiting for routePath call
	      if (shouldDraw) {
	        complianceMapService.drawRoute(r); //Draw rough route at first.
	        setProfile(r); //Change the profile - this will asynchronously load and re-draw the aligned route in the background.
	      }
	      return r;
	    });
	  }
	  // <-- END OF mapRoute() --> //
	
	  //Called when the routing profile dropdown changes. Uses the selected routing profile to re-draw the routes on the map according to that routing profile.
	  function changeProfile(route) {
	    debug("changeProfile event");
	    setProfile(route);
	  }
	
	  function setProfile(route) {
	    route.isChangingProfile = true;
	    route.routingProfileError = false;
	    var rp = route.selectedRoutingProfile;
	    debug("setProfile() -> selectedRoutingProfile:", rp, "route:", route);
	    var deriveRouteDeps = { $q: $q, cacheService: cacheService, ComplianceRoutingProfileService: ComplianceRoutingProfileService, UserProvider: UserProvider, mapUtilities: mapUtilities
	
	      // TODO: use tank-mode when no rp is available
	    };var actualRoutePromise = (0, _deriveRoute.deriveRoute)(route.origActualRoutePoints, rp, route.tripId, 1, deriveRouteDeps);
	    var plannedRoutePromise = (0, _deriveRoute.deriveRoute)(route.origPlannedRoutePoints, rp, route.tripId, 0, deriveRouteDeps);
	
	    $q.all([actualRoutePromise, plannedRoutePromise]).then(function (results) {
	      route.actualRoutePoints = results[0];
	      route.plannedRoutePoints = results[1];
	      debug("plannedRoutePromise() -> results:", route.plannedRoutePoints.length);
	      // debug("setProfile()-> plannedRouteFeature.geometry:", route.complianceObj.plannedRouteFeature.geometry.components);
	      complianceMapService.redrawRoute(route);
	      route.isChangingProfile = false;
	      route.routingProfileError = false;
	    }, function (error) {
	      route.isChangingProfile = false;
	      route.routingProfileError = true;
	    });
	  }
	
	  function noRoutingProfiles(route) {
	    return _.isEmpty(route.routingProfiles);
	  }
	
	  //Set rough route points for the actual/planned routes when the page first loads.
	  function setRoughRoutePoints(route) {
	
	    function convertLLtoMerc(latLon) {
	      var merc = mapUtilities.LLtoMerc(latLon[0], latLon[1]);
	      return new ALKMaps.Geometry.Point(merc.lon, merc.lat);
	    }
	
	    route.actualRoutePoints = _.map(route.origActualRoutePoints, convertLLtoMerc);
	    route.plannedRoutePoints = _.map(route.origPlannedRoutePoints, convertLLtoMerc);
	    var origin = _.map(route.origPlannedConnectorPoints.origin, convertLLtoMerc);
	    var destination = _.map(route.origPlannedConnectorPoints.destination, convertLLtoMerc);
	    route.plannedConnectorPoints = { origin: origin, destination: destination };
	  }
	
	  function getBackupRPPromise(r) {
	    var user = UserProvider.getUser();
	    var options = { cache: true };
	    if (user.supportAccount) {
	      options.params = { targetAccount: user.supportAccount.accountId };
	    }
	
	    return RoutingProfiles.getVehicleRoutingProfiles(r.unitId, options).then(function (results) {
	      debug("### getBackupRPPromise() => getVehicleRoutingProfiles()", results);
	      if (results && results.length > 0) {
	        var rps = results.map(function (rp) {
	          rp.source = "CompanyProfile_BackupVG";
	          return rp;
	        });
	        return rps;
	      } else {
	        //If that doesn't exist, last fallback is the account routing profiles.
	        debug("using accountRoutingProfiles!", $ctrl.accountRoutingProfiles);
	        return $ctrl.accountRoutingProfiles;
	      }
	    }, function (error) {
	      console.error("getVehicleRoutingProfiles() " + error); // eslint-disable-line no-console
	    });
	  }
	
	  /**
	     * Get and draw a list of routes for a specific page.
	     * @param {object} vm view model
	     * @param {object} searchSettings options
	     * @param {int} pageNumber page index
	     * @param {int} pageIndex is optional - if set will only draw route at that index
	     * @returns {Promise} object representing the completion of querying the service and setting the returned routes on the model.
	     */
	  function getRoutePage(vm, searchSettings, pageNumber, pageIndex) {
	    vm.isLoading = true;
	
	    //Wrap this in a timeout after isLoading so the isLoading spinner always displays even when loading from cache
	    //$timeout returns a promise.
	    return $timeout(function () {
	
	      complianceMapService.clearMap();
	
	      var user = JSON.parse(window.sessionStorage["userAuthInfo"]);
	
	      var accountId = user.accountId;
	      var currentUser = UserProvider.getUser();
	      if (currentUser.supportAccount) {
	        accountId = currentUser.supportAccount.accountId;
	      }
	
	      var p = {
	        "accountId": accountId,
	        "pageNumber": pageNumber,
	        "pageSize": 10,
	        "noCoords": false,
	        "oorCost": 0.0,
	        "sort": "VehicleName",
	        "order": "asc",
	        "isOor": false,
	        "hideCoords": false
	      };
	
	      var allParams = _angular2.default.merge({}, p, searchSettings);
	
	      //HTTP POST calls cannot be cached by angular's $http (only GET). Must use custom cacheService to cache instead.
	      //Cache compliance calls by page number.
	      var cachedResponse = cacheService.getCachedRouteResponse(pageNumber);
	      var getComplianceDataCall = cachedResponse ? $q.when(cachedResponse) : getComplianceData(allParams);
	
	      return getComplianceDataCall.then(function (resp) {
	        cacheService.setCachedRouteResponse(pageNumber, resp);
	        if (resp.results === null || resp.results.routes.length === 0) {
	          vm.routeList = [];
	          vm.totalRoutesNum = 0;
	          vm.totalPagesNum = 0;
	          vm.isLoading = false;
	          return;
	        }
	        resp.results.routes = removeDuplicateRoutes(resp.results.routes);
	        vm.totalRoutesNum = resp.results.totalRoutes;
	        $location.search("pageNumber", vm.currentPageNum);
	        vm.totalPagesNum = resp.results.totalPages;
	
	        vm.firstItemNum = vm.currentPageNum * 10 - 9;
	        vm.lastItemNum = vm.currentPageNum * 10 > vm.totalRoutesNum ? vm.totalRoutesNum : vm.currentPageNum * 10;
	
	        var getRoutesWithRoutingProfile = resp.results.routes.map(function (route) {
	          if (route.prescribedRoute.prescribedRouteId) {
	            return ComplianceRoutingProfileService.getRoutingProfileByPrescribedRouteId(route.prescribedRoute.prescribedRouteId).then(function (rp) {
	              route.routingProfileFromPrescribedRoute = rp.data;
	              return route;
	            });
	          }
	          return _promise2.default.resolve(route);
	        });
	
	        // Fetch routingProfile for each route using prescribedRouteId and then mapRoute() each route
	        return _promise2.default.all(getRoutesWithRoutingProfile).then(function (routes) {
	          var mapRoutePromises = resp.results.routes.map(function (route, index) {
	            var shouldDraw = false;
	            var pageIndexNotSet = pageIndex === undefined || pageIndex === null;
	            if (pageIndexNotSet || !pageIndexNotSet && index === pageIndex) {
	              shouldDraw = true;
	            }
	            return mapRoute(route, shouldDraw);
	          });
	          return _promise2.default.all(mapRoutePromises);
	        }).then(function (resultsArray) {
	          vm.routeList = resultsArray;
	          complianceMapService.frameAllRoutes();
	          vm.isLoading = false;
	        });
	      });
	    }, 100);
	  }
	
	  function removeDuplicateRoutes(routes) {
	    var _routes = _.uniq(routes.reverse(), "tripId");
	    return _routes.reverse();
	  }
	
	  //Get and set routes for the first time. (Calls getRoutePage under the hood.) Needed to initialize routing profiles.
	  //This "resets" the service. Should be called on init of any controller that needs it.
	  //pageIndex is optional integer. If set, will only draw that route index (zero indexed).
	  function initRoutes(vm, searchSettings, pageNumber, pageIndex) {
	    $ctrl = vm;
	    vehicleGroupRoutingProfiles = [];
	    currentColor = 0;
	    var options = { cache: true };
	    var user = UserProvider.getUser();
	    if (user.supportAccount) {
	      options.params = {};
	      options.params.targetAccount = user.supportAccount.accountId;
	    }
	
	    return RoutingProfiles.getDefaultRoutingProfile(options).then(function (results) {
	      $ctrl.accountRoutingProfiles = results.map(function (rp) {
	        rp.source = "Account";
	        return rp;
	      });
	      debug("getDefaultRoutingProfile() => accountRoutingProfiles", $ctrl.accountRoutingProfiles);
	      //Then get routing profiles from the vehicle group id, if it is available
	      if (vm.currentState !== "querystring" && searchSettings.idType === "vehicle") {
	        var vehGroupId = searchSettings.groupId[0];
	        return RoutingProfiles.getRoutingProfiles(vehGroupId, options);
	      }
	      //Otherwise return empty array for it
	      else {
	          return $q.when([]);
	        }
	    }).then(function (results) {
	      vehicleGroupRoutingProfiles = results.map(function (rp) {
	        rp.source = "CompanyProfile_VG";
	        return rp;
	      });
	      if (vehicleGroupRoutingProfiles.length) {
	        $ctrl.accountRoutingProfiles = []; // prevent showing the account default RPs
	      }
	      debug("getDefaultRoutingProfile() =>  vehicleGroupRoutingProfiles", vehicleGroupRoutingProfiles, $ctrl);
	      return getRoutePage(vm, searchSettings, pageNumber, pageIndex);
	    });
	  }
	}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(322);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(323), __esModule: true };

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(23);
	__webpack_require__(324);
	module.exports = __webpack_require__(31).Array.from;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(32);
	var $export = __webpack_require__(29);
	var toObject = __webpack_require__(66);
	var call = __webpack_require__(75);
	var isArrayIter = __webpack_require__(76);
	var toLength = __webpack_require__(56);
	var createProperty = __webpack_require__(325);
	var getIterFn = __webpack_require__(77);
	
	$export($export.S + $export.F * !__webpack_require__(88)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(35);
	var createDesc = __webpack_require__(43);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deriveRoute = deriveRoute;
	exports.buildDerivedRouteRequest = buildDerivedRouteRequest;
	
	var _compliance = __webpack_require__(327);
	
	/* globals ALKMaps */
	var debug = __webpack_require__(331)("compliance:deriveroute");
	
	
	/**
	   * @param {array} latLonArray latlong ie. [ [0,0], [1,1] ]
	   * @param {object} routingProfile profile
	   * @param {int} tripId id
	   * @param {string} tripType 0 for planned, 1 for actual
	   * @param {object} deps hash of dependencies
	   * @returns {Promise} deferred value
	**/
	function deriveRoute(latLonArray, routingProfile, tripId, tripType, deps) {
	  var $q = deps.$q,
	      cacheService = deps.cacheService,
	      ComplianceRoutingProfileService = deps.ComplianceRoutingProfileService,
	      UserProvider = deps.UserProvider,
	      mapUtilities = deps.mapUtilities;
	
	
	  var deferred = $q.defer();
	  if (!latLonArray || latLonArray.length === 0) {
	    deferred.resolve([]);
	    return deferred.promise;
	  }
	
	  var profileName = routingProfile ? routingProfile.name : "--";
	  var tripCacheKey = tripId + "_" + profileName + "_" + (tripType === 0 ? "planned" : "actual");
	  //Fetch from cache if exists
	  var cachedRoutePoints = cacheService.getCachedRoutePoints(tripCacheKey, routingProfile);
	  if (cachedRoutePoints) {
	    deferred.resolve(cachedRoutePoints);
	    return deferred.promise;
	  }
	  var offRouteMiles = 0.03; // Always use 0.03 to account for small variations in Data Versions
	  //Show the aligned route
	  var request = ComplianceRoutingProfileService.getDerivedRouteRequest(latLonArray, routingProfile, offRouteMiles);
	  debug("getDerivedRouteRequest() -> request:", request);
	
	  ALKMaps.Services.postDerivedRoutePath({
	    request: request,
	    dataset: UserProvider.getUser().dataVersion,
	    success: function success(results) {
	      if (!results) {
	        deferred.resolve([]);
	        return;
	      }
	      var mercPoints = (0, _compliance.getMercPoints)(results, mapUtilities);
	      //Cache using tripId and routingProfile.routingProfileId
	      cacheService.setCachedRoutePoints(tripCacheKey, routingProfile, mercPoints);
	      deferred.resolve(mercPoints);
	    },
	    failure: function failure(error) {
	      debug("ALKMaps.Services.postDerivedRoutePath() >> error:", error, latLonArray);
	      deferred.reject(error);
	    }
	  });
	
	  return deferred.promise;
	}
	
	function buildDerivedRouteRequest(_ref) {
	  var region = _ref.region,
	      routingProfile = _ref.routingProfile,
	      latLonArray = _ref.latLonArray,
	      offRouteMiles = _ref.offRouteMiles,
	      weight = _ref.weight,
	      isMetric = _ref.isMetric;
	
	  // https://developer.dev.trimblemaps.com/restful-apis/routing/post-route-reports/
	  // refer to Libraries\ALK.Common.Model\RoutingProfiles\RoutingProfile.cs
	  var request = {
	    "RoutePings": (0, _compliance.getRoutePings)(latLonArray),
	    "OffRouteMiles": offRouteMiles,
	    "HighwayOnly": routingProfile.highwayOnly || false,
	    "ReportType": null,
	    "Region": region,
	    "RoutingOptions": {
	      "VehicleType": _compliance.routingProfileProps.vehicleTypes[routingProfile.vehicleType],
	      "RoutingType": _compliance.routingProfileProps.routingTypes[routingProfile.routingType],
	      "HighwayOnly": routingProfile.highwayOnly || false,
	      "UseAvoidsAndFavors": routingProfile.useAvoidFavors,
	      "ClassOverrides": routingProfile.classOverrides,
	      "DistanceUnits": _compliance.routingProfileProps.distanceUnits[routingProfile.distanceUnits],
	      "TollDiscourage": routingProfile.tollDiscouraged || false,
	      "BordersOpen": routingProfile.bordersOpen,
	      "OverrideRestrict": routingProfile.overrideRestrictions,
	      "HazMatType": _compliance.routingProfileProps.hazmatTypes[routingProfile.hazmatType],
	      "RouteOptimization": null,
	      "TruckCfg": {
	        "Weight": weight,
	        "Axles": routingProfile.numAxles < 2 ? null : routingProfile.numAxles,
	        "Units": _compliance.routingProfileProps.unitTypes[routingProfile.unitsOfMeasure],
	        "LCV": routingProfile.lcv,
	        "Width": routingProfile.maxWidth ? routingProfile.maxWidth + (isMetric ? "" : "\"") : null,
	        "Height": routingProfile.maxHeight ? routingProfile.maxHeight + (isMetric ? "" : "\"") : null,
	        "Length": routingProfile.totalLength ? routingProfile.totalLength + (isMetric ? "" : "\"") : null
	      },
	      "HubRouting": routingProfile.hubRouting,
	      "AFSetIDs": null,
	      "ElevLimit": routingProfile.elevationLimit,
	      "FerryDiscourage": routingProfile.isFerryDiscouraged,
	      "GovernorSpeedLimit": routingProfile.governorSpeedLimit,
	      "sideOfStreetAdherence": routingProfile.sideOfStreetAdherence,
	      "useSites": routingProfile.useSites,
	      "useTraffic": routingProfile.useTraffic
	    }
	  };
	
	  // This is needed so the PCM derivedRoute/routePath service call doesn't return 400
	  request.RoutingOptions = (0, _compliance.removeEmptyProp)(request.RoutingOptions);
	  return request;
	}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routingProfileProps = undefined;
	
	var _typeof2 = __webpack_require__(262);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(238);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(328);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.getRoutePings = getRoutePings;
	exports.getMercPoints = getMercPoints;
	exports.removeEmptyProp = removeEmptyProp;
	exports.buildDefaultRoutingProfile = buildDefaultRoutingProfile;
	
	var _lodash = __webpack_require__(111);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRoutePings(latLonArray) {
	  return _lodash2.default.map(latLonArray, function (latLon) {
	    return {
	      Lon: latLon[0],
	      Lat: latLon[1]
	    };
	  });
	} /* global ALKMaps */
	function getMercPoints(results, mapUtilities) {
	  var points = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(results.geometry.coordinates), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var coords = _step.value;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(coords), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var innerCoords = _step2.value;
	
	          var merc = mapUtilities.LLtoMerc(innerCoords[0], innerCoords[1]);
	          var point = new ALKMaps.Geometry.Point(merc.lon, merc.lat);
	          points.push(point);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return points;
	}
	// deep clean null or undefined keys
	function removeEmptyProp(obj) {
	  (0, _keys2.default)(obj).forEach(function (key) {
	    if (obj[key] && (0, _typeof3.default)(obj[key]) === "object") removeEmptyProp(obj[key]); // recursive
	    else if (obj[key] == null || obj[key] == undefined) delete obj[key]; // delete
	  });
	  return obj;
	}
	
	function buildDefaultRoutingProfile(latLonArray, offRouteMiles, region) {
	  return {
	    RoutePings: getRoutePings(latLonArray),
	    OffRouteMiles: offRouteMiles,
	    HighwayOnly: false,
	    Region: region,
	    RoutingOptions: {
	      VehicleType: 2,
	      RoutingType: 1,
	      HighwayOnly: false,
	      UseAvoidsAndFavors: false,
	      ClassOverrides: 0,
	      DistanceUnits: 0,
	      TollDiscourage: false,
	      BordersOpen: true,
	      OverrideRestrict: false, // default is false, see: SWFV-399
	      HazMatType: 0,
	      RouteOptimization: 0,
	      HubRouting: false,
	      FerryDiscourage: false,
	      sideOfStreetAdherence: 0
	    }
	  };
	}
	
	//These objects map the fleetportal routing profile WS response object string to the ALKMaps derived route input
	//See RoutingProfile.cs for the keys
	var routingProfileProps = exports.routingProfileProps = {
	  vehicleTypes: {
	    Truck: 0,
	    MidsizeTruck: 1,
	    LightDuty: 1,
	    Auto: 2
	  },
	  truckStyles: {
	    Truck: 4,
	    MidsizeTruck: 3,
	    LightDuty: 2,
	    Auto: 1
	  },
	  routingTypes: {
	    Practical: 0,
	    Shortest: 1,
	    Fastest: 2,
	    "0": 0, // Practical/Quickest
	    "1": 1, // Shortest
	    "3": 2 // Fastest(Enable Active Routes + Practical/Quickest)
	  },
	  classOverrides: {
	    None: 0,
	    NationalNetwork: 1,
	    FiftyThreeFoot: 2
	  },
	  distanceUnits: {
	    Miles: 0,
	    Kilometers: 1
	  },
	  hazmatTypes: {
	    None: 0,
	    General: 1,
	    Caustic: 2,
	    Explosives: 3,
	    Flammable: 4,
	    Inhalants: 5,
	    Radioactive: 6
	  },
	  unitTypes: {
	    English: 0,
	    Metric: 1
	  }
	};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(329), __esModule: true };

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67);
	__webpack_require__(23);
	module.exports = __webpack_require__(330);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(36);
	var get = __webpack_require__(77);
	module.exports = __webpack_require__(31).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/* eslint-env browser */
	
	/**
	 * This is the web browser implementation of `debug()`.
	 */
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = localstorage();
	/**
	 * Colors.
	 */
	
	exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	// eslint-disable-next-line complexity
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
	    return true;
	  } // Internet Explorer and Edge do not support colors.
	
	
	  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
	    return false;
	  } // Is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	
	
	  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
	  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
	  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
	  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
	}
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	
	function formatArgs(args) {
	  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
	
	  if (!this.useColors) {
	    return;
	  }
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function (match) {
	    if (match === '%%') {
	      return;
	    }
	
	    index++;
	
	    if (match === '%c') {
	      // We only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	  args.splice(lastC, 0, c);
	}
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	
	function log() {
	  var _console;
	
	  // This hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
	}
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	
	function save(namespaces) {
	  try {
	    if (namespaces) {
	      exports.storage.setItem('debug', namespaces);
	    } else {
	      exports.storage.removeItem('debug');
	    }
	  } catch (error) {// Swallow
	    // XXX (@Qix-) should we be logging these?
	  }
	}
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	
	function load() {
	  var r;
	
	  try {
	    r = exports.storage.getItem('debug');
	  } catch (error) {} // Swallow
	  // XXX (@Qix-) should we be logging these?
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	
	
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"ENV":"alkqaaws","ALK_APP":"fleetview","CURRENT_TERMS_VERSION":1}).DEBUG;
	  }
	
	  return r;
	}
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	
	function localstorage() {
	  try {
	    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
	    // The Browser also has localStorage in the global context.
	    return localStorage;
	  } catch (error) {// Swallow
	    // XXX (@Qix-) should we be logging these?
	  }
	}
	
	module.exports = __webpack_require__(332)(exports);
	var formatters = module.exports.formatters;
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	formatters.j = function (v) {
	  try {
	    return JSON.stringify(v);
	  } catch (error) {
	    return '[UnexpectedJSONParseError]: ' + error.message;
	  }
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(199)))

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 */
	function setup(env) {
	  createDebug.debug = createDebug;
	  createDebug.default = createDebug;
	  createDebug.coerce = coerce;
	  createDebug.disable = disable;
	  createDebug.enable = enable;
	  createDebug.enabled = enabled;
	  createDebug.humanize = __webpack_require__(333);
	  Object.keys(env).forEach(function (key) {
	    createDebug[key] = env[key];
	  });
	  /**
	  * Active `debug` instances.
	  */
	
	  createDebug.instances = [];
	  /**
	  * The currently active debug mode names, and names to skip.
	  */
	
	  createDebug.names = [];
	  createDebug.skips = [];
	  /**
	  * Map of special "%n" handling functions, for the debug "format" argument.
	  *
	  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	  */
	
	  createDebug.formatters = {};
	  /**
	  * Selects a color for a debug namespace
	  * @param {String} namespace The namespace string for the for the debug instance to be colored
	  * @return {Number|String} An ANSI color code for the given namespace
	  * @api private
	  */
	
	  function selectColor(namespace) {
	    var hash = 0;
	
	    for (var i = 0; i < namespace.length; i++) {
	      hash = (hash << 5) - hash + namespace.charCodeAt(i);
	      hash |= 0; // Convert to 32bit integer
	    }
	
	    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	  }
	
	  createDebug.selectColor = selectColor;
	  /**
	  * Create a debugger with the given `namespace`.
	  *
	  * @param {String} namespace
	  * @return {Function}
	  * @api public
	  */
	
	  function createDebug(namespace) {
	    var prevTime;
	
	    function debug() {
	      // Disabled?
	      if (!debug.enabled) {
	        return;
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var self = debug; // Set `diff` timestamp
	
	      var curr = Number(new Date());
	      var ms = curr - (prevTime || curr);
	      self.diff = ms;
	      self.prev = prevTime;
	      self.curr = curr;
	      prevTime = curr;
	      args[0] = createDebug.coerce(args[0]);
	
	      if (typeof args[0] !== 'string') {
	        // Anything else let's inspect with %O
	        args.unshift('%O');
	      } // Apply any `formatters` transformations
	
	
	      var index = 0;
	      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
	        // If we encounter an escaped % then don't increase the array index
	        if (match === '%%') {
	          return match;
	        }
	
	        index++;
	        var formatter = createDebug.formatters[format];
	
	        if (typeof formatter === 'function') {
	          var val = args[index];
	          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`
	
	          args.splice(index, 1);
	          index--;
	        }
	
	        return match;
	      }); // Apply env-specific formatting (colors, etc.)
	
	      createDebug.formatArgs.call(self, args);
	      var logFn = self.log || createDebug.log;
	      logFn.apply(self, args);
	    }
	
	    debug.namespace = namespace;
	    debug.enabled = createDebug.enabled(namespace);
	    debug.useColors = createDebug.useColors();
	    debug.color = selectColor(namespace);
	    debug.destroy = destroy;
	    debug.extend = extend; // Debug.formatArgs = formatArgs;
	    // debug.rawLog = rawLog;
	    // env-specific initialization logic for debug instances
	
	    if (typeof createDebug.init === 'function') {
	      createDebug.init(debug);
	    }
	
	    createDebug.instances.push(debug);
	    return debug;
	  }
	
	  function destroy() {
	    var index = createDebug.instances.indexOf(this);
	
	    if (index !== -1) {
	      createDebug.instances.splice(index, 1);
	      return true;
	    }
	
	    return false;
	  }
	
	  function extend(namespace, delimiter) {
	    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
	  }
	  /**
	  * Enables a debug mode by namespaces. This can include modes
	  * separated by a colon and wildcards.
	  *
	  * @param {String} namespaces
	  * @api public
	  */
	
	
	  function enable(namespaces) {
	    createDebug.save(namespaces);
	    createDebug.names = [];
	    createDebug.skips = [];
	    var i;
	    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	    var len = split.length;
	
	    for (i = 0; i < len; i++) {
	      if (!split[i]) {
	        // ignore empty strings
	        continue;
	      }
	
	      namespaces = split[i].replace(/\*/g, '.*?');
	
	      if (namespaces[0] === '-') {
	        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	      } else {
	        createDebug.names.push(new RegExp('^' + namespaces + '$'));
	      }
	    }
	
	    for (i = 0; i < createDebug.instances.length; i++) {
	      var instance = createDebug.instances[i];
	      instance.enabled = createDebug.enabled(instance.namespace);
	    }
	  }
	  /**
	  * Disable debug output.
	  *
	  * @api public
	  */
	
	
	  function disable() {
	    createDebug.enable('');
	  }
	  /**
	  * Returns true if the given mode name is enabled, false otherwise.
	  *
	  * @param {String} name
	  * @return {Boolean}
	  * @api public
	  */
	
	
	  function enabled(name) {
	    if (name[name.length - 1] === '*') {
	      return true;
	    }
	
	    var i;
	    var len;
	
	    for (i = 0, len = createDebug.skips.length; i < len; i++) {
	      if (createDebug.skips[i].test(name)) {
	        return false;
	      }
	    }
	
	    for (i = 0, len = createDebug.names.length; i < len; i++) {
	      if (createDebug.names[i].test(name)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	  /**
	  * Coerce `val`.
	  *
	  * @param {Mixed} val
	  * @return {Mixed}
	  * @api private
	  */
	
	
	  function coerce(val) {
	    if (val instanceof Error) {
	      return val.stack || val.message;
	    }
	
	    return val;
	  }
	
	  createDebug.enable(createDebug.load());
	  return createDebug;
	}
	
	module.exports = setup;
	


/***/ }),
/* 333 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var w = d * 7;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isFinite(val)) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'weeks':
	    case 'week':
	    case 'w':
	      return n * w;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (msAbs >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (msAbs >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (msAbs >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return plural(ms, msAbs, d, 'day');
	  }
	  if (msAbs >= h) {
	    return plural(ms, msAbs, h, 'hour');
	  }
	  if (msAbs >= m) {
	    return plural(ms, msAbs, m, 'minute');
	  }
	  if (msAbs >= s) {
	    return plural(ms, msAbs, s, 'second');
	  }
	  return ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, msAbs, n, name) {
	  var isPlural = msAbs >= n * 1.5;
	  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
	}


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _moment = __webpack_require__(113);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_DAYS = 33;
	var INIT_DAYS = 7;
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("complianceGroup", {
	    template: __webpack_require__(335),
	    controller: ComplianceGroupController
	  });
	
	  ComplianceGroupController.$inject = ["$scope", "$state", "$q", "$stateParams", "$location", "$timeout", "LayoutService", "Drivers", "Vehicles", "DriverGroups", "VehicleGroups", "cacheService", "UserProvider", "RouteReporterAPI"];
	
	  function ComplianceGroupController($scope, $state, $q, $stateParams, $location, $timeout, LayoutService, Drivers, Vehicles, DriverGroups, VehicleGroups, cacheService, UserProvider, RouteReporterAPI) {
	    var vm = this;
	    vm.backToGroups = backToGroups;
	    vm.viewSelectedVehicles = viewSelectedVehicles;
	    vm.onFilterKeyUp = onFilterKeyUp;
	    vm.filterItems = filterItems;
	    vm.loadMoreItems = loadMoreItems;
	    vm.showCompliance = showCompliance;
	    vm.toggleSelectedId = toggleSelectedId;
	    vm.openDatePickerPopup = openDatePickerPopup;
	    vm.selectAll = selectAll;
	    vm.selectNone = selectNone;
	    vm.exportCSV = exportCSV;
	    vm.showRoutes = showRoutes;
	    vm.backToGroup = backToGroup;
	    vm.$onInit = init;
	    vm.leftPanelWidth = leftPanelWidth;
	    vm.getStartDateString = getStartDateString;
	    vm.getEndDateString = getEndDateString;
	    vm.shouldShowCount = shouldShowCount;
	    vm.onSearchSettingsChange = onSearchSettingsChange;
	    vm.alerts = [];
	    vm.closeAlert = closeAlert;
	
	    function init() {
	      vm.panelWidth = "500px";
	      vm.isLoading = false;
	      vm.groupName = "";
	      vm.dateFormat = "MM/dd/yyyy";
	      vm.isFromPopupOpen = false;
	      vm.isToPopupOpen = false;
	      vm.allItems = [];
	      vm.filteredItems = [];
	      vm.shownItems = [];
	      vm.ids = [];
	      vm.groupInfo = $stateParams;
	      vm.values = [];
	      vm.groupIds = [];
	      vm.counter = 0;
	
	      // don't allow coming to this state with no groupid set.  todo: this might be better in a resolve on the state.
	      if ($stateParams.groupId == null) {
	        return vm.backToGroups();
	      }
	
	      //get params
	      vm.groupType = $stateParams.groupType;
	
	      // handle the to/from dates - never allow them to be set greater than MAX_DAYS days apart
	      $scope.$watch(function () {
	        return vm.toDate;
	      }, function (newValue) {
	        return _handleToDateChanged(newValue);
	      });
	      $scope.$watch(function () {
	        return vm.fromDate;
	      }, function (newValue) {
	        return _handleFromDateChanged(newValue);
	      });
	
	      vm.groupId = $stateParams.groupId; // id or 'all'
	      var parsedGroupId = parseInt($stateParams.groupId) || 0;
	      vm.groupIds = [parsedGroupId];
	
	      var settings = cacheService.getSearchSettings();
	      //If the settings retrieved were for a different vehicle/driver group, do not apply them
	      if (!sameGroup(settings)) {
	        settings = null;
	      }
	      if (settings) {
	        vm.fromDate = (0, _moment2.default)(settings.startDate).toDate();
	        vm.toDate = (0, _moment2.default)(settings.endDate).toDate();
	        vm.hideQuestionable = settings.noQuestionableRoutes;
	        vm.hideNoOOr = !settings.includeRoutesWithNoOorMiles;
	        vm.idchanged = settings.counter;
	        vm.filter = settings.filter;
	        vm.filterItems(vm.filter);
	      } else {
	        vm.toDate = (0, _moment2.default)().endOf("day").toDate();
	        vm.fromDate = (0, _moment2.default)(vm.toDate).subtract(INIT_DAYS, "days").startOf("day").toDate();
	        vm.hideQuestionable = true;
	        vm.hideNoOOr = false;
	      }
	
	      var promises = [];
	
	      var currentUser = UserProvider.getUser();
	      var targetAccount = null;
	      if (currentUser.supportAccount) targetAccount = currentUser.supportAccount.accountId;
	
	      // set group name
	      if (vm.groupType === "vehicleGroup" && vm.groupId !== "all") {
	        promises.push(VehicleGroups.getById(vm.groupIds[0], targetAccount).then(function (group) {
	          return vm.groupName = group.name;
	        }));
	        promises.push(_loadVehicles(vm.groupIds));
	      } else if (vm.groupType === "driverGroup" && vm.groupId !== "all") {
	        promises.push(DriverGroups.getById(vm.groupIds[0], targetAccount).then(function (group) {
	          return vm.groupName = group.name;
	        }));
	        promises.push(_loadDrivers(vm.groupIds));
	      }
	
	      if (vm.groupType === "vehicleGroup" && $stateParams.groupId === "all") {
	        promises.push(_loadVehicles());
	        vm.groupName = "All Vehicles";
	      }
	
	      if (vm.groupType === "driverGroup" && $stateParams.groupId === "all") {
	        promises.push(_loadDrivers());
	        vm.groupName = "All Driver";
	      }
	
	      vm.isLoading = true;
	      $q.all(promises).finally(function () {
	        vm.isLoading = false;
	        var allIds = vm.allItems.map(function (c) {
	          return c.id;
	        });
	        if (settings) {
	          vm.ids = settings.ids;
	          //Must remove all ids that were previously selected, but that no longer exist in allItems
	          vm.ids = _.intersection(allIds, vm.ids);
	        }
	        // order the display items properly - toggled items on top
	        vm.filterItems(vm.filter);
	      });
	    }
	
	    //Are the saved settings for the same vehicle/driver group as the current one in the vm?
	    function sameGroup(settings) {
	      if (!settings) {
	        return false;
	      }
	      var vmIdType = vm.groupType === "vehicleGroup" ? "vehicle" : "driver";
	      return settings.groupId[0] === vm.groupIds[0] && settings.idType === vmIdType;
	    }
	
	    function onFilterKeyUp(event) {
	      if (event.keyCode === 27) {
	        vm.filter = null;
	        vm.filterItems(vm.filter);
	      }
	    }
	
	    function closeAlert(index) {
	      vm.alerts.splice(index, 1);
	    }
	
	    // based on the user input filter and whatever items the user has toggled/selected,
	    // show the toggled items in alphabetical order on top
	    // and the non-toggled items in alphabetical order underneath
	    function filterItems(filter) {
	      // filter is cleared
	      if (!filter) {
	        var toggledItems = [];
	        toggledItems = vm.allItems.filter(function (item) {
	          return vm.ids.includes(item.id);
	        });
	        vm.allItems = vm.allItems.filter(function (item) {
	          return !toggledItems.includes(item);
	        });
	
	        // sort the toggled items alphabetically by name
	        toggledItems.sort(function (x, y) {
	          return x.name < y.name ? -1 : x.name > y.name ? 1 : 0;
	        });
	        // sort the rest of the items alphabetically by name
	        vm.allItems.sort(function (x, y) {
	          return x.name < y.name ? -1 : x.name > y.name ? 1 : 0;
	        });
	        // place the toggled items before the rest of the items
	        vm.allItems = toggledItems.concat(vm.allItems);
	        vm.filteredItems = vm.allItems;
	      } else {
	        var filterUpperCase = filter.toUpperCase();
	        vm.filteredItems = vm.allItems.filter(function (c) {
	          return c.name != null && (c.name.toUpperCase().indexOf(filterUpperCase) !== -1 || c.itemId.toString().indexOf(filterUpperCase) !== -1);
	        });
	      }
	
	      // show first 20 items
	      vm.shownItems = vm.filteredItems.slice(0, 20);
	      // make sure to let the list know that the items in it changed so it can do the correct infinite scroll logic
	      $scope.$emit("list:filtered");
	    }
	
	    function loadMoreItems() {
	      //console.log("showing more items: " + vm.shownItems.length + ":" + (vm.shownItems.length + 10));
	
	      var newItems = vm.filteredItems.slice(vm.shownItems.length, vm.shownItems.length + 10);
	      vm.shownItems = vm.shownItems.concat(newItems);
	    }
	
	    function leftPanelWidth() {
	      return LayoutService.getLeftPanelWidth();
	    }
	
	    /**
	     * Closes the compliance tab
	     */
	
	    /**
	     * Hide compliance panel but keep routes
	     */
	
	    function showCompliance() {
	      LayoutService.openLeftHandPanel("500px");
	    }
	
	    /**
	     * Returns to the list of vehicle/driver groups state
	     */
	    function backToGroups() {
	      $state.go($stateParams.parentState, {
	        "group": vm.groupInfo.groupType
	      });
	    }
	
	    function showRoutes() {
	      //console.log("getting data with the following options ", vm.settings, $stateParams.childState);
	      $state.go($stateParams.childState, {
	        settings: vm.settings
	      });
	    }
	
	    function getStartDateString() {
	      var settings = cacheService.getSearchSettings();
	      if (settings) {
	        return (0, _moment2.default)(settings.startDate).format("MM/DD/YYYY");
	      }
	      return "";
	    }
	
	    function getEndDateString() {
	      var settings = cacheService.getSearchSettings();
	      if (settings) {
	        return (0, _moment2.default)(settings.endDate).format("MM/DD/YYYY");
	      }
	      return "";
	    }
	
	    function shouldShowCount() {
	      return vm.ids.length > 0 && !$state.is("main.compliance.group.routes");
	    }
	
	    function backToGroup() {
	      $state.go($stateParams.parentState, {
	        "groupType": vm.groupInfo.groupType,
	        "groupId": vm.groupInfo.groupId
	      });
	    }
	    /**
	     * Toggles the selection of the vehicle or driver
	     *
	     * @param {integer} id Identifier of the vehicle or driver to toggle selection
	     *
	     * @memberOf ComplianceGroupController
	     */
	    function toggleSelectedId(id) {
	      vm.counter++;
	      var idx = vm.ids.indexOf(id);
	
	      // isolate the toggled item
	      var itemIndex = vm.allItems.findIndex(function (c) {
	        return c.id == id;
	      });
	      var item = vm.allItems[itemIndex];
	      vm.allItems.splice(itemIndex, 1);
	
	      // item is being unchecked
	      if (idx > -1) {
	        vm.ids.splice(idx, 1);
	        // move it to the back of the list containing all items
	        vm.allItems.push(item);
	      } else {
	        vm.ids.push(id);
	        // move it to the front of the list containing all items
	        vm.allItems.unshift(item);
	      }
	    }
	
	    /**
	     *  Open a date picker on the screen
	     *
	     * @param {string} whichPicker Describes which date picker to open.  This can be "from" or "to".
	     *
	     * @memberOf ComplianceGroupController
	     */
	    function openDatePickerPopup(whichPicker) {
	      if (whichPicker === "from") {
	        vm.isFromPopupOpen = true;
	      } else {
	        vm.isToPopupOpen = true;
	      }
	    }
	
	    /**
	     * Uses the current set filter parameters to query the compliance service to return a list of all compliance routes.
	     *
	     * @returns a Promise object representing the completion of querying the service and setting the returned routes on the model.
	     */
	    function viewSelectedVehicles() {
	      console.log('in viewSelectedVehicles in complianceGroup controller');
	      onSearchSettingsChange();
	      showRoutes();
	    }
	
	    function onSearchSettingsChange() {
	      vm.settings = {
	        startDate: (0, _moment2.default)(vm.fromDate).startOf("day").toDate(),
	        endDate: (0, _moment2.default)(vm.toDate).startOf("day").toDate(), // NOTE: Sproc 'SPR_PrescribedRoute_GetByVehicle' filters by 'day', not datetime.
	        idType: vm.groupType === "vehicleGroup" ? "vehicle" : "driver",
	        noQuestionableRoutes: vm.hideQuestionable,
	        includeRoutesWithNoOorMiles: !vm.hideNoOOr,
	        ids: vm.ids,
	        idchanged: vm.counter,
	        groupId: vm.groupIds
	      };
	      vm.settings.filter = vm.filter;
	      cacheService.setSearchSettings(vm.settings);
	    }
	
	    /**
	     * Select all filtered vehicle or drivers
	     *
	     * @memberOf ComplianceGroupController
	     */
	    function selectAll() {
	      var itemsToSelect = vm.filteredItems.filter(function (item) {
	        return !vm.ids.includes(item.id);
	      });
	
	      for (var i = 0; i < itemsToSelect.length; i++) {
	        vm.toggleSelectedId(itemsToSelect[i].id);
	      }
	    }
	
	    /**
	     * Unselect all filtered vehicle or drivers
	     *
	     * @memberOf ComplianceGroupController
	     */
	    function selectNone() {
	      var itemsToRemove = vm.filteredItems.filter(function (item) {
	        return vm.ids.includes(item.id);
	      });
	
	      for (var i = 0; i < itemsToRemove.length; i++) {
	        vm.toggleSelectedId(itemsToRemove[i].id);
	      }
	    }
	
	    function exportCSV() {
	      vm.alerts.push({ msg: "Started export process!", type: "info" });
	      var user = JSON.parse(window.sessionStorage["userAuthInfo"]);
	      var accountId = user.accountId;
	      var currentUser = UserProvider.getUser();
	      if (currentUser.supportAccount) {
	        accountId = currentUser.supportAccount.accountId;
	      }
	
	      var data = {
	        accountId: accountId,
	        startDate: (0, _moment2.default)(vm.fromDate).startOf("day").toDate(),
	        endDate: (0, _moment2.default)(vm.toDate).startOf("day").toDate(),
	        groupId: vm.groupIds,
	        idType: vm.groupType === "vehicleGroup" ? "vehicle" : "driver",
	        idchanged: vm.counter,
	        ids: vm.filteredItems.map(function (c) {
	          return c.id;
	        }),
	        includeRoutesWithNoOorMiles: !vm.hideNoOOr,
	        isOor: false,
	        noCoords: false,
	        noQuestionableRoutes: true,
	        oorCost: 0,
	        order: "asc",
	        pageNumber: 1,
	        pageSize: 10,
	        sort: ""
	      };
	      RouteReporterAPI.post("api/report/export", data, null).then(function successCallback(response) {
	        vm.alerts.splice(0, 1);
	        vm.alerts.push({ msg: "Report has been exported, Please check your email!", type: "info" });
	        timeoutAlert();
	      }, function errorCallback(response) {
	        vm.alerts.splice(0, 1);
	        vm.alerts.push({ msg: "Export failed, please try again!", type: "danger" });
	        timeoutAlert();
	      });
	    }
	
	    function timeoutAlert() {
	      $timeout(function () {
	        vm.closeAlert(0);
	      }, 5 * 1000);
	    }
	
	    function _loadDrivers() {
	      var groupIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var currentUser = UserProvider.getUser();
	      var targetAccount = null;
	      if (currentUser.supportAccount) {
	        targetAccount = currentUser.supportAccount.accountId;
	      }
	      return Drivers.getDrivers(groupIds, null, null, targetAccount).then(function (drivers) {
	        vm.allItems = drivers.map(function (c) {
	          return {
	            name: c.name,
	            id: c.id,
	            itemId: c.driverId
	          };
	        });
	      });
	    }
	
	    function _loadVehicles() {
	      var groupIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var currentUser = UserProvider.getUser();
	      var targetAccount = null;
	      if (currentUser.supportAccount) {
	        targetAccount = currentUser.supportAccount.accountId;
	      }
	      // TODO: add ability to filter out vehicles with no routes
	      return Vehicles.getVehicleList(groupIds, targetAccount).then(function (vehicles) {
	        vm.allItems = vehicles.map(function (c) {
	          return {
	            name: c.name,
	            id: c.id,
	            itemId: c.vehicleId
	          };
	        });
	      });
	    }
	
	    function _handleFromDateChanged(newFromDate) {
	      if (newFromDate == null) return;
	
	      var toDate = (0, _moment2.default)(vm.toDate);
	      var fromDate = (0, _moment2.default)(newFromDate);
	
	      if (fromDate.isAfter(toDate)) vm.toDate = fromDate.toDate();
	
	      // Don't allow fromDate to be more then MAX_DAYS days before toDate
	      if (toDate.diff(fromDate, "days") > MAX_DAYS) vm.toDate = fromDate.add(MAX_DAYS, "days").toDate();
	    }
	
	    function _handleToDateChanged(newToDate) {
	      if (newToDate == null) return;
	
	      var toDate = (0, _moment2.default)(newToDate);
	      var fromDate = (0, _moment2.default)(vm.fromDate);
	
	      // don't allow fromdate to after toDate
	      if (toDate.isBefore(fromDate)) vm.fromDate = toDate.toDate();
	
	      // Don't allow fromDate to be more then MAX_DAYS days before toDate
	      if (toDate.diff(fromDate, "days") > MAX_DAYS) vm.fromDate = toDate.subtract(MAX_DAYS, "days").toDate();
	    }
	  }
	})(window.angular);

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"ui-panel left-panel\" ng-style=\"{'width': $ctrl.panelWidth}\">\r\n    <form novalidate ng-submit=\"$ctrl.viewSelectedVehicles()\" ng-hide=\"$ctrl.leftPanelWidth()==='0'\">\r\n      <div class=\"panel panel-default panel-fixed edits-panel ng-cloak\" ng-cloak>\r\n        <div class=\"panel-heading\">\r\n          <button type=\"button\" ng-hide=\"'main.compliance.group.routes' | isState\" class=\"btn btn-default btn-sm\" ng-click=\"$ctrl.backToGroups()\">\r\n          <span class=\"ico ico-chevron-left-thick\"></span><span translate=\"common.Back\"></span>\r\n        </button>\r\n        <button type=\"button\"   ng-if=\"'main.compliance.group.routes' | isState\"  class=\"btn btn-default btn-sm\" ng-click=\"$ctrl.backToGroup()\">\r\n          <span class=\"ico ico-chevron-left-thick\"></span><span translate=\"common.Back\"></span>\r\n        </button>\r\n          <h4 class=\"panel-name text-center text-ellipsis\" tooltip-placement=\"top\" title=\"{{$ctrl.groupName}}\" style=\"z-index:300; margin-right: 25px;\">\r\n            {{$ctrl.groupName}}<span title=\"+{{$ctrl.groupIds.length-1}} more\" ng-show=\"$ctrl.groupIds.length>1\">(+{{$ctrl.groupIds.length-1}} more)</span>\r\n          </h4>\r\n        </div>\r\n        <div class=\"panel-body v-flex-container\">\r\n\r\n          <h5 class=\"legend\" >\r\n            <span ng-hide=\"'main.compliance.group.routes' | isState\" translate=\"views.compliance.DateRangeHeader\">  </span>\r\n            <span ng-if=\"'main.compliance.group.routes' | isState\" translate=\"views.compliance.selectedRouteDates\">  </span>\r\n            <span ng-if=\"'main.compliance.group.routes' | isState\" style=\"position: absolute; padding-left: 5px;\"> {{$ctrl.getStartDateString()}} - {{$ctrl.getEndDateString()}} <span>\r\n          </h5>\r\n          <div ng-hide=\"'main.compliance.group.routes' | isState\">\r\n            <div class=\"form-group col-sm-6\">\r\n              <label class=\"\" translate=\"views.compliance.FromDate\"></label>\r\n              <div class=\"input-group input-group-sm date\">\r\n                <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{$ctrl.dateFormat}}\" ng-focus=\"$ctrl.openDatePickerPopup('from')\"\r\n                  ng-model=\"$ctrl.fromDate\" is-open=\"$ctrl.isFromPopupOpen\" ng-change=\"$ctrl.onSearchSettingsChange()\"/>\r\n                <span class=\"input-group-btn\">\r\n                  <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"$ctrl.openDatePickerPopup('from')\"><i class=\"glyphicon glyphicon-th\"></i></button>\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group col-sm-6\">\r\n              <label class=\"\" translate=\"views.compliance.ToDate\"></label>\r\n              <div class=\"input-group input-group-sm date\">\r\n                <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{$ctrl.dateFormat}}\" ng-focus=\"$ctrl.openDatePickerPopup('to')\"\r\n                  popup-placement=\"bottom-right\" ng-model=\"$ctrl.toDate\" is-open=\"$ctrl.isToPopupOpen\" ng-change=\"$ctrl.onSearchSettingsChange()\" />\r\n                <span class=\"input-group-btn\">\r\n                  <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"$ctrl.openDatePickerPopup('to')\"><i class=\"glyphicon glyphicon-th\"></i></button>\r\n                </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <h5 class=\"legend\" ng-hide=\"'main.compliance.group.routes' | isState\">\r\n            <span>\r\n              {{($ctrl.groupType === \"vehicleGroup\")? (\"common.Vehicles\" | translate):(\"common.Drivers\" | translate)}}\r\n            </span>\r\n            <!-- Set Count -->\r\n            <span class=\"badge with-actions\">{{$ctrl.filteredItems.length}}</span>\r\n          </h5>\r\n          <div uib-alert ng-repeat=\"alert in $ctrl.alerts\" ng-class=\"'alert-' + (alert.type || 'warning')\" close=\"$ctrl.closeAlert($index)\">{{alert.msg}}</div>\r\n          <div class=\"form-inline filter-group row\" ng-hide=\"'main.compliance.group.routes' | isState\">\r\n            <div class=\"input-group col-sm-6 col-xs-6 col-md-6\">\r\n              <span class=\"input-group-btn\">\r\n                <span class=\"btn btn-sm btn-fake-addon\">\r\n                <i class=\"ico ico-filter\"></i>\r\n                </span>\r\n              </span>\r\n              <input type=\"text\" class=\"form-control\" id=\"set-filter\" placeholder=\"{{'common.Filter' | translate }}\" ng-model=\"$ctrl.filter\"\r\n                ng-model-options=\"{ debounce: 200 }\" ng-change=\"$ctrl.filterItems($ctrl.filter); $ctrl.onSearchSettingsChange();\" ng-keyup=\"$ctrl.onFilterKeyUp($event)\"  onkeydown=\"event.stopPropagation()\">\r\n              <span class=\"input-group-btn\">\r\n                <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"$ctrl.filter = '';$ctrl.filterItems($ctrl.filter); $ctrl.onSearchSettingsChange();\">&times;</button>\r\n              </span>\r\n            </div>\r\n           <div class=\"col-sm-6 col-xs-6 col-md-6 pull-right\">\r\n            <button type=\"button\" class=\"btn btn-xs btn-default pull-right\" translate=\"common.SelectAll\" ng-click=\"$ctrl.selectAll(); $ctrl.onSearchSettingsChange();\"></button>\r\n            <button type=\"button\" class=\"btn btn-xs btn-default pull-right\" translate=\"common.SelectNone\" ng-click=\"$ctrl.selectNone(); $ctrl.onSearchSettingsChange();\"></button>\r\n            <button type=\"button\" class=\"btn btn-xs btn-default pull-right\" translate=\"Export All\" ng-click=\"$ctrl.exportCSV(); $ctrl.onSearchSettingsChange();\"></button> <!--translate should be common.ExportCSV, but that's not working rn so ¯\\_(ツ)_/¯-->\r\n          </div>\r\n          </div>\r\n          <div class=\"selection-conditional ng-cloak\" ng-cloak ng-show=\"$ctrl.shouldShowCount()\">\r\n            <p> <!--clean this-->\r\n              <!--This is for showing the count of selected vehicles -->\r\n              <span ng-show=\"$ctrl.ids.length>0 && $ctrl.groupType === 'vehicleGroup'\" translate=\"{{ $ctrl.ids.length===1? 'views.compliance.SelectedVehicleCount' : 'views.compliance.SelectedVehiclesCount'}}\"\r\n                translate-values=\"{ count: $ctrl.ids.length, total: $ctrl.allItems.length }\"></span>\r\n              <!-- END -->\r\n              <span ng-show=\"$ctrl.ids.length>0 && $ctrl.groupType === 'driverGroup'\" translate=\"{{ $ctrl.ids.length===1? 'views.compliance.SelectedDriverCount' : 'views.compliance.SelectedDriversCount'}}\"\r\n                translate-values=\"{ count: $ctrl.ids.length, total: $ctrl.allItems.length }\"></span>\r\n            </p>\r\n          </div>\r\n          <div class=\"list-flex complianceStyle\"  ui-view = \"sub\">\r\n            <ul id=\"unitItemsList\" class=\"results-list list-group\">\r\n              <div infinite-scroll-parent=\"'#unitItemsList'\" infinite-scroll-disabled=\"$ctrl.shownItems.length === $ctrl.filteredItems.length\"\r\n                infinite-scroll=\"$ctrl.loadMoreItems()\" infinite-scroll-listen-for-event=\"list:filtered\">\r\n                <li ng-if=\"$ctrl.isLoading\" ng-cloak class=\"list-group-item conditional-item ng-cloak\">\r\n                  <span class=\"ico ico-circle-notch ico-spin\"></span>\r\n                  <span translate=\"common.Loading\"></span>...\r\n                </li>\r\n                <li class=\"list-group-item results-item\" ng-repeat=\"item in $ctrl.shownItems\" ng-click=\"$ctrl.toggleSelectedId(item.id); $ctrl.onSearchSettingsChange();\">\r\n                  <div class=\"flex-group\">\r\n                    <div class=\"flex-element text-ellipsis\" tooltip-placement=\"top\" title=\"{{item.name}}\">\r\n                      <input type=\"checkbox\" name=\"selectedIds\" value=\" {{item.id}}\" ng-checked=\"$ctrl.ids.indexOf(item.id) >= 0\"> {{item.name}}&nbsp; <label> ({{item.itemId}})</label>\r\n                    </div>\r\n                  </div>\r\n                </li>\r\n              </div>\r\n            </ul>\r\n            <div style='clear: both;'></div>\r\n          </div>\r\n\r\n          <div ng-hide=\"'main.compliance.group.routes' | isState\">\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input type=\"checkbox\" ng-model=\"$ctrl.hideNoOOr\" ng-change=\"$ctrl.onSearchSettingsChange()\"> <span translate=\"views.compliance.HideNoOORRoutes\"></span>\r\n              </label>\r\n            </div>\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input type=\"checkbox\" ng-model=\"$ctrl.hideQuestionable\" ng-change=\"$ctrl.onSearchSettingsChange()\"> <span translate=\"views.compliance.QuestionableData\"></span>\r\n              </label>\r\n            </div>\r\n          </div>\r\n          <div ng-hide=\"'main.compliance.group.routes' | isState\">\r\n            <button type=\"submit\" ng-disabled=\"$ctrl.ids.length===0\" class=\"btn btn-xs btn-success pull-right\">\r\n           {{($ctrl.groupType === \"vehicleGroup\")? (\"views.compliance.ViewVehicles\" | translate):(\"views.compliance.ViewDrivers\" | translate)}}\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</div>\r\n";

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _moment = __webpack_require__(113);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_DAYS = 33;
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("complianceQueryString", {
	    template: __webpack_require__(337),
	    controller: ComplianceQueryStringController
	  });
	
	  ComplianceQueryStringController.$inject = ["$location", "$q", "LayoutService", "GroupsService", "$scope", "$state", "$stateParams"];
	
	  function ComplianceQueryStringController($location, $q, LayoutService, GroupsService, $scope, $state, $stateParams) {
	    var vm = this;
	    vm.$onInit = init;
	    function init() {
	
	      var endDate = _getEndDateFromQueryString();
	      var startDate = _getStartDatefromQueryString(endDate);
	      var tripIds = _getTripIdsFromQueryString();
	      var vehicleIds = _getVehicleIdsFromQueryString();
	      var driverIds = _getDriverIdsFromQueryString();
	      var hideNoOOr = _getIncludeRoutesWithNoOORMilesFromQueryString();
	      var hideQuestionable = _getNoQuestionableRoutesFromQueryString();
	      var promises = [_getVehicleGroupIdsFromQueryString(), _getDriverGroupIdsFromQueryString()];
	
	      $q.all(promises).then(function (queryResults) {
	        var vehicleGroupIds = queryResults[0];
	        var driverGroupIds = queryResults[1];
	
	        var ids = [];
	        var groupType = "vehicle";
	        var groupIds = [];
	
	        if (vehicleGroupIds.length > 0 || vehicleIds.length > 0) {
	          groupType = "vehicle";
	          ids = vehicleIds;
	          groupIds = vehicleGroupIds;
	        } else {
	          groupType = "driver";
	          ids = driverIds;
	          groupIds = driverGroupIds;
	        }
	
	        vm.settings = {
	          startDate: startDate,
	          endDate: endDate,
	          idType: groupType,
	          noQuestionableRoutes: hideQuestionable,
	          includeRoutesWithNoOorMiles: !hideNoOOr,
	          ids: ids,
	          tripId: tripIds,
	          groupId: groupIds
	        };
	        showRoutes(vm.settings);
	      });
	    }
	    function showRoutes(settings) {
	      //console.log("getting data with the following options ", vm.settings);
	      $state.go($stateParams.childState, {
	        settings: vm.settings,
	        queryUrl: $stateParams.queryUrl
	      });
	      vm.startDate = vm.settings.startDate.toLocaleDateString();
	      vm.endDate = vm.settings.endDate.toLocaleDateString();
	    }
	
	    function _getVehicleGroupIdsFromQueryString() {
	      var groupNames = _getArrayFromQueryString("vehicleGroupName");
	      if (groupNames.length === 0) {
	        return $q.when([]);
	      }
	
	      var groupNamesObj = {};
	      groupNames.forEach(function (groupName) {
	        return groupNamesObj[groupName.toUpperCase()] = -1;
	      });
	
	      return GroupsService.getVehicleGroups().then(function (groups) {
	        var groupIds = [];
	
	        for (var i = 0; i < groups.length; i++) {
	          if (groups[i].name != null && groupNamesObj[groups[i].name.toUpperCase()] === -1) {
	            groupIds.push(groups[i].id);
	          }
	        }
	
	        return groupIds;
	      });
	    }
	
	    function _getDriverGroupIdsFromQueryString() {
	      var groupNames = _getArrayFromQueryString("driverGroupName");
	      if (groupNames.length === 0) return $q.when([]);
	
	      var groupNamesObj = {};
	      groupNames.forEach(function (groupName) {
	        return groupNamesObj[groupName.toUpperCase()] = -1;
	      });
	
	      return GroupsService.getDriverGroups().then(function (groups) {
	        var groupIds = [];
	
	        for (var i = 0; i < groups.length; i++) {
	          if (groups[i].name != null && groupNamesObj[groups[i].name.toUpperCase()] === -1) {
	            groupIds.push(groups[i].id);
	          }
	        }
	
	        return groupIds;
	      });
	    }
	
	    function _getTripIdsFromQueryString() {
	      return _getArrayFromQueryString("tripId");
	    }
	
	    function _getVehicleIdsFromQueryString() {
	      return _getArrayFromQueryString("vehicleId").filter(function (c) {
	        return _isNumber(c);
	      }).map(function (c) {
	        return parseInt(c);
	      });
	    }
	
	    function _getDriverIdsFromQueryString() {
	      return _getArrayFromQueryString("driverId").filter(function (c) {
	        return _isNumber(c);
	      }).map(function (c) {
	        return parseInt(c);
	      });
	    }
	
	    function _getIncludeRoutesWithNoOORMilesFromQueryString() {
	      if (typeof $location.search().hideNoOOR === "string") {
	        return $location.search().hideNoOOR.toUpperCase() === "TRUE";
	      }
	
	      return false;
	    }
	
	    function _getNoQuestionableRoutesFromQueryString() {
	      if (typeof $location.search().hideQuestionable === "string") {
	        return $location.search().hideQuestionable.toUpperCase() === "TRUE";
	      }
	
	      return true;
	    }
	
	    /**
	     * Returns the initial end date for the screen.
	     *
	     * @returns a Date javascript object representing the end date
	     */
	    function _getEndDateFromQueryString() {
	      var endDate = (0, _moment2.default)($location.search().endDate, _moment2.default.ISO_8601);
	
	      // if there is no valid end date passed in, take todays date
	      if (!endDate.isValid()) {
	        return (0, _moment2.default)().endOf("day").toDate();
	      }
	
	      return endDate.toDate();
	    }
	
	    /**
	     * Returns the initial start date for the screen.
	     * If the "startDate" query string parameter exists it uses this in the calculation
	     *
	     * @param {any} endDateJS Date Javascript object representing the end date
	     * @returns a Date Javascript object representing the start date
	     */
	    function _getStartDatefromQueryString(endDateJS) {
	      var endDate = (0, _moment2.default)(endDateJS);
	
	      var startDate = (0, _moment2.default)($location.search().startDate, _moment2.default.ISO_8601);
	
	      // if date is not valid, return one month  before the end date.
	      if (!startDate.isValid()) {
	        return endDate.subtract(MAX_DAYS, "days").startOf("day").toDate();
	      }
	
	      // if the start date is after the end date, send the end date back
	      if (startDate.isAfter(endDate)) {
	        return endDate.startOf("day").toDate();
	      }
	
	      // it is a valid start date, return it back.
	      return startDate.toDate();
	    }
	
	    function _getArrayFromQueryString(param) {
	      var search = $location.search();
	      var value = search[param];
	      if (typeof value !== "string") {
	        return [];
	      }
	
	      return decodeURIComponent(value).split(",").map(function (c) {
	        return c.trim();
	      }).filter(function (c) {
	        return c !== "";
	      }).unique();
	    }
	
	    // TODO: put into common file
	    function _isValidDate(str) {
	      var date = new Date(str);
	
	      if (Object.prototype.toString.call(date) !== "[object Date]") return false;
	
	      if (isNaN(date.getTime())) return false;
	
	      return true;
	    }
	
	    // TODO: put into common file
	    function _isNumber(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	  }
	})(window.angular);

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"ui-panel left-panel\" style=\"width:500px;\">\r\n    <div class=\"panel panel-default panel-fixed edits-panel\">\r\n      <div class=\"panel-heading\">\r\n        <div class=\"no-button\"></div>\r\n        <h4 class=\"panel-name text-center\">\r\n          <span translate=\"views.compliance.title\"></span>\r\n        </h4>\r\n      </div>\r\n      <div class=\"panel-body v-flex-container route-list-container\">\r\n        <div class=\"text-center\" ng-show=\"$ctrl.isLoading\">\r\n          <span class=\"ico ico-circle-notch ico-spin\"></span>\r\n          <span translate=\"common.Loading\"></span>...\r\n        </div>\r\n        <div class=\"list-group-section query-routes\">\r\n<div  ui-view = \"query\">\r\n</div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n";

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").service("GroupsService", GroupsService);
	
	  GroupsService.$inject = ["$q", "DriverGroups", "VehicleGroups", "UserProvider"];
	
	  function GroupsService($q, DriverGroups, VehicleGroups, UserProvider) {
	    var vehicleGroupPromise = null;
	    var driverGroupPromise = null;
	
	    var service = {
	      getVehicleGroups: getVehicleGroups,
	      getDriverGroups: getDriverGroups
	    };
	
	    return service;
	
	    function getVehicleGroups(forceRefresh) {
	      if (forceRefresh === true) {
	        vehicleGroupPromise = null;
	      }
	
	      // don't have the data already but have a promise for it, return that.
	      if (vehicleGroupPromise) {
	        return vehicleGroupPromise;
	      }
	
	      var supportAccountId = null;
	      if (UserProvider.getUser().supportAccount) {
	        supportAccountId = UserProvider.getUser().supportAccount.accountId;
	      }
	      vehicleGroupPromise = VehicleGroups.getVehicleGroups([], [], null, null, supportAccountId);
	
	      return vehicleGroupPromise;
	    }
	
	    function getDriverGroups(forceRefresh) {
	      if (forceRefresh === true) {
	        driverGroupPromise = null;
	      }
	
	      if (driverGroupPromise) {
	        return driverGroupPromise;
	      }
	
	      var supportAccountId = null;
	      if (UserProvider.getUser().supportAccount) {
	        supportAccountId = UserProvider.getUser().supportAccount.accountId;
	      }
	      driverGroupPromise = DriverGroups.getDriverGroups([], [], null, null, supportAccountId);
	
	      return driverGroupPromise;
	    }
	
	    function querystringSettings(settings) {
	      console.log(settings);
	      return settings;
	    }
	  }
	})(window.angular);

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getIterator2 = __webpack_require__(328);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _angular = __webpack_require__(3);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _compliance = __webpack_require__(327);
	
	var _deriveRoute = __webpack_require__(326);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module("fleetviewApp").service("ComplianceRoutingProfileService", ComplianceRoutingProfileService); /* global _ */
	
	
	ComplianceRoutingProfileService.$inject = ["$translate", "UserProvider", "PCMRegion", "FleetViewAPI"];
	
	//Contains helper functions and data for calculating derived routes from routing profile data
	function ComplianceRoutingProfileService($translate, UserProvider, PCMRegion, FleetViewAPI) {
	
	  function getRoutingProfileByPrescribedRouteId(prescribedRouteId) {
	    var url = FleetViewAPI.config.apiUrl + "v1/routing-profile/" + prescribedRouteId;
	    return FleetViewAPI.$http.get(url);
	  }
	
	  function getDerivedRouteRequest(latLonArray, routingProfile, offRouteMiles) {
	
	    var region = PCMRegion[UserProvider.getUser().region];
	
	    //If no routing profile is specified, use the most lenient/most default settings
	    if (!routingProfile) {
	      return (0, _compliance.buildDefaultRoutingProfile)(latLonArray, offRouteMiles, region);
	    }
	
	    //Comes in format of string, "FiftyThreeFoot, NationalNetwork". Must parse and convert to bitflag
	    if (routingProfile.classOverrides && typeof routingProfile.classOverrides === "string") {
	      var classes = routingProfile.classOverrides.split(",");
	      var bitFlag = 0;
	      // TODO: replace for-of with iterator
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(classes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var cls = _step.value;
	
	          var clsNum = _compliance.routingProfileProps.classOverrides[cls.trim()];
	          bitFlag += clsNum;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      routingProfile.classOverrides = bitFlag;
	    }
	
	    var isMetric = _compliance.routingProfileProps.unitTypes[routingProfile.unitsOfMeasure] === 1;
	    var weight = routingProfile.totalWeight;
	    if (isMetric) {
	      //Weight for metric routing profiles is in metric tons. But web service expects kilograms. 1 metric ton = 1000 kg
	      weight *= 1000;
	    }
	    var request = (0, _deriveRoute.buildDerivedRouteRequest)({ region: region, routingProfile: routingProfile, latLonArray: latLonArray, offRouteMiles: offRouteMiles, weight: weight, isMetric: isMetric });
	
	    //If vehicle type is set to auto, don't pass in TruckCfg
	    if (_compliance.routingProfileProps.vehicleTypes[routingProfile.vehicleType] === 2 && request.RoutingOptions) {
	      delete request.RoutingOptions["TruckCfg"];
	    }
	
	    return request;
	  }
	
	  var service = { getDerivedRouteRequest: getDerivedRouteRequest, getRoutingProfileByPrescribedRouteId: getRoutingProfileByPrescribedRouteId };
	  return service;
	}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("complianceGroups", {
	    template: __webpack_require__(341),
	    controller: ComplianceGroupsController
	  });
	
	  ComplianceGroupsController.$inject = ["$scope", "$state", "$q", "GroupsService", "$rootScope", "$location", "$stateParams", "cacheService"];
	
	  function ComplianceGroupsController($scope, $state, $q, GroupsService, $rootScope, $location, $stateParams, cacheService) {
	    var vm = this;
	    //Check for query string parameters. Redirect if so
	    var search = $location.search();
	    var isQueryString = !!search.vehicleGroupName || !!search.driverGroupName || !!search.driverId || !!search.vehicleId || !!search.tripId;
	    if (isQueryString) {
	      $rootScope.$broadcast("DisableAddCenterParam");
	      $rootScope.$broadcast("hideCompliance");
	      $state.go("main.compliance.querystring", {
	        "queryUrl": search
	      }, {
	        location: false,
	        notify: false
	      });
	      return;
	    }
	
	    vm.$onInit = init;
	
	    vm.goToGroup = goToGroup;
	    vm.loadMoreItems = loadMoreItems;
	    vm.filterItems = filterItems;
	    vm.onGroupTypeChange = onGroupTypeChange;
	
	    function init() {
	      // Properties
	      vm.panelWidth = "500px";
	      vm.isLoading = false;
	      vm.selectedGroupType = $stateParams.group ? $stateParams.group : cacheService.getCache().selectedGroupType; //$stateParam is defined if coming from a group state
	      vm.filterGroup = vm.selectedGroupType === "vehicleGroup" ? cacheService.getCache().vehicleGroupFilter : cacheService.getCache().driverGroupFilter;
	      vm.allItems = [];
	      vm.filteredItems = [];
	      vm.shownItems = [];
	      vm.isLoading = true;
	      vm.hideQuestionable = true;
	
	      // load vehicle and driver groups once and keep them in memory. This may need to be reworked depending on the user interaction.
	      $q.all([_loadDriverGroups(), _loadVehicleGroups()]).finally(function () {
	        return vm.isLoading = false;
	      });
	
	      $scope.$watch(function () {
	        return vm.selectedGroupType;
	      }, function (newValue, oldValue) {
	        return _selectedGroupTypeChanged(newValue, oldValue);
	      });
	    }
	
	    function goToGroup(groupType, groupId) {
	      $state.go($stateParams.childState, {
	        "groupType": groupType,
	        "groupId": groupId
	      });
	    }
	
	    function onGroupTypeChange() {
	      cacheService.getCache().selectedGroupType = vm.selectedGroupType;
	      cacheService.saveCache();
	    }
	
	    function filterItems(filter) {
	      // whenever filtering the list of units, reset the selected items
	      if (!filter) {
	        vm.filteredItems = vm.allItems;
	      } else if (vm.selectedGroupType === "driverGroup" || vm.selectedGroupType === "vehicleGroup") {
	        var filterUpperCase = filter.toUpperCase();
	        vm.filteredItems = vm.allItems.filter(function (g) {
	          return g.groupName != null && g.groupName.toUpperCase().indexOf(filterUpperCase) != -1;
	        });
	      } else {
	        var _filterUpperCase = filter.toUpperCase();
	        vm.filteredItems = vm.allItems.filter(function (c) {
	          return c.name != null && c.name.toUpperCase().indexOf(_filterUpperCase) != -1;
	        });
	      }
	      // make sure to let the list know that the items in it changed so it can do the correct infinite scroll logic
	      vm.shownItems = vm.filteredItems.slice(0, 40);
	      $scope.$emit("list:filtered");
	
	      if (vm.selectedGroupType === "vehicleGroup") {
	        cacheService.getCache().vehicleGroupFilter = filter;
	      } else {
	        cacheService.getCache().driverGroupFilter = filter;
	      }
	      cacheService.saveCache();
	    }
	
	    function onFilterKeyUp(event) {
	      if (event.keyCode === 27) {
	        vm.filterGroup = null;
	        vm.filterItems(vm.filterGroup);
	      }
	    }
	
	    function loadMoreItems() {
	      console.log("showing more items: " + vm.shownItems.length + ":" + (vm.shownItems.length + 10));
	      var newItems = vm.filteredItems.slice(vm.shownItems.length, vm.shownItems.length + 10);
	      vm.shownItems = vm.shownItems.concat(newItems);
	    }
	
	    function _loadDriverGroups() {
	      var forceRefresh = true;
	      return GroupsService.getDriverGroups(forceRefresh).then(function (groups) {
	        vm.driverGroups = groups.map(function (c) {
	          return {
	            groupId: c.id,
	            groupName: c.name,
	            numItems: c.numberOfDrivers
	          };
	        });
	
	        // after loading driver groups, if this is what tab is currently selected, show the results
	        if (vm.selectedGroupType === "driverGroup") {
	          vm.allItems = vm.driverGroups;
	          filterItems(vm.filterGroup);
	        }
	      });
	    }
	
	    function _loadVehicleGroups() {
	      var forceRefresh = true;
	      return GroupsService.getVehicleGroups(forceRefresh).then(function (groups) {
	        vm.vehicleGroups = groups.map(function (c) {
	          return {
	            groupId: c.id,
	            groupName: c.name,
	            numItems: c.numberOfVehicles
	          };
	        });
	
	        // after loading vehicle groups, if this is what tab is currently selected, show the results
	        if (vm.selectedGroupType === "vehicleGroup") {
	          vm.allItems = vm.vehicleGroups;
	          filterItems(vm.filterGroup);
	        }
	      });
	    }
	
	    function _selectedGroupTypeChanged(newValue, oldValue) {
	      // whenever the tab between vehicle and driver groups changes, set those as the current groups
	      if (newValue === "vehicleGroup") {
	        vm.allItems = vm.vehicleGroups || [];
	      } else {
	        vm.allItems = vm.driverGroups || [];
	      }
	
	      var element = document.getElementById("groupsList");
	      if (element) {
	        element.scrollTop = 0;
	      }
	
	      if (newValue === "vehicleGroup") {
	        vm.filterGroup = cacheService.getCache().vehicleGroupFilter;
	      } else {
	        vm.filterGroup = cacheService.getCache().driverGroupFilter;
	      }
	      filterItems(vm.filterGroup);
	    }
	  }
	})(window.angular);

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <div class=\"ui-panel left-panel\" ng-style=\"{'width': $ctrl.panelWidth}\">\r\n    <div class=\"panel panel-default panel-fixed edits-panel ng-cloak\" ng-cloak>\r\n      <div class=\"panel-heading\">\r\n        <div class=\"no-button\"></div>\r\n        <h4 class=\"panel-name text-center\">\r\n          <span translate=\"views.compliance.title\"></span>\r\n        </h4>\r\n      </div>\r\n      <div class=\"panel-body v-flex-container\">\r\n        <div class=\"text-center\" ng-show=\"$ctrl.isLoading\">\r\n          <span class=\"ico ico-circle-notch ico-spin\"></span>\r\n          <span translate=\"common.Loading\"></span>...\r\n        </div>\r\n        <div class=\"list-group-section\">\r\n          <div class=\"btn-group\">\r\n            <label class=\"btn btn-default btn-sm\" ng-model=\"$ctrl.selectedGroupType\" ng-change=\"$ctrl.onGroupTypeChange()\" uib-btn-radio=\"'vehicleGroup'\">\r\n              <span translate=\"common.Vehicles\"></span>\r\n            </label>\r\n            <label class=\"btn btn-default btn-sm\" ng-model=\"$ctrl.selectedGroupType\" ng-change=\"$ctrl.onGroupTypeChange()\" uib-btn-radio=\"'driverGroup'\">\r\n              <span translate=\"common.Drivers\"></span>\r\n            </label>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-inline filter-group\">\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-btn\">\r\n                <span class=\"btn btn-sm btn-fake-addon\">\r\n                <i class=\"ico ico-filter\"></i>\r\n                </span>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" id=\"set-group-filters\" placeholder=\"{{'common.Filter' | translate }}\" ng-model=\"$ctrl.filterGroup\"\r\n              ng-model-options=\"{ debounce: 200 }\" ng-change=\"$ctrl.filterItems($ctrl.filterGroup)\" ng-keyup=\"$ctrl.onFilterKeyUp($event)\">\r\n            <span class=\"input-group-btn\">\r\n                <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"$ctrl.filterGroup = '';$ctrl.filterItems($ctrl.filterGroup)\">&times;</button>\r\n              </span>\r\n          </div>\r\n        </div>\r\n        <div class=\"list-flex\">\r\n          <ul id=\"groupsList\" class=\"results-list list-group\">\r\n            <div infinite-scroll-parent=\"'#groupsList'\" infinite-scroll-disabled=\"$ctrl.shownItems.length === $ctrl.filteredItems.length\"\r\n              infinite-scroll=\"$ctrl.loadMoreItems()\" infinite-scroll-listen-for-event=\"list:filtered\">\r\n              <li ng-if=\"$ctrl.selectedGroupType === 'vehicleGroup'\" class=\"list-group-item results-item\" ng-click=\"$ctrl.goToGroup($ctrl.selectedGroupType, 'all'); $event.preventDefault(); $event.stopPropogation();\">\r\n                  View All Vehicles\r\n                  <div class=\"pull-right line-arrow\">\r\n                    <span class=\"ico ico-chevron-right-thick\"></span>\r\n                  </div>\r\n              </li>\r\n              <li ng-if=\"$ctrl.selectedGroupType === 'driverGroup'\" class=\"list-group-item results-item\" ng-click=\"$ctrl.goToGroup($ctrl.selectedGroupType, 'all'); $event.preventDefault(); $event.stopPropogation();\">\r\n                View All Drivers\r\n                <div class=\"pull-right line-arrow\">\r\n                  <span class=\"ico ico-chevron-right-thick\"></span>\r\n                </div>\r\n              </li>\r\n              <li class=\"list-group-item results-item\" ng-click=\"$ctrl.goToGroup($ctrl.selectedGroupType, group.groupId); $event.preventDefault(); $event.stopPropogation();\"\r\n                ng-repeat=\"group in $ctrl.shownItems\">\r\n                <div class=\"flex-group\">\r\n                  <div class=\"flex-element text-ellipsis\" tooltip-placement=\"top\" title=\"{{group.groupName}}\">\r\n                    {{group.groupName}}\r\n                  </div>\r\n                  <span class=\"badge with-actions ng-binding\">{{group.numItems}}</span>\r\n                  <div class=\"pull-right line-arrow\">\r\n                    <span class=\"ico ico-chevron-right-thick\"></span>\r\n                  </div>\r\n                </div>\r\n              </li>\r\n            </div>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _moment = __webpack_require__(113);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("complianceGroupRoutes", {
	    template: __webpack_require__(343),
	    controller: ComplianceRoutesController
	  });
	
	  ComplianceRoutesController.$inject = ["$scope", "$location", "LayoutService", "complianceMapService", "complianceService", "$stateParams", "$state", "RoutingProfiles", "mapUtilities", "$q", "UserProvider", "ComplianceRoutingProfileService", "cacheService"];
	
	  function ComplianceRoutesController($scope, $location, LayoutService, complianceMapService, complianceService, $stateParams, $state, RoutingProfiles, mapUtilities, $q, UserProvider, ComplianceRoutingProfileService, cacheService) {
	    var vm = this;
	    vm.settings = $stateParams.settings;
	    if (!vm.settings || _.isEmpty(vm.settings)) {
	      vm.settings = cacheService.getSearchSettings();
	    }
	    vm.currentState = $stateParams.currentState;
	    vm.$onInit = init;
	    vm.$onDestroy = destroy;
	    vm.leftPanelWidth = leftPanelWidth;
	    vm.selectRoute = selectRoute;
	    vm.frameRoute = frameRoute;
	    vm.frameAll = frameAll;
	    vm.routedetails = routedetails;
	    vm.setRouteVisibility = setRouteVisibility;
	    vm.setRoutePingsVisibility = setRoutePingsVisibility;
	    vm.toggleAllRoutes = toggleAllRoutes;
	    vm.nextCompliancePage = nextCompliancePage;
	    vm.previousCompliancePage = previousCompliancePage;
	    vm.changeProfile = complianceService.changeProfile;
	    vm.noRoutingProfiles = complianceService.noRoutingProfiles;
	    vm.zoomtoStop = zoomtoStop;
	    vm.groupId = $stateParams.groupId;
	
	    function init() {
	      complianceMapService.initMap();
	      vm.selectedRouteId = 0;
	
	      //pagination properties
	      vm.firstItemNum = 1;
	      vm.lastItemNum = 10;
	      vm.routesPerPage = 10;
	      vm.currentPageNum = $stateParams.pageNumber;
	      //vm.oorCost = 1;
	      vm.totalPagesNum = 1;
	
	      // stores the routes in the current page, which helps to synchronize with the view
	      vm.routeList = [];
	
	      vm.isLoading = false;
	
	      $scope.$watch(function () {
	        return vm.settings;
	      }, function () {
	
	        vm.isLoading = true;
	
	        cacheService.clearCachedRouteResponses(); //If the user changes search settings in route search, should also clear cache
	
	        var pageNumber = vm.currentPageNum > 1 ? vm.currentPageNum : $location.search().pageNumber;
	
	        if (_isNumber(pageNumber)) {
	          pageNumber = parseInt(pageNumber);
	
	          vm.currentPageNum = pageNumber;
	        } else {
	          vm.currentPageNum = 1;
	        }
	
	        // draw all routes first, and then hide the ones that we want to hide.
	        complianceService.initRoutes(vm, vm.settings, vm.currentPageNum).then(function () {
	          if (vm.routeList.length === 0) {
	            return;
	          }
	
	          // keep a route object to sync between the view and the model
	          vm.route = vm.routeList[vm.currentPageIndex];
	
	          var routeVisibilityList = complianceService.getRouteVisibilityList();
	
	          var start = (vm.currentPageNum - 1) * vm.routesPerPage;
	          var end = void 0;
	          if (vm.currentPageNum * vm.routesPerPage < routeVisibilityList.length) {
	            end = vm.currentPageNum * vm.routesPerPage;
	          } else {
	            end = routeVisibilityList.length;
	          }
	
	          for (var i = start; i < end; i++) {
	            vm.setRouteVisibility(routeVisibilityList[i].tripId, routeVisibilityList[i].isVisible);
	          }
	        });
	      });
	
	      $scope.$on("mapRouteClicked", function (state, msg) {
	        // console.log(msg.tripId);
	        vm.selectRoute(msg.tripId, true);
	        // console.log(vm.routeList);
	        var routeToUse = [];
	        vm.routeList.forEach(function (route) {
	          if (route.tripId === msg.tripId) {
	            routeToUse = route;
	          }
	        });
	        vm.routedetails(routeToUse);
	      });
	    }
	
	    function destroy() {
	      complianceMapService.clearMap();
	    }
	
	    // when a user selects a route, we want the route to be visible
	    // and the visibility should persist until they unselect the route
	    function selectRoute(tripId, isVisible) {
	      vm.selectedRouteId = tripId;
	      vm.setRouteVisibility(tripId, isVisible);
	    }
	
	    function setRouteVisibility(tripId, isVisible) {
	      // set the route in the view to visible
	      var idx = vm.routeList.map(function (r) {
	        return r.tripId;
	      }).indexOf(tripId);
	      vm.routeList[idx].isVisible = isVisible;
	
	      // update our route visibility array in complianceService
	      var index = complianceService.getRouteVisibilityList().map(function (r) {
	        return r.tripId;
	      }).indexOf(tripId);
	      complianceService.setRouteVisibility(index, isVisible);
	
	      // set the route to be visible in the map
	      complianceMapService.setRouteVisibility(tripId, isVisible);
	    }
	
	    function setRoutePingsVisibility(tripId, routePingsVisible) {
	      // set the route pings visibility in the view
	      var idx = vm.routeList.map(function (r) {
	        return r.tripId;
	      }).indexOf(tripId);
	      vm.routeList[idx].isRoutePingsVisible = routePingsVisible;
	
	      complianceMapService.setRoutePingsVisibility(tripId, routePingsVisible);
	    }
	
	    function toggleAllRoutes(routeList, areVisible) {
	      _.forEach(routeList, function (route) {
	        setRouteVisibility(route.tripId, areVisible);
	        route.isVisible = areVisible;
	      });
	    }
	
	    function frameAll() {
	      complianceMapService.frameAllRoutes();
	    }
	
	    function frameRoute(tripId) {
	      complianceMapService.frameRoute(tripId);
	    }
	
	    function zoomtoStop(latlong) {
	      complianceMapService.zoomtoStop(latlong);
	    }
	    function previousCompliancePage() {
	      vm.currentPageNum--;
	      vm.routeList = [];
	
	      // based on our route visibility info, keep or hide the route
	      complianceService.getRoutePage(vm, vm.settings, vm.currentPageNum).then(function () {
	        vm.route = vm.routeList[vm.currentPageIndex];
	        var routeVisibilityList = complianceService.getRouteVisibilityList();
	
	        var start = (vm.currentPageNum - 1) * vm.routesPerPage;
	        var end = start + vm.routesPerPage;
	
	        for (var i = start; i < end; i++) {
	          vm.setRouteVisibility(routeVisibilityList[i].tripId, routeVisibilityList[i].isVisible);
	        }
	      });
	    }
	
	    function nextCompliancePage() {
	      vm.currentPageNum++;
	      vm.routeList = [];
	
	      // based on our route visibility info, keep or hide the route
	      complianceService.getRoutePage(vm, vm.settings, vm.currentPageNum).then(function () {
	        vm.route = vm.routeList[vm.currentPageIndex];
	        var routeVisibilityList = complianceService.getRouteVisibilityList();
	
	        var start = (vm.currentPageNum - 1) * vm.routesPerPage;
	        var end = void 0;
	        if (vm.currentPageNum * vm.routesPerPage < routeVisibilityList.length) {
	          end = vm.currentPageNum * vm.routesPerPage;
	        } else {
	          end = routeVisibilityList.length;
	        }
	
	        for (var i = start; i < end; i++) {
	          vm.setRouteVisibility(routeVisibilityList[i].tripId, routeVisibilityList[i].isVisible);
	        }
	      });
	    }
	
	    function leftPanelWidth() {
	      return LayoutService.getLeftPanelWidth(vm);
	    }
	
	    // todo: put into common file
	    function _isNumber(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	    function routedetails(route) {
	      $state.go($stateParams.childState, {
	        pageNumber: vm.currentPageNum,
	        pageIndex: vm.routeList.indexOf(route),
	        totalPagesNum: vm.totalPagesNum,
	        queryUrl: $stateParams.queryUrl
	      });
	    }
	  }
	})(window.angular); /* globals _ */

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"compliance-grid-panel\" ng-hide=\"$ctrl.leftPanelWidth() === '0'\">\r\n  <div class=\"panel\">\r\n    <div class=\"complaince-routes\">\r\n      <div class=\"route-icons\" ng-hide=\"$ctrl.routeList.length === 1\">\r\n        <button class=\"frame-button btn btn-sm btn-default\" type=\"button\" ng-click=\"$ctrl.frameAll();\" title=\"Frame All\">\r\n          <i class=\"ico ico-frame-box\"></i>\r\n        </button>\r\n        <button class=\"btn btn-sm btn-default\" type=\"button\" ng-model=\"areVisible\" ng-click=\"$ctrl.toggleAllRoutes($ctrl.routeList, true)\"\r\n          title=\"Show All\">\r\n          <i class=\"ico ico-eye-open\"></i>\r\n        </button>\r\n        <button class=\"btn btn-sm btn-default\" type=\"button\" ng-model=\"areVisble\" ng-click=\"$ctrl.toggleAllRoutes($ctrl.routeList, false)\"\r\n          title=\"Hide All\">\r\n          <i class=\"ico ico-eye-blocked\"></i>\r\n        </button>\r\n      </div>\r\n      <table width=\"100%\">\r\n        <tbody>\r\n          <!-- Loading Row -->\r\n          <tr>\r\n            <td colspan=\"5\" ng-if=\"$ctrl.isLoading\" ng-cloak class=\"loading ng-cloak\">\r\n              <span class=\"ico ico-circle-notch ico-spin\"></span>\r\n              <span translate=\"common.Loading\"></span>...\r\n            </td>\r\n          </tr>\r\n          <!-- No Routes -->\r\n          <tr ng-if=\"(($ctrl.routeList.length === 0) && (!$ctrl.isLoading))\" ng-class=\"{selected: (route.tripId === $ctrl.selectedRouteId)}\">\r\n            <td colspan=\"5\" class=\"loading\">\r\n              <span translate=\"views.compliance.NoRoutes\" style=\"font-size:12px\"></span>\r\n            </td>\r\n          </tr>\r\n          <!-- Route List Item Header -->\r\n          <tr ng-repeat-start=\"route in $ctrl.routeList\" class=\"route-row route-row-header\" ng-click=\"$ctrl.selectRoute(route.tripId, route.isVisible)\"\r\n            ng-class=\"{selected: (route.tripId === $ctrl.selectedRouteId)}\" ng-style=\"{'border-left-color': (route.routeColor | hexToRGBa : 0.5), 'border-top-color':(route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"3\">\r\n              <div tooltip-placement=\"top\" title=\"{{route.driverName}} ({{ route.driverId }})\" tooltip-class=\"{{route.driverName}}\">\r\n                <label class=\"route-pad-item\" translate=\"views.compliance.DriverLabel\"></label>\r\n                <span class=\"route-pad-value span-ellipsis text-ellipsis\"> {{route.driverName || \"--\"}} </span>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"3\">\r\n              <div tooltip-placement=\"top\" title=\"{{route.vehicleName}} ({{route.vehicleId}})\" tooltip-class=\"{{route.vehicleName}}\">\r\n                <label class=\"route-pad-item\" translate=\"views.compliance.VehicleLabel\"></label>\r\n                <span class=\"route-pad-value span-ellipsis text-ellipsis\">{{route.vehicleName}} </span>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"2\">\r\n              <span tooltip-placement=\"top\" class=\"unpredictable ico ico-help ico-help-with-circle\" title=\"Unpredictable Data\" ng-if=\"route.questionable\"\r\n                tooltip-class=\"unpredictable\"></span>\r\n            </td>\r\n            <td class=\"{{route.routeColorClass}}\" colspan=\"3\">\r\n              <button class=\"header-button\" type=\"button\" title=\"Route Pings\" ng-model=\"route.isRoutePingsVisible\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); route.isRoutePingsVisible = !route.isRoutePingsVisible; $ctrl.setRoutePingsVisibility(route.tripId, route.isRoutePingsVisible)\"\">\r\n                <span tooltip-placement=\"top\" class=\"btn btn-sm btn-default ico ico-location-arrow\" title=\"Route Pings\"></span>\r\n              </button>\r\n              <switch class=\"route-switch\" ng-click=\"$event.preventDefault(); $event.stopPropagation();\" ng-model=\"route.isVisible\" ng-change=\"$ctrl.setRouteVisibility(route.tripId, route.isVisible)\">\r\n              </switch>\r\n              <button class=\"header-button frame-in\" type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); $ctrl.frameRoute(route.tripId)\"\r\n                title=\"Frame Route\">\r\n                <span class=\"btn btn-sm btn-default ico ico-frame-box\"></span>\r\n              </button>\r\n            </td>\r\n            <td colspan=\"1\">\r\n              <button class=\"header-button route-details\" type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); $ctrl.routedetails(route);\"\r\n                title=\"Route Details\">\r\n                <span tooltip-placement=\"top\" class=\"btn btn-default ico ico-chevron-right-thick\" title=\"Route Details\" tooltip-class=\"Route Details\"></span>\r\n              </button>\r\n            </td>\r\n          </tr>\r\n          <!-- Route Item Stats -->\r\n          <tr ng-click=\"$ctrl.selectRoute(route.tripId, route.isVisible)\" class=\"route-row route-row-body\" ng-class=\"{selected: (route.tripId === $ctrl.selectedRouteId)}\"\r\n            ng-style=\"{'border-left-color': (route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"4\">\r\n              <div class=\"route-pad-item\">\r\n                <label class=\"header\" translate=\"views.compliance.Distance\"> </label>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.Planned\"></label>\r\n                <span class=\"route-pad-value\"> {{route.distancePlanned}} {{\"common.MileAbbreviation\" | translate}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"route.distanceActual>0\">\r\n                <label translate=\"views.compliance.Actual\"></label>\r\n                <span ng-if=\"route.distanceActual>0\" class=\"route-pad-value\"> {{route.distanceActual}} {{\"common.MileAbbreviation\" | translate}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"route.distanceActual>0\">\r\n                <label translate=\"views.compliance.Difference\"></label>\r\n                <span ng-if=\"route.distanceActual>0\" class=\"route-pad-value\"> {{route.distanceDifference}} {{\"common.MileAbbreviation\" | translate}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"route.distanceActual<=0\">\r\n                <label></label>\r\n                <span class=\"route-pad-value\"> </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"route.distanceActual<=0\">\r\n                <label></label>\r\n                <span class=\"route-pad-value\"> </span>\r\n            </td>\r\n            <td colspan=\"4\">\r\n              <div class=\"route-pad-item\">\r\n                <label class=\"header\" translate=\"views.compliance.Duration\"></label>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.Planned\"></label>\r\n                <span class=\"route-pad-value\"> {{route.timePlanned}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"route.distanceActual>0\">\r\n                <label translate=\"views.compliance.Actual\"></label>\r\n                <span ng-if=\"route.distanceActual>0\" class=\"route-pad-value\"> {{route.timeActual}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"route.distanceActual>0\">\r\n                <label translate=\"views.compliance.Difference\"></label>\r\n                <span ng-if=\"route.distanceActual>0\" class=\"route-pad-value\"> {{route.timeDifference}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"route.distanceActual<=0\">\r\n                <label></label>\r\n                <span class=\"route-pad-value\"> </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"route.distanceActual<=0\">\r\n                <label></label>\r\n                <span class=\"route-pad-value\"> </span>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"4\">\r\n              <div class=\"route-pad-item\">\r\n                <label class=\"header\" translate=\"views.compliance.routeEvents\"> </label>\r\n                <span tooltip-placement=\"top\" title=\"Cancelled\" class=\"route-pad-value info-icons\" tooltip-class=\"cancelled\">\r\n                  <i class=\"ico ico-close\" ng-if=\"route.isCancelled\"></i>\r\n\r\n                </span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.Distance\"></label>\r\n                <span class=\"route-pad-value\"> {{route.oorDistance>0?route.oorDistance:0}} {{\"common.MileAbbreviation\" | translate}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.isOor\"></label>\r\n                <span ng-class=\"{'oor-events':route.isOor!= 'None'}\" class=\"route-pad-value\">{{route.isOor}}</span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label>RouteSource</label>\r\n                <span class=\"route-pad-value\" title=\"{{route.routeSource}}\">\r\n                  <span ng-if=\"route.routeSource === 'MANUAL'\" class=\"route-source manual\">MAN</span>\r\n                  <span ng-if=\"route.routeSource === 'INTEGRATION' || route.routeSource === 'DISPATCH'\" class=\"route-source int\">INT</span>\r\n                  <span ng-if=\"route.routeSource === 'ROUTESYNC'\" class=\"route-source routesync\">RS</span>\r\n                  <span ng-if=\"route.routeSource === 'UNKNOWN'\" class=\"route-source other\">?</span>\r\n                </span>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n          <!-- Route Item Origin -->\r\n          <tr ng-click=\"$ctrl.selectRoute(route.tripId, route.isVisible)\" class=\"route-row route-row-body origin-row stop-item\" ng-class=\"{selected: (route.tripId === $ctrl.selectedRouteId)}\"\r\n            ng-style=\"{'border-left-color': (route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td class=\"stop-num origin\" ng-click=\"$ctrl.zoomtoStop(route.originLonLat)\">\r\n              <div class=\"cell-liner\">\r\n                <span class=\"circle origin\" ng-class=\"stop.Icon\"></span>\r\n                <div class=\"stop-line origin\" ng-attr-style=\"{{'background-color:' + route.routeColor + ' !important'}}\"></div>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"6\" class=\"route-info\">\r\n              <span class=\"address-text\">\r\n                <span ng-hide=\"route.originStopName==='GPS Location'\" class=\"strong-name\"> {{route.originStopName}} </span>\r\n                <span ng-if=\"route.originStreet\"> {{route.originStreet}}</span>\r\n              </span>\r\n              </br>\r\n              <span class=\"address-subtext\"> {{route.originCity}}, {{route.originState}}, {{route.originZip}} </span>\r\n            </td>\r\n            <td class=\"route-info\" colspan=\"5\"> {{route.originTime}}\r\n            </td>\r\n          </tr>\r\n          <!-- Route Item Stops -->\r\n          <tr class=\"route-row route-row-body multi-stops-row\" ng-if=\"route.stops\" ng-class=\"{selected: (route.tripId === $ctrl.selectedRouteId)}\"\r\n            ng-style=\"{'border-left-color': (route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"12\">\r\n\r\n              <div class=\"stops-divider stop-num\">\r\n                <div class=\"expand-container toggle-stops\" ng-click=\"route.showStops = !route.showStops\">\r\n                  <div class=\"expand-button\" ng-class=\"{'open':route.showStops}\"></div>\r\n                </div>\r\n                <span type=\"button\" class=\"stops-button circle\" ng-attr-style=\"{{'border-color:' + route.routeColor + ' !important'}}\" ng-click=\"route.showStops = !route.showStops\"\r\n                  ng-show=\"!route.showStops\">{{route.stopCount}}</span>\r\n              </div>\r\n\r\n              <div class=\"stops-panel\" ng-show=\"route.showStops\">\r\n                <div class=\"route-row-body stop-item flex-group\" ng-repeat=\"stop in route.stops\">\r\n                  <div class=\"stop-num\" ng-click=\"$ctrl.zoomtoStop(stop.stoplonLat)\">\r\n                    <div class=\"cell-liner\">\r\n                      <span class=\"circle stop-circle\" ng-class=\"stop.Icon\" ng-attr-style=\"{{'border-color:' + route.routeColor}}\">{{stop.stopNumber}}</span>\r\n                      <span class=\"stop-line\" ng-attr-style=\"{{'background-color:' + route.routeColor + ' !important'}}\"></span>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"route-info flex-element\" id=\"demo\">\r\n                    <div class=\"address-text\">\r\n                      <span ng-hide=\"stop.stopName==='GPS Location'\" class=\"strong-name\"> {{stop.stopName}} </span>\r\n                      <span ng-if=\"stop.stopStreet\"> {{stop.stopStreet}}</span>\r\n                    </div>\r\n                    <div class=\"address-subtext\"> {{stop.stopCity}}, {{stop.stopState}}, {{stop.stopZip}}</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n          <!-- Route Item Destination -->\r\n          <tr class=\"route-row route-row-body stop-item destination\" ng-click=\"$ctrl.selectRoute(route.tripId, route.isVisible)\" ng-class=\"{selected: (route.tripId === $ctrl.selectedRouteId), lastRow: !$ctrl.shouldShowProfile(route)}\"\r\n            ng-style=\"{'border-left-color': (route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td class=\"stop-num destination info-num\" ng-click=\"$ctrl.zoomtoStop(route.destinationLonLat)\">\r\n              <div class=\"cell-liner\">\r\n                <div class=\"stop-line destination\" ng-class=\"{'with-stops':(route.stops && !route.showStops)}\" ng-attr-style=\"{{'background-color:' + route.routeColor + ' !important'}}\"></div>\r\n                <span class=\"circle destination\" ng-class=\"stop.Icon\"></span>\r\n              </div>\r\n            </td>\r\n\r\n            <td colspan=\"6\" class=\"route-info\">\r\n              <span class=\"address-text\">\r\n                <span ng-hide=\"route.destinationStopName==='GPS Location'\" class=\"strong-name\"> {{route.destinationStopName}} </span>\r\n                <span ng-if=\"route.destinationStreet\"> {{route.destinationStreet}}</span>\r\n              </span>\r\n              </br>\r\n              <span class=\"address-subtext\"> {{route.destinationCity}}, {{route.destinationState}}, {{route.destinationZip}} </span>\r\n            </td>\r\n            <td class=\"route-info\" colspan=\"5\">\r\n              <span> {{route.destinationTime}} </span>\r\n            </td>\r\n          </tr>\r\n          <tr ng-repeat-end class=\"route-row route-row-body\" ng-click=\"$ctrl.selectRoute(route.tripId, route.isVisible)\" ng-class=\"{selected: (route.tripId === $ctrl.selectedRouteId), lastRow: $ctrl.shouldShowProfile(route)}\"\r\n            ng-style=\"{'border-left-color': (route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"12\" class=\"route-profile-select\">\r\n              <routing-profile-select></routing-profile-select>\r\n            </td>\r\n          </tr>\r\n          <!-- End Route Table -->\r\n        </tbody>\r\n      </table>\r\n      </div>\r\n      <div class=\"footer clearfix\" ng-if=\"$ctrl.routeList.length!=0\">\r\n        <div class=\"pagination-description\">\r\n          <span translate=\"common.Displaying\" translate-values=\"{ first: $ctrl.firstItemNum, last: $ctrl.lastItemNum, total: $ctrl.totalRoutesNum }\"></span>\r\n        </div>\r\n        <div class=\"pagination-buttons\">\r\n          <button class=\"btn\" type=\"button\" ng-click=\"$ctrl.previousCompliancePage()\" ng-disabled=\"($ctrl.currentPageNum===1)\">\r\n            <span class=\"glyphicon glyphicon-menu-left\"></span>\r\n            <span translate=\"common.Previous\"></span>\r\n          </button>\r\n          <button class=\"btn\" type=\"button\" ng-click=\"$ctrl.nextCompliancePage()\" ng-disabled=\"($ctrl.currentPageNum===$ctrl.totalPagesNum)\">\r\n            <span translate=\"common.Next\"></span>\r\n            <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n";

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _moment = __webpack_require__(113);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("complianceRouteDetails", {
	    template: __webpack_require__(345),
	    controller: complianceRouteDetailsController
	  });
	
	  complianceRouteDetailsController.$inject = ["$scope", "$location", "LayoutService", "complianceMapService", "complianceService", "$stateParams", "$state", "RoutingProfiles", "mapUtilities", "$q", "UserProvider", "ComplianceRoutingProfileService", "cacheService", "timeService"];
	
	  function complianceRouteDetailsController($scope, $location, LayoutService, complianceMapService, complianceService, $stateParams, $state, RoutingProfiles, mapUtilities, $q, UserProvider, ComplianceRoutingProfileService, cacheService, timeService) {
	    var vm = this;
	    vm.settings = $stateParams.settings;
	    if (!vm.settings || _.isEmpty(vm.settings)) {
	      vm.settings = cacheService.getSearchSettings();
	    }
	    vm.currentState = $stateParams.currentState;
	    vm.$onInit = init;
	    vm.$onDestroy = destroy;
	    vm.leftPanelWidth = leftPanelWidth;
	    vm.selectRoute = selectRoute;
	    vm.frameRoute = frameRoute;
	    vm.setRouteVisibility = setRouteVisibility;
	    vm.setRoutePingsVisibility = setRoutePingsVisibility;
	    vm.changeProfile = complianceService.changeProfile;
	    vm.zoomtoStop = zoomtoStop;
	    vm.currentPageNum = $stateParams.pageNumber;
	    vm.currentPageIndex = $stateParams.pageIndex;
	    vm.totalPagesNum = $stateParams.totalPagesNum;
	    vm.nextRoute = nextRoute;
	    vm.prevRoute = prevRoute;
	    vm.getCurrentRouteIndex = getCurrentRouteIndex;
	    vm.backToRoutes = backToRoutes;
	
	    // stores the routes in the current page, which helps to synchronize with the view
	    vm.routeList = [];
	
	    vm.routesPerPage = 10;
	
	    vm.selectedRouteId = 0;
	
	    vm.isLoading = true;
	
	    function init() {
	      complianceMapService.initMap();
	      // draw all routes first, and then hide the ones that we want to hide.
	      complianceService.initRoutes(vm, vm.settings, vm.currentPageNum, vm.currentPageIndex).then(function () {
	        vm.route = vm.routeList[vm.currentPageIndex];
	        var routeVisibilityList = complianceService.getRouteVisibilityList();
	        var routeIndex = vm.getCurrentRouteIndex();
	        vm.selectRoute(routeVisibilityList[routeIndex].tripId, routeVisibilityList[routeIndex].isVisible);
	      });
	    }
	
	    function getCurrentRouteIndex() {
	      return (vm.currentPageNum - 1) * vm.routesPerPage + vm.currentPageIndex;
	    }
	
	    function nextRoute() {
	      vm.currentPageIndex++;
	      if (vm.currentPageIndex >= vm.routeList.length) {
	        vm.currentPageNum++;
	        vm.currentPageIndex = 0;
	      }
	
	      // draw all routes first, and then hide the ones that should be invisible.
	      complianceService.initRoutes(vm, vm.settings, vm.currentPageNum, vm.currentPageIndex).then(function () {
	        vm.route = vm.routeList[vm.currentPageIndex];
	        var routeIndex = vm.getCurrentRouteIndex();
	        var routeVisibilityList = complianceService.getRouteVisibilityList();
	        vm.selectRoute(routeVisibilityList[routeIndex].tripId, routeVisibilityList[routeIndex].isVisible);
	      });
	    }
	
	    function backToRoutes() {
	      $state.go($stateParams.parentState, {
	        queryUrl: $stateParams.queryUrl,
	        pageNumber: vm.currentPageNum
	      });
	    }
	
	    function prevRoute() {
	      vm.currentPageIndex--;
	      if (vm.currentPageIndex < 0) {
	        vm.currentPageNum--;
	        vm.currentPageIndex = 9;
	      }
	
	      // draw all routes first, and then hide the ones that should be invisible.
	      complianceService.initRoutes(vm, vm.settings, vm.currentPageNum, vm.currentPageIndex).then(function () {
	        vm.route = vm.routeList[vm.currentPageIndex];
	        var routeIndex = vm.getCurrentRouteIndex();
	        var routeVisibilityList = complianceService.getRouteVisibilityList();
	        vm.selectRoute(routeVisibilityList[routeIndex].tripId, routeVisibilityList[routeIndex].isVisible);
	      });
	    }
	
	    function destroy() {
	      complianceMapService.clearMap();
	    }
	
	    // when a user selects a particular route for the first time, 
	    // set visibility for the route and GPS pings
	    // and the visibility should persist until the user changes the settings
	    function selectRoute(tripId, isVisible) {
	      vm.selectedRouteId = tripId;
	
	      vm.setRouteVisibility(tripId, isVisible);
	
	      vm.setRoutePingsVisibility(tripId, isVisible);
	    }
	
	    function setRouteVisibility(tripId, isVisible) {
	      // set the route in the view to visible
	      var idx = vm.routeList.map(function (r) {
	        return r.tripId;
	      }).indexOf(tripId);
	      vm.routeList[idx].isVisible = isVisible;
	
	      // update our route visibility array in complianceService
	      var index = complianceService.getRouteVisibilityList().map(function (r) {
	        return r.tripId;
	      }).indexOf(tripId);
	      complianceService.setRouteVisibility(index, isVisible);
	
	      // set the route visibility in the map
	      complianceMapService.setRouteVisibility(tripId, isVisible);
	    }
	
	    function setRoutePingsVisibility(tripId, routePingsVisible) {
	      // set the route pings visibility in the view
	      var idx = vm.routeList.map(function (r) {
	        return r.tripId;
	      }).indexOf(tripId);
	      vm.routeList[idx].isRoutePingsVisible = routePingsVisible;
	
	      complianceMapService.setRoutePingsVisibility(tripId, routePingsVisible);
	    }
	
	    function frameRoute(tripId) {
	      complianceMapService.frameRoute(tripId);
	    }
	
	    function zoomtoStop(latlong) {
	      complianceMapService.zoomtoStop(latlong);
	    }
	
	    function leftPanelWidth() {
	      return LayoutService.getLeftPanelWidth();
	    }
	
	    // todo: put into common file
	    function _isNumber(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	  }
	})(window.angular);

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	module.exports = "\r\n<div class=\"compliance-grid-panel\" ng-hide=\"$ctrl.leftPanelWidth() === '0'\">\r\n  <div class=\"panel panel-default panel-fixed edits-panel\">\r\n    <div class=\"panel-heading\">\r\n              <div class=\"back-button\">\r\n          <button type=\"button\"  class=\"btn btn-default btn-sm\" ng-click=\"$ctrl.backToRoutes()\">\r\n          <span class=\"ico ico-chevron-left-thick\"></span><span translate=\"common.Back\"></span>\r\n        </button>\r\n        </div>\r\n        <h4 class=\"panel-name text-center\">\r\n          <span translate=\"views.details.title\"></span>\r\n        </h4>\r\n      </div>\r\n    <div class=\"complaince-routes route-details\">\r\n      <table width=\"100%\" >\r\n        <tbody>\r\n          <!-- Loading Row -->\r\n          <tr>\r\n            <td colspan=\"5\" ng-if=\"$ctrl.isLoading\" ng-cloak class=\"loading ng-cloak\">\r\n              <span class=\"ico ico-circle-notch ico-spin\"></span>\r\n              <span translate=\"common.Loading\"></span>...\r\n            </td>\r\n          </tr>\r\n          <!-- Route List Item Header -->\r\n          <tr ng-if-start=\"!$ctrl.isLoading\" class=\"route-row route-row-header\"  ng-style=\"{'border-left-color': ($ctrl.route.routeColor | hexToRGBa : 0.5), 'border-top-color':($ctrl.route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"4\">\r\n              <div tooltip-placement=\"top\" title=\"{{$ctrl.route.driverName}}\" tooltip-class=\"{{$ctrl.route.driverName}}\">\r\n                <label class=\"route-pad-item\" translate=\"views.compliance.DriverLabel\"></label> <span class=\"route-pad-value span-ellipsis text-ellipsis\">  {{$ctrl.route.driverName || \"--\"}} </span>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"4\">\r\n              <div tooltip-placement=\"top\" title=\"{{$ctrl.route.vehicleName}}\" tooltip-class=\"{{$ctrl.route.vehicleName}}\">\r\n                <label class=\"route-pad-item\" translate=\"views.compliance.VehicleLabel\"></label><span class=\"route-pad-value span-ellipsis text-ellipsis\">{{$ctrl.route.vehicleName}} </span>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"1\">\r\n              <span tooltip-placement=\"top\" class=\"unpredictable ico ico-help ico-help-with-circle\" title=\"Unpredictable Data\" ng-if=\"$ctrl.route.questionable\" tooltip-class=\"unpredictable\"></span>\r\n            </td>\r\n            <td class=\"{{$ctrl.route.routeColorClass}}\" colspan=\"3\">\r\n              <button class=\"header-button\"  title=\"Route Pings\" ng-model=\"route.isRoutePingsVisible\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); route.isRoutePingsVisible = !route.isRoutePingsVisible; $ctrl.setRoutePingsVisibility(route.tripId, route.isRoutePingsVisible)\">\r\n                <span tooltip-placement=\"top\" class=\"btn btn-sm btn-default ico ico-location-arrow\" title=\"Route Pings\"></span>\r\n                </button>\r\n              <switch class=\"route-switch\" ng-click=\"$event.preventDefault(); $event.stopPropagation();\" ng-model=\"$ctrl.route.isVisible\" ng-change=\"$ctrl.setRouteVisibility($ctrl.route.tripId, $ctrl.route.isVisible)\">\r\n              </switch>\r\n              <button class=\"header-button frame-in\" type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); $ctrl.frameRoute($ctrl.route.tripId)\"\r\n                title=\"Frame Route\">\r\n                <span class=\"btn btn-sm btn-default ico ico-frame-box\"></span>\r\n              </button>\r\n            </td>\r\n          </tr>\r\n          <tr class=\"route-row route-row-header sub-header\"\r\n           ng-style=\"{'border-left-color': ($ctrl.route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"4\">\r\n              <div tooltip-placement=\"top\" title=\"{{$ctrl.route.driverId}}\" tooltip-class=\"{{$ctrl.route.driverId}}\">\r\n                <label class=\"route-pad-item\" translate=\"views.compliance.DriverId\"></label> <span class=\"route-pad-value span-ellipsis text-ellipsis\">  {{$ctrl.route.driverId || \"--\"}} </span>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"4\">\r\n              <div tooltip-placement=\"top\" title=\"{{$ctrl.route.vehicleId}}\" tooltip-class=\"{{$ctrl.route.vehicleId}}\">\r\n                <label class=\"route-pad-item\" translate=\"views.compliance.VehicleId\"></label><span class=\"route-pad-value span-ellipsis text-ellipsis\">{{$ctrl.route.vehicleId}} </span>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"4\" tooltip-placement=\"top\">\r\n              <div tooltip-placement=\"top\" title=\"{{$ctrl.route.tripId}}\" tooltip-class=\"{{$ctrl.route.tripId}}\">\r\n                <label class=\"route-pad-item\" translate=\"views.compliance.tripId\"></label><span class=\"route-pad-value\"> &nbsp; {{$ctrl.route.tripId}} </span>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n          <!-- Route Item Stats -->\r\n          <tr  class=\"route-row details-row route-row-body\" ng-style=\"{'border-left-color': ($ctrl.route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"6\">\r\n              <div class=\"route-pad-item\">\r\n                <label class=\"header\" translate=\"views.compliance.Distance\">    </label>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.Planned\"></label>\r\n                <span class=\"route-pad-value\"> {{$ctrl.route.distancePlanned}} {{\"common.MileAbbreviation\" | translate}}      </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"$ctrl.route.distanceActual>0\">\r\n                <label translate=\"views.compliance.Actual\"></label>\r\n                <span ng-if=\"$ctrl.route.distanceActual>0\" class=\"route-pad-value\"> {{$ctrl.route.distanceActual}} {{\"common.MileAbbreviation\" | translate}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"$ctrl.route.distanceActual>0\">\r\n                <label translate=\"views.compliance.Difference\"></label>\r\n                <span ng-if=\"$ctrl.route.distanceActual>0\" class=\"route-pad-value\"> {{$ctrl.route.distanceDifference}} {{\"common.MileAbbreviation\" | translate}}  </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"$ctrl.route.distanceActual<=0\">\r\n                <label></label>\r\n                <span class=\"route-pad-value\">  </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"$ctrl.route.distanceActual<=0\">\r\n                <label></label>\r\n                <span class=\"route-pad-value\">  </span>\r\n            </td>\r\n            <td colspan=\"6\">\r\n              <div class=\"route-pad-item\">\r\n                <label class=\"header\" translate=\"views.compliance.Duration\"></label>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.Planned\"></label>\r\n                <span class=\"route-pad-value\"> {{$ctrl.route.timePlanned}}       </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"$ctrl.route.distanceActual>0\">\r\n                <label translate=\"views.compliance.Actual\"></label>\r\n                <span ng-if=\"$ctrl.route.distanceActual>0\" class=\"route-pad-value\">  {{$ctrl.route.timeActual}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"$ctrl.route.distanceActual>0\">\r\n                <label translate=\"views.compliance.Difference\"></label>\r\n                <span ng-if=\"$ctrl.route.distanceActual>0\" class=\"route-pad-value\">  {{$ctrl.route.timeDifference}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"$ctrl.route.distanceActual<=0\">\r\n                <label></label>\r\n                <span class=\"route-pad-value\">  </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"$ctrl.route.distanceActual<=0\">\r\n                <label></label>\r\n                <span class=\"route-pad-value\">  </span>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n           <!--Route Details-->\r\n          <tr class=\"route-row route-row-body details-row stop-item destination\"  ng-style=\"{'border-left-color': ($ctrl.route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"6\">\r\n              <div class=\"route-pad-item\">\r\n                <label class=\"header\" style=\"text-align: left\" translate=\"views.compliance.details\"></label>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.Status\"></label>\r\n                <span class=\"route-pad-value\"> {{$ctrl.route.status}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"route.timeActual\">\r\n                <label translate=\"views.compliance.timeFrame\"></label>\r\n                <span class=\"route-pad-value\"> {{$ctrl.route. r.isDelayed ? \"Delayed\" : \"Not Delayed\"}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.dataAccuracy\"></label>\r\n                <span class=\"route-pad-value\">{{$ctrl.route.questionable? \"Low\" : \"High\"}} </span>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"6\">\r\n                <div class=\"route-pad-item\">\r\n                <label translate=\"\"></label>\r\n                <span class=\"route-pad-value\"> </span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.reports.routeSource\"></label>\r\n                <span class=\"route-pad-value\"> {{$ctrl.route.routeSource}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.reports.stops\"></label>\r\n                <span class=\"route-pad-value\">{{$ctrl.route.stopCount || \"None\"}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\" ng-if=\"$ctrl.route.externalTripId\">\r\n                  <label translate=\"views.compliance.externalTripId\"></label>\r\n                  <span class=\"route-pad-value\">{{$ctrl.route.externalTripId || \"None\"}} </span>\r\n                </div>\r\n            </td>\r\n          </tr>\r\n          <!--Routing Profile Selector-->\r\n          <tr class=\"route-row route-row-body\" ng-style=\"{'border-left-color': ($ctrl.route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"12\" class=\"route-profile-select\">\r\n              <routing-profile-select></routing-profile-select>\r\n            </td>\r\n          </tr>\r\n          <!-- Route Item Origin -->\r\n          <tr class=\"route-row route-row-body origin-row stop-item\" ng-style=\"{'border-left-color': ($ctrl.route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td class=\"stop-num origin\" ng-click=\"$ctrl.zoomtoStop($ctrl.route.originLonLat)\">\r\n              <div class=\"cell-liner\">\r\n                <span class=\"circle origin\" ng-class=\"stop.Icon\"></span>\r\n                <div class=\"stop-line origin\" ng-attr-style=\"{{'background-color:' + $ctrl.route.routeColor + ' !important'}}\"></div>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"6\" class=\"route-info\">\r\n              <span class=\"address-text\"><span ng-hide=\"$ctrl.route.originStopName==='GPS Location'\"  class=\"strong-name\">  {{$ctrl.route.originStopName}} </span> <span ng-if=\"$ctrl.route.originStreet\"> {{$ctrl.route.originStreet}} </span> </span> </br> <span class=\"address-subtext\"> {{$ctrl.route.originCity}},  {{$ctrl.route.originState}}, {{$ctrl.route.originZip}} </span>              </td>\r\n            <td class=\"route-info\" colspan=\"5\"> {{$ctrl.route.originTime}}\r\n            </td>\r\n          </tr>\r\n          <!-- Route Item Stops -->\r\n          <tr class=\"route-row route-row-body multi-stops-row\" ng-if=\"$ctrl.route.stops\" ng-style=\"{'border-left-color': ($ctrl.route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"12\">\r\n\r\n              <div class=\"stops-divider stop-num\">\r\n                <div class=\"expand-container toggle-stops\" ng-click=\"$ctrl.route.showStops = !$ctrl.route.showStops\" ng-init=\"$ctrl.route.showStops=true\">\r\n                  <div class=\"expand-button\" ng-class=\"{'open':$ctrl.route.showStops}\"></div>\r\n                </div>\r\n                <span type=\"button\" class=\"stops-button circle\" ng-attr-style=\"{{'border-color:' + $ctrl.route.routeColor + ' !important'}}\"\r\n                  ng-click=\"$ctrl.route.showStops = !$ctrl.route.showStops\" ng-show=\"!$ctrl.route.showStops\">{{$ctrl.route.stopCount}}</span>\r\n              </div>\r\n\r\n              <div class=\"stops-panel\" ng-show=\"$ctrl.route.showStops\">\r\n                <div class=\"route-row-body stop-item flex-group\" ng-repeat=\"stop in $ctrl.route.stops\">\r\n                  <div class=\"stop-num\" ng-click=\"$ctrl.zoomtoStop(stop.stoplonLat)\">\r\n                    <div class=\"cell-liner\">\r\n                      <span class=\"circle stop-circle\" ng-class=\"stop.Icon\" ng-attr-style=\"{{'border-color:' + $ctrl.route.routeColor}}\">{{stop.stopNumber}}</span>\r\n                      <span class=\"stop-line\" ng-attr-style=\"{{'background-color:' + $ctrl.route.routeColor + ' !important'}}\"></span>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"route-info flex-element\" id=\"demo\">\r\n                    <div class=\"address-text\">  <span ng-hide=\"stop.stopName==='GPS Location'\" class=\"strong-name\"> {{stop.stopName}} </span>\r\n                      <span ng-if=\"stop.stopStreet\"> {{stop.stopStreet}} </span> </div>\r\n                    <div class=\"address-subtext\">  {{stop.stopCity}}, {{stop.stopState}}, {{stop.stopZip}}</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n          <!-- Route Item Destination -->\r\n          <tr class=\"route-row route-row-body stop-item destination\"  ng-class=\"{ lastRow: !$ctrl.shouldShowProfile($ctrl.route)}\" ng-style=\"{'border-left-color': ($ctrl.route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td class=\"stop-num destination info-num\" ng-click=\"$ctrl.zoomtoStop($ctrl.route.destinationLonLat)\">\r\n              <div class=\"cell-liner\">\r\n                <div class=\"stop-line destination\" ng-class=\"{'with-stops':($ctrl.route.stops && !$ctrl.route.showStops)}\" ng-attr-style=\"{{'background-color:' + $ctrl.route.routeColor + ' !important'}}\"></div>\r\n                <span class=\"circle destination\" ng-class=\"stop.Icon\"></span>\r\n              </div>\r\n            </td>\r\n\r\n            <td colspan=\"6\" class=\"route-info\">\r\n              <span class=\"address-text\">  <span ng-hide=\"$ctrl.route.destinationStopName==='GPS Location'\"  class=\"strong-name\">  {{$ctrl.route.destinationStopName}} </span> <span ng-if=\"$ctrl.route.destinationStreet\"> {{$ctrl.route.destinationStreet}}</span> </span> </br>\r\n              <span class=\"address-subtext\">  {{$ctrl.route.destinationCity}}, {{$ctrl.route.destinationState}}, {{$ctrl.route.destinationZip}} </span>              </td>\r\n            <td class=\"route-info\" colspan=\"5\"> <span> {{$ctrl.route.destinationTime}} </span>\r\n            </td>\r\n          </tr>\r\n          <!--OOR Events-->\r\n          <tr ng-if-end class=\"route-row route-row-body route-end\"\r\n            ng-style=\"{'border-left-color': ($ctrl.route.routeColor | hexToRGBa : 0.5), 'border-bottom-color': ($ctrl.route.routeColor | hexToRGBa : 0.5)}\">\r\n            <td colspan=\"12\" ng-if=\"$ctrl.route.outOfRouteEvents.length<=0\">\r\n            <td colspan=\"12\" ng-if=\"$ctrl.route.outOfRouteEvents.length>0\" class=\"event-details\">\r\n              <label class=\"header\" translate=\"views.compliance.eventDetails\"> </label> <br/>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.Distance\"></label>\r\n                <span class=\"route-pad-value\"> {{$ctrl.route.oorDistance>0?$ctrl.route.oorDistance:0}} {{\"common.MileAbbreviation\" | translate}}     </span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.isOor\"></label>\r\n                <span ng-class=\"{'oor-events':$ctrl.route.isOor!= 'None'}\" class=\"route-pad-value\">{{$ctrl.route.isOor}}</span>\r\n              </div>\r\n              <!-- <div class=\"route-pad-item\">\r\n                <label translate=\"views.compliance.Cost\"> </label>\r\n                <span class=\"route-pad-value\">{{$ctrl.route.oorCost}} </span>\r\n              </div> -->\r\n              <div class=\"events-row\">\r\n            <table >\r\n              <tr ng-repeat=\"event in $ctrl.route.outOfRouteEvents\" class=\"route-row-body stop-item details-row\"  ng-click=\"$ctrl.zoomtoStop(event.lonlat)\">\r\n              <td colspan=\"6\">\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"\"> Type </label>\r\n                <span class=\"route-pad-value\"> {{event.type}}</span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"\">TimeStamp</label>\r\n                <span class=\"route-pad-value\">{{event.timeStamp}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label> Distance</label>\r\n                <span class=\"route-pad-value\">{{event.distanceOOR}} </span>\r\n              </div>\r\n            </td>\r\n            <td colspan=\"6\">\r\n              <div class=\"route-pad-item\">\r\n                <label translate=\"\">Location</label>\r\n                <span ng-if=\"event.oorStreetAddr\" class=\"route-pad-value address-text strong-name\">{{event.oorStreetAddr}}<br></span>\r\n                <span ng-if=\"event.oorCity\" class=\"route-pad-value address-text strong-name\">{{event.oorCity}}</span>\r\n                <span ng-if=\"event.state\" class=\"route-pad-value address-text strong-name\"> {{event.state}} </span>\r\n                <span ng-if=\"event.zip\" class=\"route-pad-value address-text strong-name\">{{event.zip}} </span>\r\n              </div>\r\n              <div class=\"route-pad-item\">\r\n                <label>GPS Coordinates</label>\r\n                <span class=\"route-pad-value\"> {{event.oorLat}},{{event.oorLon}} </span>\r\n              </div>\r\n            </td>\r\n              </tr>\r\n            </table>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n          <!-- End Route Table -->\r\n        </tbody>\r\n      </table>\r\n      </div>\r\n      <div class=\"footer clearfix\" ng-if=\"$ctrl.routeList.length!=0\">\r\n        <div class=\"pagination-description\">\r\n          <span translate=\"common.DisplayingDetail\" translate-values=\"{ current: $ctrl.getCurrentRouteIndex() + 1, total: $ctrl.totalRoutesNum }\"></span>\r\n        </div>\r\n        <div class=\"pagination-buttons\">\r\n          <button class=\"btn\" type=\"button\" ng-click=\"$ctrl.prevRoute()\" ng-disabled=\"($ctrl.getCurrentRouteIndex() === 0)\">\r\n          <span class=\"glyphicon glyphicon-menu-left\"></span>\r\n          <span translate=\"common.Previous\"></span>\r\n        </button>\r\n          <button class=\"btn\" type=\"button\" ng-click=\"$ctrl.nextRoute()\" ng-disabled=\"($ctrl.getCurrentRouteIndex()===$ctrl.totalRoutesNum-1)\">\r\n          <span translate=\"common.Next\"></span>\r\n          <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n        </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _angular = __webpack_require__(3);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = __webpack_require__(331)("compliance:rp-select");
	
	_angular2.default.module("fleetviewApp").directive("routingProfileSelect", routingProfileSelect);
	
	var vehicleTypeMap = {
	  "Truck": "Heavy Duty",
	  "MidsizeTruck": "Medium Duty",
	  "LightDuty": "Light Duty",
	  "9": "School Bus"
	};
	
	function routingProfileSelect() {
	
	  // logic for which profiles to show in drop-down...
	  function getItemsForSelect(scope) {
	    var route = scope.route;
	
	    debug("route:", route);
	    if (route.routingProfileFromPrescribedRoute) {
	      debug("route.routingProfileFromPrescribedRoute");
	      route.routingProfiles.unshift(route.routingProfileFromPrescribedRoute); // aka 'Trip Options'
	      route.selectedRoutingProfile = route.routingProfiles[0];
	    }
	
	    // if any RPs are companyProfile, select it
	    var companyProfile = route.routingProfiles.find(function (rp) {
	      return rp.source === "CompanyProfile";
	    });
	    if (companyProfile) {
	      route.selectedRoutingProfile = companyProfile;
	    }
	
	    var items = route.routingProfiles.map(function (rp) {
	      if (!rp.name) {
	        // use vehicleType as a backup name
	        if (vehicleTypeMap[rp.vehicleType]) {
	          rp.name = vehicleTypeMap[rp.vehicleType];
	        } else {
	          rp.name = rp.vehicleType;
	        }
	      }
	      return rp;
	    });
	
	    // filter out Account-RPs when we have VehicleGroup-RPs
	    var companyVehicleGroupRP = items.find(function (r) {
	      return r.source === "CompanyProfile_VG";
	    });
	    if (companyVehicleGroupRP) {
	      items = items.filter(function (r) {
	        return r.source !== "CompanyProfile_Acct";
	      });
	    }
	
	    // sets selectedRP when its needed
	    if (companyVehicleGroupRP && !route.selectedRoutingProfile) {
	      route.selectedRoutingProfile = companyVehicleGroupRP;
	    }
	
	    // if !rpId & !TripOptions & !selectedRP, add the 'Unknown profile'
	    if (!route.routingProfileId && !route.routingProfileFromPrescribedRoute && !route.selectedRoutingProfile) {
	      items.unshift({ name: "Unknown profile", source: "Default", vehicleType: "Truck" });
	      route.unknownProfile = true;
	      debug("no routingProfileId");
	    }
	
	    debug("items:", items);
	    return items;
	  }
	
	  function sourceName() {
	    var selectedRP = this.route.selectedRoutingProfile || {};
	    if (selectedRP.source) {
	      if (selectedRP.source.includes("Driver")) {
	        return "Driver"; // used to display to end-user
	      } else if (selectedRP.source.includes("Company")) {
	        return "Company";
	      }
	      return selectedRP.source;
	    }
	  }
	
	  function vehicleTypeName() {
	    var selectedRP = this.route.selectedRoutingProfile || {};
	    var vType = selectedRP.vehicleType;
	
	    if (vehicleTypeMap[vType]) {
	      return vehicleTypeMap[vType];
	    }
	    return vType;
	  }
	
	  function showLabel() {
	    if (this.route.dropDownItems.length === 1) {
	      return true;
	    }
	    var selectedRP = this.route.selectedRoutingProfile || {};
	    // if source if company profile or trip options, show label
	    return selectedRP.source === "CompanyProfile" || selectedRP.source === "DriverProfile";
	  }
	
	  function showLabelWarning() {
	    var _route = this.route,
	        unknownProfile = _route.unknownProfile,
	        dropDownItems = _route.dropDownItems;
	
	    var item = dropDownItems[0];
	    if (item && item.source === "DriverProfile") {
	      return true;
	    }
	    if (dropDownItems.length === 0 || unknownProfile) {
	      return true;
	    }
	    return false;
	  }
	
	  function showDropDownWarning() {
	    var selectedRP = this.route.selectedRoutingProfile;
	    if (!selectedRP) {
	      return true;
	    }
	    if (selectedRP.source === "DriverProfile") {
	      return true;
	    }
	    if (selectedRP.source.includes("Company")) {
	      return false;
	    }
	    if (this.route.unknownProfile) {
	      return true;
	    }
	
	    return false;
	  }
	
	  function showDropDown() {
	    // debug("$crtl", this.$ctrl)
	    var route = this.route;
	    if (!route || !route.routingProfiles) {
	      return false;
	    }
	
	    var selectedRP = route.selectedRoutingProfile;
	    if (selectedRP && selectedRP.source === "CompanyProfile") {
	      return false;
	    } else if (selectedRP && selectedRP.source === "DriverProfile") {
	      // tripOptions from CP v10
	      return false;
	    }
	
	    return route.dropDownItems.length > 1;
	  }
	
	  var directive = {
	    template: __webpack_require__(347),
	    restrict: "E",
	    scope: false, // use parent scope
	    link: function link(scope, element, attrs) {
	      if (!scope.route) {
	        scope.route = scope.$ctrl.route; // ensure scope.route exists, route-detail only has {route} on $ctrl
	      }
	      scope.showDropDown = showDropDown;
	      scope.showLabel = showLabel;
	      scope.showLabelWarning = showLabelWarning;
	      scope.showDropDownWarning = showDropDownWarning;
	      scope.vehicleTypeName = vehicleTypeName;
	      scope.sourceName = sourceName;
	      var items = getItemsForSelect(scope);
	      scope.route.routingProfiles = items;
	      scope.route.dropDownItems = items;
	
	      // logic for setting selectedRoutingProfile
	      if (scope.route.unknownProfile) {
	        scope.route.selectedRoutingProfile = items[0];
	      }
	      debug("rp-select-> scope", scope);
	    }
	  };
	  return directive;
	}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports = "<!-- <span>debug: {{showDropDown()}} </span> -->\r\n<div ng-if=\"showDropDown()\">\r\n    <span ng-if=\"route.isChangingProfile\" ng-cloak class=\"ng-cloak\">\r\n        <span class=\"ico ico-circle-notch ico-spin\"></span>\r\n        <label class=\"header\"> {{ \"views.compliance.loadingRoutingProfile\" | translate }}</label>\r\n    </span>\r\n    <br>\r\n    <label class=\"header\"> {{ \"views.compliance.routingProfile\" | translate }}</label>\r\n    <span ng-if=\"route.routingProfileError\" class=\"ico ico-info-circle ico-info-color\" tooltip-placement=\"top-left\" uib-tooltip=\"{{ 'views.compliance.routingProfileError' | translate }}\"\r\n      tooltip-append-to-body=\"true\"></span>\r\n    <!-- show drop-down of profiles -->\r\n    <span ng-if=\"route.routingProfiles.length\">\r\n      <select ng-options=\"profile as profile.name for profile in route.routingProfiles\" ng-model=\"route.selectedRoutingProfile\"\r\n      ng-change=\"$ctrl.changeProfile(route)\" ng-disabled=\"route.isChangingProfile\">\r\n      </select>\r\n    </span>\r\n      <!-- profile info tooltip: for debug -->\r\n      <span class=\"hidden\" ng-if=\"route.selectedRoutingProfile\">\r\n          <span class=\"ico ico-more-vertical\" tooltip-placement=\"top-left\"\r\n          uib-tooltip=\"Vehicle Type: {{vehicleTypeName()}}, Profile Source: {{sourceName()}}\" tooltip-append-to-body=\"true\"></span>\r\n      </span>\r\n  </div>\r\n  <div ng-if=\"showLabel()\">\r\n    <!-- if there is only one routing profile -->\r\n    <label class=\"header\" ng-class=\"{'ico-info-color': route.routingProfileError}\"> {{ \"views.compliance.routingProfile\" | translate }}:</label>\r\n    <span ng-if=\"$ctrl.noRoutingProfiles(route)\"> No Routing Profiles exist <i class=\"ico ico-info-circle ico-info-color\"></i></span>\r\n    <span ng-if=\"route.selectedRoutingProfile\">{{route.selectedRoutingProfile.name}}</span>\r\n    <!-- profile info tooltip: for debug -->\r\n    <span class=\"hidden\" ng-if=\"route.selectedRoutingProfile\">\r\n        <span class=\"ico ico-more-vertical\" tooltip-placement=\"top-left\"\r\n        uib-tooltip=\"Vehicle Type: {{vehicleTypeName()}}, Profile Source: {{sourceName()}}\" tooltip-append-to-body=\"true\"></span>\r\n    </span>\r\n  </div>\r\n";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getIterator2 = __webpack_require__(328);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _moment = __webpack_require__(113);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("reportsData", {
	    template: __webpack_require__(349),
	    controller: reportsDataController
	  });
	
	  reportsDataController.$inject = ["$scope", "$location", "LayoutService", "complianceService", "$stateParams", "$state", "$translate", "papaparse", "filesaver", "moment", "$window", "cacheService", "timeService", "UserProvider"];
	
	  function reportsDataController($scope, $location, LayoutService, complianceService, $stateParams, $state, $translate, papaparse, filesaver, moment, $window, cacheService, timeService, UserProvider) {
	    var vm = this;
	    vm.settings = $stateParams.settings;
	
	    //Refreshed page in reports data state: fetch the search settings from cache
	    if ((!vm.settings || _.isEmpty(vm.settings)) && $state.is("reports.groups.group.data")) {
	      vm.settings = cacheService.getSearchSettings();
	      if (!vm.settings) vm.settings = {};
	    }
	
	    vm.$onInit = init;
	    vm.nextCompliancePage = nextCompliancePage;
	    vm.previousCompliancePage = previousCompliancePage;
	    vm.downloadReportCSV = downloadReportCSV;
	    vm.printReport = printReport;
	    vm.getDateRange = getDateRange;
	    vm.hideQuestionable = vm.settings ? vm.settings.noQuestionableRoutes : "true"; //user's selection
	    vm.getDisplayAddress = getDisplayAddress;
	    vm.getDisplayTimeDiff = getDisplayTimeDiff;
	    vm.onFilterChanged = onFilterChanged;
	
	    function init() {
	      vm.selectedRouteId = 0;
	      //route color properties
	      vm.routeColors = ["#00ff06", "#027ffb", "#a55fff", "#2448ff", "#fc5800", "#02d4cf", "#ce4871", "#fe9300"];
	      vm.currentColor = 0;
	      //pagination properties
	      vm.firstItemNum = 1;
	      vm.lastItemNum = 10;
	      vm.totalRoutesNum = 10000;
	      vm.currentPageNum = 1;
	      //vm.oorCost = 1;
	      vm.totalPagesNum = 1;
	      vm.routeList = [];
	      vm.isLoading = false;
	
	      vm.filterby = cacheService.getCache().complianceReportFilters;
	      if (cacheService.getCache().gridSortType) {
	        vm.sortType = cacheService.getCache().gridSortType;
	        vm.sortReverse = cacheService.getCache().gridSortReverse;
	      }
	
	      //Refreshed page in reports data state: re-view the group data
	      if ($state.is("reports.groups.group.data")) {
	        viewSelectedVehicles();
	      }
	
	      $scope.$watch(function () {
	        return vm.settings;
	      }, function () {
	        var pageNumber = $location.search().pageNumber;
	        if (_isNumber(pageNumber)) {
	          pageNumber = parseInt(pageNumber);
	
	          vm.currentPageNum = pageNumber;
	        } else {
	          vm.currentPageNum = 1;
	        }
	        viewSelectedVehicles(); //comment this
	      });
	    }
	
	    function previousCompliancePage() {
	      vm.currentPageNum--;
	      vm.routeList = [];
	      viewSelectedVehicles();
	    }
	
	    function nextCompliancePage() {
	      vm.currentPageNum++;
	      vm.routeList = [];
	      viewSelectedVehicles();
	    }
	
	    function leftPanelWidth() {
	      return LayoutService.getLeftPanelWidth();
	    }
	
	    // todo: put into common file
	    function _isNumber(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	    function downloadReportCSV() {
	      var csvArray = getCSVArray();
	      var exportString = papaparse.unparse(csvArray, {
	        delimiter: ",",
	        header: false
	      });
	
	      try {
	        var isFileSaverSupported = !!new Blob();
	      } catch (e) {
	        console.error("File download API not supported in this browser");
	        return;
	      }
	      var file = new Blob([exportString], {
	        type: "text/plain;charset=utf-8"
	      });
	      filesaver.saveAs(file, "compliance-reports_" + moment().format("YYYYMMDD") + ".csv");
	    }
	
	    function printReport() {
	
	      //Move the print section to body because a scrollable div that is to be printed must be on top-level body to be printed on multiple pages
	      var element = $("#section-to-print").detach();
	      $("body").append(element);
	
	      //Make the print section visible
	      $("#section-to-print").show();
	
	      //Set the print date on the report
	      $("#print-date").html(getDateRange());
	
	      //Generate the print report table in the div
	      var csvArray = getCSVArray();
	      var tableStr = "";
	      for (var i = 0; i < csvArray.length; i++) {
	        var tdEl = "td";
	        if (i === 0) {
	          tdEl = "th";
	        }
	        tableStr += "<tr>";
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(csvArray[i]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var val = _step.value;
	
	            tableStr += "<" + tdEl + ">";
	            tableStr += val;
	            tableStr += "</" + tdEl + ">";
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        tableStr += "</tr>";
	      }
	      $("#print-table").html(tableStr);
	
	      //Actually call the browser print function
	      $window.print();
	
	      //Once that is done, re-hide the print div
	      $("#section-to-print").hide();
	    }
	
	    function getDateRange() {
	      if (!vm.settings || !vm.settings.startDate || !vm.settings.endDate) {
	        return "";
	      }
	      return moment(vm.settings.startDate).format("MM/DD/YYYY") + " - " + moment(vm.settings.endDate).format("MM/DD/YYYY");
	    }
	
	    function getCSVArray() {
	      var csvArray = [];
	      var headerRow = [];
	      headerRow.push($translate.instant("views.reports.TripID"));
	      headerRow.push($translate.instant("views.reports.DriverLabel"));
	      headerRow.push($translate.instant("views.reports.DriverID"));
	      headerRow.push($translate.instant("views.reports.VehicleLabel"));
	      headerRow.push($translate.instant("views.reports.VehicleID"));
	      headerRow.push($translate.instant("views.reports.routeSource"));
	      headerRow.push($translate.instant("views.compliance.routingProfile"));
	      headerRow.push($translate.instant("views.reports.cancelled"));
	      headerRow.push($translate.instant("views.reports.plannedDistance"));
	      headerRow.push($translate.instant("views.reports.actualDistance"));
	      headerRow.push($translate.instant("views.reports.distanceDifference"));
	      headerRow.push($translate.instant("views.reports.plannedTime"));
	      headerRow.push($translate.instant("views.reports.actualTime"));
	      headerRow.push($translate.instant("views.reports.timeDifference"));
	      headerRow.push($translate.instant("views.compliance.isOor"));
	      headerRow.push($translate.instant("views.reports.oorDistance"));
	      headerRow.push($translate.instant("views.reports.originAddress"));
	      headerRow.push($translate.instant("views.reports.startTime"));
	      headerRow.push($translate.instant("views.reports.destinationAddress"));
	      headerRow.push($translate.instant("views.reports.destinationTime"));
	      headerRow.push($translate.instant("views.reports.stops"));
	      headerRow.push($translate.instant("views.reports.unpredictable"));
	      csvArray.push(headerRow);
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(vm.routeList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var route = _step2.value;
	
	          var row = [];
	          row.push(route.tripId);
	          row.push(route.driverName);
	          row.push(route.driverId);
	          row.push(route.vehicleName);
	          row.push(route.vehicleId);
	          row.push(route.routeSource);
	          row.push(route.routeProfile);
	          row.push(route.isCancelled);
	          row.push(route.distancePlanned);
	          row.push(route.distanceActual > 0 ? route.distanceActual : "");
	          row.push(route.distanceActual > 0 ? route.distanceDifference : "");
	          row.push(route.distanceActual > 0 ? route.timePlanned : "");
	          row.push(route.distanceActual > 0 ? route.timeActual : "");
	          row.push(getDisplayTimeDiff(route));
	          row.push(route.isOor);
	          row.push(route.oorDistance > 0 ? route.oorDistance : 0);
	          row.push(getDisplayAddress(route.originAddress));
	          row.push(route.originTime);
	          row.push(getDisplayAddress(route.destinationAddress));
	          row.push(route.destinationTime);
	          row.push(route.stopCount);
	          row.push(route.questionable);
	
	          //For each row: if it is null or undefined, replace it with the empty string, to prevent null or undefined from showing in CSV/print report
	          for (var i = 0; i < row.length; i++) {
	            if (row[i] === null || row[i] === undefined) {
	              row[i] = "";
	            }
	          }
	
	          csvArray.push(row);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return csvArray;
	    }
	
	    function getDisplayTimeDiff(route) {
	      if (route.distanceActual <= 0 || !route.timePlanned || !route.timeActual) {
	        return "--";
	      }
	      var timeDiff = route.timeDifference;
	      if (timeDiff.length > 0 && timeDiff[0] !== "-" && timeDiff !== "0:00") {
	        timeDiff = "+" + timeDiff;
	      }
	      return timeDiff;
	    }
	
	    function getDisplayAddress(address) {
	      if (!address) {
	        return "";
	      }
	      var displayAddress = address;
	      displayAddress = displayAddress.replace(/,/g, ", ");
	      displayAddress = displayAddress.replace(/,  /g, ", ");
	      return displayAddress;
	    }
	
	    function onFilterChanged() {
	      cacheService.getCache().gridSortType = vm.sortType;
	      cacheService.getCache().gridSortReverse = vm.sortReverse;
	      cacheService.saveCache();
	    }
	
	    /**
	     * Uses the current set filter parameters to query the compliance service to return a list of all compliance routes.
	     *
	     * @returns a Promise object representing the completion of querying the service and setting the returned routes on the model.
	     */
	    function viewSelectedVehicles() {
	
	      if (vm.isLoading) {
	        return;
	      }
	      vm.isLoading = true;
	
	      if (vm.settings == null) {
	        vm.routeList = [];
	        return;
	      }
	
	      var user = JSON.parse(window.sessionStorage["userAuthInfo"]);
	
	      var accountId = user.accountId;
	      var currentUser = UserProvider.getUser();
	      if (currentUser.supportAccount) {
	        accountId = currentUser.supportAccount.accountId;
	      }
	
	      var p = {
	        "accountId": accountId,
	        "pageNumber": vm.currentPageNum,
	        //"pageSize":  vm.totalRoutesNum,
	        "noCoords": false,
	        "oorCost": 0.0,
	        "sort": "VehicleName",
	        "order": "asc",
	        "isOor": false,
	        "hideCoords": true
	      };
	
	      var allParams = angular.merge({}, p, vm.settings);
	
	      //console.log("querying for compliance data with ", allParams);
	
	      return complianceService.getComplianceData(allParams).then(function (resp) {
	        if (resp.results) {
	          vm.totalRoutesNum = resp.results.totalRoutes;
	          vm.totalPagesNum = resp.results.totalPages;
	
	          vm.firstItemNum = 1;
	          vm.lastItemNum = vm.totalRoutesNum;
	
	          vm.routeList = resp.results.routes.map(function (route) {
	            return _mapRoute(route);
	          });
	        }
	      }, function (err) {
	        // todo: show user some type of notification of the error
	        console.log("error!", err);
	      }).finally(function () {
	        vm.isLoading = false;
	      });
	    }
	
	    /**
	     * Converts a route returned from the compliance data to a format usable for this component.
	     *
	     * @param {any} route
	     * @returns
	     */
	    //function(){}
	    //  TODO: clean this up
	    function _mapRoute(route) {
	      var r = {};
	      var stops = {};
	      r.tripId = route.tripId;
	      r.routeColor = vm.routeColors[vm.currentColor];
	      r.routeColorClass = "routeColor" + vm.currentColor;
	
	      vm.currentColor++;
	      if (vm.currentColor >= 8) {
	        vm.currentColor = 0;
	      }
	
	      r.driverName = route.driverName;
	      r.vehicleName = route.vehicleName;
	      r.driverId = route.prescribedRoute.driverId;
	      r.vehicleId = route.deviceId;
	      r.showStops = false;
	      r.isCancelled = route.effectedRoute.canceled === true ? "Yes" : "No";
	      r.cancelledFilter = !route.effectedRoute.canceled;
	      r.questionable = route.effectedRoute.questionable === true ? "Yes" : "No";
	      r.isCompleted = route.effectedRoute.distance > 0 ? true : false;
	      r.routeSource = route.prescribedRoute.routeSource.toUpperCase();
	      if (r.routeSource !== "MANUAL" && r.routeSource !== "INTEGRATION" && r.routeSource !== "ROUTESYNC") {
	        if (r.routeSource === "DISPATCH") {
	          r.routeSource = "INTEGRATION";
	        } else {
	          r.routeSourceOther = "unknown";
	        }
	      }
	      r.routeProfile = route.prescribedRoute.routingProfileName || "--";
	
	      if (route.prescribedRoute.tripStops.length > 0) {
	        r.originStopName = route.prescribedRoute.tripStops[0].stopName !== "GPS Location" ? route.prescribedRoute.tripStops[0].stopName : "";
	        r.originStreet = route.prescribedRoute.tripStops[0].street;
	        r.originStreet = r.originStreet ? r.originStreet + ", " : "";
	        r.originCity = route.prescribedRoute.tripStops[0].city;
	        r.originState = route.prescribedRoute.tripStops[0].state;
	        r.originZip = route.prescribedRoute.tripStops[0].zip;
	        r.originAddress = r.originStopName + " " + r.originStreet + r.originCity + "," + r.originState + "," + r.originZip;
	        r.originOffset = route.effectedRoute.routeStartUtcOffset;
	        r.originTime = timeService.getFormattedTime2(route.effectedRoute.routeStart, route.effectedRoute.routeStartUtcOffset);
	        if (route.effectedRoute.routeStartUtcOffset) {
	          r.originTimeStamp = route.effectedRoute.routeStart;
	        }
	        r.originLonLat = new ALKMaps.LonLat(route.prescribedRoute.tripStops[0].longitude, route.prescribedRoute.tripStops[0].latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	        r.destinationStopName = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].stopName !== "GPS Location" ? route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].stopName : "";
	        r.destinationStreet = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].street;
	        r.destinationStreet = r.destinationStreet ? r.destinationStreet + ", " : "";
	        r.destinationCity = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].city;
	        r.destinationState = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].state;
	        r.destinationZip = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].zip;
	        r.destinationAddress = r.destinationStopName + " " + r.destinationStreet + " " + r.destinationCity + "," + r.destinationState + "," + r.destinationZip;
	        r.destinationOffset = route.effectedRoute.routeEndUtcOffset;
	        r.destinationTime = timeService.getFormattedTime2(route.effectedRoute.routeEnd, route.effectedRoute.routeEndUtcOffset);
	        if (route.effectedRoute.routeEndUtcOffset) {
	          r.destinationTimeStamp = route.effectedRoute.routeEnd;
	        }
	        r.destinationLonLat = new ALKMaps.LonLat(route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].longitude, route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	        //route.prescribedRoute.tripStops[1] = stop1; route.prescribedRoute.tripStops[2] = stop2; route.prescribedRoute.tripStops[3] = stop3; length of stops not known
	        if (route.prescribedRoute.tripStops.length > 2) {
	          for (var i = 1; i < route.prescribedRoute.tripStops.length - 1; i++) {
	            stops[i] = [];
	            stops[i].stopNumber = i;
	            stops[i].stopName = route.prescribedRoute.tripStops[i].stopName !== "GPS Location" ? route.prescribedRoute.tripStops[i].stopName : "";
	            stops[i].stopStreet = route.prescribedRoute.tripStops[i].street;
	            stops[i].stopStreet = stops[i].stopStreet ? stops[i].stopStreet + ", " : "";
	            stops[i].stopCity = route.prescribedRoute.tripStops[i].city;
	            stops[i].stopState = route.prescribedRoute.tripStops[i].state;
	            stops[i].stopZip = route.prescribedRoute.tripStops[i].zip;
	            stops[i].stoplonLat = new ALKMaps.LonLat(route.prescribedRoute.tripStops[i].longitude, route.prescribedRoute.tripStops[i].latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	          }
	          r.stops = stops;
	        }
	        r.stopCount = route.prescribedRoute.tripStops.length - 2;
	      } else {
	        console.log("no trips stops! todo: log error. ", route);
	      }
	
	      r.distancePlanned = route.prescribedRoute.distance;
	      r.distanceActual = route.effectedRoute.distance;
	      r.distanceDifference = route.distanceDelta;
	
	      r.timePlanned = moment.duration(route.prescribedRoute.time / 1000, "hours").format("h:mm", {
	        trim: false
	      });
	      r.timeActual = moment.duration(route.effectedRoute.time / 1000, "hours").format("h:mm", {
	        trim: false
	      });
	      r.timeDifference = moment.duration(route.timeDelta / 1000, "hours").format("h:mm", {
	        trim: false
	      });
	      r.isDelayed = r.timePlanned < r.timeActual ? true : false;
	      r.oorDistance = route.oorDistance;
	      r.isOor = route.outOfRouteEvents.events.length > 0 ? route.outOfRouteEvents.events.length : "None";
	      r.noEvents = r.isOor !== "None" ? true : false;
	      r.stopList = _.map(route.prescribedRoute.tripStops, function (stop) {
	        return new ALKMaps.LonLat(stop.longitude, stop.latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	      });
	
	      r.plannedRoutePoints = [];
	      if (route.prescribedRoute.coords.length > 0) {
	        r.plannedRoutePoints = _.map(route.prescribedRoute.coords, function (p) {
	          return new ALKMaps.Geometry.Point(p[0], p[1]).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	        });
	      }
	
	      r.actualRoutePoints = [];
	      if (route.effectedRoute.coords.length > 0) {
	        r.actualRoutePoints = _.map(route.effectedRoute.coords, function (p) {
	          return new ALKMaps.Geometry.Point(p[0], p[1]).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
	        });
	      }
	
	      r.outOfRouteEvents = [];
	      if (route.outOfRouteEvents.events.length > 0) {
	        r.outOfRouteEvents = _.map(route.outOfRouteEvents.events, function (e) {
	          return {
	            type: e.type,
	            lonlat: new ALKMaps.LonLat(e.lon, e.lat).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913")),
	            point: new ALKMaps.Geometry.Point(e.lon, e.lat).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913")),
	            distanceOOR: e.distanceOOR,
	            timeStamp: e.timeStamp,
	            timeStampUtcOffset: e.timeStampUtcOffset
	          };
	        });
	      }
	      return r;
	    }
	  }
	})(window.angular);

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"report-section\">\r\n  <div class=\"panel panel-fixed\">\r\n    <div class=\"panel-heading\">\r\n      <h4>Compliance Reports</h4>\r\n    </div>\r\n    <div class=\"panel-body v-flex-container\">\r\n      <form>\r\n        <div class=\"form-inline filter-group row\">\r\n          <div class=\"col-xs-12 col-sm-12 col-md-3 input-group\">\r\n            <span class=\"input-group-btn\">\r\n                <span class=\"btn btn-sm btn-fake-addon\">\r\n                <i class=\"ico ico-filter\"></i>\r\n                </span>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"Filter By Vehicle Name (eg: v1ae)\" ng-model=\"$ctrl.filterby.vehicleName\"\r\n              ng-change=\"$ctrl.onFilterChanged()\">\r\n            <span class=\"input-group-btn\">\r\n                <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"$ctrl.filterby.vehicleName = ''; $ctrl.onFilterChanged();\">&times;</button>\r\n              </span>\r\n          </div>\r\n          <div class=\"col-xs-12 col-sm-12 col-md-3 input-group\">\r\n            <span class=\"input-group-btn\">\r\n                <span class=\"btn btn-sm btn-fake-addon\">\r\n                <i class=\"ico ico-filter\"></i>\r\n                </span>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"Filter By Route Source (eg: Manual, Int, RouteSource, other)\" ng-model=\"$ctrl.filterby.routeSource\"\r\n              ng-change=\"$ctrl.onFilterChanged()\">\r\n            <span class=\"input-group-btn\">\r\n                <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"$ctrl.filterby.routeSource = ''; $ctrl.onFilterChanged();\">&times;</button>\r\n              </span>\r\n          </div>\r\n          <div class=\"col-xs-12 col-sm-12 col-md-3 input-group\">\r\n            <span class=\"input-group-btn\">\r\n                <span class=\"btn btn-sm btn-fake-addon\">\r\n                <i class=\"ico ico-filter\"></i>\r\n                </span>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"Filter By Route Profile (eg: Name)\" ng-model=\"$ctrl.filterby.routeProfile\"\r\n              ng-change=\"$ctrl.onFilterChanged()\">\r\n            <span class=\"input-group-btn\">\r\n                <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"$ctrl.filterby.routeProfile = ''; $ctrl.onFilterChanged();\">&times;</button>\r\n              </span>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-inline filter-group row\">\r\n          <div class=\"col-xs-3 col-sm-3 col-md-3 checkbox\">\r\n            <label>\r\n                <input type=\"checkbox\" class=\"form-control\" ng-false-value=\"\" ng-true-value= \"true\" ng-model=\"$ctrl.filterby.noEvents\" ng-change=\"$ctrl.onFilterChanged()\"> <span translate=\"views.compliance.HideNoOORRoutes\"></span>\r\n              </label>\r\n          </div>\r\n          <div class=\"col-xs-3 col-sm-3 col-md-3 checkbox\">\r\n            <label>\r\n                <input type=\"checkbox\" class=\"form-control\" ng-true-value=\"true\" ng-false-value=\"\" ng-model=\"$ctrl.filterby.isCompleted\" ng-change=\"$ctrl.onFilterChanged()\"> <span translate=\"views.reports.showCompleted\"></span>\r\n              </label>\r\n          </div>\r\n          <div class=\"col-xs-3 col-sm-3 col-md-3 checkbox\">\r\n            <label>\r\n                <input type=\"checkbox\" class=\"form-control\" ng-false-value=\"\" ng-true-value=\"true\"  ng-model=\"$ctrl.filterby.cancelledFilter\" ng-change=\"$ctrl.onFilterChanged()\"> <span translate=\"views.reports.hideCancelled\"></span>\r\n              </label>\r\n          </div>\r\n        </div>\r\n      </form>\r\n      <div class=\"report-data\">\r\n        <table class=\"table table-striped table-hover\">\r\n          <thead>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'tripId'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.TripID\">\r\n              </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n                  <a href=\"#\" ng-click=\"$ctrl.sortType = 'vehicleId'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                      <label translate=\"views.reports.VehicleID\">\r\n                  </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'vehicleName'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.VehicleLabel\">\r\n              </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n                <a href=\"#\" ng-click=\"$ctrl.sortType = 'driverId'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                    <label translate=\"views.reports.DriverID\">\r\n                </label></a>\r\n              </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'driverName'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.DriverLabel\">\r\n              </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'routeSource'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label  translate=\"views.reports.routeSource\">\r\n              </label></a>\r\n            </th>\r\n            <!--<th colspan=\"1\">\r\n                <a href=\"#\" ng-click=\"$ctrl.sortType = 'routeProfile'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label  translate=\"views.compliance.routingProfile\">\r\n              </label></a>\r\n              </th>-->\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'isCancelled'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.cancelled\">\r\n              </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'distancePlanned'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.plannedDistance\">\r\n               </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'distanceActual'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.actualDistance\">\r\n                </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'distanceDifference'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.distanceDifference\">\r\n                 </label></a>\r\n            </th>\r\n\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'timePlanned'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.plannedTime\">\r\n                 </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'timeActual'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.actualTime\">\r\n                 </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'timeDifference'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.timeDifference\">\r\n                  </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'isOor'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.compliance.isOor\">\r\n                 </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'oorDistance'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.oorDistance\">\r\n                 </label></a>\r\n            </th>\r\n            <th colspan=\"3\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'originAddress'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.originAddress\">\r\n                 </label></a>\r\n            </th>\r\n            <th colspan=\"2\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'originTimeStamp'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.startTime\">\r\n                </label></a>\r\n            </th>\r\n            <th colspan=\"3\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'destinationAddress'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.destinationAddress\">\r\n               </label></a>\r\n            </th>\r\n            <th colspan=\"2\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'destinationTimeStamp'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.destinationTime\">\r\n                 </label></a>\r\n            </th>\r\n            <th colspan=\"1\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'stopCount'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label translate=\"views.reports.stops\">\r\n                </label></a>\r\n            </th>\r\n            <th colspan=\"1\" ng-if=\"$ctrl.hideQuestionable === false\" title=\"Unpredictable Data\">\r\n              <a href=\"#\" ng-click=\"$ctrl.sortType = 'questionable'; $ctrl.sortReverse = !$ctrl.sortReverse; $ctrl.onFilterChanged();\">\r\n                  <label class=\"text-ellipsis\" translate=\"views.reports.unpredictable\">\r\n                </label></a>\r\n            </th>\r\n          </thead>\r\n          <tbody>\r\n            <tr ng-show=\"'reports.groups.group.data' | isState\">\r\n              <td ng-if=\"$ctrl.isLoading\" ng-cloak class=\"loading ng-cloak\">\r\n                <span class=\"ico ico-circle-notch ico-spin\"></span>\r\n                <span translate=\"common.Loading\"></span>...\r\n              </td>\r\n            </tr>\r\n            <tr ng-if=\"(($ctrl.routeList.length === 0) && (!$ctrl.isLoading))\" ng-class=\"{selected: (route.tripId === $ctrl.selectedRouteId)}\">\r\n              <td colspan=\"25\" class=\"loading\">\r\n                <span translate=\"views.compliance.NoRoutes\" style=\"font-size:12px\"></span>\r\n              </td>\r\n            </tr>\r\n            <tr ng-repeat=\"route in $ctrl.routeList  | orderBy:$ctrl.sortType:$ctrl.sortReverse  | filter: $ctrl.filterby\" class=\"route-row-header\"\r\n              ng-click=\"$ctrl.selectRoute(route.tripId)\" ng-class=\"{selected: (route.tripId === $ctrl.selectedRouteId)}\">\r\n              <td colspan=\"1\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\"{{route.tripId}} \" tooltip-class=\"{{route.tripId}} \">\r\n                <!--<a href=\"/compliance?tripId={{route.tripId}}\" target=\"_blank\"> </a> --><span class=\"route-pad-value\">{{route.tripId}}</span> </td>\r\n              <td colspan=\"1\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\"{{route.vehicleId}} \" tooltip-class=\"{{route.vehicleId}} \">\r\n                <!--<a href=\"/compliance?tripId={{route.tripId}}\" target=\"_blank\"> </a> --><span class=\"route-pad-value\">{{route.vehicleId}}</span> </td>\r\n              <td colspan=\"1\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\"{{route.vehicleName}} \" tooltip-class=\"{{route.vehicleName}} \">\r\n                <!--<a href=\"/compliance?tripId={{route.tripId}}\" target=\"_blank\"> </a> --><span class=\"route-pad-value\">{{route.vehicleName}}</span> </td>\r\n                <td colspan=\"1\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\"{{route.driverId}} \" tooltip-class=\"{{route.driverId}} \">\r\n                  <span class=\"route-pad-value\">{{route.driverId}}</span> </td>\r\n              \r\n                <td colspan=\"1\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\"{{route.driverName}}\" tooltip-class=\"{{route.driverName}}\">\r\n                  <span class=\"route-pad-value\">{{route.driverName}}</span></td>\r\n              <td colspan=\"1\" tooltip-placement=\"top\" title=\"{{route.routeSource}} \">\r\n                <span ng-if=\"route.routeSource === 'MANUAL'\" class=\"route-source manual\">MAN</span>\r\n                <span ng-if=\"route.routeSource === 'INTEGRATION'\" class=\"route-source int\">INT</span>\r\n                <span ng-if=\"route.routeSource === 'ROUTESYNC'\" class=\"route-source routesync\">RS</span>\r\n                <span ng-if=\"route.routeSourceOther === 'unknown'\" class=\"route-source other\">?</span>\r\n              </td>\r\n              <!--<td colspan=\"1\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\"{{route.routeProfile}} \" tooltip-class=\"{{route.routeProfile}} \">\r\n                  <span class=\"route-pad-value\">{{route.routeProfile}}</span> </td>-->\r\n              <td colspan=\"1\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\"{{route.isCancelled}}\" tooltip-class=\"{{route.isCancelled}}\"><span ng-hide=\"1\"> {{route.cancelledFilter}} </span> {{route.isCancelled}} </td>\r\n              <td colspan=\"1\"> <span class=\"route-pad-value\"> {{route.distancePlanned}}     </span> </td>\r\n              <td colspan=\"1\"><span ng-if=\"route.distanceActual>0\" class=\"route-pad-value\">{{route.distanceActual}}</span> </td>\r\n              <td colspan=\"1\"> <span ng-if=\"route.distanceActual>0\" class=\"route-pad-value\">{{route.distanceDifference}}</span> </td>\r\n              <td colspan=\"1\"><span ng-if=\"route.distanceActual>0\" class=\"route-pad-value\">{{route.timePlanned}}</span></td>\r\n              <td colspan=\"1\"><span ng-if=\"route.distanceActual>0\" class=\"route-pad-value\">{{route.timeActual}}</span> </td>\r\n              <td colspan=\"1\"> <span class=\"route-pad-value\">{{ $ctrl.getDisplayTimeDiff(route) }}</span> </td>\r\n              <td colspan=\"1\"> <span ng-class=\"{'oor-events':route.isOor!= 'None'}\" class=\"route-pad-value\">{{route.isOor}}\r\n\r\n                   <span ng-hide=\"1\">{{route.noEvents}}</span></span>\r\n              </td>\r\n              <td colspan=\"1\"> <span class=\"route-pad-value\">{{route.oorDistance>0?route.oorDistance:0}} </span> </td>\r\n              <td colspan=\"3\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\" {{route.originAddress}}\" tooltip-class=\"origin-tooltip\">\r\n                {{ $ctrl.getDisplayAddress(route.originAddress) }}</td>\r\n              <td colspan=\"2\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\"{{route.originTime}}\">{{route.originTime}}</td>\r\n              <td colspan=\"3\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\" {{route.destinationAddress}} \" tooltip-class=\"destination-tooltip\">\r\n                {{ $ctrl.getDisplayAddress(route.destinationAddress) }} </td>\r\n              <td colspan=\"2\" class=\"text-ellipsis\" tooltip-placement=\"top\" title=\"{{route.destinationTime}}\"> {{route.destinationTime}} </td>\r\n              <td colspan=\"1\">{{route.stopCount}}</td>\r\n              <td colspan=\"1\" ng-if=\"$ctrl.hideQuestionable === false\">\r\n                <span ng-hide=\"1\">{{route.questionable}}</span>\r\n                <span tooltip-placement=\"top\" title=\"Unpredictable Data\" tooltip-class=\"unpredictable\">{{route.questionable}}</span>\r\n              </td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n        <div>\r\n        </div>\r\n      </div>\r\n      <div class=\"footer clearfix\" ng-if=\"$ctrl.routeList.length!=0\">\r\n        <div class=\"pagination-description\" ng-show=\"'reports.groups.group.data' | isState\">\r\n          <span translate=\"views.reports.Displaying\" translate-values=\"{ total: ($ctrl.routeList | filter: $ctrl.filterby).length  }\"> </span>\r\n        </div>\r\n        <div>\r\n          <!--<button ng-click=\"$ctrl.gotoMap()\" class=\"btn btn-success btn-xs\"> generate map</button>-->\r\n          <button id=\"downloadReportCSV\" ng-click=\"$ctrl.downloadReportCSV()\" class=\"btn btn-primary btn-xs\">{{ \"views.reports.csv\" | translate }}</button>\r\n          <button id=\"printReport\" ng-click=\"$ctrl.printReport()\" class=\"btn btn-primary btn-xs\">{{ \"views.reports.print\" | translate }}</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n</div>\r\n\r\n<!--This div will be printed for compliance reports (table is generated from CSV data in code)-->\r\n<div id=\"section-to-print\">\r\n  <img id=\"print-img\" src=\"/img/CoPilotRouteReporter_Logo.svg\" width=\"136px\" height=\"40\" />\r\n  <h2 id=\"print-title\">{{ \"views.reports.complianceReport\" | translate }}</h2>\r\n  <h4 id=\"print-date\"></h4>\r\n  <hr id=\"print-divider\">\r\n  <table id=\"print-table\"></table>\r\n</div>\r\n";

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(262);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(328);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _moment = __webpack_require__(113);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("dashboard", {
	    template: __webpack_require__(351),
	    controller: dashboardController
	  });
	
	  dashboardController.$inject = ["$scope", "$location", "$stateParams", "$state", "$q", "FleetViewDashboard", "GroupsService", "RouteReporterAPI"];
	
	  function dashboardController($scope, $location, $stateParams, $state, $q, FleetViewDashboard, GroupsService, RouteReporterAPI) {
	    var vm = this;
	
	    var ChartOptions = function ChartOptions() {
	      return {
	        backgroundColor: "#f5f5f5",
	        chartArea: {
	          right: 10,
	          left: 40,
	          top: 20,
	          bottom: 40
	        },
	        hAxis: {
	          titleTextStyle: {
	            bold: true,
	            italic: false
	          }
	        },
	        vAxis: {
	          gridlines: {
	            color: "#DDD"
	          }
	        },
	        titlePosition: "out",
	        legend: {
	          position: "none"
	        },
	        tooltip: {
	          isHtml: false
	        },
	        fontName: "Open Sans",
	        height: 200
	      };
	    };
	
	    vm.charts = [{
	      "title": "Compliance Routes Received (by week)",
	      "isLoading": false,
	      "noData": false,
	      "chart": null
	    }, {
	      "title": "Percent of OOR Miles (by Vehicle)",
	      "isLoading": false,
	      "noData": false,
	      "chart": null
	    }, {
	      "title": "Percent of Routes with OOR Events",
	      "isLoading": false,
	      "noData": false,
	      "chart": null
	    }, {
	      "title": "Ratio of OOR Miles (by week)",
	      "isLoading": false,
	      "noData": false,
	      "chart": null
	    }];
	
	    google.charts.load("current", {
	      packages: ["corechart"]
	    });
	    google.charts.setOnLoadCallback(init);
	
	    function init() {
	      console.log('init dashboard');
	
	      // Properties
	      vm.isLoading = true;
	      vm.selectedGroupType = "Vehicle";
	      vm.selectedGroup = null;
	
	      // pagination properties
	      vm.firstItemNum = 1;
	      vm.lastItemNum = 10;
	      vm.docsPerPage = 10;
	      vm.currentPageNum = 1;
	      vm.totalPagesNum = 1;
	      vm.download = download;
	      vm.getNextDocumentsPage = getNextDocumentsPage;
	      vm.getPreviousDocumentsPage = getPreviousDocumentsPage;
	
	      // stores the documents in the current page
	      vm.docsList = [];
	
	      _loadExportedDocuments();
	
	      // load vehicle and driver groups once and keep them in memory. This may need to be reworked depending on the user interaction.
	      $q.all([_loadDriverGroups(), _loadVehicleGroups()]).finally(function () {
	        vm.selectedGroup = vm.allItems[0];
	        vm.isLoading = false;
	        $scope.$watch(function () {
	          return vm.selectedGroupType;
	        }, function (newValue, oldValue) {
	          return _selectedGroupTypeChanged(newValue, oldValue);
	        });
	        $scope.$watch(function () {
	          return vm.selectedGroup;
	        }, function (newValue, oldValue) {
	          return loadChartData(newValue);
	        });
	      });
	    }
	
	    function loadChartData(group) {
	      _.each(vm.charts, function (c) {
	        c.isLoading = true;
	        c.noData = false;
	        if (c.chart !== null) c.chart.clearChart();
	      });
	      if (group) {
	        _loadOutOfRoutePercertange([group.groupId], vm.selectedGroupType);
	        _loadOutOfRoutRatioReport(8, [group.groupId], vm.selectedGroupType);
	        _loadOutOfRouteReport([group.groupId], vm.selectedGroupType);
	        _loadRoutesByWeek(6, [group.groupId], vm.selectedGroupType);
	        _loadSummary([group.groupId], vm.selectedGroupType);
	      } else {
	        _.each(vm.charts, function (c) {
	          c.isLoading = false;
	          c.noData = true;
	        });
	      }
	    }
	
	    function _loadExportedDocuments() {
	      RouteReporterAPI.get("api/ExportQueue", null).then(function (response) {
	        vm.exportedDocuments = _.map(response.data, function (data) {
	
	          // parse date of export (from this format 2021-02-16T12:14:43 to 20210216121443)
	          var separators = ['-', 'T', ':'];
	          var dateExported = data.dateExported.split(new RegExp(separators.join('|'), 'g')).join('');
	
	          return {
	            identifier: data.identifier,
	            displayName: "routereporterexport_" + dateExported,
	            dateExported: data.dateExported,
	            fileNames: data.fileNames,
	            downloaded: data.dateDownloaded ? true : false
	          };
	        });
	        _displayExportedDocuments();
	      }, function (error) {
	        console.log('error getting exported documents');
	      });
	    }
	
	    function _displayExportedDocuments() {
	      // sort newest to oldest export time
	      vm.exportedDocuments.sort(function (d1, d2) {
	        return d1.dateExported < d2.dateExported ? 1 : -1;
	      });
	
	      // find the total number of pages
	      vm.totalDocsNum = vm.exportedDocuments.length;
	      vm.totalPagesNum = Math.ceil(vm.totalDocsNum / vm.docsPerPage);
	
	      // get docs to display on first page
	      vm.docsList = [];
	      if (vm.totalDocsNum > vm.docsPerPage) {
	        vm.docsList = vm.exportedDocuments.slice(0, vm.docsPerPage);
	      } else {
	        vm.docsList = vm.exportedDocuments;
	        vm.lastItemNum = vm.totalDocsNum;
	      }
	    }
	
	    function getNextDocumentsPage() {
	      vm.currentPageNum++;
	      vm.docsList = [];
	
	      var start = (vm.currentPageNum - 1) * vm.docsPerPage;
	      var numRemainingDocs = vm.totalDocsNum - start;
	      vm.firstItemNum = start + 1;
	
	      if (numRemainingDocs > vm.docsPerPage) {
	        vm.docsList = vm.exportedDocuments.slice(start, start + vm.docsPerPage);
	        vm.lastItemNum = start + vm.docsPerPage;
	      } else {
	        vm.docsList = vm.exportedDocuments.slice(start, vm.totalDocsNum);
	        vm.lastItemNum = vm.totalDocsNum;
	      }
	    }
	
	    function getPreviousDocumentsPage() {
	      vm.currentPageNum--;
	      vm.docsList = [];
	
	      var start = (vm.currentPageNum - 1) * vm.docsPerPage;
	      vm.docsList = vm.exportedDocuments.slice(start, start + vm.docsPerPage);
	
	      vm.firstItemNum = start + 1;
	      vm.lastItemNum = start + vm.docsPerPage;
	    }
	
	    function download(doc) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var fileName = _step.value;
	
	          RouteReporterAPI.get("download/csv/" + fileName, null).then(function (response) {
	            var blob = new Blob([response.data], { type: 'octet/stream' });
	            var uri = window.URL.createObjectURL(blob);
	
	            // fileName format = {identifier}_{documentNumber}
	            var documentNumber = fileName.split('_').slice(-1).pop();
	            // save file as routereporterexport_{date/time}_{documentNumber}
	            var formattedFileName = doc.displayName + "_" + documentNumber;
	            saveFileAs(uri, formattedFileName);
	            return doc.identifier;
	          }).then(function (identifier) {
	            RouteReporterAPI.get("acknowledge/download/" + identifier, null);
	            if (doc.downloaded === false) {
	              doc.downloaded = true;
	            }
	          }).catch(function () {
	            return console.log('error downloading document');
	          });
	        };
	
	        for (var _iterator = (0, _getIterator3.default)(doc.fileNames), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	
	    function saveFileAs(uri, filename) {
	      var link = document.createElement('a');
	      if (typeof link.getAttribute('download') === 'string' || (0, _typeof3.default)(link.getAttribute('download')) === 'object') {
	        link.style.display = "none";
	        link.href = uri;
	        link.setAttribute('download', filename);
	
	        // Firefox requires the link to be in the body
	        document.body.appendChild(link);
	
	        // simulate click
	        link.click();
	
	        // remove the link when done
	        document.body.removeChild(link);
	
	        //release object url when done
	        window.URL.revokeObjectURL(uri);
	      } else {
	        window.open(uri);
	      }
	    }
	
	    function _loadDriverGroups() {
	      var forceRefresh = true;
	      return GroupsService.getDriverGroups(true).then(function (groups) {
	        vm.driverGroups = groups.map(function (c) {
	          return {
	            groupId: c.id,
	            groupName: c.name,
	            numItems: c.numberOfDrivers
	          };
	        });
	
	        // after loading driver groups, if this is what tab is currently selected, show the results
	        if (vm.selectedGroupType === "Driver") {
	          vm.allItems = vm.driverGroups;
	          vm.selectedGroup = vm.allItems[0];
	        }
	      });
	    }
	
	    function _loadVehicleGroups() {
	      var forceRefresh = true;
	      return GroupsService.getVehicleGroups(forceRefresh).then(function (groups) {
	        vm.vehicleGroups = groups.map(function (c) {
	          return {
	            groupId: c.id,
	            groupName: c.name,
	            numItems: c.numberOfVehicles
	          };
	        });
	
	        // after loading vehicle groups, if this is what tab is currently selected, show the results
	        if (vm.selectedGroupType === "Vehicle") {
	          vm.allItems = vm.vehicleGroups;
	          vm.selectedGroup = vm.allItems[0];
	        }
	      });
	    }
	
	    function _selectedGroupTypeChanged(newValue, oldValue) {
	      // whenever the tab between vehicle and driver groups changes, set those as the current groups
	      if (newValue === "Vehicle") {
	        vm.allItems = vm.vehicleGroups || [];
	        vm.selectedGroup = vm.allItems[0];
	      } else {
	        vm.allItems = vm.driverGroups || [];
	        vm.selectedGroup = vm.allItems[0];
	      }
	
	      vm.charts[1].title = "Percent of OOR Miles (by " + newValue + ")";
	
	      var element = document.getElementById("groupsList");
	      if (element) {
	        element.scrollTop = 0;
	      }
	    }
	
	    function _loadRoutesByWeek(weeks, groupIds, groupType) {
	      return FleetViewDashboard.getRoutesByWeek(weeks, groupIds, groupType).then(function (res) {
	        if (vm.charts[0].chart === null) vm.charts[0].chart = new google.visualization.ColumnChart(document.getElementById("chart-0"));
	        var chart = vm.charts[0].chart;
	        vm.charts[0].isLoading = false;
	        if (res.length > 1) {
	          var header = res[0];
	          header.push({
	            "role": "annotation"
	          });
	          var rows = _.map(res.slice(1), function (r) {
	            return [r[0], parseInt(r[1]), parseInt(r[1])];
	          });
	          rows.unshift(header);
	          var data = google.visualization.arrayToDataTable(rows);
	          // Set chart options
	          var options = new ChartOptions();
	          options.hAxis.slantedText = true;
	          chart.draw(data, options);
	        } else {
	          vm.charts[0].noData = true;
	        }
	      });
	    }
	
	    function _loadOutOfRouteReport(groupIds, groupType) {
	      return FleetViewDashboard.getOutOfRouteReport(groupIds, groupType).then(function (res) {
	        if (vm.charts[1].chart === null) vm.charts[1].chart = new google.visualization.BarChart(document.getElementById("chart-1"));
	        var chart = vm.charts[1].chart;
	        vm.charts[1].isLoading = false;
	        if (res.length > 1) {
	          var header = [res[0][0], res[0][3], {
	            "role": "annotation"
	          }, {
	            "type": "string",
	            "role": "tooltip",
	            "p": {
	              "html": true
	            }
	          }];
	          var rows = _.map(res.slice(1), function (r) {
	            var tooltip = "<div class=\"chart-tooltip\">" + "<strong>" + vm.selectedGroupType + " ID: </strong>" + r[0] + "<br/>" + "<strong>On-Route Miles: </strong>" + r[1] + "<br/>" + "<strong>OOR Miles: </strong>" + r[2] + "<br/>" + "<strong>OOR Percent: </strong>" + parseFloat(r[3]).toFixed(1) + "%</div>";
	            return [r[0], parseFloat(r[3]), parseFloat(r[3]).toFixed(1) + "%", tooltip];
	          });
	          rows.unshift(header);
	          var data = google.visualization.arrayToDataTable(rows);
	          // Set chart options
	          var options = new ChartOptions();
	          options.tooltip.isHtml = true;
	          options.chartArea.left = 70;
	          options.chartArea.right = 30;
	          options.colors = ["#ff9e21"];
	          options.chartArea.bottom = 20;
	          chart.draw(data, options);
	        } else {
	          vm.charts[1].noData = true;
	        }
	      });
	    }
	
	    function _loadOutOfRoutePercertange(groupIds, groupType) {
	      return FleetViewDashboard.getOutOfRoutePercertange(groupIds, groupType).then(function (res) {
	        if (vm.charts[2].chart === null) vm.charts[2].chart = new google.visualization.PieChart(document.getElementById("chart-2"));
	        var chart = vm.charts[2].chart;
	        vm.charts[2].isLoading = false;
	        var withOORVal = parseFloat(res[1][1]);
	        var withoutOORVal = parseFloat(res[2][1]);
	        if (res.length > 1 && withOORVal > 0 && withoutOORVal > 0) {
	          var header = res[0];
	
	          var rows = [[res[1][0], withOORVal], [res[2][0], withoutOORVal]];
	          rows.unshift(header);
	          var data = google.visualization.arrayToDataTable(rows);
	          // Set chart options
	          var options = new ChartOptions();
	          options.colors = ["#cf6c6c", "#49b54b"];
	          options.legend.position = "right";
	          options.chartArea.bottom = 10;
	          chart.draw(data, options);
	        } else {
	          vm.charts[2].noData = true;
	        }
	      });
	    }
	
	    function _loadOutOfRoutRatioReport(weeks, groupIds, groupType) {
	      return FleetViewDashboard.getOutOfRouteRatioReport(weeks, groupIds, groupType).then(function (res) {
	        vm.charts[3].chart = new google.visualization.SteppedAreaChart(document.getElementById("chart-3"));
	        var chart = vm.charts[3].chart;
	        vm.charts[3].isLoading = false;
	        if (res.length > 1) {
	          var header = [res[0][0], "OOR Miles", "On Route Miles"];
	          var rows = _.map(res.slice(1), function (r) {
	            return [r[0], parseFloat(r[2]), parseFloat(r[1])];
	          });
	          rows.unshift(header);
	          var data = google.visualization.arrayToDataTable(rows);
	          // Set chart options
	          var options = new ChartOptions();
	          options.hAxis.slantedText = true;
	          options.isStacked = "percent";
	          options.connectSteps = false;
	          options.colors = ["#cf6c6c", "#49b54b"];
	          chart.draw(data, options);
	        } else {
	          vm.charts[3].noData = true;
	        }
	      });
	    }
	
	    function _loadSummary(groupIds, groupType) {
	      return FleetViewDashboard.getSummary(groupIds, groupType).then(function (res) {
	        vm.fleetSummary = res.fleetStats;
	      });
	    }
	  }
	})(window.angular);

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n  <alk-main-nav></alk-main-nav>\r\n  <div class=\"container with-nav dashboard-page\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-4\">\r\n        <div class=\"panel panel-default\">\r\n          <h3 class=\"fw-300\" translate=\"views.company.groups\"></h3>\r\n          <div class=\"form-group\">\r\n            <div class=\"btn-group\">\r\n              <label class=\"btn btn-default btn-sm\" ng-model=\"$ctrl.selectedGroupType\" uib-btn-radio=\"'Vehicle'\">\r\n                <span translate=\"common.Vehicles\"></span>\r\n              </label>\r\n              <label class=\"btn btn-default btn-sm\" ng-model=\"$ctrl.selectedGroupType\" uib-btn-radio=\"'Driver'\">\r\n                <span translate=\"common.Drivers\"></span>\r\n              </label>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <label translate=\"views.dashboard.SelectGroup\"></label>\r\n            <div class=\"text-center form-control-static\" ng-show=\"$ctrl.isLoading\">\r\n              <span class=\"ico ico-circle-notch ico-spin\"></span>\r\n              <span translate=\"common.Loading\"></span>...\r\n            </div>\r\n            <ui-select ng-model=\"$ctrl.selectedGroup\" theme=\"bootstrap\" ng-hide=\"$ctrl.isLoading\">\r\n              <ui-select-match placeholder=\"Select a group...\">{{$select.selected.groupName}}</ui-select-match>\r\n              <ui-select-choices position=\"down\" repeat=\"group in $ctrl.allItems | filter: $select.search\">\r\n                <div ng-bind-html=\"group.groupName | highlight: $select.search\"></div>\r\n              </ui-select-choices>\r\n            </ui-select>\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <label>Total {{$ctrl.selectedGroupType}}s</label>\r\n            <h4 ng-hide=\"$ctrl.isLoading\">{{$ctrl.fleetSummary.unitCount}}</h4>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-8\">\r\n        <div class=\"panel panel-default chart-panel\">\r\n          <h1 class=\"fw-300\" translate=\"views.dashboard.DataOverview\"></h1>\r\n          <div class=\"row\">\r\n            <div ng-repeat=\"chart in $ctrl.charts\" class=\"col-xs-6\">\r\n              <h5>{{chart.title}}</h5>\r\n              <div class=\"chart-area\">\r\n                <div class=\"chart-no-data ng-cloak\" ng-cloak ng-show=\"chart.noData && !chart.isLoading\"\r\n                  translate=\"views.dashboard.NoData\"></div>\r\n                <div class=\"chart-loading ng-cloak\" ng-cloak ng-show=\"chart.isLoading\"> <span\r\n                    class=\"ico ico-spin ico-circle-notch\"></span> <span translate=\"common.Loading\"></span>... </div>\r\n                <div id=\"chart-{{$index}}\"></div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- Table of Exported Documents -->\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12\">\r\n        <div class=\"panel panel-default\">\r\n          <h1 class=\"fw-300\" style=\"text-align: center\" translate=\"views.dashboard.ExportedDocuments\">\r\n          </h1>\r\n          <div class=\"panel-body\">\r\n            <div style=\"text-align:center\" translate=\"views.reports.NoDocuments\"\r\n              ng-show=\"$ctrl.exportedDocuments.length === 0\">\r\n            </div>\r\n            <table class=\"table table-striped table-hover\" ng-show=\"$ctrl.exportedDocuments.length > 0\">\r\n              <thead>\r\n                <th colspan=\"1\">\r\n                  <h5 style=\"font-weight:bold\" translate=\"views.reports.DocumentName\">\r\n                  </h5>\r\n                </th>\r\n                <th colspan=\"1\">\r\n                  <h5 style=\"font-weight:bold\" translate=\"views.reports.DocumentExportDate\">\r\n                  </h5>\r\n                </th>\r\n                <th colspan=\"1\">\r\n                  <h5 style=\"font-weight:bold\" translate=\"views.reports.TotalPages\">\r\n                  </h5>\r\n                </th>\r\n                <th colspan=\"1\">\r\n                  <h5 style=\"font-weight:bold\" translate=\"views.reports.Download\">\r\n                  </h5>\r\n                </th>\r\n                <th colspan=\"1\">\r\n                  <h5 style=\"font-weight:bold\" translate=\"views.reports.DownloadState\">\r\n                  </h5>\r\n                </th>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-repeat=\"doc in $ctrl.docsList\">\r\n                  <td>{{ doc.displayName }}</td>\r\n                  <td>{{ doc.dateExported }}</td>\r\n                  <td>{{ doc.fileNames.length }}</td>\r\n                  <td>\r\n                    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"($ctrl.download(doc))\">Download</button>\r\n                  </td>\r\n                  <td ng-model=\"doc.downloaded\">{{ doc.downloaded }}</td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n          <table class=\"table table-striped table-hover\" ng-show=\"$ctrl.exportedDocuments.length > 0\">\r\n            <thead>\r\n              <th colspan=\"1\">\r\n                <div class=\"footer clearfix\" ng-if=\"$ctrl.docsList.length>0\">\r\n                  <div class=\"pagination-description\">\r\n                    <span translate=\"common.Displaying\"\r\n                      translate-values=\"{ first: $ctrl.firstItemNum, last: $ctrl.lastItemNum, total: $ctrl.totalDocsNum }\"></span>\r\n                  </div>\r\n                </div>\r\n              </th>\r\n              <th colspan=\"1\">\r\n                <div class=\"footer clearfix\" ng-if=\"$ctrl.docsList.length>0\">\r\n                  <div class=\"pagination-buttons\">\r\n                    <button class=\"btn\" type=\"button\" ng-click=\"($ctrl.getPreviousDocumentsPage())\"\r\n                      ng-disabled=\"($ctrl.currentPageNum===1)\">\r\n                      <span class=\"glyphicon glyphicon-menu-left\"></span>\r\n                      <span translate=\"common.Previous\"></span>\r\n                    </button>\r\n                    <button class=\"btn\" type=\"button\" ng-click=\"($ctrl.getNextDocumentsPage())\"\r\n                      ng-disabled=\"($ctrl.currentPageNum===$ctrl.totalPagesNum)\">\r\n                      <span translate=\"common.Next\"></span>\r\n                      <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n              </th>\r\n            </thead>\r\n          </table>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <map-footer app=\"FleetView\"></map-footer>\r\n</div>";

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	
	  angular.module("fleetviewApp").filter("moment", [function () {
	    return function (date, method) {
	      var momented = moment(date);
	      return momented[method].apply(momented, Array.prototype.slice.call(arguments, 2));
	    };
	  }]);
	
	  angular.module("fleetviewApp").filter("momentParse", [function () {
	    return function (date, format) {
	      return moment(date, format);
	    };
	  }]);
	
	  angular.module("fleetviewApp").directive("showFocus", ['$timeout', function ($timeout) {
	    return function (scope, element, attrs) {
	      scope.$watch(attrs.showFocus, function (newValue) {
	        $timeout(function () {
	          newValue && element.focus();
	        });
	      }, true);
	    };
	  }]);
	
	  angular.module("fleetviewApp").directive('focusOn', ["$timeout", function ($timeout) {
	    return {
	      restrict: 'A',
	      link: function link($scope, $element, $attr) {
	        $scope.$watch($attr.focusOn, function (_focusVal) {
	          $timeout(function () {
	            _focusVal ? $element.focus() : $element.blur();
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module("fleetviewApp").directive('emptyToNull', function () {
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      link: function link(scope, elem, attrs, ctrl) {
	        ctrl.$parsers.push(function (viewValue) {
	          if (viewValue === "") {
	            return null;
	          }
	          return viewValue;
	        });
	      }
	    };
	  });
	})();

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	    var listSelectDirective = "listSelect";
	    var focusListDirective = "focusList";
	    angular.module("fleetviewApp").directive(listSelectDirective, ["$timeout", function ($timeout) {
	        return {
	            restrict: "A",
	            link: function link(scope, element, attrs) {
	                if (scope.$last) {
	                    $timeout(function () {
	                        element.parent().children().first().focus().addClass("selected");
	                    }, 1);
	                }
	                element.bind("keydown keypress", function (event) {
	                    if (event.which === 13) {
	                        scope.$apply(function () {
	                            scope.$eval(attrs.listSelectOnEnter);
	                        });
	                        event.preventDefault();
	                    }
	
	                    if (event.which === 38) {
	                        //up arrow
	                        element.removeClass("selected").siblings().removeClass("selected");
	                        if (element.is(element.parent().children().first())) {
	                            element.focus().addClass("selected");
	                        } else {
	                            element.prev().focus().addClass("selected");
	                        }
	
	                        if (attrs.listSelect !== "") {
	                            element.parent().children(".selected").click();
	                        }
	
	                        return false;
	                    }
	
	                    if (event.which === 40) {
	                        //down arrow
	                        element.removeClass("selected").siblings().removeClass("selected");
	                        if (element.is(element.parent().children().last())) {
	                            element.focus().addClass("selected");
	                        } else {
	                            element.next().focus().addClass("selected");
	                        }
	
	                        if (attrs.listSelect !== "") {
	                            element.parent().children(".selected").click();
	                        }
	
	                        return false;
	                    }
	                });
	                element.bind("click", function () /* event */{
	                    element.removeClass("selected").siblings().removeClass("selected");
	                    element.focus().addClass("selected");
	                });
	            }
	        };
	    }]);
	
	    angular.module("fleetviewApp").directive(focusListDirective, ["$timeout", function ($timeout) {
	        return {
	            restrict: "A",
	            link: function link(scope, element, attrs) {
	                element.bind("click", function () /*event*/{
	                    $timeout(function () {
	                        angular.element(attrs.focusList).find(".selected").focus();
	                    }, 50);
	                });
	            }
	        };
	    }]);
	
	    var directiveIdShow = "showonhoverparent";
	    var directiveIdHide = "hideonhoverparent";
	    angular.module("fleetviewApp").directive(directiveIdShow, ["$timeout", function ($timeout) {
	        return {
	            restrict: "A",
	            link: function link(scope, element, attrs) {
	                var overTimeout;
	                element.addClass("parentHoverHide");
	                var elemToBind = element.parent();
	                if (attrs.showonhoverparent !== "") {
	                    elemToBind = element.closest(attrs.showonhoverparent);
	                }
	                elemToBind.bind("mouseenter", function () {
	                    overTimeout = $timeout(function () {
	                        element.removeClass("parentHoverHide");
	                        element.addClass("parentHoverShow");
	                    }, 150);
	                });
	                elemToBind.bind("mouseleave", function () {
	                    $timeout.cancel(overTimeout);
	                    element.removeClass("parentHoverShow");
	                    element.addClass("parentHoverHide");
	                });
	            }
	        };
	    }]);
	
	    angular.module("fleetviewApp").directive(directiveIdHide, function () {
	        return {
	            restrict: "A",
	            link: function link(scope, element, attrs) {
	                element.addClass("parentHoverShow");
	
	                var elemToBind = element.parent();
	
	                if (attrs.hideonhoverparent !== "") {
	                    elemToBind = element.closest(attrs.hideonhoverparent);
	                }
	
	                elemToBind.bind("mouseenter", function () {
	                    element.removeClass("parentHoverHide");
	                    element.addClass("parentHoverShow");
	                });
	                elemToBind.bind("mouseleave", function () {
	                    element.removeClass("parentHoverShow");
	                    element.addClass("parentHoverHide");
	                });
	            }
	        };
	    });
	})();

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	    var directiveId = "dateTimePicker";
	    //requires jquery.scrollTableBody-1.0.0.js
	    angular.module("fleetviewApp").directive(directiveId, function () {
	        return {
	            restrict: "A",
	            replace: true,
	            scope: false,
	            link: function link(scope, element, attrs /*, ngModel*/) {
	                //var input = element.find('input');
	                var pickerOpt = {
	                    format: "m/dd/yyyy hh:ii",
	                    minView: 0,
	                    maxView: 3,
	                    showMeridian: false,
	                    autoclose: true,
	                    todayHighlight: true,
	                    bootcssVer: 3,
	                    pickerPosition: "bottom-right"
	                };
	                var iconClass = "glyphicon-th";
	                switch (attrs.dateTimePicker) {
	                    case "date":
	                        pickerOpt.minView = 2;
	                        pickerOpt.format = "m/dd/yyyy";
	                        break;
	                    case "time":
	                        pickerOpt.maxView = 1;
	                        pickerOpt.startView = 1;
	                        pickerOpt.format = "hh:ii";
	                        pickerOpt.showMeridian = true;
	                        iconClass = "glyphicon-time";
	                        pickerOpt.pickerPosition = "bottom-right dontshowdate";
	                        break;
	                }
	                element.find(".glyphicon").addClass(iconClass);
	                element.datetimepicker(pickerOpt);
	
	                //element.bind('blur keyup change', function () {
	                //  scope.ngModel = input.val();
	                //});
	            }
	        };
	    });
	})();

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(102);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").service("cacheService", cacheService);
	
	  cacheService.$inject = ["$window", "$cacheFactory"];
	
	  //Handles saving and loading things from local/session storage for persistance and performance.
	  function cacheService($window, $cacheFactory) {
	
	    var routePointsCache = $cacheFactory("routePointsCache", {
	      number: 100 //Max 100 route point arrays
	    });
	
	    var defaultCacheObj = {
	      vehicleGroupFilter: "",
	      driverGroupFilter: "",
	      selectedGroupType: "vehicleGroup",
	      complianceReportFilters: {
	        vehicleName: "",
	        routeSource: "",
	        routeProfile: ""
	      },
	      gridSortType: "",
	      gridSortReverse: false
	    };
	
	    //A generic cache object that can be used by the whole app. Saved to session storage
	    var cacheObj = angular.copy(defaultCacheObj);
	
	    //Holds a key-value mapping of page numbers to route lists for the current search settings.
	    var cachedRoutesObj = null;
	
	    var cacheStr = $window.sessionStorage["appCacheObj"];
	    if (cacheStr) {
	      cacheObj = JSON.parse(cacheStr);
	    }
	
	    var service = {
	      //Get a generic cache object that persists in session storage. (Persists in session storage across page refreshes but not across tabs)
	      //Can be get/set with cacheService.getCache().<prop> = <val>, and saved with cacheService.saveCache()
	      //Do not put things too large in here, max browser sessionStorage size is 5 MB
	      getCache: getCache,
	      //Save the cache object to session storage
	      saveCache: saveCache,
	
	      //Get/set the vm.settings variable that is used by a lot of the pages (parameters for fetching compliance data). Persists in session storage.
	      setSearchSettings: setSearchSettings,
	      getSearchSettings: getSearchSettings,
	
	      //Get/set cached route points (only persists in-memory, lost on refresh)
	      getCachedRoutePoints: getCachedRoutePoints,
	      setCachedRoutePoints: setCachedRoutePoints,
	
	      //Get/Set/clear compliance route response cache, keyed by page number. (only persists in-memory, lost on refresh)
	      getCachedRouteResponse: getCachedRouteResponse,
	      setCachedRouteResponse: setCachedRouteResponse,
	      clearCachedRouteResponses: clearCachedRouteResponses,
	
	      clearForLogout: clearForLogout
	    };
	
	    function getCache() {
	      return cacheObj;
	    }
	
	    function saveCache() {
	      var cacheObjStr = (0, _stringify2.default)(cacheObj);
	      $window.sessionStorage["appCacheObj"] = cacheObjStr;
	    }
	
	    /**
	     * @param {object} settings
	     */
	    function setSearchSettings(settings) {
	      if (_.isEmpty(settings)) {
	        //console.error("Can't input an empty settings!");
	        return;
	      }
	      //console.log("Setting search settings " + settings);
	      cachedRoutesObj = null; //When the search settings change, the cached route list should be cleared.
	      $window.sessionStorage["complianceSearchSettings"] = (0, _stringify2.default)(settings);
	    }
	
	    /**
	     * @returns {object} The search settings object or null if not found
	     */
	    function getSearchSettings() {
	      var searchSettings = $window.sessionStorage["complianceSearchSettings"];
	      if (searchSettings) {
	        //console.log("Getting search settings " + JSON.parse(searchSettings));
	        return JSON.parse(searchSettings);
	      }
	      return null;
	    }
	
	    /**
	     *
	     * @param {string} tripId
	     * @param {object} routingProfile
	     * @returns {array} The cached route points array
	     */
	    function getCachedRoutePoints(tripId, routingProfile) {
	      var rpId = routingProfile && routingProfile.routingProfileId ? routingProfile.routingProfileId : "";
	      var cacheKey = String(tripId) + String(rpId);
	      var cacheResult = routePointsCache.get(cacheKey);
	      if (cacheResult) {
	        //console.log("Retrieved cached points from trip " + tripId + " + rp id " + rpId);
	        //console.log(cacheResult);
	      }
	      return cacheResult;
	    }
	
	    /**
	     *
	     * @param {string} tripId
	     * @param {string} routingProfile
	     * @param {array} routeMercPoints
	     */
	    function setCachedRoutePoints(tripId, routingProfile, routeMercPoints) {
	      var rpId = routingProfile && routingProfile.routingProfileId ? routingProfile.routingProfileId : "";
	      if (!tripId && !rpId) {
	        console.error("Can't put empty fields in route points cache");
	      }
	      var cacheKey = String(tripId) + String(rpId);
	      //console.log("Putting cached points for trip " + tripId + " + rp id " + rpId);
	      //console.log(routeMercPoints);
	      routePointsCache.put(cacheKey, routeMercPoints);
	    }
	
	    //On logout or account switch, need to clear account-specific cache data
	    function clearForLogout() {
	      $window.sessionStorage["complianceSearchSettings"] = "";
	      cacheObj = angular.copy(defaultCacheObj);
	      $window.sessionStorage["appCacheObj"] = "";
	      $cacheFactory.get("$http").removeAll();
	      clearCachedRouteResponse();
	    }
	
	    //Set a key-value mapping entry
	    function setCachedRouteResponse(currentPageNum, routeResponse) {
	      if (!cachedRoutesObj) {
	        cachedRoutesObj = {};
	      }
	      cachedRoutesObj[currentPageNum] = routeResponse;
	    }
	
	    //Given a page number and the index in that page number, get the route response if exists, or null otherwise.
	    function getCachedRouteResponse(currentPageNum) {
	      if (!cachedRoutesObj) {
	        cachedRoutesObj = {};
	      }
	      var currentPage = cachedRoutesObj[currentPageNum];
	      if (currentPage) {
	        return currentPage;
	      }
	      return null;
	    }
	
	    function clearCachedRouteResponses() {
	      cachedRoutesObj = null;
	    }
	
	    return service;
	  }
	})(window.angular);

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").service("timeService", timeService);
	
	  timeService.$inject = ["moment"];
	
	  function timeService(moment) {
	
	    var formatStr = "M/D/YYYY h:mm a ZZ";
	
	    var service = {
	      getFormattedTime: getFormattedTime,
	      getFormattedTime2: getFormattedTime2,
	      getEpochFormattedTime: getEpochFormattedTime
	    };
	
	    return service;
	
	    /**
	     * Get formatted time given parameters in the format below:
	     * @param {string} webSvcReturnTime - The web service time string returned by the web service. Format is "2021-01-22T21:22:46".
	     * @param {string} webSvcReturnOffset - The web service UTC time offset string. Format is "+0400".
	     */
	    function getFormattedTime(webSvcReturnTime, webSvcReturnOffset) {
	      if (!webSvcReturnTime || !webSvcReturnOffset) {
	        return "--";
	      }
	
	      // parse the time (format: 2021-01-22T21:22:46)
	      var timeParts = webSvcReturnTime.split(/[T:\-]+/);
	      var year = timeParts[0];
	      var month = timeParts[1];
	      var date = timeParts[2];
	      var hours = timeParts[3];
	      var mins = timeParts[4];
	
	      // + or -
	      var sign = webSvcReturnOffset.charAt(0);
	      var offset = parseInt(webSvcReturnOffset.charAt(1) + webSvcReturnOffset.charAt(2));
	
	      if (sign === "-") {
	        hours -= offset;
	      } else {
	        hours += offset;
	      }
	
	      var suffix = hours >= 12 ? 'pm' : 'am';
	
	      // only -12 from hours if it is greater than 12 (if not back at mid night)
	      hours = hours > 12 ? hours - 12 : hours;
	
	      // if 00 then it is 12 am
	      hours = hours == '00' ? 12 : hours;
	
	      // want: m/d/yyyy h:mm a offset
	      var finalTime = month + "/" + date + "/" + year + " " + hours + ":" + mins + " " + suffix + " " + webSvcReturnOffset;
	      return finalTime;
	    }
	
	    /**
	     * Get formatted time given parameters in the format below:
	     * @param {string} webSvcReturnTime - The web service time string returned by the web service. Format is "3/14/2017 3:12:15 PM".
	     * @param {string} webSvcReturnOffset - The web service UTC time offset string. Format is "+0400".
	     */
	    function getFormattedTime2(webSvcReturnTime, webSvcReturnOffset) {
	      if (!webSvcReturnTime || !webSvcReturnOffset) {
	        return "--";
	      }
	      return moment.utc(webSvcReturnTime).utcOffset(webSvcReturnOffset).format(formatStr);
	    }
	
	    function getEpochFormattedTime(webSvcReturnTime, webSvcReturnOffset) {
	      if (!webSvcReturnTime || !webSvcReturnOffset) {
	        return "--";
	      }
	      return moment.unix(webSvcReturnTime).utcOffset(webSvcReturnOffset).format(formatStr);
	    }
	  }
	})(window.angular);

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("fleetviewApp").controller("mapController", mapController);
	  mapController.$inject = ["$rootScope", "$scope", "$timeout", "mapService", "$state", "LayoutService"];
	
	  function mapController($rootScope, $scope, $timeout, mapService, $state, LayoutService) {
	    var vm = this;
	    var resizeTimeout;
	
	    vm.canEdit = function () {
	      return true;
	    };
	
	    vm.leftPanelWidth = function () {
	      return LayoutService.getLeftPanelWidth();
	    };
	    vm.hidePanel = function () {
	      if (!vm.isleftPanelHidden) {
	        vm.isleftPanelHidden = true;
	        LayoutService.closeLeftHandPanel();
	      } else {
	        vm.isleftPanelHidden = false;
	        LayoutService.openLeftHandPanel(500);
	      }
	    };
	
	    vm.locationText = "";
	    vm.mapMessage = {
	      show: false,
	      txt: "",
	      showMsg: function showMsg() {
	        return vm.show;
	      }
	    };
	    vm.mapObj = function () {
	      return mapService.getMap();
	    };
	    vm.mapTooltip = {
	      show: false,
	      txt: "",
	      labelClass: "info"
	    };
	    vm.showLoading = function () {
	      return false;
	    };
	    vm.zoomToEdit = function () {
	      mapService.zoomTo(16);
	    };
	
	    ///////////////////
	
	    function init() {
	      var that = vm;
	    }
	
	    function updateConstants() {
	      var that = vm;
	    }
	
	    $rootScope.$watch("userInfo.dataVersion", function (n, o) {
	      if (angular.equals(n, o)) {
	        return;
	      }
	    });
	
	    $scope.$on("mapMsg", function (event, msg) {
	      $scope.mapMessage.show = msg.show;
	      $scope.mapMessage.txt = msg.txt;
	      if (!$scope.$$phase) $scope.$apply();
	    });
	
	    $scope.$on("tooltipMsg", function (event, msg) {
	      $scope.mapTooltip.labelClass = msg.labelClass;
	      $scope.mapTooltip.txt = msg.txt;
	      $scope.mapTooltip.show = msg.show;
	      if (!$scope.$$phase) $scope.$apply();
	
	      if (msg.show === true) {
	        var mouseFollow = function mouseFollow(e) {
	          //find X & Y coordinates
	          var x = e.clientX,
	              y = e.clientY,
	              tooltipSpan = document.getElementById("map-cursor-tooltip");
	          //Set tooltip position according to mouse position
	          tooltipSpan.style.top = y - 80 + "px";
	          tooltipSpan.style.left = x + 20 + "px";
	        };
	        $(document).mousemove(mouseFollow);
	      } else {
	        $(document).off("mousemove", mouseFollow);
	      }
	    });
	
	    $scope.$watch(function () {
	      return LayoutService.getLeftPanelWidth();
	    }, function (newValue) {
	      $timeout.cancel(resizeTimeout);
	
	      resizeTimeout = $timeout(function () {
	        return mapService.resizeMap();
	      }, 400);
	    });
	  }
	})();

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function (angular) {
	  angular.module("fleetviewApp").service("LayoutService", LayoutService);
	
	  LayoutService.$inject = ["$rootScope"];
	
	  function LayoutService($rootScope) {
	    var leftPanelWidth = "0";
	
	    var service = {
	      getLeftPanelWidth: getLeftPanelWidth,
	      openLeftHandPanel: openLeftHandPanel,
	      closeLeftHandPanel: closeLeftHandPanel
	    };
	
	    return service;
	
	    function getLeftPanelWidth() {
	      return leftPanelWidth;
	    }
	
	    function openLeftHandPanel(width) {
	      leftPanelWidth = width;
	    }
	
	    function closeLeftHandPanel() {
	      leftPanelWidth = "0";
	    }
	  }
	})(window.angular);

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("fleetviewApp").directive("alkMainNav", alkMainNav);
	
	  alkMainNav.$inject = [];
	
	  var config = __webpack_require__(110);
	
	  function alkMainNav() {
	    // Usage:
	    //
	    // Creates:
	    //
	    var directive = {
	      bindToController: true,
	      controller: alkMainNavController,
	      controllerAs: "vm",
	      restrict: "E",
	      scope: {},
	      template: __webpack_require__(360)
	    };
	
	    return directive;
	  }
	  /* @ngInject */
	  alkMainNavController.$inject = ["$rootScope", "$location", "alkAuthenticationService", "mapService", "$state", "$transitions", "alkModalService", "$q", "$translate", "LayoutService", "cacheService", "UserProvider"];
	
	  function alkMainNavController($rootScope, $location, alkAuthenticationService, mapService, $state, $transitions, alkModalService, $q, $translate, LayoutService, cacheService, userProvider) {
	    var vm = this;
	
	    vm.gotoCompliance = gotoCompliance;
	    vm.gotoReports = gotoReports;
	    vm.isComplianceSelected = false;
	    vm.showCompliance = true;
	    vm.isleftPanelHidden = false;
	    vm.hidePanel = hidePanel;
	    vm.reportsSelected = false;
	    vm.userInfo = $rootScope.userInfo;
	
	    function gotoCompliance() {
	      $state.go("main.compliance");
	      LayoutService.openLeftHandPanel(500);
	      vm.isComplianceSelected = true;
	    }
	
	    function gotoReports() {
	      $state.go("reports.groups");
	    }
	
	    function hidePanel() {
	      if (!vm.isleftPanelHidden) {
	        LayoutService.closeLeftHandPanel();
	        vm.isleftPanelHidden = true;
	      } else {
	        LayoutService.openLeftHandPanel(500);
	        vm.isleftPanelHidden = false;
	      }
	    }
	
	    vm.stateIncludes = function (stateStr) {
	      return $state.includes(stateStr);
	    };
	
	    vm.newRRWeb = function () {
	      return config.newRRWeb + "?token=" + userProvider.getUser().authToken;
	    };
	
	    $transitions.onBefore({}, function (trans) {
	      return allowTransition(trans).then(function () {
	        return true;
	      }, function () {
	        return false;
	      });
	    });
	
	    function allowTransition(trans) {
	      return $q(function (resolve, reject) {
	        resolve(true);
	        $rootScope.$broadcast("panelClosed", {
	          name: trans.$from().name
	        });
	      });
	    }
	
	    vm.showTracks = false;
	
	    vm.changeMapStyle = function (style) {
	      mapService.setStyle(style);
	    };
	
	    vm.canEdit = function () {
	      return true;
	    };
	
	    vm.goToAccount = function () {
	      $state.go("user");
	    };
	
	    vm.goToAdmin = function () {
	      $state.go("company");
	    };
	
	    vm.goToDashboard = function () {
	      $state.go("dashboard");
	    };
	    vm.cAdmin = function () {
	      $state.go("companyadmin");
	    };
	
	    vm.onLogOut = function () {
	      var userString = window.sessionStorage["userAuthInfo"];
	      var user = JSON.parse(userString);
	      var tidToken = window.localStorage["trimbleIdToken"];
	      var baseUrl = window.location.protocol + "//" + window.location.host;
	
	      if (tidToken) {
	        var url = config.trimbleCloudUrl + "oauth/logout?";
	        url += "post_logout_redirect_uri=" + baseUrl + "/tid/logout";
	        url += "&id_token_hint=" + tidToken;
	
	        window.location.href = url;
	
	        alkAuthenticationService.logout(user.authToken).then(function () {
	          window.sessionStorage["logoutInProgress"] = true;
	          //$state.go("login");
	          window.location.replace("/");
	        });
	      } else {
	        alkAuthenticationService.logout(user.authToken).then(function () {
	          window.sessionStorage["logoutInProgress"] = true;
	          //$state.go("login");
	          window.location.replace("/");
	        });
	      }
	      cacheService.clearForLogout();
	    };
	
	    vm.quickStart = function () {
	      $rootScope.$broadcast("toggleStart");
	    };
	
	    $rootScope.$on("hideCompliance", function (event, message) {
	      vm.showCompliance = false;
	    });
	
	    setTimeout(function () {
	      var logoutButton = document.getElementById("logoutButton");
	      var newLogOutButton = "<a id=\"logoutButton\" class=\"btn btn-xs btn-default pull-right cloud-menu-btn cloud-menu-btn-last ng-scope\" alk-analytics=\"['Logout']\" onclick=\"window.location.replace('" + baseUrl() + "/logout');\" translate=\"common.nav.Logout\">Logout</a>";
	      logoutButton.remove();
	      var changePassButton = document.getElementById("changePasswordButton");
	      changePassButton.insertAdjacentHTML("beforebegin", newLogOutButton);
	      changePassButton.remove();
	    });
	
	    function baseUrl() {
	      return "" + (window.location.protocol + "//" + window.location.host);
	    }
	  }
	})();

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"header\" class=\"alk-menu-bar slant\">\r\n  <span class=\"main-logo\">\r\n      <div>\r\n        <img id=\"routereporter-logo\" ng-click=\"vm.goToDashboard()\" src=\"/img/RouteReporter_Logo-reversed.svg\" / >\r\n      </div>\r\n  </span>\r\n  <div class=\"nav-section\" ng-hide=\"('main.compliance.querystring' | includedByState) || ('acceptTerms' | includedByState) || ('terms' | includedByState)\">\r\n    <ul>\r\n      <li class=\"large-btn\">\r\n        <button class=\"nav-button\" ng-click=\"vm.goToDashboard()\" ng-class=\"{'selected' : vm.stateIncludes('dashboard')}\">\r\n            <img src=\"/img/icons/dashboard.svg\" />\r\n            <span translate=\"views.dashboard.Dashboard\"></span>\r\n          </button>\r\n      </li>\r\n    </ul>\r\n    <ul ng-if=\"vm.showCompliance\">\r\n      <li class=\"large-btn\">\r\n        <button class=\"nav-button\" ng-click=\"vm.gotoCompliance()\" alk-analytics=\"['Menu','Compliance']\" ng-class=\"{'selected' : vm.stateIncludes('main.compliance')}\">\r\n            <img src=\"/img/icons/compliance.svg\" />\r\n            <span translate=\"views.nav.Compliance\"></span>\r\n          </button>\r\n      </li>\r\n    </ul>\r\n    <ul>\r\n      <li class=\"large-btn\" ng-hide=\"'main.compliance.querystring' | includedByState\">\r\n        <button class=\"nav-button\" ng-click=\"vm.gotoReports()\" ng-class=\"{'selected' : vm.stateIncludes('reports')}\">\r\n            <img src=\"/img/icons/reports.svg\" />\r\n            <span translate=\"views.nav.Reports\"></span>\r\n          </button>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n\r\n  <div class=\"nav-section map\" ng-if=\"vm.stateIncludes('main')\">\r\n    <map-styles exclude=\"terrain,datadark,satellite_only\"></map-styles>\r\n  </div>\r\n\r\n  <h1 class=\"nav-title\" ng-if=\"vm.stateIncludes('user')\" translate=\"views.nav.Settings\"></h1>\r\n  <h1 class=\"nav-title\" ng-if=\"vm.stateIncludes('terms') || vm.stateIncludes('acceptTerms')\" translate=\"views.nav.TOS\"></h1>\r\n\r\n  <div class=\"nav-section right\" ng-hide=\"('acceptTerms' | includedByState)\">\r\n    <alk-cloud-menu on-Log-Out=\"vm.onLogOut()\"></alk-cloud-menu>\r\n  </div>\r\n\r\n  <div class=\"nav-section right\" ng-hide=\"('acceptTerms' | includedByState) || ('terms' | includedByState)\">\r\n    <tm-nav-buttons-three-stack\r\n      show-company-admin=\"!('main.compliance.querystring' | includedByState) && (vm.userInfo.roles[0]==='ALK Administrator' || vm.userInfo.roles[0]==='ALK Support' || vm.userInfo.roles[0]==='Support' ||vm.userInfo.roles[0]==='support' ||vm.userInfo.roles[0]==='Company Administrator')\"\r\n      go-to-company-admin=\"vm.cAdmin()\"\r\n    ></tm-nav-buttons-three-stack>\r\n  </div>\r\n\r\n  <span class=\"nav-section\">\r\n    <div class=\"new-rr-web-container-nav\">\r\n      <a href=\"{{vm.newRRWeb()}}\" class=\"new-rr-web\">We've redesigned RouteReporter, click here to check out the new version.</a>\r\n    </div>\r\n  </span>\r\n\r\n  <div class=\"nav-section right\" partner-account-select=\"CoPilot FleetView\"></div>\r\n\r\n</div>\r\n";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("forgotPassword", {
	    template: __webpack_require__(362),
	    controller: ForgotPasswordController
	  });
	
	  ForgotPasswordController.$inject = ["$location", "$filter", "alkAuthenticationService", "Messages", "$scope", "ALKForgotPassword"];
	
	  function ForgotPasswordController($location, $filter, alkAuthenticationService, Messages, $scope, ALKForgotPassword) {
	    var vm = this;
	
	    vm.email = "";
	    vm.isProcessing = false;
	    vm.submitForgotPassword = submitForgotPassword;
	
	    function submitForgotPassword() {
	      vm.isProcessing = true;
	      Messages.clear();
	
	      var forgotPassword = new ALKForgotPassword(vm.email);
	
	      alkAuthenticationService.forgotPassword(forgotPassword).then(function () {
	        return Messages.add("success", $filter("translate")("views.forgotPassword.Success"), {
	          showOnNextPage: false
	        });
	      }, function (err) {
	        if (err.status === "LoginNotExist") {
	          Messages.add("danger", $filter("translate")("views.forgotPassword.InvalidEmail"), {
	            showOnNextPage: false
	          });
	        } else {
	          Messages.add("danger", $filter("translate")("views.forgotPassword.Error"), {
	            showOnNextPage: false
	          });
	        }
	      }).finally(function () {
	        return vm.isProcessing = false;
	      });
	    }
	
	    $scope.$on("$destroy", function () {
	      Messages.clear();
	    });
	  }
	})(window.angular);

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	module.exports = "<form name=\"forgotPasswordForm\" alk-disabled=\"$ctrl.isProcessing\" alk-submit=\"$ctrl.submitForgotPassword()\" novalidate role=\"form\">\r\n  <alk-messages></alk-messages>\r\n  <div class=\"row\">\r\n    <div class=\"form-group col-sm-12\" ng-class=\"{ 'has-error' : forgotPasswordForm.email.$invalid && forgotPasswordForm.submitted }\">\r\n      <input id=\"email\" name=\"email\" class=\"form-control input-sm\" type=\"text\" ng-model=\"$ctrl.email\" alk-autofocus alk-email placeholder=\"{{ 'views.forgotPassword.Email' | translate }}\"\r\n        required />\r\n      <div ng-show=\"forgotPasswordForm.submitted\">\r\n        <p ng-show=\"forgotPasswordForm.email.$error.alkEmail\" class=\"help-block\">{{\"validation.email\" | translate}}</p>\r\n        <p ng-show=\"forgotPasswordForm.email.$error.required\" class=\"help-block\">{{\"validation.required\" | translate}}</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n  <div class=\"col-sm-12 text-right\">\r\n    <button type=\"submit\" class=\"btn btn-success btn-lg\"><i ng-show=\"$ctrl.isProcessing\" class=\"ico ico-circle-notch ico-spin ng-cloak\" ng-cloak></i> <span translate>{{($ctrl.isProcessing)? 'common.Submitting': 'common.Go'}}</span> </button>\r\n  </div>\r\n  </div>\r\n</form>\r\n";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("resetPassword", {
	    template: __webpack_require__(364),
	    controller: ResetPasswordController
	  });
	
	  ResetPasswordController.$inject = ["$location", "$filter", "alkAuthenticationService", "Messages", "ALKResetPassword"];
	
	  function ResetPasswordController($location, $filter, alkAuthenticationService, Messages, ALKResetPassword) {
	    var vm = this;
	
	    vm.isProcessing = false;
	    vm.userInfo = {};
	    vm.redirectTo = "";
	    vm.submitResetPassword = submitResetPassword;
	
	    vm.$onInit = init;
	
	    function init() {
	      var searchObject = $location.search();
	
	      vm.userInfo = {
	        email: searchObject.email,
	        token: searchObject.token,
	        password: "",
	        confirmPassword: ""
	      };
	
	      var redirectTo = "/";
	
	      if ($location.search().r) {
	        redirectTo = decodeURIComponent($location.search().r);
	      }
	
	      vm.redirectTo = redirectTo;
	    }
	
	    function submitResetPassword(isValid) {
	      if (!isValid) return;
	
	      vm.isProcessing = true;
	      Messages.clear();
	
	      var resetPassword = new ALKResetPassword(vm.userInfo.email, vm.userInfo.password, vm.userInfo.token);
	
	      alkAuthenticationService.resetPassword(resetPassword).then(function () {
	        return _handleSuccess();
	      }, function (err) {
	        return _handleError(err);
	      }).finally(function () {
	        return vm.isProcessing = false;
	      });
	    }
	
	    function _handleError(err) {
	      if (err.status === "TokenInvalid") {
	        Messages.add("danger", $filter("translate")("views.resetPassword.ErrorInvalidToken"), {
	          showOnNextPage: false
	        });
	      } else if (err.status === "LoginNotExist") {
	        Messages.add("danger", $filter("translate")("views.resetPassword.ErrorLoginNotExist"), {
	          showOnNextPage: false
	        });
	      } else {
	        Messages.add("danger", $filter("translate")("views.resetPassword.Error"), {
	          showOnNextPage: false
	        });
	      }
	    }
	
	    function _handleSuccess() {
	      Messages.add("success", $filter("translate")("views.resetPassword.Success"), {
	        showOnNextPage: true
	      });
	      $location.url(vm.redirectTo);
	    }
	  }
	})(window.angular);

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container reset-password\">\r\n  <div class=\"panel col-md-push-3 col-md-6\">\r\n    <div class=\"page-content col-md-offset-1 col-md-10\">\r\n      <div class=\"row\" style=\"margin:30px 0\">\r\n        <div class=\"col-md-8\">\r\n          <div class=\"routereporter-logo\"></div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <h3 translate=\"views.resetPassword.Reset Password\"></h3>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <alk-messages></alk-messages>\r\n        <div alk-disabled=\"$ctrl.isProcessing\">\r\n          <form name=\"resetPasswordForm\" alk-submit=\"$ctrl.submitResetPassword(resetPasswordForm.$valid)\" novalidate role=\"form\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-8\">\r\n                <div class=\"form-group\" ng-class=\"{ 'has-error' : resetPasswordForm.email.$invalid && (!resetPasswordForm.email.$pristine || resetPasswordForm.submitted) }\">\r\n                  <input id=\"email\" name=\"email\" class=\"form-control\" type=\"text\" alk-email alk-autofocus=\"!$ctrl.userInfo.email && !$ctrl.userInfo.token\"\r\n                    ng-model=\"$ctrl.userInfo.email\" placeholder=\"{{ 'views.resetPassword.Email' | translate }}\" required />\r\n                  <label for=\"email\" class=\"control-label label-sm label-line label-line\">{{\"views.resetPassword.Email\" | translate}}</label>\r\n                  <div ng-show=\"!resetPasswordForm.email.$pristine || resetPasswordForm.submitted\">\r\n                    <p ng-show=\"resetPasswordForm.email.$error.alkEmail\" class=\"help-block\" translate=\"validation.email\"></p>\r\n                    <p ng-show=\"resetPasswordForm.email.$error.required\" class=\"help-block\" translate=\"validation.required\"></p>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\" ng-class=\"{ 'has-error' : resetPasswordForm.token.$invalid && (!resetPasswordForm.token.$pristine || resetPasswordForm.submitted) }\">\r\n                  <input id=\"token\" name=\"token\" class=\"form-control\" type=\"text\" ng-model=\"$ctrl.userInfo.token\" alk-autofocus=\"$ctrl.userInfo.email && !$ctrl.userInfo.token\"\r\n                    placeholder=\"{{ 'views.resetPassword.Token' | translate }}\" required />\r\n                  <label for=\"token\" class=\"control-label label-sm label-line label-line\">{{\"views.resetPassword.Token\" | translate}}</label>\r\n                  <div ng-show=\"!resetPasswordForm.token.$pristine || resetPasswordForm.submitted\">\r\n                    <p ng-show=\"resetPasswordForm.token.$error.required\" class=\"help-block\" translate=\"validation.required\"></p>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\" ng-class=\"{ 'has-error' : resetPasswordForm.password.$invalid && (!resetPasswordForm.password.$pristine || resetPasswordForm.submitted) }\">\r\n                  <input id=\"password\" name=\"password\" class=\"form-control\" type=\"password\" ng-model=\"$ctrl.userInfo.password\" alk-autofocus=\"$ctrl.userInfo.email && $ctrl.userInfo.token\"\r\n                    placeholder=\"{{ 'views.resetPassword.Password' | translate }}\" tid-password ng-minlength=\"8\" ng-maxlength=\"20\" required\r\n                  />\r\n                  <label for=\"password\" class=\"control-label label-sm label-line label-line\">{{\"views.resetPassword.Password\" | translate}}</label>\r\n                  <div ng-show=\"!resetPasswordForm.password.$pristine || resetPasswordForm.submitted\">\r\n                    <p ng-show=\"resetPasswordForm.password.$error.required\" class=\"help-block\" translate=\"validation.required\"></p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-md-8\">\r\n                <div class=\"form-group\" ng-class=\"{ 'has-error' : resetPasswordForm.confirmPassword.$invalid && (!resetPasswordForm.confirmPassword.$pristine || resetPasswordForm.submitted) }\">\r\n                  <input name=\"confirmPassword\" class=\"form-control\" type=\"password\" ng-model=\"$ctrl.userInfo.confirmPassword\" placeholder=\"{{ 'views.resetPassword.Confirm Password' | translate }}\"\r\n                    alk-compare=\"$ctrl.userInfo.password\" />\r\n                  <label for=\"confirmPassword\" class=\"control-label label-sm label-line label-line\">{{\"views.resetPassword.Confirm Password\" | translate}}</label>\r\n                  <div ng-show=\"!resetPasswordForm.confirmPassword.$pristine || resetPasswordForm.submitted\">\r\n                    <p ng-show=\"resetPasswordForm.confirmPassword.$error.alkCompare\" class=\"help-block\" translate=\"validation.doesnt match\"></p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <button type=\"submit\" class=\"btn btn-primary\"><i ng-show=\"$ctrl.isProcessing\" class=\"ico ico-circle-notch ico-spin ng-cloak\" ng-cloak></i> <span translate>{{($ctrl.isProcessing)? 'common.Submitting': 'common.Submit'}}</span></button>\r\n                <p translate=\"views.resetPassword.Click here to login\"></p>\r\n              </div>\r\n            </div>\r\n          </form>\r\n          <div>\r\n            <ul>\r\n              <li ng-class=\"{'text-danger':resetPasswordForm.password.$error.maxlength || resetPasswordForm.password.$error.minlength}\">Must be between 8 and 20 characters</li>\r\n              <li ng-class=\"{'text-danger':resetPasswordForm.password.$error.hasNumber}\">At least one number</li>\r\n              <li ng-class=\"{'text-danger':resetPasswordForm.password.$error.hasLowercase}\">At least one lowercase letter</li>\r\n              <li ng-class=\"{'text-danger':resetPasswordForm.password.$error.hasUppercase}\">At least one uppercase letter</li>\r\n              <li ng-class=\"{'text-danger':resetPasswordForm.password.$error.hasCharacter}\">At least one of these characters (!@#$%&amp;*^_-+)</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("acceptTerms", {
	    replace: false,
	    template: __webpack_require__(366),
	    controller: AcceptTermsController
	  });
	
	  AcceptTermsController.$inject = ["$location", "$http", "UserProvider", "alkAuthenticationService", "$rootScope"];
	
	  function AcceptTermsController($location, $http, UserProvider, alkAuthenticationService, $rootScope) {
	    var vm = this;
	    vm.isProcessing = false;
	    vm.acceptTerms = acceptTerms;
	    vm.language = $rootScope.language;
	
	    function acceptTerms() {
	      vm.isProcessing = true;
	
	      alkAuthenticationService.acceptTerms().then(function () {
	        UserProvider.getUser().currentTermsOfUseAccepted = true;
	        $location.url(getRedirectUrl());
	      }, function () {
	        vm.isProcessing = false;
	      });
	    }
	
	    function getRedirectUrl() {
	      var redirectTo = "/";
	
	      if ($location.search().r) {
	        redirectTo = decodeURIComponent($location.search().r);
	      }
	
	      return redirectTo;
	    }
	  }
	})(window.angular);

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	module.exports = "<alk-main-nav></alk-main-nav>\r\n<div class=\"container with-nav accept-terms-page\">\r\n  <div class=\"panel col-md-10 col-md-offset-1\">\r\n    <div class=\"page-content\">\r\n      <!-- <h3 data-translate=\"views.acceptTerms.Read through to the bottom of the page to accept these terms\">Read through to the bottom of the page to accept these terms</h3> -->\r\n      <div ng-include=\"'/app/auth/' + $ctrl.language + '/termsContent.html'\"></div>\r\n\r\n      <div class=\"text-center\">\r\n        <button id=\"accept-terms-btn\" type=\"button\" class=\"btn btn-lg btn-success\" ng-disabled=\"$ctrl.isProcessing\" ng-click=\"$ctrl.acceptTerms()\">\r\n          <i ng-show=\"$ctrl.isProcessing\" class=\"ico ico-circle-notch ico-spin ng-cloak\" ng-cloak></i>\r\n          <span translate=\"views.acceptTerms.Accept\">Accept</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("loginForm", {
	    template: __webpack_require__(368),
	    controller: LoginController
	  });
	
	  LoginController.$inject = ["$location", "$window", "alkAuthenticationService", "$rootScope", "UserProvider", "ALKLogin"];
	
	  function LoginController($location, $window, alkAuthenticationService, $rootScope, UserProvider, ALKLogin) {
	    var vm = this;
	
	    vm.isProcessing = false;
	
	    vm.userInfo = {};
	    vm.isEmailFocused = true;
	    vm.accounts = [];
	
	    vm.isIE9 = $window.isIE9 != null;
	    vm.isltIE9 = $window.isltIE9 != null;
	
	    vm.login = login;
	
	    vm.forgotPassword = forgotPassword;
	
	    function forgotPassword() {
	      $rootScope.$broadcast("forgotPassword");
	    }
	
	    function login(userInfo) {
	      vm.showPasswordIncorrect = false;
	      vm.showNoAccountForApplication = false;
	      vm.showAccountDisabled = false;
	
	      // remove the user from session before attempting to sign in a new user
	      UserProvider.clearUser();
	
	      var login = new ALKLogin(vm.userInfo.username, vm.userInfo.password, vm.userInfo.account);
	      if (!login.isBaseValid()) return;
	
	      if (vm.accounts.length > 0 && !login.isAccountValid()) return;
	
	      vm.isProcessing = true;
	
	      alkAuthenticationService.login(login).then(function () {
	        return loginSuccess();
	      }, function (error) {
	        return loginFailed(error);
	      });
	    }
	
	    function loginSuccess() {
	      var redirectTo = "/app/dashboard";
	
	      if ($location.search().r) {
	        redirectTo = decodeURIComponent($location.search().r);
	      }
	
	      $location.url(redirectTo);
	    }
	
	    function loginFailed(error) {
	      // if the authorization fails and the service sends back a list of accounts, this means the username/password was correct, but there was more than one account for this user for this application.
	      // display the list of accounts to the user so they can select one and continue.
	
	      // on failed login - reset the list of accounts.
	      vm.accounts = [];
	      delete vm.userInfo.account;
	
	      console.log("error logging in ", error);
	
	      if (error.status !== null && error.status === "FailedToLoginDueToMultipleAccounts" && error.accounts.length > 0) {
	        vm.accounts = error.accounts;
	        vm.userInfo.account = vm.accounts[0].accountName;
	      } else if (error.status !== null && error.status === "FailedToLogin") {
	        vm.showPasswordIncorrect = true;
	      } else if (error.status !== null && error.status === "FailedToLoginNotAuthorized") {
	        vm.showNoAccountForApplication = true;
	      } else {
	        vm.showPasswordIncorrect = true;
	      }
	
	      vm.isProcessing = false;
	    }
	  }
	})(window.angular);

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	module.exports = "<form alk-disabled=\"$ctrl.isProcessing\" name=\"loginForm\" alk-submit=\"$ctrl.login($ctrl.userInfo)\" novalidate role=\"form\"\r\n  ng-show=\"!$ctrl.isltIE9\">\r\n  <div class=\"row\">\r\n    <alk-messages></alk-messages>\r\n\r\n    <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : loginForm.username.$invalid && loginForm.submitted }\">\r\n      <input id=\"username\" name=\"username\" placeholder=\"{{'views.login.Email Address' | translate}}\" class=\"form-control input-line\"\r\n        type=\"text\" alk-email alk-autofocus ng-model=\"$ctrl.userInfo.username\" ng-disabled=\"$ctrl.accounts.length>0\" required\r\n      />\r\n      <p ng-show=\"loginForm.username.$error.alkEmail && loginForm.submitted\" class=\"help-block\">{{\"validation.email\" | translate}}</p>\r\n      <p ng-show=\"loginForm.username.$error.required && loginForm.submitted\" class=\"help-block\">{{\"validation.required\" | translate}}</p>\r\n    </div>\r\n    <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : loginForm.password.$invalid && loginForm.submitted }\">\r\n      <input id=\"password\" name=\"password\" placeholder=\"{{'views.login.Password' | translate}}\" class=\"form-control input-line\"\r\n        type=\"password\" ng-model=\"$ctrl.userInfo.password\" ng-disabled=\"$ctrl.accounts.length>0\" required />\r\n      <p ng-show=\"loginForm.password.$error.required && loginForm.submitted\" class=\"help-block\">{{\"validation.required\" | translate}}</p>\r\n      <span class=\"pull-right\"><a ng-click=\"$ctrl.forgotPassword()\" class=\"btn btn-link btn-sm\">{{\"views.login.Forgot Password?\" | translate}}</a></span>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"form-group col-sm-12\" ng-if=\"$ctrl.accounts.length>0\" ng-class=\"{ 'has-error' : loginForm.account.$invalid && loginForm.submitted }\">\r\n      <select id=\"account\" name=\"account\" class=\"form-control input-sm input-line\" ng-model=\"$ctrl.userInfo.account\" required>\r\n        <option value=\"\">{{\"common.login.Select Account\" | translate}}</option>\r\n        <option ng-repeat=\"account in $ctrl.accounts\" value=\"{{account.accountName}}\">{{account.accountName}}</option>\r\n      </select>\r\n      <p ng-show=\"loginForm.account.$error.required && loginForm.submitted\" class=\"help-block\">{{\"validation.required\" | translate}}</p>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-7\">\r\n      <p class=\"text-small\"><a href=\"https://support.copilotpro.com/en/support/solutions/articles/19000087821-what-is-an-alk-id-or-copilot-id-\">{{\"common.landing.DoIHaveID\" | translate}}</a></p>\r\n    </div>\r\n    <div class=\"col-sm-5 text-right form-group\">\r\n      <button id=\"login-submit\" type=\"submit\" class=\"btn btn-lg btn-success\" ng-disabled=\"$ctrl.isltIE9 || $ctrl.isIE9\">\r\n                <i ng-show=\"$ctrl.isProcessing\" class=\"ico ico-circle-notch ico-spin ng-cloak\" ng-cloak></i> <span translate>{{($ctrl.isProcessing)? 'views.login.Logging in...': 'common.Go'}}</span>\r\n              </button>\r\n    </div>\r\n\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <div class=\"has-error\">\r\n        <p class=\"help-block\" ng-show=\"$ctrl.showAccountDisabled\">{{\"views.login.User or account is disabled\" | translate}}</p>\r\n        <p id=\"login-error\" class=\"help-block\" ng-show=\"$ctrl.showPasswordIncorrect\">{{\"views.login.Username or password is incorrect\" | translate}}</p>\r\n        <p class=\"help-block\" ng-show=\"$ctrl.showNoAccountForApplication\">{{\"views.login.Your login credentials do not have access to MapSure Web Editor.\" | translate}}</p>\r\n      </div>\r\n      <div class=\"ie-old-warn alert alert-danger\" ng-if=\"$ctrl.isltIE9 || $ctrl.isIE9\">\r\n        <strong>{{\"common.OldIE\" | translate}}</strong>\r\n      </div>\r\n    </div>\r\n\r\n\r\n  </div>\r\n\r\n</form>\r\n";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("fleetviewApp").component("user", {
	    template: __webpack_require__(370),
	    controller: UserController
	  });
	
	  UserController.$inject = ["$scope", "$filter", "Messages", "alkAuthenticationService", "ALKChangePassword"];
	
	  function UserController($scope, $filter, Messages, alkAuthenticationService, ALKChangePassword) {
	    var vm = this;
	
	    vm.isProcessing = false;
	    vm.loginInfo = {};
	
	    vm.updateLogin = updateLogin;
	
	    function updateLogin() {
	      vm.isProcessing = true;
	      Messages.clear();
	
	      var changePassword = new ALKChangePassword(vm.loginInfo.existingPassword, vm.loginInfo.newPassword);
	
	      alkAuthenticationService.changePassword(changePassword).then(_onSuccess, _onError);
	    }
	
	    function _onSuccess() {
	      vm.loginInfo = {};
	      Messages.add("success", $filter("translate")("views.user.ChangePasswordSuccess"), {
	        showOnNextPage: false
	      });
	      vm.isProcessing = false;
	    }
	
	    function _onError(err) {
	      var errData = err.data;
	      var message = $filter("translate")("views.user.ChangePasswordUnknownError");
	      if (errData.reason === 1) {
	        message = $filter("translate")("views.user.ChangePasswordFailedToLogin");
	      }
	
	      Messages.add("danger", message, {
	        showOnNextPage: false
	      });
	
	      vm.isProcessing = false;
	    }
	
	    $scope.$on("$destroy", function () {
	      Messages.clear();
	    });
	  }
	})(window.angular);

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports = "<alk-main-nav></alk-main-nav>\r\n<div class=\"container  with-nav\">\r\n  <div class=\"forms-content forms-content-small\">\r\n    <div>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-6\">\r\n          <div class=\"panel\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <h3 translate=\"views.user.Change Password\"></h3>\r\n\r\n                <alk-messages></alk-messages>\r\n                <form name=\"loginInformationForm\" alk-submit=\"$ctrl.updateLogin()\" novalidate>\r\n                  <div alk-disabled=\"$ctrl.isProcessing\">\r\n                    <div class=\"form-group sm row\">\r\n                      <div class=\"col-md-6\" ng-class=\"{ 'has-error' : loginInformationForm.currentPassword.$invalid && loginInformationForm.submitted}\">\r\n                        <input id=\"currentPassword\" name=\"currentPassword\" class=\"form-control input-sm input-line\" required type=\"password\" ng-model=\"$ctrl.loginInfo.existingPassword\"\r\n                        />\r\n                        <label for=\"currentPassword\" class=\"control-label label-sm label-line\" translate=\"views.user.Current Password\"></label>\r\n                        <p ng-show=\"loginInformationForm.currentPassword.$error.required && loginInformationForm.submitted\" class=\"help-block\" translate=\"validation.required\"></p>\r\n                      </div>\r\n                      <div class=\"col-md-6\" ng-class=\"{ 'has-error' : loginInformationForm.password.$invalid && loginInformationForm.submitted}\">\r\n                        <input id=\"password\" name=\"password\" class=\"form-control input-sm input-line\" type=\"password\" ng-model=\"$ctrl.loginInfo.newPassword\"\r\n                          required ng-minlength=\"8\" ng-maxlength=\"20\" />\r\n                        <label for=\"password\" class=\"control-label label-sm label-line\" translate=\"views.user.New Password\"></label>\r\n                        <p ng-show=\"loginInformationForm.password.$error.required && loginInformationForm.submitted\" class=\"help-block\" translate=\"validation.required\"></p>\r\n                        <p ng-show=\"loginInformationForm.password.$error.maxlength && loginInformationForm.submitted\" class=\"help-block\" translate=\"validation.passwordMaximum\"></p>\r\n                        <p ng-show=\"loginInformationForm.password.$error.minlength && loginInformationForm.submitted\" class=\"help-block\" translate=\"validation.passwordMinimum\"></p>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group sm row\">\r\n                      <div class=\"col-md-6 col-md-push-6\" ng-class=\"{ 'has-error' : loginInformationForm.confirmPassword.$invalid && loginInformationForm.submitted}\">\r\n                        <input id=\"confirmPassword\" name=\"confirmPassword\" class=\"form-control input-sm input-line\" type=\"password\" ng-model=\"$ctrl.loginInfo.confirmPassword\"\r\n                          alk-compare=\"$ctrl.loginInfo.newPassword\" />\r\n                        <label for=\"confirmPassword\" class=\"control-label label-sm label-line\" translate=\"views.user.Confirm Password\"></label>\r\n                        <p ng-show=\"loginInformationForm.confirmPassword.$error.alkCompare && loginInformationForm.submitted\" class=\"help-block\"\r\n                          translate=\"validation.doesnt match\"></p>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"form-group sm row\">\r\n                      <div class=\"col-md-12\">\r\n                        <button type=\"submit\" class=\"btn btn-success btn-sm pull-right\"><i ng-show=\"$ctrl.isProcessing\" class=\"ico ico-circle-notch ico-spin ng-cloak\" ng-cloak></i> <span translate>{{($ctrl.isProcessing)? 'views.user.Updating Password': 'views.user.Update Password'}}</span> </button>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </form>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-6\">\r\n          <div class=\"panel\">\r\n            <h3 translate=\"directives.language-select.Language\">Language</h3>\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <div class=\"form-group\">\r\n                  <div alk-language-select alk-class=\"input-sm\"></div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	(function () {
	  "use strict";
	
	  tidLoginController.$inject = ["$rootScope", "$scope", "Messages", "$location", "tidLoginService", "alkAuthenticationService", "$q", "UserProvider"];
	  angular.module("fleetviewApp").controller("tidLoginController", tidLoginController);
	
	  tidLoginController.inject = ["$rootScope", "$scope", "Messages", "$location", "tidLoginService", "alkAuthenticationService", "$q", "UserProvider"];
	  function tidLoginController($rootScope, $scope, Messages, $location, tidLoginService, alkAuthenticationService, $q, UserProvider) {
	
	    var vm = this;
	    vm.formTab = "login";
	    vm.isProcessing = false;
	    vm.baseurl = window.location.protocol + "//" + window.location.host;
	    vm.tidConfig = {
	      eventHandler: function eventHandler(event) {
	
	        switch (event.type) {
	          case "SIGN_IN_USERNAME":
	            {
	              $scope.handleSignInUsername(event);
	              break;
	            }
	          case "SIGN_IN_LEGACY":
	            {
	              $scope.handleSignInLegacy();
	              break;
	            }
	          case "SIGN_IN_TID":
	            {
	              $scope.handleSignInTid(event);
	              break;
	            }
	          case "SIGN_IN_PASSWORD":
	            {
	              $scope.handleSignInPassword(event);
	              break;
	            }
	          case "SIGN_IN_CONFIRM_CANCEL":
	            {
	              $scope.handleSignInCancel();
	              break;
	            }
	          case "SIGN_IN_ACCOUNT":
	            {
	              if ($scope.useTidSSOLogin === true) {
	                $scope.tidSSOlogin(event.account);
	              } else {
	                $scope.handleSignInPassword(event);
	              }
	            }
	        }
	      } };
	
	    $rootScope.$on("forgotPassword", function (msg) {
	      vm.formTab = "forgot";
	    });
	
	    $scope.$watch("vm.formTab", function (newValue, oldValue) {
	      if (newValue !== oldValue) {
	        Messages.clear();
	      }
	    });
	
	    $scope.authCode = $location.search().code;
	    $scope.useTidSSOLogin = true;
	    $scope.showGenericError = false;
	    $scope.showPasswordIncorrect = false;
	    $scope.showNoAccountForApplication = false;
	    $scope.failedToLoginAccountExpired = false;
	    $scope.failedToValidateTidToken = false;
	    $scope.failedToFindUserInAccount = false;
	    $scope.showAccountDisabled = false;
	    $scope.userDoesNotExist = false;
	    $scope.noAccess = false;
	
	    var tmxTidService = tmxtidmodule.init(vm.tidConfig);
	    localStorage.removeItem("idToken");
	
	    $scope.handleSignInUsername = function (tidEvent) {
	      tidLoginService.getTidMigrationStatus(tidEvent.username).then(function (resp) {
	        if (resp.data.exists === false) {
	          $scope.userDoesNotExist = true;
	          tmxTidService.showSignInUsername();
	        } else if (resp.data.migrated === true && resp.data.exists === true) {
	          redirectToTid(tidEvent.username, "login");
	          $scope.userDoesNotExist = false;
	        } else {
	          $scope.showGenericError = false;
	          $scope.showPasswordIncorrect = false;
	          $scope.showNoAccountForApplication = false;
	          $scope.failedToLoginAccountExpired = false;
	          $scope.failedToValidateTidToken = false;
	          $scope.failedToFindUserInAccount = false;
	          $scope.showAccountDisabled = false;
	          $scope.userDoesNotExist = false;
	          tmxTidService.showSignInConfirm();
	        }
	      });
	    };
	
	    $scope.handleSignInCancel = function () {
	      tmxTidService.showSignInUsername();
	    };
	
	    $scope.handleSignInLegacy = function () {
	      $scope.useTidSSOLogin = false;
	      tmxTidService.showSignInPassword();
	    };
	
	    $scope.handleSignInTid = function (tidEvent) {
	      redirectToTid(tidEvent.username, "create");
	    };
	
	    $scope.handleSignInPassword = function (tidEvent) {
	      var userInfo = {
	        account: tidEvent.account,
	        password: tidEvent.password,
	        username: tidEvent.username
	      };
	      alkAuthenticationService.login(userInfo).then(function (response) {
	        window.location.replace(vm.baseurl + "/app/dashboard");
	      }).catch(function (error) {
	        switch (true) {
	          case error.status === "FailedToLoginDueToMultipleAccounts":
	            {
	              var accountDisplayObjs = createSelectAccountObjs(error.accounts);
	              tmxTidService.showSignInAccounts(accountDisplayObjs);
	              break;
	            }
	          case error.status === "FailedToLoginNotAuthorized":
	            {
	              $scope.showNoAccountForApplication = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          case error.status === "LoginNotExist":
	            {
	              $scope.showPasswordIncorrect = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          case error.status === "FailedToLogin":
	            {
	              $scope.showPasswordIncorrect = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          case error.isAccountDisabled === true:
	            {
	              $scope.showAccountDisabled = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          default:
	            {
	              $scope.showGenericError = true;
	              tmxTidService.showSignInUsername();
	            }
	        }
	      });
	    };
	
	    $scope.tidSSOlogin = function login(account) {
	      var deferred = $q.defer();
	      tidLoginService.tidSSOLogin(account, $scope.authCode).success(function (resp) {
	        window.localStorage.setItem("idToken", resp.idToken);
	        var authToken = resp.authToken,
	            username = resp.username,
	            accountName = resp.accountName,
	            forcePasswordReset = resp.forcePasswordReset;
	
	        alkAuthenticationService.getUserInfo(authToken, username, accountName, forcePasswordReset).then(function (userInfo) {
	          UserProvider.loadUser(userInfo.user);
	          window.location.replace(vm.baseurl + "/app/dashboard");
	        });
	      }).error(function (error) {
	        switch (error.status) {
	          case "FailedToLoginDueToMultipleAccounts":
	            {
	              var accountDisplayObjs = createSelectAccountObjs(error.accounts);
	              tmxTidService.showSignInAccounts(accountDisplayObjs);
	              break;
	            }
	          case "FailedToLoginNotAuthorized":
	            {
	              $scope.showNoAccountForApplication = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          case "LoginNotExist":
	            {
	              $scope.showPasswordIncorrect = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          case "FailedtoLogin":
	            {
	              $scope.showPasswordIncorrect = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          case "FailedToLoginAccountExpired":
	            {
	              $scope.failedToLoginAccountExpired = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          case "FailedToValidateTrimbleIdentityToken":
	            {
	              $scope.failedToValidateTidToken = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          case "NoAccess":
	            {
	              $scope.noAccess = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          case "FailedToFindUserInAccount":
	            {
	              $scope.failedToFindUserInAccount = true;
	              tmxTidService.showSignInUsername();
	              break;
	            }
	          default:
	            {
	              $scope.showGenericError = true;
	              tmxTidService.showSignInUsername();
	            }
	        }
	      });
	
	      return deferred.promise;
	    };
	
	    if ($scope.authCode) {
	      // After Tid login redirects back to app, log into SSO
	      $scope.tidSSOlogin(null);
	    }
	
	    function redirectToTid(emailAccount, prompt) {
	      var url = config.trimbleCloudUrl + "oauth/authorize";
	      url += "?client_id=" + config.trimbleCloudClientId;
	      url += "&response_type=code";
	      url += "&scope=openid " + config.trimbleApplication;
	      url += "&redirect_uri=" + vm.baseurl + "/tid/redirect";
	      url += "&prompt=" + prompt;
	      url += "&login_hint=" + encodeURIComponent(emailAccount);
	      window.location.href = url;
	    }
	
	    function createSelectAccountObjs(accounts) {
	      var accountDisplayObjs = [];
	      for (var i = 0; i < accounts.length; i++) {
	        accountDisplayObjs.push({
	          displayName: accounts[i].accountName,
	          value: accounts[i].accountName
	        });
	      }
	      return accountDisplayObjs;
	    }
	  }
	})();

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function () {
	
	  angular.module("fleetviewApp").factory("tidLoginService", ["$http", "$q", "UserProvider", "Messages", "$window", function alkService($http, $q, UserProvider, Messages, $window) {
	    var baseUrl = window.location.protocol + "//" + window.location.host;
	    function getTidMigrationStatus(username) {
	      var requestParams = {
	        method: "POST",
	        url: config.ssoUrl + "v1/trimbleid/migration-status",
	        data: {
	          email: username
	        }
	      };
	      return $http(requestParams);
	    }
	
	    function tidSSOLogin(account, authCode) {
	      var requestParams = {
	        method: "POST",
	        url: config.ssoUrl + "v1/trimbleid/authenticate",
	        data: {
	          authorizationCode: authCode,
	          redirectUrl: baseUrl + "/tid/redirect",
	          applicationName: config.applicationName,
	          trimbleApplication: config.trimbleApplication,
	          account: account
	        },
	        withCredentials: true
	      };
	      return $http(requestParams);
	    }
	
	    // Define the functions and properties to reveal.
	    var service = {
	      getTidMigrationStatus: getTidMigrationStatus,
	      tidSSOLogin: tidSSOLogin
	    };
	
	    return service;
	  }]);
	})();

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	    "use strict";
	
	    angular.module("fleetviewApp").factory("LocationItem", [function () {
	        function LocationItem(data, name) {
	            var self = this;
	            self.Name = name;
	            self.Address = data.Address;
	            self.Coords = data.Coords;
	            self.TypeIcon = "ico-circle-plus";
	            self.Type = -1;
	            if (data.type) {
	                self.Type = data.type;
	                if (data.type === 1) {
	                    self.TypeIcon = "ico-star";
	                } else if (data.type === 0) {
	                    self.TypeIcon = "ico-clock-o";
	                }
	            }
	            if (data.location) {
	                data = data.location;
	            }
	            self.Icon = "destination";
	            self.IconText = "D";
	            // self.LineClass = (data.Address.StreetAddress === "") ? "noAddress" : "";
	            self.CityStateZip = data.Address.City + ", " + data.Address.State + (data.Address.Zip !== null ? " " + data.Address.Zip : "");
	
	            self.CountyStr = data.Address.County !== "" ? data.Address.County + " County" : "";
	            self.ALKObj = data;
	            self.isVisible = false;
	
	            self.showMe = function () {
	                self.isVisible = true;
	            };
	
	            self.hideMe = function () {
	                self.isVisible = false;
	            };
	        }
	
	        return LocationItem;
	    }]);
	})();

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function () {
	  "use strict";
	
	  angular.module("alk.maps").directive("alkmap", ["$rootScope", "$location", "ALKMaps", "mapService", "UserProvider", "Messages", "$translate", "$timeout", "$window", "savedMapInfo", "mapUtilities", "$injector", function ($rootScope, $location, ALKMaps, mapService, UserProvider, Messages, $translate, $timeout, $window, savedMapInfo, mapUtilities, $injector) {
	
	    // Tile loading error counts
	    var errorCount = 0;
	    var userInfo;
	    var availableRegions;
	    if (UserProvider.getUser().isLoggedIn) {
	      userInfo = UserProvider.getUser();
	      availableRegions = userInfo.availableRegions || [userInfo.region];
	    } else {
	      userInfo = {
	        region: "NA",
	        dataVersion: "Current"
	      };
	      availableRegions = ["NA"];
	    }
	    var baseLayerDefs = mapUtilities.getMapBaseLayerDefs();
	
	    availableRegions.sort(function (a, b) {
	      return baseLayerDefs[a].index - baseLayerDefs[b].index;
	    });
	
	    var disableAddCenterParam = false;
	
	    /**
	     * Tile load error handler
	     */
	    function onTileError() {
	      errorCount++;
	    }
	
	    /**
	     * Tile load start handler
	     */
	    function onLoadStart() {
	      errorCount = 0;
	    }
	
	    /**
	     * Tile load end handler
	     */
	    function onLoadEnd() {
	      var scope = this;
	      if (errorCount > 0) {
	        errorCount = 0;
	
	        Messages.add("danger", $translate.instant("common.relogin"));
	        UserProvider.clearUser();
	        $location.path("/login");
	
	        if (!scope.$$phase) {
	          scope.$apply();
	        }
	      }
	    }
	
	    /**
	     * Map move end handler
	     * For one data version web apps like MapSure, MapExact or Content Tools account with only one data version, only update center params
	     * For multiple data versions Content Tools, add logic to switch base layers and region/dataVersion/gridDataVersion in userInfo automatically
	     */
	    function onMoveEnd() {
	      var baseLayers = this.baseLayers;
	      var scope = this.scope;
	      var map = scope.map;
	      if (map == null) {
	        return;
	      }
	
	      $timeout(function () {
	        scope.keyboardControl.activate();
	        updateUrlCenterParameter(scope);
	        $rootScope.$broadcast("MapMove");
	      });
	
	      // multiple data region support scenario
	      if (baseLayers.length > 1) {
	        var mapCenter = map.center.clone();
	        mapCenter.transform(map.getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));
	        // Code originated from Rishi.
	        var newRegion = mapUtilities.getRegionFromLonLat(mapCenter.lon, mapCenter.lat);
	
	        /*
	          After we get the new region, we need to check if the account has access to the base layer for this region, such as NAMap, OCMap..
	          If user does not have access but has access to WWMap, then use WWMap instead
	          If neither, do nothing
	        */
	        var newRegionLayer = _.find(map.layers, { name: newRegion + "Map" }) || _.find(map.layers, { name: "WWMap" });
	        if (!newRegionLayer) {
	          newRegion = userInfo.region;
	        } else if (newRegionLayer.name == "WWMap") {
	          newRegion = "WW";
	        }
	
	        // if it zooms to a new region, need to update region and data version saved in userInfo
	        if (userInfo.region != newRegion) {
	          userInfo.region = newRegion;
	          userInfo.dataVersion = "PCM_" + newRegion;
	          map.setBaseLayer(_.find(map.layers, { name: newRegion + "Map" }));
	
	          // if app has constantsService in injector, needs to call getConstants to update gridDataVersion too.
	          if ($injector.has("constantsService")) {
	            $injector.get("constantsService").getConstants(userInfo.dataVersion).then(function (PCMWS_CONSTANTS) {
	              userInfo.gridDataVersion = PCMWS_CONSTANTS.gridDataVersion;
	              UserProvider.loadUser(userInfo);
	              $rootScope.$broadcast("RegionUpdated");
	            });
	          }
	        }
	      }
	    }
	
	    /**
	     * Creates base layers.
	     */
	    function createBaseLayers(scope, savedInfo) {
	      var layers = [];
	      var availableBaseLayers = [];
	      // add one or more base layers. Note the first layer should be set to default base layer
	      for (var i = 0; i < availableRegions.length; i++) {
	        availableBaseLayers.push(baseLayerDefs[availableRegions[i]]);
	      }
	
	      for (var layerIndex = 0; layerIndex < availableBaseLayers.length; layerIndex++) {
	
	        var layerDef = availableBaseLayers[layerIndex];
	        var baseLayer = new ALKMaps.Layer.BaseMap(layerDef.name, {
	          region: layerDef.region,
	          dataset: layerDef.dataset
	        }, {
	          localLanguage: true,
	          wrapDateLine: true,
	          isBaseLayer: layerIndex === 0 ? true : false,
	          visibility: layerIndex === 0 ? true : false
	        });
	        baseLayer.setSatelliteImageSource(scope.mapSatelliteProvider || 0);
	        baseLayer.events.register("tileerror", scope, onTileError);
	        baseLayer.events.register("loadstart", scope, onLoadStart);
	        baseLayer.events.register("loadend", scope, onLoadEnd);
	        layers.push(baseLayer);
	      }
	
	      return layers;
	    }
	
	    /**
	     * Creates click handler
	     */
	    function createClickHandler(scope) {
	      var c = new ALKMaps.Handler.Click(new ALKMaps.Control(), {
	        click: function click() {
	          if (scope.keyboardControl) {
	            scope.keyboardControl.activate();
	          }
	          $rootScope.$broadcast("MapClickHandler");
	        }
	      }, {
	        single: true
	      });
	
	      return c;
	    }
	
	    /**
	     *  Updates URL center parameter
	     */
	    function updateUrlCenterParameter(scope) {
	      if (scope.addCenterParam !== false && disableAddCenterParam === false) {
	        var center = scope.map.getCenter().transform(scope.map.getProjectionObject(), new ALKMaps.Projection("EPSG:4326")),
	            zoom = scope.map.getZoom(),
	            precision = Math.max(0, Math.ceil(Math.log(zoom) / Math.LN2));
	
	        var urlCenterParam = [zoom, center.lat.toFixed(precision), center.lon.toFixed(precision)].join(",");
	        savedMapInfo.saveCurrentInfo(scope.map.getCenter(), scope.map.getZoom(), scope.map.style);
	        $location.search("center", urlCenterParam);
	      }
	    }
	
	    /**
	     * Link
	     */
	    function link(scope, element, attrs) {
	      if (UserProvider.getUser() && UserProvider.getUser().authToken) {
	        {
	          ALKMaps.APIKey = config.alkmapsApiKey + "|" + UserProvider.getUser().authToken;
	        }
	      }
	
	      if ($window.localStorage.getItem("jwtToken")) {
	        {
	          ALKMaps.APIKey = config.alkmapsApiKey + " ";
	        }
	      }
	
	      // set the initial language of the map
	      if ($translate.use()) {
	        ALKMaps.Lang.setCode($translate.use().substring(0, 2));
	      }
	
	      // watch for changes to the locale and update the map and controls
	      $rootScope.$on("$localeChangeSuccess", function (e, locale) {
	        ALKMaps.Lang.setCode(locale.substring(0, 2));
	      });
	
	      var mapId = attrs.id || "map";
	      scope.elementWithFocus = false;
	      scope.keyboardControl = null;
	      scope.navControl = null;
	      var savedInfo = savedMapInfo.getSavedInfo();
	      scope.map = mapService.getMap();
	      scope.map.render(mapId);
	      var baseLayers = createBaseLayers(scope, savedInfo);
	      scope.map.addLayers(baseLayers);
	      scope.map.setBaseLayer(baseLayers[0]);
	      scope.map.setCenter(savedInfo.mapCenter, savedInfo.mapZoom);
	      var c = createClickHandler(scope);
	      c.setMap(scope.map);
	      c.activate();
	      scope.map.events.register("moveend", {
	        scope: scope,
	        baseLayers: baseLayers
	      }, onMoveEnd);
	
	      //Handle disabling of map keyboard tracking for specific input controls
	      for (var i = 0; i < scope.map.controls.length; i++) {
	        if (scope.map.controls[i].displayClass === "olControlKeyboardDefaults") {
	          scope.keyboardControl = scope.map.controls[i];
	        }
	      }
	
	      scope.$on("MapInputFocus", function (event, message) {
	        // jshint ignore:line
	        scope.keyboardControl.deactivate();
	        scope.elementWithFocus = message;
	      });
	
	      scope.$on("MapInputBlur", function () /*event, message */{
	        scope.keyboardControl.activate();
	        scope.elementWithFocus = false;
	      });
	
	      $rootScope.$on("DisableAddCenterParam", function () {
	        disableAddCenterParam = true;
	      });
	
	      scope.$on("$destroy", function () {
	        mapService.releaseMap();
	        var layerIndex;
	        for (layerIndex = 0; layerIndex < baseLayers.length; layerIndex++) {
	          var basemap = baseLayers[layerIndex];
	          basemap.events.unregister("tileerror", scope, onTileError);
	          basemap.events.unregister("loadstart", scope, onLoadStart);
	          basemap.events.unregister("loadend", scope, onLoadEnd);
	          scope.map.removeLayer(basemap);
	        }
	        scope.map.events.unregister("moveend", {
	          scope: scope,
	          baseLayers: baseLayers
	        }, onMoveEnd);
	        c.deactivate();
	        scope.map = null;
	        errorCount = 0;
	      });
	
	      updateUrlCenterParameter(scope);
	    }
	
	    // Usage: <div alkmap id="map" map-satellite-provider="{{userInfo.satelliteProvider}}" map-region="userInfo.region" map-dataset="userInfo.dataVersion" multiple-data-region="true"></div>
	    //
	    // Creates:
	    //TODO: add attribs for center and zoom
	    var directive = {
	      link: link,
	      restrict: "AE",
	      scope: {
	        apikey: "@",
	        mapSatelliteProvider: "@",
	        mapDataset: "=",
	        mapRegion: "=",
	        multipleDataRegion: "=", // If true, regional street map layers will be used instead of the one base layer.
	        addCenterParam: "="
	      }
	    };
	
	    return directive;
	  }]);
	})();

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("fleetviewApp").directive("alkmapsNavigation", [function () {
	    var directive = {
	      restrict: "AE",
	      scope: {
	        mapId: "@"
	      },
	      controllerAs: "vm",
	      controller: ["$scope", "mapService", "ALKMaps", function ($scope, mapService, ALKMaps) {
	        var vm = this;
	
	        var zoomBoxControl = new ALKMaps.Control.ZoomBox({ autoActivate: false });
	        var navHistoryControl = new ALKMaps.Control.NavigationHistory();
	
	        mapService.addControl("zoomBox", zoomBoxControl);
	        mapService.addControl("navHistory", navHistoryControl);
	
	        vm.mapId = $scope.mapId;
	
	        vm.boxZoomState = false;
	
	        vm.isBackDisabled = function () {
	          return navHistoryControl.previousStack.length <= 1;
	        };
	
	        vm.isForwardDisabled = function () {
	          return navHistoryControl.nextStack.length <= 0;
	        };
	
	        vm.zoomIn = function () {
	          mapService.zoomIn(vm.mapId);
	        };
	
	        vm.zoomOut = function () {
	          mapService.zoomOut(vm.mapId);
	        };
	
	        vm.toggleBoxZoom = function () {
	          vm.boxZoomState = !vm.boxZoomState;
	
	          if (vm.boxZoomState) {
	            zoomBoxControl.activate();
	          } else {
	            zoomBoxControl.deactivate();
	          }
	        };
	
	        vm.goBack = function () {
	          navHistoryControl.previousTrigger();
	        };
	
	        vm.goForward = function () {
	          navHistoryControl.nextTrigger();
	        };
	
	        vm.goToLocation = function () {
	          mapService.zoomToCurrentLocation();
	        };
	      }],
	      template: "<div class=\"map-btns btn-group-vertical\">" + "    <button class=\"btn btn-default btn-nofocus map-btn zoom-in-btn\" ng-click=\"vm.zoomIn()\" title=\"{{'views.alkmapsNavigation.ZoomIn' | translate}}\"><i class=\"ico ico-plus\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn zoom-out-btn\" ng-click=\"vm.zoomOut()\" title=\"{{'views.alkmapsNavigation.ZoomOut' | translate}}\"><i class=\"ico ico-minus\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn zoom-box-btn\" ng-click=\"vm.toggleBoxZoom()\" title=\"{{((vm.boxZoomState)?'views.alkmapsNavigation.DragToPan':'views.alkmapsNavigation.DragToZoom') | translate}}\"><i class=\"ico\" ng-class=\"(vm.boxZoomState)?'ico-hand':'ico-box'\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn map-prev-btn\" ng-click=\"vm.goBack()\" ng-disabled=\"vm.isBackDisabled()\" title=\"{{'views.alkmapsNavigation.PreviousView' | translate}}\"><i class=\"ico ico-back\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn map-next-btn\" ng-click=\"vm.goForward()\" ng-disabled=\"vm.isForwardDisabled()\" title=\"{{'views.alkmapsNavigation.NextView' | translate}}\"><i class=\"ico ico-next\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn map-loc-btn\" ng-click=\"vm.goToLocation()\" title=\"{{'views.alkmapsNavigation.ZoomToLocation' | translate}}\"><i class=\"ico ico-location-arrow\"></i></button>" + "</div>"
	    };
	
	    return directive;
	  }]);
	})();

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.marketing", []);
	})(window.angular);

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("alk.marketing").controller("landingController", landingController);
	
	  landingController.$inject = ["$rootScope", "$scope", "$http", "Messages", "$injector"];
	  function landingController($rootScope, $scope, $http, Messages, $injector) {
	
	    var vm = this;
	    vm.formTab = "login";
	    vm.isProcessing = false;
	
	    $rootScope.$on("forgotPassword", function (msg) {
	      vm.formTab = "forgot";
	    });
	
	    $scope.$watch("vm.formTab", function (newValue, oldValue) {
	      if (newValue !== oldValue) {
	        Messages.clear();
	      }
	    });
	  }
	})();

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function () {
	
	  angular.module("alk.marketing").directive("marketingFooter", marketingFooter);
	
	  //marketingFooter.$inject = [];
	  function marketingFooter() {
	    var directive = {
	      template: __webpack_require__(379),
	      link: link,
	      restrict: "E",
	      scope: {}
	    };
	    return directive;
	
	    function link(scope, element, attrs) {}
	  }
	})();

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<footer>\r\n  <style>\r\n  .pb-5{padding-bottom: 3rem!important;}\r\n  .pt-5{padding-top: 2rem!important;}\r\n  .py-3{padding-top: 1rem!important;padding-bottom: 1rem!important;}\r\n  .py-5{padding-top: 3rem!important;padding-bottom: 3rem!important;}\r\n  .footer-trimble-maps{background-color: #262533;color: #7b7a86!important;}\r\n  .footer-trimble-maps a{color: #7b7a86;}\r\n  .footer-trimble-maps a:hover{text-decoration: none;color: #fff;}\r\n  .footer-trimble-corp{background-color: #00437b;color:#fff}\r\n  .rounded-pill {border-radius: 50px!important;}\r\n  .btn-outline {background: transparent;border: 1px solid;}\r\n  .footer-trimble-maps a svg {fill:#fff;opacity:.7}\r\n  .footer-trimble-maps a svg:hover {opacity:.9}\r\n  .text-white{color:#fff!important}\r\n  .border{border:1px #7b7a86 solid !important;}\r\n  .pcmiler-asterisk{line-height: 50%;vertical-align: middle}\r\n  .text-warning{color:#ffc107!important}\r\n  </style>\r\n  <div class=\"container-fluid py-5 footer-trimble-maps\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12 text-white mx-auto text-center pb-5 pt-5\">\r\n          <img src=\"https://maps.trimble.com/img/footer/footer-trimble-maps.svg\" alt=\"Routing &amp; Scheduling - Visualization - Navigation\"\r\n            class=\"img-responsive mx-auto text-center center-block\" width=\"850\" height=\"29\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-12 col-md-6\">\r\n          <p>\r\n            <a href=\"https://maps.trimble.com\" class=\"text-warning\">Trimble MAPS</a>\r\n            is dedicated to transforming journeys through innovative routing,\r\n            scheduling, visualization and navigation solutions. Rooted by map\r\n            data and map-centric technology specifically designed for commercial\r\n            vehicles, its development platform and trusted products are made for\r\n            a broad range of industries, workforces and fleets of all sizes.\r\n          </p>\r\n          <a href=\"https://www.trimble.com\"\r\n            class=\"btn btn-outline btn-rounded border text-light rounded-pill text-uppercase\">\r\n            More about Trimble\r\n          </a>\r\n        </div>\r\n        <div class=\"col-sm-6 col-md-2\">\r\n          <ul class=\"list-unstyled notranslate\">\r\n            <li>\r\n              <a href=\"https://maps.trimble.com/solutions/#appian\" target=\"_blank\" rel=\"noopener\">Appian</a>\r\n            </li>\r\n            <li>\r\n              <a href=\"https://copilotgps.com/\" target=\"_blank\" rel=\"noopener\">CoPilot GPS</a>\r\n            </li>\r\n            <li>\r\n              <a href=\"https://copilotpro.com/\" target=\"_blank\" rel=\"noopener\">CoPilot Professional</a>\r\n            </li>\r\n            <li>\r\n              <a href=\"https://copilottruck.com/\" target=\"_blank\" rel=\"noopener\">CoPilot Truck</a>\r\n            </li>\r\n            <li>\r\n              <a href=\"https://mileonapp.com/\" target=\"_blank\" rel=\"noopener\">MileOn by PC<span\r\n                  class=\"pcmiler-asterisk\">*</span>MILER</a>\r\n            </li>\r\n            <li>\r\n              <a href=\"https://www.pcmiler.com/\" target=\"_blank\" rel=\"noopener\">PC<span\r\n                  class=\"pcmiler-asterisk\">*</span>MILER</a>\r\n            </li>\r\n            <li>\r\n              <a href=\"https://developer.trimblemaps.com\" target=\"_blank\" rel=\"noopener\">Development Platform</a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"col-sm-6 col-md-2\">\r\n          <ul class=\"list-unstyled\">\r\n            <li>\r\n              <a href=\"https://maps.trimble.com/legal/\" target=\"_blank\" rel=\"noopener\">Legal</a>\r\n            </li>\r\n            <li>\r\n              <a href=\"https://maps.trimble.com/privacy/\" target=\"_blank\" rel=\"noopener\">Privacy</a>\r\n            </li>\r\n            <li>\r\n              <a href=\"https://maps.trimble.com/cookies/\" target=\"_blank\" rel=\"noopener\">Cookies</a>\r\n            </li>\r\n            <li>\r\n              <a href=\"https://maps.trimble.com/contact/\" target=\"_blank\" rel=\"noopener\">Contact</a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"col-sm-6 col-md-2\">\r\n          <a href=\"https://www.linkedin.com/company/trimblemaps\" target=\"_blank\" rel=\"noopener\">\r\n            <svg width=\"36\" height=\"36\" aria-hidden=\"true\" data-icon=\"linkedin\"\r\n              class=\"svg-inline--fa fa-linkedin fa-w-14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\r\n              viewBox=\"0 0 448 512\">\r\n              <path\r\n                d=\"M416 32H31.9C14.3 32 0 46.5.0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6.0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3.0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2.0 38.5 17.3 38.5 38.5.0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6.0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2.0 79.7 44.3 79.7 101.9V416z\">\r\n              </path>\r\n            </svg>\r\n          </a>\r\n          <a href=\"https://twitter.com/trimblemaps\" target=\"_blank\" rel=\"noopener\">\r\n            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" viewBox=\"0 0 448 512\">\r\n              <path\r\n                d=\"M4e2 32H48C21.5 32 0 53.5.0 80v352c0 26.5 21.5 48 48 48h352c26.5.0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5.0 86.7-66 186.6-186.6 186.6-37.2.0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7.0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447.0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9.0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z\">\r\n              </path>\r\n            </svg>\r\n          </a>\r\n          <a href=\"https://vimeo.com/trimblemaps\" target=\"_blank\" rel=\"noopener\">\r\n            <svg width=\"36\" height=\"36\" aria-hidden=\"true\" data-icon=\"vimeo\" class=\"svg-inline--fa fa-vimeo fa-w-14\"\r\n              role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\r\n              <path\r\n                d=\"M403.2 32H44.8C20.1 32 0 52.1.0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7.0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9.0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4.0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z\">\r\n              </path>\r\n            </svg>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"container-fluid footer-trimble-corp\">\r\n    <div class=\"container\">\r\n      <div class=\"row py-3 text-white\">\r\n        <div class=\"col-12\">\r\n          <a href=\"https://www.trimble.com/Corporate/Copyrights.aspx\" target=\"_blank\" rel=\"noopener\"\r\n            class=\"text-white mr-3 pl-4\">\r\n            &copy; Copyright 2021, Trimble Inc.\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</footer>\r\n";

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function () {
	  "use strict";
	
	  angular.module("alk.marketing").directive("hubspotForm", hubspotForm);
	
	  function hubspotForm() {
	
	    var hubspotFormController = ["$window", function ($window) {
	
	      $window.hbspt.forms.create({
	        portalId: config.hubspotPortalId,
	        formId: config.hubspotFormId,
	        target: "#hubSpotFormDiv",
	        css: "" // allow to use custom css style
	      });
	    }];
	
	    var directive = {
	      template: __webpack_require__(381),
	      restrict: "E",
	      scope: {},
	      controller: hubspotFormController
	    };
	
	    return directive;
	  }
	})();

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<div id=\"hubSpotFormDiv\"></div>";

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.sso", []);
	})(window.angular);
	
	__webpack_require__(383);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function (angular) {
	  "use strict";
	
	  angular.module("alk.sso").service("ssoService", ["$q", "$http", "UserProvider", function ($q, $http, UserProvider) {
	
	    return {
	      getUsersInProduct: getUsersInProduct,
	      createNewUser: createNewUser,
	      updateExistingUser: updateExistingUser,
	      removeUser: removeUser
	    };
	
	    function getEncodedHeader() {
	      var basicAuthHeader = UserProvider.getUser().userName + ":" + UserProvider.getUser().account + ":" + UserProvider.getUser().authToken;
	      return "Basic " + window.btoa(basicAuthHeader);
	    }
	
	    //Get users in the current logged in account
	    function getUsersInProduct(params) {
	      var userInfoRequest = {
	        url: config.mapsureUrl + "admin/users",
	        method: "GET",
	        headers: {
	          Authorization: getEncodedHeader()
	        }
	      };
	      return $http(userInfoRequest);
	    }
	
	    function createNewUser(params) {
	      return $http.post(config.mapsureUrl + "admin/users/createNewUser", {
	        FirstName: params.firstName,
	        LastName: params.lastName,
	        Email: params.emailAddress
	      }, {
	        params: {
	          role: params.role
	
	        },
	        headers: {
	          Authorization: getEncodedHeader()
	        }
	      });
	    }
	
	    function updateExistingUser(params) {
	      return $http.post(config.mapsureUrl + "admin/users/updateUser", {
	        Email: params.emailAddress,
	        Role: params.role,
	        UserState: params.userState ? params.userState : 1
	      }, {
	        headers: {
	          Authorization: getEncodedHeader()
	        }
	      });
	    }
	
	    //Removes a user from account/product association (does not hard-delete them or remove from other account/product association)
	    function removeUser(params) {
	      return $http.post(config.mapsureUrl + "admin/users/removeUser", {
	        Email: params.emailAddress,
	        Role: params.role,
	        UserState: params.userState ? params.userState : 1
	      }, {
	        headers: {
	          Authorization: getEncodedHeader()
	        }
	      });
	    }
	  }]);
	})(window.angular);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.email", []);
	})(window.angular);
	
	__webpack_require__(385);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function (angular) {
	  "use strict";
	
	  angular.module("alk.email").service("alkEmailService", ["$q", "$http", function ($q, $http) {
	    return {
	      sendMapsureWelcomeEmail: sendMapsureWelcomeEmail,
	      sendRouteReporterWelcomeEmail: sendRouteReporterWelcomeEmail
	    };
	
	    //Sends MapSure Email
	    function sendMapsureWelcomeEmail(email, isNewSSO) {
	      return $http.post(config.mapsureUrl + "user/welcome", {
	        email: email,
	        isNewSSOUser: isNewSSO
	      });
	    }
	
	    //Sends FleetView Email
	    function sendRouteReporterWelcomeEmail(email, isExistingSSO) {
	      return $http.post(config.fleetViewUrl + "user/welcome", {
	        email: email,
	        isNewSSOUser: isExistingSSO
	      });
	    }
	  }]);
	})(window.angular);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function (angular) {
	
	  angular.module("alk.companyAdmin", ["alk.email"]);
	})(window.angular);
	
	__webpack_require__(387);
	__webpack_require__(388);
	__webpack_require__(391);

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (angular) {
	  "use strict";
	
	  angular.module("alk.companyAdmin").controller("companyAdminController", companyAdminController);
	
	  companyAdminController.$inject = ["UserProvider"];
	
	  function companyAdminController(UserProvider) {
	    var hasCompanyAdminAccess = false;
	    var vm = this;
	    vm.activeTab = "users";
	    if (UserProvider.getUser().roles[0] === "ALK Administrator" || UserProvider.getUser().roles[0] === "ALK Support" || UserProvider.getUser().roles[0] === "Company Administrator" || UserProvider.getUser().roles[0] === "cloudxchange Approver" || UserProvider.getUser().roles[0] && UserProvider.getUser().roles[0].toLowerCase() === "support") {
	      this.hasCompanyAdminAccess = true;
	    }
	  }
	})(window.angular);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var config = __webpack_require__(110);
	
	(function () {
	  "use strict";
	
	  angular.module("alk.companyAdmin").directive("commonAccountUsers", commonAccountUsers);
	
	  function commonAccountUsers() {
	    var directive = {
	      bindToController: true,
	      controller: commonAccountUsersController,
	      controllerAs: "vm",
	      restrict: "E",
	      scope: {}
	    };
	    directive.template = __webpack_require__(389);
	    return directive;
	  }
	
	  commonAccountUsersController.$inject = ["$q", "$http", "UserProvider", "_", "alkModalService", "$translate", "$scope", "$timeout", "$state", "ssoService", "alkEmailService", "$injector", "mapUtilities"];
	
	  function commonAccountUsersController($q, $http, UserProvider, _, alkModalService, $translate, $scope, $timeout, $state, ssoService, alkEmailService, $injector, mapUtilities) {
	    mapUtilities.attachScopeToMapEvents($scope);
	    var vm = this,
	        EDIT = "edit",
	        NEW = "new";
	
	    var applicationName = "";
	    var addon = "";
	    var Users;
	    var DriverGroups;
	    var VehicleGroups;
	    // capitalization for support role is different depending on environment, might as well get rid of that factor
	    var currentUserRoles = UserProvider.getUser().roles.map(function (role) {
	      return role.toLowerCase();
	    });
	
	    //FleetView will use a different API since its users must be rows in FleetUsers table beacuse they can have vehicle/driver group associations
	    //So it hits the FleetLink api.
	    //ContentTools just hits the regular SSO API since we don't want its users to become fleetusers
	    if (true) {
	      applicationName = "CoPilot FleetView";
	      vm.isFleetView = true;
	      Users = $injector.get("Users");
	      DriverGroups = $injector.get("DriverGroups");
	      VehicleGroups = $injector.get("VehicleGroups");
	    } else if (process.env.ALK_APP === "contenttools") {
	      applicationName = "CloudXChange";
	      addon = "MapSure Web Editor";
	    }
	
	    vm.displayMode = EDIT; // edit or new; This matters only if vm.listView is false.
	    vm.enableCheckEmail = null;
	    vm.firstName = "";
	    vm.isNewUser = null;
	    vm.isExistingSSOUser = null;
	    vm.listView = true;
	    vm.lastName = "";
	    vm.tab = "vehicles";
	    vm.selectedUser = null;
	    vm.userEmailSearchTerm = "";
	    vm.userNameSearchTerm = "";
	    vm.userList = [];
	    vm.sortType = "firstName";
	
	    init();
	
	    function init() {
	      vm.isLoading = true;
	
	      if (vm.isFleetView) {
	        var promise1 = Users.getUsers(applicationName);
	        var promise2 = DriverGroups.getDriverGroups();
	        var promise3 = VehicleGroups.getVehicleGroups();
	
	        $q.all([promise1, promise2, promise3]).then(function (resultsArray) {
	          vm.userList = resultsArray[0];
	          vm.allDriverGroups = resultsArray[1];
	          vm.allVehicleGroups = resultsArray[2];
	          if (currentUserRoles[0] !== "alk administrator" && currentUserRoles[0] !== "alk support") {
	            initFinish();
	          } else {
	            vm.isLoading = false;
	          }
	        });
	      } else {
	        ssoService.getUsersInProduct().then(function (results) {
	          //Convert to common format
	          vm.userList = _.map(results.data, function (user) {
	            var role = user.roleName;
	            if (role === "Company Administrator") role = "CompanyAdmin";
	            return {
	              accountId: user.accountId,
	              emailAddress: user.userName,
	              firstName: user.firstName,
	              lastName: user.lastName,
	              role: role,
	              roleId: user.roleId,
	              userId: user.userId,
	              driverGroups: [],
	              vehicleGroups: []
	            };
	          });
	          if (currentUserRoles[0] !== "alk administrator" && currentUserRoles[0] !== "alk support") initFinish();else {
	            vm.isLoading = false;
	          };
	        });
	      }
	    }
	
	    function initFinish() {
	      var validRoles = ["CompanyAdmin", "User"];
	      // Support role users should be able to see others with support role
	      var shouldSeeSupport = currentUserRoles.includes("support") || currentUserRoles.includes("company administrator");
	      if (shouldSeeSupport) {
	        //TODO: look at backend for fleetview and content tools and see if different strings for Support and
	        //ALK Support can be changed without too much work so both cases don't have to be accounted for
	        validRoles.push("support");
	        validRoles.push("Support");
	      }
	      vm.userList = _.filter(vm.userList, function (user) {
	        if (validRoles.includes(user.role)) {
	          return true;
	        }
	        return false;
	      });
	      vm.isLoading = false;
	    }
	
	    function resetForms() {
	      vm.firstName = "";
	      vm.lastName = "";
	      vm.enableCheckEmail = null;
	      vm.userExists = false;
	      vm.userEmailSearchTerm = "";
	      vm.selectedUser = null;
	      vm.driverGroups = [];
	      vm.vehicleGroups = [];
	      vm.isNewUser = false;
	      vm.hasChanges = false;
	    }
	
	    vm.backToListPanel = function () {
	      resetForms();
	      vm.listView = true;
	    };
	
	    vm.checkEmail = function () {
	      var deferred = $q.defer();
	
	      vm.userExists = false;
	      var existingUser = _.find(vm.userList, function (user) {
	        return user.emailAddress === vm.userEmailSearchTerm;
	      });
	
	      if (existingUser) {
	        vm.enableCheckEmail = false;
	        vm.userExists = true;
	        return;
	      }
	
	      vm.checkEmailService().then(function (result) {
	        vm.isNewUser = false;
	        vm.enableCheckEmail = false;
	        vm.firstName = applicationName === "CoPilot FleetView" ? result.firstName : result.data.firstName;
	        vm.lastName = applicationName === "CoPilot FleetView" ? result.lastName : result.data.lastName;
	        if (applicationName === "CoPilot FleetView") {
	          vm.vehicleGroups = result.vehicleGroups;
	          vm.driverGroups = result.driverGroups;
	        }
	
	        vm.isExistingSSOUser = true;
	      }, function (err) {
	        if (err.status === 404) {
	          vm.isNewUser = true;
	          vm.enableCheckEmail = false;
	          vm.isExistingSSOUser = false;
	        }
	      });
	    };
	
	    vm.checkEmailService = function () {
	      var deferred = $q.defer();
	      var request = {
	        url: config.ssoUrl + "v1/users",
	        method: "GET",
	        headers: {
	          "Authorization": "Bearer " + UserProvider.getUser().authToken
	        },
	        params: {
	          email: vm.userEmailSearchTerm
	        }
	      };
	      if (applicationName === "CloudXChange") {
	        $http(request).then(function (response) {
	          deferred.resolve(response);
	        }, function (err) {
	          deferred.reject(err);
	        });
	      } else {
	        $http(request).then(function (response) {
	          Users.getUserWithGroupInfo(response.data.id).then(function (groupResponse) {
	            deferred.resolve(groupResponse);
	          }, function (err) {
	            deferred.reject(err);
	          });
	        }, function (err) {
	          deferred.reject(err);
	        });
	      }
	
	      return deferred.promise;
	    };
	
	    vm.checkEmailDoOver = function () {
	      resetForms();
	    };
	
	    vm.isLoggedInUser = function (user) {
	      return user.emailAddress === UserProvider.getUser().userName;
	    };
	
	    vm.getFilteredUserList = function () {
	      return _.filter(vm.userList, function (user) {
	        var lowerFirstName = user.firstName == null ? "" : user.firstName.toLowerCase();
	        var lowerLastName = user.lastName == null ? "" : user.lastName.toLowerCase();
	        var lowerSearch = vm.userNameSearchTerm.toLowerCase();
	        return lowerFirstName.includes(lowerSearch) || lowerLastName.includes(lowerSearch) || (lowerFirstName + " " + lowerLastName).toLowerCase().includes(lowerSearch) || user.emailAddress.toLowerCase().includes(lowerSearch);
	      });
	    };
	
	    vm.cancel = function () {
	      if (vm.hasChanges) {
	        alkModalService.show({
	          size: "sm"
	        }, {
	          headerText: $translate.instant("service.mapService.Unsaved Changes"),
	          bodyText: $translate.instant("service.linkdrawService.You have unsaved changes."),
	          closeButtonText: $translate.instant("service.mapService.Go Back"),
	          actionButtonText: $translate.instant("service.mapService.Discard Changes")
	        }).then(function () {
	          vm.backToListPanel();
	        }, function () {//Cancel
	
	        });
	      } else {
	        vm.backToListPanel();
	      }
	    };
	
	    vm.deleteUser = function (user) {
	      alkModalService.show({
	        size: "sm"
	      }, {
	        headerText: $translate.instant("view.accountUser.deletConfirmTitle"),
	        bodyText: $translate.instant("view.accountUser.deletConfirmBody"),
	        closeButtonText: $translate.instant("common.Cancel"),
	        actionButtonText: $translate.instant("common.OK")
	      }).then(function () {
	        // OK
	        if (vm.isFleetView) {
	          Users.removeUser(user.userId, applicationName).then(function () {
	            $state.reload();
	          });
	        } else {
	          ssoService.removeUser({
	            emailAddress: user.emailAddress,
	            role: user.role === "CompanyAdmin" ? "Company Administrator" : user.role
	          }).then(function () {
	            $state.reload();
	          });
	        }
	      }, function () {//Cancel
	
	      });
	    };
	
	    vm.editUser = function (user) {
	      vm.listView = false;
	      vm.displayMode = EDIT;
	      vm.selectedUser = user;
	      vm.driverGroups = angular.copy(user.driverGroups);
	      vm.vehicleGroups = angular.copy(user.vehicleGroups);
	      vm.selectedRole = user.role;
	    };
	
	    vm.newUser = function () {
	      vm.listView = false;
	      vm.displayMode = NEW;
	      vm.driverGroups = [];
	      vm.vehicleGroups = [];
	      vm.selectedRole = "User";
	    };
	
	    vm.saveExistingUser = function () {
	      vm.selectedUser.role = vm.selectedRole;
	      if (vm.isFleetView) {
	        if (vm.selectedRole === "ALK Support") {
	          vm.selectedUser.role = "ALKSupport";
	        }
	        Users.updateUser(vm.selectedUser, applicationName).then(function (response) {
	          setGroups(vm.selectedUser.userId).then(function (response) {
	            $state.reload();
	          });
	        });
	      } else {
	        var role = vm.selectedRole;
	        if (role === "CompanyAdmin") {
	          role = "Company Administrator";
	        }
	        //Create user & assign to account
	        ssoService.updateExistingUser({
	          accountId: UserProvider.getUser().accountId,
	          emailAddress: vm.selectedUser.emailAddress,
	          role: role,
	          product: applicationName
	        }).then(function () {
	          $state.reload();
	        });
	      }
	    };
	
	    vm.saveNewUser = function () {
	      if (vm.isFleetView) {
	        var user = {
	          emailAddress: vm.userEmailSearchTerm,
	          firstName: vm.firstName,
	          lastName: vm.lastName,
	          enabled: true,
	          role: vm.selectedRole
	        };
	        if (user.role === "ALK Support") {
	          user.role = "ALKSupport";
	        }
	        var userId;
	        Users.createUser(user, applicationName).then(function (response) {
	          userId = response.userId;
	          return setGroups(userId);
	        }).then(function (response) {
	          alkEmailService.sendRouteReporterWelcomeEmail(vm.userEmailSearchTerm, vm.isExistingSSOUser);
	          $state.reload();
	        });
	      } else {
	        var role = vm.selectedRole;
	        if (role === "CompanyAdmin") role = "Company Administrator";
	        var userObj = {
	          emailAddress: vm.userEmailSearchTerm,
	          accountId: UserProvider.getUser().accountId,
	          role: role,
	          firstName: vm.firstName,
	          lastName: vm.lastName
	        };
	
	        var assignUserToProduct = vm.isNewUser ? ssoService.createNewUser : ssoService.updateExistingUser;
	        assignUserToProduct(userObj).then(function (response) {
	          alkEmailService.sendMapsureWelcomeEmail(vm.userEmailSearchTerm, vm.isNewUser);
	          $state.reload();
	        });
	      }
	    };
	
	    vm.saveNewUserDisabled = function () {
	      if (!vm.firstName || !vm.lastName) return true;
	      return false;
	    };
	
	    function setGroups(userId) {
	      if (vm.selectedRole === "CompanyAdmin") {
	        return $q.when();
	      }
	      var vehicleGroupIds = _.map(vm.vehicleGroups, function (vehicleGroup) {
	        return vehicleGroup.groupId;
	      });
	      var driverGroupIds = _.map(vm.driverGroups, function (driverGroup) {
	        return driverGroup.groupId;
	      });
	      var promise1 = Users.setUserVehicleGroups(userId, applicationName, vehicleGroupIds);
	      var promise2 = Users.setUserDriverGroups(userId, applicationName, driverGroupIds);
	      return $q.all([promise1, promise2]);
	    }
	
	    vm.removeDriverGroup = function (driverGroup) {
	      vm.hasChanges = true;
	      _.remove(vm.driverGroups, {
	        groupId: driverGroup.groupId
	      });
	    };
	
	    vm.removeVehicleGroup = function (vehicleGroup) {
	      vm.hasChanges = true;
	      _.remove(vm.vehicleGroups, {
	        groupId: vehicleGroup.groupId
	      });
	    };
	
	    vm.getFormattedRole = function (role) {
	      if (role === "User") return $translate.instant("view.accountUser.userRole");else if (role === "CompanyAdmin") return $translate.instant("view.accountUser.companyAdminRole");else if (role === "ALK Administrator") return $translate.instant("view.accountUser.alkAdminRole");else if (role === "ALKAdmin") return $translate.instant("view.accountUser.alkAdminRole");else if (["ALK Support", "ALKSupport"].includes(role)) return $translate.instant("view.accountUser.alkSupportRole");else if (role.toLowerCase() === "support") return $translate.instant("view.accountUser.supportRole");else if (role === "cloudxchange Approver") return $translate.instant("view.accountUser.approverRole");
	    };
	
	    vm.addVehicleGroup = function () {
	      alkModalService.show({
	        size: "md",
	        template: __webpack_require__(390),
	        controller: "addGroupsController",
	        controllerAs: "vm",
	        resolve: {
	          modalData: function modalData() {
	            return {
	              user: vm.selectedUser,
	              selectedVehicleGroups: vm.vehicleGroups,
	              selectedDriverGroups: vm.driverGroups,
	              allVehicleGroups: vm.allVehicleGroups,
	              allDriverGroups: vm.allDriverGroups,
	              isVehicle: true
	            };
	          }
	        }
	      }).then(function (results) {
	        vm.hasChanges = true;
	        vm.vehicleGroups = results.groups;
	      }, function () {//new
	      });
	    };
	
	    vm.addDriverGroup = function () {
	      alkModalService.show({
	        size: "md",
	        template: __webpack_require__(390),
	        controller: "addGroupsController",
	        controllerAs: "vm",
	        resolve: {
	          modalData: function modalData() {
	            return {
	              user: vm.selectedUser,
	              selectedVehicleGroups: vm.vehicleGroups,
	              selectedDriverGroups: vm.driverGroups,
	              allVehicleGroups: vm.allVehicleGroups,
	              allDriverGroups: vm.allDriverGroups,
	              isVehicle: false
	            };
	          }
	        }
	      }).then(function (results) {
	        vm.hasChanges = true;
	        vm.driverGroups = results.groups;
	      }, function () {//new
	      });
	    };
	
	    vm.testAddVehicleGroup = function () {
	      vm.hasChanges = true;
	      var newGroup = vm.allVehicleGroups[vm.vehicleGroups.length];
	      var group = {
	        groupId: newGroup.id,
	        groupName: newGroup.name,
	        numMembers: newGroup.numberOfVehicles
	      };
	      vm.vehicleGroups.push(group);
	    };
	
	    vm.testAddDriverGroup = function () {
	      vm.hasChanges = true;
	      var newGroup = vm.allDriverGroups[vm.driverGroups.length];
	      var group = {
	        groupId: newGroup.id,
	        groupName: newGroup.name,
	        numMembers: newGroup.numberOfDrivers
	      };
	      vm.driverGroups.push(group);
	    };
	
	    vm.showSupportRoleOption = function () {
	      return currentUserRoles.includes("support") || currentUserRoles.includes("alk support");
	    };
	
	    vm.showAlkSupportRoleOption = function () {
	      return currentUserRoles.includes("alk support");
	    };
	  }
	})();

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<div class=\"container-fluid admin-users\">\r\n  <div ng-switch=\"vm.listView\">\r\n    <div class=\"list-flex\" ng-switch-when=\"true\">\r\n      <!-- User Filter -->\r\n      <div class=\"row filter-panel\">\r\n        <div class=\"panel-body\">\r\n          <div class=\"col-xs-3\">\r\n            <div class=\"form-group\">\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\"> <i class=\"ico ico-filter\"></i></span>\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.userNameSearchTerm\" ng-change=\"vm.searchUser()\"\r\n                  placeholder=\"{{ 'view.accountGroup.findUsers' | translate }}\" ng-model-options=\"{debounce: 800}\" />\r\n                <span class=\"input-group-btn\">\r\n                <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"vm.userNameSearchTerm = '';vm.searchUser()\">&times;</button>\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- Add User -->\r\n          <div class=\"col-xs-9 text-right\">\r\n            <div class=\"form-group\">\r\n              <button ng-click=\"vm.newUser()\" class=\"btn btn-sm btn-default btn-success\">\r\n                <i class=\"ico ico-plus\"></i>\r\n                <span translate=\"views.accountUser.newUser\"></span>\r\n              </button>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- User list -->\r\n    <div id=\"account-user-list-container\" class=\"panel-body\" infinite-scroll='vm.loadMore()' infinite-scroll-distance='200'>\r\n      <table class=\"list-table\" ng-switch-when=\"true\">\r\n        <thead ng-if=\"vm.getFilteredUserList().length !== 0\">\r\n          <th><a href=\"#\" ng-click=\"vm.sortType = 'firstName'; vm.sortReverse = !vm.sortReverse;\">Name\r\n            <span ng-if=\"vm.sortType === 'firstName'\" class=\"ico\" ng-class=\"{'ico-down-open' :vm.sortReverse, 'ico-up-open':!vm.sortReverse}\"> </span></a></th>\r\n          <th><a href=\"#\" ng-click=\"vm.sortType = 'emailAddress'; vm.sortReverse = !vm.sortReverse;\">Email Address \r\n            <span ng-if=\"vm.sortType === 'emailAddress'\" class=\"ico\" ng-class=\"{'ico-down-open' :vm.sortReverse, 'ico-up-open':!vm.sortReverse}\"></span></a></th>\r\n          <th><a href=\"#\" ng-click=\"vm.sortType = 'role'; vm.sortReverse = !vm.sortReverse;\">Role\r\n             <span ng-if=\"vm.sortType === 'role'\" class=\"ico\" ng-class=\"{'ico-down-open' :vm.sortReverse, 'ico-up-open':!vm.sortReverse}\"></span></a></th>\r\n          <th></th>\r\n        </thead>\r\n        <tr >\r\n          <td colspan=\"4\" ng-if=\"vm.getFilteredUserList().length === 0 && !vm.isLoading\">\r\n            {{ \"templates.allEdits.NoResults\" | translate }}\r\n          </td>\r\n          <td>\r\n            <h5 ng-if=\"vm.isLoading\"> <span class=\"ico ico-load-c spinner\"></span> loading....</h5>\r\n          </td>\r\n        </tr>\r\n        \r\n\r\n        <tr ng-class=\"!vm.isLoggedInUser(user)? 'clickable-row':'disabled-row'\" ng-repeat=\"user in vm.getFilteredUserList() | orderBy:vm.sortType:vm.sortReverse\"  ng-click=\"!vm.isLoggedInUser(user) && vm.editUser(user); event.preventDefault(); $event.stopPropagation();\"\r\n          title=\"\" analytics=\"['Account','User','Edit']\">\r\n          <td>{{user.firstName}} {{user.lastName}}</td>\r\n          <td>{{user.emailAddress}}</td>\r\n          <td>{{vm.getFormattedRole(user.role)}}</td>\r\n          <td class=\"text-right\">\r\n            <button class=\"btn btn-md btn-link btn-action\" ng-click=\"vm.deleteUser(user); $event.preventDefault(); $event.stopPropagation();\"\r\n              title=\"{{'views.accountUser.deleteUser' | translate}}\" analytics=\"['Account','User','Delete']\" ng-disabled = \"vm.isLoggedInUser(user)\">\r\n                <i class=\"ico ico-trash\"></i>\r\n            </button>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n\r\n    <div ng-switch-when=\"false\">\r\n      <div class=\"panel-body\">\r\n        <fieldset ng-show=\"vm.displayMode==='new'\">\r\n          <form class=\"new-group-name\" name=\"userTabForm\" novalidate role=\"form\">\r\n            <div ng-show=\"vm.displayMode==='new'\" style=\"padding: 20px;\">\r\n              <div class=\"row\">\r\n                <div class=\"col-sm-6\" ng-class=\"{ 'has-error' : userTabForm.username.$dirty && userTabForm.username.$invalid }\">\r\n                  <div class=\"form-group\"  alkmaps-input> \r\n                    <label>\r\n                        <span translate=\"views.accountUser.loginHeader\"></span>\r\n                    </label>\r\n                    <input name=\"username\" class=\"form-control input-sm\" type=\"text\" ng-model=\"vm.userEmailSearchTerm\" alk-autofocus alk-email\r\n                      placeholder=\"{{ 'views.accountUser.userSeach' | translate }} \" maxlength=\"64\"\r\n                      required />\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                  <div class=\"form-group\" style=\"padding-top: 21px;\">\r\n                    <button class=\"btn btn-sm btn-success\" ng-click=\"vm.checkEmail()\" type=\"submit\" ng-disabled=\"userTabForm.username.$pristine || userTabForm.username.$invalid || vm.enableCheckEmail === false\">\r\n                        <span translate=\"view.accountGroup.checkEmail\"></span>\r\n                    </button>\r\n                    <button class=\"btn btn-sm btn-default pull-right\" ng-disabled=\"vm.enableCheckEmail !== false\" ng-click=\"vm.checkEmailDoOver()\" type=\"submit\">\r\n                        <span translate=\"views.accountUser.doOver\"></span>\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col-sm-12\">\r\n                  <p class=\"alert alert-success\" translate=\"views.accountUser.existingUserMsgCompanyAdmin\" ng-if=\"!vm.userExists && vm.isNewUser===false && vm.enableCheckEmail === false\"></p>\r\n                  <p class=\"alert alert-success\" translate=\"views.accountUser.newUserMsg\" ng-if=\"vm.isNewUser===true && vm.enableCheckEmail === false\"></p>\r\n                  <p class=\"alert alert-warning\" translate=\"views.accountUser.existingUserInAccount\" ng-if=\"vm.userExists && vm.enableCheckEmail === false\"></p>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" ng-if=\"vm.enableCheckEmail === false && !vm.userExists\" ng-class=\"{ 'has-error' : (vm.enableCheckEmail!=null && userTabForm.firstName.$invalid)}\">\r\n                <div class=\"col-sm-3\">\r\n                  <label>\r\n                    <span translate=\"view.accountUser.firstName\"></span>\r\n                  </label>\r\n                  <input name=\"firstName\" id=\"firstName\" class=\"form-control input-sm\" type=\"text\" placeholder=\"{{'view.accountUser.firstName' | translate}}\"\r\n                    ng-model=\"vm.firstName\" required ng-change=\"vm.hasChanges=true\" ng-disabled=\"!vm.isNewUser\" maxlength=\"64\"/>\r\n                </div>\r\n                <div class=\"col-sm-3\">\r\n                  <label>\r\n                    <span translate=\"view.accountUser.lastName\"></span>\r\n                  </label>\r\n                  <input name=\"lastName\" id=\"lastName\" class=\"form-control input-sm\" type=\"text\" placeholder=\"{{'view.accountUser.lastName' | translate}}\"\r\n                    ng-model=\"vm.lastName\" required ng-change=\"vm.hasChanges=true\" ng-disabled=\"!vm.isNewUser\" maxlength=\"64\"/>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </fieldset>\r\n\r\n      </div>\r\n      <div>\r\n        <div class=\"panel-body\" ng-show=\"vm.displayMode==='edit'\">\r\n          <div class=\"row\">\r\n            <span class=\" col-sm-12 title\" translate=\"views.accountUser.editUser\"></span>\r\n          </div>\r\n          <fieldset>\r\n            <div class=\"row action-panel\">\r\n              <label class=\"col-sm-6\">\r\n                <span class=\"title\"><strong>{{'views.accountUser.loginHeader' | translate}}:</strong> {{vm.selectedUser.emailAddress}} </span><br />\r\n                <span class=\"title\"><strong>{{'views.accountUser.nameHeader' | translate}}:</strong> {{vm.selectedUser.firstName}} {{vm.selectedUser.lastName}} </span>\r\n              </label>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"panel-body\" ng-show=\"(vm.displayMode==='edit' || vm.displayMode==='new') && !(vm.displayMode==='new' && vm.enableCheckEmail!==false) && !vm.userExists\">\r\n          <label > Role </label>\r\n          <fieldset>\r\n            <div class=\"radio\">\r\n              <label class=\"dark\">\r\n                  <input type=\"radio\"\r\n                          name=\"role\"\r\n                          value=\"User\"\r\n                          ng-model=\"vm.selectedRole\"\r\n                          ng-checked=\"vm.selectedRole==='User'\"\r\n                          ng-change=\"vm.hasChanges=true\" />\r\n                  <strong>{{ 'view.accountUser.userRole' | translate }}</strong>\r\n              </label>\r\n            </div>\r\n            <div class=\"radio\">\r\n              <label class=\"dark\">\r\n                  <input type=\"radio\"\r\n                          name=\"role\"\r\n                          value=\"CompanyAdmin\"\r\n                          ng-model=\"vm.selectedRole\"\r\n                          ng-checked=\"vm.selectedRole==='CompanyAdmin'\"\r\n                          ng-change=\"vm.hasChanges=true\" />\r\n                  <strong>{{ 'view.accountUser.companyAdminRole' | translate }}</strong>\r\n              </label>\r\n            </div>\r\n            <!--Still have to restrict to certain products here and in backend-->\r\n            <div class=\"radio\" ng-if=\"vm.showSupportRoleOption()&& !vm.isFleetView\">\r\n              <label class=\"dark\">\r\n                  <input type=\"radio\"\r\n                          name=\"role\"\r\n                          value=\"support\"\r\n                          ng-model=\"vm.selectedRole\"\r\n                          ng-change=\"vm.hasChanges=true\" />\r\n                  <strong>{{ 'view.accountUser.supportRole' | translate }}</strong>\r\n              </label>\r\n            </div>\r\n            <div class=\"radio\" ng-if=\"vm.showAlkSupportRoleOption() && !vm.isFleetView\">\r\n              <label class=\"dark\">\r\n                  <input type=\"radio\"\r\n                          name=\"role\"\r\n                          value=\"ALK Support\"\r\n                          ng-model=\"vm.selectedRole\"\r\n                          ng-change=\"vm.hasChanges=true\" />\r\n                  <strong>{{ 'view.accountUser.alkSupportRole' | translate }}</strong>\r\n              </label>\r\n            </div>\r\n            <div class=\"radio\" ng-if=\"vm.showSupportRoleOption() && vm.isFleetView\">\r\n              <label class=\"dark\">\r\n                  <input type=\"radio\"\r\n                          name=\"role\"\r\n                          value=\"Support\"\r\n                          ng-model=\"vm.selectedRole\"\r\n                          ng-change=\"vm.hasChanges=true\" />\r\n                  <strong>{{ 'view.accountUser.supportRole' | translate }}</strong>\r\n              </label>\r\n            </div>\r\n            <div class=\"radio\" ng-if=\"vm.showAlkSupportRoleOption() && vm.isFleetView\">\r\n              <label class=\"dark\">\r\n                  <input type=\"radio\"\r\n                          name=\"role\"\r\n                          value=\"ALKSupport\"\r\n                          ng-model=\"vm.selectedRole\"\r\n                          ng-change=\"vm.hasChanges=true\" />\r\n                  <strong>{{ 'view.accountUser.alkSupportRole' | translate }}</strong>\r\n              </label>\r\n            </div>\r\n          </fieldset>\r\n          <!--Group Assignment-->\r\n          <div class=\"row tab-panel\" ng-if=\"vm.selectedRole==='User' && vm.isFleetView\">\r\n            <ul class=\"nav nav-tabs\">\r\n              <li class=\"nav-item\" ng-class=\"{'active':vm.tab==='vehicles'}\" ng-click=\"vm.tab = 'vehicles'\">\r\n                <a class=\"nav-link\"><span translate=\"common.VehicleGroups\"></span></a>\r\n              </li>\r\n              <li class=\"nav-item\" ng-class=\"{'active':vm.tab==='drivers'}\" ng-click=\"vm.tab = 'drivers'\">\r\n                <a class=\"nav-link\"><span translate=\"common.DriverGroups\"></span></a>\r\n              </li>\r\n            </ul>\r\n            <div class=\"tab-content\" ng-if=\"vm.tab==='vehicles'\">\r\n                  <div class=\" row action-panel\">\r\n                    <div class=\"pull-right\">\r\n                      <button id=\"add-vehicle-group\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.addVehicleGroup()\">\r\n                        <span class=\"ico ico-plus\"> </span>\r\n                        <span translate=\"common.Add\"></span>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"panel-body\">\r\n\r\n                    <table id=\"group-assoc-table\" class=\"table table-hover list-table\">\r\n                      <thead>\r\n                        <tr>\r\n                          <th translate=\"common.VehicleGroups\"></th>\r\n                          <th>Remove</th>\r\n                        </tr>\r\n                      </thead>\r\n                      <tbody>\r\n                        <tr ng-repeat=\"vehicleGroup in vm.vehicleGroups | orderBy: 'groupName'\">\r\n                          <td>\r\n                            {{vehicleGroup.groupName}}\r\n                          </td>\r\n                          <td class=\"text-right\">\r\n                            <button class=\"btn btn-md btn-link button-action\" type=\"button\" ng-click=\"vm.removeVehicleGroup(vehicleGroup)\">\r\n                              <span > &times;</span>\r\n                            </button>\r\n                          </td>\r\n                        </tr>\r\n                      </tbody>\r\n                    </table>\r\n\r\n                  </div>\r\n            </div>\r\n\r\n            <div class=\"tab-content\" ng-if=\"vm.tab==='drivers'\">\r\n                  <div class=\"row action-panel\">\r\n                    <div class=\"pull-right\">\r\n                      <button id=\"add-vehicle-group\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.addDriverGroup()\">\r\n                        <span class=\"ico ico-plus\"> </span>\r\n                        <span translate=\"common.Add\"></span>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"panel-body\">\r\n\r\n                    <table id=\"group-assoc-table\" class=\"table table-hover list-table\">\r\n                      <thead>\r\n                        <tr>\r\n                          <th translate=\"common.DriverGroups\"></th>\r\n                          <th>Remove</th>\r\n                        </tr>\r\n                      </thead>\r\n                      <tbody>\r\n                        <tr ng-repeat=\"driverGroup in vm.driverGroups| orderBy: 'groupName'\">\r\n                          <td>\r\n                            {{driverGroup.groupName}}\r\n                          </td>\r\n                          <td class=\"text-right\">\r\n                            <button class=\"btn btn-md btn-link button-action\" type=\"button\" ng-click=\"vm.removeDriverGroup(driverGroup)\">\r\n                              <span > &times;</span>\r\n                            </button>\r\n                          </td>\r\n                        </tr>\r\n                      </tbody>\r\n                    </table>\r\n\r\n                  </div>\r\n              </div>\r\n\r\n\r\n\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!--end of group assignment-->\r\n      </div>\r\n    </div>\r\n\r\n    <div>\r\n      <div class=\"pull-right panel-footer\" ng-if=\"vm.displayMode==='edit' && vm.listView === false\">\r\n          <button class=\"btn btn-sm btn-default\" ng-click=\"vm.cancel()\">\r\n              <i class=\"ico ico-chevron-left-thick\"></i>\r\n              <span translate=\"common.Back\"></span>\r\n          </button>\r\n          <button class=\"btn btn-sm btn-success\" ng-click=\"vm.saveExistingUser()\" ng-disabled=\"!vm.hasChanges\">\r\n              <span translate=\"common.Save\"></span>\r\n          </button>\r\n      </div>\r\n      <div class=\"pull-right panel-footer\" ng-if=\"vm.displayMode==='new' && vm.listView === false\">\r\n          <button class=\"btn btn-sm btn-default\" ng-click=\"vm.cancel()\">\r\n              <i class=\"ico ico-chevron-left-thick\"></i>\r\n              <span translate=\"common.Back\"></span>\r\n          </button>\r\n          <button class=\"btn btn-sm btn-success\" ng-click=\"vm.saveNewUser()\" ng-disabled=\"vm.saveNewUserDisabled()\">\r\n              <span translate=\"common.Save\"></span>\r\n          </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>\r\n";

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<div class=\"modal-content\">\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title\">\r\n      <span>Select {{ vm.isVehicle ? \"Vehicle\" : \"Driver\" }} Groups</span>\r\n    </h4>\r\n  </div>\r\n  <div class=\"modal-body embedded-list-panel \">\r\n        <div class=\"form-inline filter-group row\">\r\n          <div class=\"input-group col-sm-6 col-xs-6 col-md-6\">\r\n            <span class=\"input-group-btn\">\r\n                <span class=\"btn btn-sm btn-fake-addon\">\r\n                <i class=\"ico ico-filter\"></i>\r\n                </span>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" id=\"set-group-filters\" placeholder=\"{{'common.Filter' | translate }}\" ng-model=\"vm.filterGroup\"\r\n              ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.filterItems(vm.filterGroup)\" ng-keyup=\"vm.onFilterKeyUp($event)\">\r\n            <span class=\"input-group-btn\">\r\n                <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"vm.filterGroup = '';vm.filterItems(vm.filterGroup)\">&times;</button>\r\n              </span>\r\n          </div>\r\n          <div class=\"col-sm-6 col-xs-6 col-md-6 pull-right\">\r\n              <button type=\"button\" class=\"btn btn-sm btn-default pull-right\" ng-disabled=\"vm.shownItems.length === 0\" translate=\"common.SelectNone\" ng-click=\"vm.selectNone();\"></button>\r\n              \r\n              <button type=\"button\" class=\"btn btn-sm btn-default pull-right\" ng-disabled=\"vm.shownItems.length === 0\" translate=\"common.SelectAll\" style=\"margin-right: 5px;\" ng-click=\"vm.selectAll();\"></button>\r\n            </div>\r\n        </div>\r\n    <div class=\"panel-body v-flex-container\" style=\"max-height: 600px;\">\r\n      <div class=\"group-list\">\r\n    <table class=\"table table-hover table-striped list-table\">\r\n      <thead ng-if=\"vm.shownItems.length !== 0\">\r\n          <th class=\"checkbox-column\">\r\n          </th>\r\n          <th>Name</th>\r\n      </thead>\r\n      <tbody>\r\n        <tr ng-if=\"vm.shownItems.length === 0\">\r\n          <td>No results to display</td>\r\n        </tr>\r\n          <tr ng-repeat=\"group in vm.shownItems\" ng-click=\"vm.toggleSelectedId(item.id);\">\r\n            <td class=\"checkbox-column\">\r\n              <input type=\"checkbox\" name=\"selectedIds\" value=\"{{group.id}}\" ng-model=\"group.checked\" ng-checked=\"vm.ids.indexOf(group.id) >= 0\">\r\n            </div>\r\n            </td>\r\n            <td class=\"group-association-add-selectroutingprofiles-name-col\">\r\n              <span>\r\n              <span class=\"highlight\"></span>{{group.name}}</span>\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n    </table>\r\n      </div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n      <div class=\"pagination-panel\" ng-if=\"vm.shownItems.length !== 0\">\r\n          <div class=\"pull-left grid-details\">\r\n             <span translate=\"common.DisplayingDetail\" translate-values=\"{ current: vm.shownItems.length, total: vm.groupList.length }\"></span>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n        </div>\r\n    <button class=\"btn btn-default btn-sm\" ng-disabled=\"vm.shownItems.length === 0\" type=\"button\" ng-click=\"vm.ok()\">OK</button>\r\n    <button class=\"btn btn-default btn-sm\" id=\"cancel-button\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\r\n  </div>\r\n</div>\r\n";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getIterator2 = __webpack_require__(328);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	  "use strict";
	
	  angular.module("alk.companyAdmin").controller("addGroupsController", addGroupsController);
	
	  addGroupsController.$inject = ["$q", "$http", "UserProvider", "_", "alkModalService", "$translate", "$scope", "$timeout", "$state", "modalData", "$uibModalInstance"];
	  function addGroupsController($q, $http, UserProvider, _, alkModalService, $translate, $scope, $timeout, $state, modalData, $uibModalInstance) {
	    var vm = this;
	    vm.filteredItems = [];
	    vm.shownItems = [];
	
	    vm.selectedVehicleGroups = angular.copy(modalData.selectedVehicleGroups);
	    vm.selectedDriverGroups = angular.copy(modalData.selectedDriverGroups);
	    vm.isVehicle = modalData.isVehicle;
	
	    if (vm.isVehicle) {
	      vm.groupList = angular.copy(modalData.allVehicleGroups);
	      vm.shownItems = vm.groupList;
	    } else {
	      vm.groupList = angular.copy(modalData.allDriverGroups);
	      vm.shownItems = vm.groupList;
	    }
	
	    init();
	
	    function init() {
	      vm.ids = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(vm.groupList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var group = _step.value;
	
	          if (vm.isVehicle) {
	            if (_.any(vm.selectedVehicleGroups, function (userGroup) {
	              return userGroup.groupId === group.id;
	            })) {
	              group.checked = true;
	            }
	          } else {
	            if (_.any(vm.selectedDriverGroups, function (userGroup) {
	              return userGroup.groupId === group.id;
	            })) {
	              group.checked = true;
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var allIds = vm.groupList.map(function (c) {
	        return c.id;
	      });
	      //vm.ids = allIds;
	    }
	    vm.selectAll = function () {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(vm.shownItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var group = _step2.value;
	
	          group.checked = true;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      vm.ids = vm.shownItems.map(function (c) {
	        return c.id;
	      });
	    };
	
	    vm.selectNone = function () {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(vm.groupList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var group = _step3.value;
	
	          group.checked = false;
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      vm.ids = [];
	    };
	    vm.isUserAssignedToGroup = function (group) {
	      if (vm.isVehicle) {
	        return _.any(vm.selectedVehicleGroups, function (userGroup) {
	          return userGroup.groupId === group.id;
	        });
	      } else {
	        return _.any(vm.selectedDriverGroups, function (userGroup) {
	          return userGroup.groupId === group.id;
	        });
	      }
	    };
	
	    vm.ok = function () {
	      var groups = [];
	      if (vm.isVehicle) {
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)(vm.groupList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var group = _step4.value;
	
	            if (group.checked) {
	              groups.push({
	                groupId: group.id,
	                groupName: group.name
	              });
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      } else {
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	          for (var _iterator5 = (0, _getIterator3.default)(vm.groupList), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var _group = _step5.value;
	
	            if (_group.checked) {
	              groups.push({
	                groupId: _group.id,
	                groupName: _group.name
	              });
	            }
	          }
	        } catch (err) {
	          _didIteratorError5 = true;
	          _iteratorError5 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	              _iterator5.return();
	            }
	          } finally {
	            if (_didIteratorError5) {
	              throw _iteratorError5;
	            }
	          }
	        }
	      }
	      $uibModalInstance.close({
	        groups: groups
	      });
	    };
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss();
	    };
	    vm.filterItems = function (filter) {
	      // whenever filtering the list of units, reset the selected items
	      if (!filter) {
	        vm.filteredItems = vm.groupList;
	      } else {
	        var filterUpperCase = filter.toUpperCase();
	        vm.filteredItems = vm.groupList.filter(function (c) {
	          return c.name != null && c.name.toUpperCase().indexOf(filterUpperCase) != -1;
	        });
	      }
	      // make sure to let the list know that the items in it changed so it can do the correct infinite scroll logic
	      vm.shownItems = vm.filteredItems;
	    };
	  }
	})();

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(393);
	
	(function (angular) {
	
	  angular.module("tm.navButtonsThreeStack", ["tm.supportChat"]);
	})(window.angular);
	
	__webpack_require__(397);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(246);
	
	(function (angular) {
	
	  angular.module("tm.supportChat", ["alk.authentication"]);
	})(window.angular);
	
	__webpack_require__(394);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(395);
	
	(function () {
	  "use strict";
	
	  angular.module("tm.supportChat").directive("tmSupportChatSmall", function () {
	    return {
	      controller: "supportChatController",
	      template: __webpack_require__(396),
	      link: link,
	      restrict: "E"
	    };
	  });
	
	  function link(scope, element, attrs) {}
	})();

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("tm.supportChat").controller("supportChatController", ["$scope", "$translate", "UserProvider", function ($scope, $translate, UserProvider) {
	    // fcWidget stub (SWPWEB-994)
	    $scope.fcWidget = {
	      init: function init() {},
	      destroy: function destroy() {},
	      isOpen: function isOpen() {},
	      isInitialized: function isInitialized() {},
	      user: {
	        setProperties: function setProperties() {}
	      },
	      open: function open() {},
	      close: function close() {}
	    };
	    $scope.tooltipText = $translate.instant("views.nav.SupportChatDisabledTooltip");
	
	    function init() {
	      // ALK UserInfo structure
	      //   data should be set by the product when the user logs into the product
	      //   see @trimblemaps/webtools-common/javascript/AngularJS/alk-authentication/module
	      $scope.userInfo = UserProvider.getUser();
	      // fcWidget should be imported via <script> tag in each product's index.html
	      // TODO pchen: use npm package because firewall blocks freshchat import <script>
	      if (window.fcWidget) {
	        $scope.fcWidget = window.fcWidget;
	        $scope.fcWidget.init({
	          // shared token for all apps and environments
	          token: '797ed190-4ef3-4faa-81f8-367d7ba5e6dc',
	          host: 'https://wchat.freshchat.com',
	          // required, supposedly
	          externalId: $scope.userInfo.userName,
	          config: {
	            headerProperty: {
	              hideChatButton: true
	            }
	          }
	        });
	        if ($scope.fcWidget.isInitialized()) {
	          $scope.tooltipText = $translate.instant('views.nav.SupportChat');
	        }
	      }
	    }
	
	    $scope.toggleShowChat = function () {
	      if (!$scope.fcWidget.isOpen()) {
	        // always send up-to-date user info (SWPWEB-982)
	        $scope.fcWidget.user.setProperties({
	          firstName: $scope.userInfo.firstName,
	          lastName: $scope.userInfo.lastName,
	          email: $scope.userInfo.userName,
	          account: $scope.userInfo.account
	        }).then(function () {
	          $scope.fcWidget.open();
	        });
	      } else {
	        $scope.fcWidget.close();
	      }
	    };
	
	    init();
	  }]);
	})();

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<li\r\n  class=\"small-btn\"\r\n  title=\"{{tooltipText}}\"\r\n  placement=\"bottom\"\r\n>\r\n  <button\r\n    ng-disabled=\"!fcWidget.isInitialized()\"\r\n    class=\"nav-button\"\r\n    ng-click=\"toggleShowChat()\"\r\n  >\r\n    <i class=\"header-icon-small chat-icon\"></i>\r\n    <span translate=\"views.nav.SupportChat\"></span>\r\n  </button>\r\n</li>";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function () {
	  "use strict";
	
	  angular.module("tm.navButtonsThreeStack").directive("tmNavButtonsThreeStack", function () {
	    return {
	      template: __webpack_require__(398),
	      link: link,
	      restrict: "E",
	      scope: {
	        // Show Company Admin button only for Company Admin, Partner, Support accounts
	        showCompanyAdmin: "=",
	        goToCompanyAdmin: "&"
	      }
	    };
	  });
	
	  function link(scope, element, attrs) {}
	})();

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = "<ul>\r\n  <li class=\"small-btn\" ng-If=\"showCompanyAdmin\">\r\n    <button type=\"button\" class=\"nav-button\" ng-click=\"goToCompanyAdmin()\" alkmaps-input analytics=\"['Company Admin']\">\r\n      <i class=\"header-icon-small company-administration-icon\"></i>\r\n      <span translate=\"views.nav.CompanyAdmin\"></span>\r\n    </button>\r\n  </li>\r\n\r\n  <li class=\"small-btn\">\r\n    <a href=\"https://support.copilotpro.com/en/support/home#users\" target=\"_blank\">\r\n      <button class=\"nav-button\">\r\n        <i class=\"header-icon-small help-icon\"></i>\r\n        <span translate=\"views.nav.Help\"></span>\r\n      </button>\r\n    </a>\r\n  </li>\r\n\r\n  <tm-support-chat-small></tm-support-chat-small>\r\n</ul>\r\n";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "node_modules/angular-i18n/angular-locale_en.js";

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "node_modules/angular-i18n/angular-locale_en-us.js";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "node_modules/angular-i18n/angular-locale_de.js";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "node_modules/angular-i18n/angular-locale_de-de.js";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "node_modules/angular-i18n/angular-locale_es.js";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "node_modules/angular-i18n/angular-locale_es-es.js";

/***/ })
]);


// WEBPACK FOOTER //
// app.5fead4848433dbc1da76.js